
function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequirefc28"];
var parcelRegister = parcelRequire.register;
parcelRegister("c4urb", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => $9f99e301892a62b1$export$2e2bcd8739ae039);

var $j2vrN = parcelRequire("j2vrN");

var $j8KPd = parcelRequire("j8KPd");
var $9f99e301892a62b1$export$2e2bcd8739ae039 = (0, $j2vrN.withExperienceNotifier)('request-create-form')((0, $j8KPd.default));

});
parcelRegister("j8KPd", function(module, exports) {
$parcel$export(module.exports, "default", () => $6853c130a8ba3447$export$2e2bcd8739ae039);

var $bSJIT = parcelRequire("bSJIT");

var $egQxE = parcelRequire("egQxE");

var $BOq7h = parcelRequire("BOq7h");

var $4v2A7 = parcelRequire("4v2A7");

var $2OuWT = parcelRequire("2OuWT");

var $lFpPv = parcelRequire("lFpPv");

var $xb2jO = parcelRequire("xb2jO");

var $eL3zl = parcelRequire("eL3zl");

var $i5HDF = parcelRequire("i5HDF");

var $oDZyG = parcelRequire("oDZyG");

var $9K7mZ = parcelRequire("9K7mZ");

var $3u4M3 = parcelRequire("3u4M3");

var $4ZMmh = parcelRequire("4ZMmh");

var $fK3tS = parcelRequire("fK3tS");

var $9GQhj = parcelRequire("9GQhj");

var $1biTA = parcelRequire("1biTA");

var $bkU3q = parcelRequire("bkU3q");

var $6GvED = parcelRequire("6GvED");

var $ik9zp = parcelRequire("ik9zp");

var $ay2XP = parcelRequire("ay2XP");

var $aI0YR = parcelRequire("aI0YR");

var $jAqu4 = parcelRequire("jAqu4");
parcelRequire("67fJ8");
var $9MGCy = parcelRequire("9MGCy");
parcelRequire("frMhy");
var $pj5PM = parcelRequire("pj5PM");

var $7VUtk = parcelRequire("7VUtk");

var $2usNr = parcelRequire("2usNr");

var $kIbto = parcelRequire("kIbto");

var $87QgR = parcelRequire("87QgR");

var $cQRu3 = parcelRequire("cQRu3");

var $7x378 = parcelRequire("7x378");

var $92LrB = parcelRequire("92LrB");

var $gdUUy = parcelRequire("gdUUy");

var $gUpf2 = parcelRequire("gUpf2");

var $cMYsY = parcelRequire("cMYsY");

var $2IITT = parcelRequire("2IITT");

var $1qPbZ = parcelRequire("1qPbZ");

var $9hihM = parcelRequire("9hihM");

var $hCnLH = parcelRequire("hCnLH");

var $2Zepk = parcelRequire("2Zepk");

var $gEVth = parcelRequire("gEVth");
var $jBiia = parcelRequire("jBiia");

var $6NtVd = parcelRequire("6NtVd");

var $5oBRG = parcelRequire("5oBRG");

var $l6qfM = parcelRequire("l6qfM");

var $eDcdn = parcelRequire("eDcdn");

var $5LmQo = parcelRequire("5LmQo");

var $gYDJY = parcelRequire("gYDJY");

var $aYbXa = parcelRequire("aYbXa");

var $g5FS7 = parcelRequire("g5FS7");

var $kcqdg = parcelRequire("kcqdg");

var $chubD = parcelRequire("chubD");

var $if8pw = parcelRequire("if8pw");

var $lVOVX = parcelRequire("lVOVX");

var $c7bWK = parcelRequire("c7bWK");

var $2r1Ci = parcelRequire("2r1Ci");

var $dQ3Zn = parcelRequire("dQ3Zn");
parcelRequire("fDjPz");
var $bnpCY = parcelRequire("bnpCY");

var $fnB99 = parcelRequire("fnB99");

var $gLV5g = parcelRequire("gLV5g");
parcelRequire("iGm04");
var $eSxIC = parcelRequire("eSxIC");
class $6853c130a8ba3447$export$23aadacdae45e79 extends $bSJIT.Component {
    static #_ = this.DIRTY_CHECK_DEBOUNCE_MS = 100;
    componentWillUnmount() {
        this.isUnmounted = true;
    }
    componentDidMount() {
        const fieldConfigErrors = this.getInvalidConfigFieldErrors();
        if (!(0, $4ZMmh.isEmpty)(fieldConfigErrors)) this.setState((previousState)=>({
                errors: {
                    ...previousState.errors,
                    fieldErrors: fieldConfigErrors
                }
            }));
    }
    renderAnonymousRedirect() {
        const { complete: complete } = this.state;
        const { portalId: portalId, requestTypeId: requestTypeId } = this.props;
        return /*#__PURE__*/ $bSJIT.createElement((0, $g5FS7.PushRedirectWithState), {
            // TypeScript upgrade (v4.4.3). Please correct when you revisit this code. Please correct when this code is revisited.
            // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
            to: `/portal/${portalId}/create/${requestTypeId}/confirm`,
            state: {
                email: complete === null || complete === void 0 ? void 0 : complete.email,
                issueKey: complete === null || complete === void 0 ? void 0 : complete.issueKey
            }
        });
    }
    render() {
        const { formData: formData, portalId: portalId, requestTypeId: requestTypeId, userAuthenticated: userAuthenticated, canAdministerJira: canAdministerJira, isEmbeddedRoute: isEmbeddedRoute, intl: intl, error: error, isPrefillPending: isPrefillPending } = this.props;
        const referrer = $5LmQo.get((0, $lVOVX.REFERRER_QUERY_PARAM));
        const shouldAddReferrer = referrer && referrer !== 'undefined';
        // TODO: Move this into <Formik /> when upgraded to formik@1.x.x
        // See: https://github.com/jaredpalmer/formik#the-gist
        const { complete: complete } = this.state;
        if (!portalId || !requestTypeId) return null;
        // Show UFOHold when formData is not loaded yet (no error)
        if (!formData && !error) return /*#__PURE__*/ $bSJIT.createElement($6853c130a8ba3447$var$Root, null, /*#__PURE__*/ $bSJIT.createElement((0, $1qPbZ.default), {
            name: "request-create-form-loading"
        }, /*#__PURE__*/ $bSJIT.createElement((0, $i5HDF.SkeletonLoadingWrapper), {
            isLoading: true
        })));
        // When jsm_portal_rovo_integration is on and there are URL params for pre-filling,
        // we delay rendering the form until the epic has resolved all field values.
        // This prevents Formik from initialising with empty values before pre-fill data arrives.
        // We only do this when pre-fill is actually being used to avoid impacting the normal flow.
        if ((0, $gdUUy.fg)('jsm_portal_rovo_integration') && isPrefillPending) return /*#__PURE__*/ $bSJIT.createElement($6853c130a8ba3447$var$Root, null, /*#__PURE__*/ $bSJIT.createElement((0, $i5HDF.SkeletonLoadingWrapper), {
            isLoading: true
        }));
        // If the submission is complete we will direct the user to the next page,
        // after checking if user is authenticated and
        // portal is rendered inside an embeddable route or not
        if (complete) {
            if (userAuthenticated) return isEmbeddedRoute ? /*#__PURE__*/ $bSJIT.createElement($6853c130a8ba3447$var$Root, null, /*#__PURE__*/ $bSJIT.createElement((0, $bnpCY.default), {
                actionHrefTarget: "_blank",
                title: intl.formatMessage((0, $fnB99.default).thanksTitle),
                description: intl.formatMessage((0, $fnB99.default).referenceDescription),
                callToActionHref: `/portal/${portalId}/${complete.issueKey}${shouldAddReferrer ? `?${0, $lVOVX.REFERRER_QUERY_PARAM}=${referrer}` : ''}`,
                callToActionText: intl.formatMessage((0, $fnB99.default).callToAction)
            })) : /*#__PURE__*/ $bSJIT.createElement($6853c130a8ba3447$var$Root, null, /*#__PURE__*/ $bSJIT.createElement((0, $g5FS7.PushRedirect), {
                to: $5LmQo.addParamsToUrl(`/portal/${portalId}/${complete.issueKey}`, {
                    created: 'true',
                    ...shouldAddReferrer && {
                        [(0, $lVOVX.REFERRER_QUERY_PARAM)]: referrer
                    }
                })
            }));
            return /*#__PURE__*/ $bSJIT.createElement($6853c130a8ba3447$var$Root, null, this.renderAnonymousRedirect());
        }
        if (formData) {
            const { initialFieldValues: initialFieldValues, proforma: proforma } = formData;
            if (proforma && proforma.formExists && !proforma.formValid) return /*#__PURE__*/ $bSJIT.createElement((0, $eSxIC.default), {
                requestTypeId: requestTypeId,
                portalId: portalId,
                admin: canAdministerJira,
                formValidationResult: proforma.formValidationResult
            });
            return /*#__PURE__*/ $bSJIT.createElement($6853c130a8ba3447$var$Root, null, (this.hasRequiredFields() || this.hasRequiredFieldsInProformaForm()) && /*#__PURE__*/ $bSJIT.createElement((0, $cQRu3.FormHeader), null, /*#__PURE__*/ $bSJIT.createElement((0, $cMYsY.Flex), {
                justifyContent: "space-between"
            }, /*#__PURE__*/ $bSJIT.createElement((0, $gUpf2.Box), null, intl.formatMessage((0, $fnB99.default).instructionForMandatoryField), /*#__PURE__*/ $bSJIT.createElement((0, $7x378.RequiredAsterisk), null)))), (0, $87QgR.default).checkGate('render_create_request_field_with_loading_cursor') ? /*#__PURE__*/ $bSJIT.createElement((0, $jAqu4.DisableViewUntilMount), {
                name: 'request-create-form'
            }, /*#__PURE__*/ $bSJIT.createElement((0, $3u4M3.Formik), {
                initialValues: initialFieldValues,
                onSubmit: this.onSubmit
            }, this.renderForm)) : /*#__PURE__*/ $bSJIT.createElement((0, $3u4M3.Formik), {
                initialValues: initialFieldValues,
                onSubmit: this.onSubmit
            }, this.renderForm));
        }
        return null;
    }
    constructor(...args){
        super(...args), this.state = {
            errors: undefined,
            submitting: false,
            submitDisabled: false,
            submissionErrorCount: 0,
            isDirty: false,
            isFormExpanded: true,
            isAttachmentUploading: false,
            resolveForgeCustomFields: ()=>Promise.resolve((0, $dQ3Zn.FORM_SUBMISSION_PROCEED)),
            failedOrTimedOutForgeCustomFields: [],
            forgeFormData: {}
        }, this.isUnmounted = false, this.formRef = /*#__PURE__*/ $bSJIT.createRef(), /** Correlation id generated per submit attempt (set at the start of onSubmit). */ this.formSubmissionId = undefined, this.proformaSerializationTraceAttributes = {}, /** Shared trace attributes derived from props, attached to every trace event. */ this.getProformaTraceBaseAttributes = ()=>({
                context_formSubmissionId: this.formSubmissionId,
                context_hasProformaForm: this.props.hasProformaForm,
                context_portalId: this.props.portalId,
                context_requestTypeId: this.props.requestTypeId,
                context_projectId: this.props.projectId
            }), this.validateProformaFormFields = ()=>{
            let isValid = true;
            const validateFnPresent = Boolean(this.validateProformaForm);
            this.validateProformaForm && this.validateProformaForm((isFormValid)=>{
                isValid = isFormValid;
            });
            this.proformaSerializationTraceAttributes = {
                ...this.proformaSerializationTraceAttributes,
                validateForm_validateFnPresent: validateFnPresent,
                validateForm_isProformaFormValid: isValid
            };
            return isValid;
        }, this.serializeProformaFormFields = ()=>{
            let serializedAnswer = undefined;
            let serializedAnswerCount = 0;
            let visibleFieldCount;
            const serializeFnPresent = Boolean(this.serializeProformaForm);
            this.serializeProformaForm && this.serializeProformaForm((serializedData)=>{
                serializedAnswer = serializedData;
                visibleFieldCount = serializedData === null || serializedData === void 0 ? void 0 : serializedData.visibleFieldCount;
                serializedAnswerCount = serializedData !== null && serializedData !== void 0 && serializedData.answers ? Object.keys(serializedData.answers).length : 0;
            });
            this.proformaSerializationTraceAttributes = {
                ...this.proformaSerializationTraceAttributes,
                serializeForm_serializedAnswerCount: serializedAnswerCount,
                serializeForm_visibleFieldCount: visibleFieldCount,
                serializeForm_serializeFnPresent: serializeFnPresent,
                serializeForm_serializedResultPresent: Boolean(serializedAnswer)
            };
            return serializedAnswer;
        }, this.checkIfFormIsDirty = (0, $4ZMmh.debounce)((values, initialValues, fields)=>{
            const copyValues = {
                ...values
            };
            const copyIntitalValues = {
                ...initialValues
            };
            const clearValues = (fieldId)=>{
                delete copyValues[fieldId];
                delete copyIntitalValues[fieldId];
            };
            // Organisation picker and rich text area is added to the values after page load so we need
            // to remove these for a deep equality check as it doesnt appear in the initialValues
            for (const f of fields){
                if (f.type === 'organisationpicker') {
                    delete copyValues[f.id];
                    delete copyIntitalValues[f.id];
                }
                if ((0, $lFpPv.isRichTextAreaEnabled)() && f.type === 'textarea') {
                    // Note: This will not render a dirty form warning when users replace rich text area default values with content of the same length
                    // object property order is not guaranteed to be the same in the stringified ADF values when they update so we can't do a simple equality check.
                    // this is preferred to alternatives like performing a deepEquals on the ADF structure, or normalizing the stringified ADF before comparing them
                    // because this is on a performance sensitive rendering path, and will work as expected for the vast majority of cases
                    // Suppressing existing violation. Please fix this.
                    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
                    const value = copyValues[f.id] ?? '';
                    // Suppressing existing violation. Please fix this.
                    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
                    const initial = copyIntitalValues[f.id] ?? '';
                    // TypeScript upgrade (v4.4.3). Please correct when you revisit this code.
                    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
                    if (initial.length === value.length) clearValues(f.id);
                }
            }
            // Remove recaptcha value when checking form is dirty - we don't want it to come up if they want
            // to leave.
            delete copyValues['g-recaptcha-response'];
            const isDirty = !(0, $4ZMmh.isEqual)(copyIntitalValues, copyValues);
            // While this isn't explicitly tested, it will result in an infinite loop without it.
            // Don't remove!
            if (this.state.isDirty !== isDirty) this.setState({
                isDirty: isDirty
            });
        }, $6853c130a8ba3447$export$23aadacdae45e79.DIRTY_CHECK_DEBOUNCE_MS), this.onToggleFormExpanded = ()=>{
            this.setState((prevState)=>({
                    isFormExpanded: !prevState.isFormExpanded
                }));
        }, this.getFieldErrors = (formInput)=>{
            const emptyRequiredFieldErrors = this.getEmptyRequiredFieldErrors(formInput);
            // Insight/CMDB field errors
            const cmdbOverLimitFieldErrors = this.getInsightFieldLimitErrors(formInput);
            const cmdbInvalidConfigFieldErrors = this.getInvalidConfigFieldErrors();
            // Affected Service field errors
            const affectedServiceFieldLimitErrors = this.getAffectedServicesFieldLimitErrors(formInput);
            return {
                ...emptyRequiredFieldErrors,
                ...cmdbOverLimitFieldErrors,
                ...cmdbInvalidConfigFieldErrors,
                ...affectedServiceFieldLimitErrors
            };
        }, this.ifForgeFormValid = (forgeData)=>{
            const forgeDataKeys = Object.keys(forgeData);
            return forgeDataKeys.filter((keys)=>forgeData[keys].isValid).length === forgeDataKeys.length;
        }, this.getRovoAnalyticsAttributes = (formInput, searchParams)=>{
            var _this$props$formData;
            if (!(0, $gdUUy.fg)('jsm_portal_rovo_integration')) return {};
            const prefillOverrides = ((_this$props$formData = this.props.formData) === null || _this$props$formData === void 0 ? void 0 : _this$props$formData.urlParamFieldValueOverrides) ?? {};
            const prefillFieldIds = Object.keys(prefillOverrides);
            const prefillFieldCount = prefillFieldIds.length;
            const isPrefillTriggeredByRovo = searchParams.has('rovoChatTriggeringAction');
            const prefillModifiedByUser = prefillFieldIds.some((fieldId)=>{
                // If the field was not submitted (e.g. conditionally hidden), treat it as unmodified
                if (!(fieldId in formInput)) return false;
                // Suppressing existing violation. Please fix this.
                // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
                const prefillValue = prefillOverrides[fieldId];
                // Suppressing existing violation. Please fix this.
                // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
                const submittedValue = formInput[fieldId];
                return JSON.stringify(prefillValue) !== JSON.stringify(submittedValue);
            });
            return {
                isPrefillTriggeredByRovo: isPrefillTriggeredByRovo,
                prefillFieldCount: prefillFieldCount,
                prefillFieldIds: prefillFieldIds,
                prefillModifiedByUser: prefillModifiedByUser
            };
        }, this.hasRequiredFields = ()=>{
            var _formData$fields;
            const { formData: formData } = this.props;
            return !!(formData !== null && formData !== void 0 && (_formData$fields = formData.fields) !== null && _formData$fields !== void 0 && _formData$fields.find((f)=>f.displayed && f.required));
        }, this.hasRequiredFieldsInProformaForm = ()=>{
            var _design;
            const { formData: formData } = this.props;
            const proformaForm = formData === null || formData === void 0 ? void 0 : formData.proformaTemplateForm;
            const formQuestions = proformaForm === null || proformaForm === void 0 || (_design = proformaForm.design) === null || _design === void 0 ? void 0 : _design.questions;
            let hasRequiredFields = false;
            for(const questionKey in formQuestions){
                var _formQuestions$questi;
                if ((_formQuestions$questi = formQuestions[questionKey]) !== null && _formQuestions$questi !== void 0 && (_formQuestions$questi = _formQuestions$questi.validation) !== null && _formQuestions$questi !== void 0 && _formQuestions$questi.rq) {
                    hasRequiredFields = true;
                    break;
                }
            }
            return hasRequiredFields;
        }, this.getEmptyRequiredFieldErrors = (formInput)=>{
            var _formData$fields2;
            const { formData: formData, intl: intl } = this.props;
            const requiredFields = formData === null || formData === void 0 || (_formData$fields2 = formData.fields) === null || _formData$fields2 === void 0 ? void 0 : _formData$fields2.filter((f)=>f.displayed && f.required);
            const invalidFields = Object.keys(formInput).reduce((fields, fieldId)=>{
                const invalidField = requiredFields === null || requiredFields === void 0 ? void 0 : requiredFields.find((f)=>{
                    // Suppressing existing violation. Please fix this.
                    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
                    const value = formInput[fieldId];
                    // check if value of form field is an empty array, it is an invalid value for a required field.
                    if (Array.isArray(value)) return f.id === fieldId && value.length === 0;
                    return f.id === fieldId && !Boolean(value);
                });
                return invalidField ? fields.concat(invalidField) : fields;
            }, []);
            return invalidFields.reduce((errors, field)=>{
                const invalidField = invalidFields.find((f)=>f.id === field.id);
                if (invalidField) // @ts-ignore TS(7053) TypeScript upgrade 5.1.6, please fix this violation when you revisit this code.: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
                errors[invalidField.id] = intl.formatMessage((0, $fnB99.default).fieldValidationError, {
                    fieldLabel: (field === null || field === void 0 ? void 0 : field.label) ?? ''
                });
                return errors;
            }, {});
        }, this.getAffectedServicesFieldLimitErrors = (formInput)=>{
            var _formData$fields3;
            const { formData: formData, intl: { formatMessage: formatMessage } } = this.props;
            const hasExceededLimit = (field)=>{
                var _formInput$field$id;
                return field.type === 'multiservicepicker' && Boolean(field.displayed) && // TypeScript upgrade (v4.4.3). Please correct when you revisit this code.
                // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
                ((_formInput$field$id = formInput[field.id]) === null || _formInput$field$id === void 0 ? void 0 : _formInput$field$id.length) > field.limit;
            };
            const limitExceededAffectedServiceFields = (formData === null || formData === void 0 || (_formData$fields3 = formData.fields) === null || _formData$fields3 === void 0 ? void 0 : _formData$fields3.filter(hasExceededLimit)) ?? [];
            return limitExceededAffectedServiceFields.reduce((total, current)=>({
                    ...total,
                    [current.id]: formatMessage((0, $fnB99.default).affectedServicesFieldLimitError, {
                        serviceLimit: current.limit
                    })
                }), {});
        }, this.getInsightFieldLimitErrors = (formInput)=>{
            var _formData$fields4;
            const { formData: formData, intl: intl } = this.props;
            // Filter the field type to be Cmdb Object Picker
            // and whether the cmdb object picker has exceeded its limit
            const hasExceededLimit = (field)=>{
                var _formInput$field$id2;
                return field.type === 'cmdbobjectpicker' && Boolean(field.displayed) && // TypeScript upgrade (v4.4.3). Please correct when you revisit this code.
                // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
                ((_formInput$field$id2 = formInput[field.id]) === null || _formInput$field$id2 === void 0 ? void 0 : _formInput$field$id2.length) > field.limit;
            };
            const limitExceededCmdbFields = (formData === null || formData === void 0 || (_formData$fields4 = formData.fields) === null || _formData$fields4 === void 0 ? void 0 : _formData$fields4.filter(hasExceededLimit)) ?? [];
            return limitExceededCmdbFields.reduce((errors, field)=>{
                errors[field.id] = intl.formatMessage((0, $fnB99.default).fieldLimitExceededError, {
                    objectLimit: field.limit
                });
                return errors;
            }, {});
        }, this.getInvalidConfigFieldErrors = ()=>{
            var _formData$fields5;
            const { formData: formData, intl: intl } = this.props;
            // Filter the field type to be cmdb object picker
            // and whether the REQUIRED cmdb object picker has a valid configuration
            const hasInvalidFieldConfiguration = (field)=>{
                return field.type === 'cmdbobjectpicker' && Boolean(field.required) && Boolean(field.displayed) && !field.hasValidConfig;
            };
            const invalidCmdbFields = (formData === null || formData === void 0 || (_formData$fields5 = formData.fields) === null || _formData$fields5 === void 0 ? void 0 : _formData$fields5.filter(hasInvalidFieldConfiguration)) ?? [];
            return invalidCmdbFields.reduce((errors, field)=>{
                errors[field.id] = intl.formatMessage((0, $fnB99.default).fieldInvalidConfigError);
                return errors;
            }, {});
        }, this.shareRequestWithMentionedUsers = (completeData, users, shareRequestAction, reporterId)=>{
            // add the share event for the addParticipants
            const usersWithoutReporter = users === null || users === void 0 ? void 0 : users.filter(([userId])=>userId !== reporterId);
            const idsOnly = (usersWithoutReporter === null || usersWithoutReporter === void 0 ? void 0 : usersWithoutReporter.map(([userId])=>userId)) || [];
            const usersLength = usersWithoutReporter === null || usersWithoutReporter === void 0 ? void 0 : usersWithoutReporter.length;
            const isSingleUser = usersLength === 1;
            const firstUser = (0, $4ZMmh.first)(usersWithoutReporter);
            const firstUserName = (0, $4ZMmh.last)(firstUser);
            if (usersLength) shareRequestAction(completeData.issueKey, [], [], idsOnly, true, isSingleUser ? firstUserName : undefined, true);
        }, this.getRichTextAnalytics = (formInput)=>{
            const { formData: formData } = this.props;
            const richTextFields = formData === null || formData === void 0 ? void 0 : formData.fields.filter((field)=>field.type === 'textarea' && field.rendererType === 'atlassian-wiki-renderer');
            const formFields = Object.keys(formInput);
            const filledFields = richTextFields === null || richTextFields === void 0 ? void 0 : richTextFields.filter((field)=>formFields.includes(field.id) && !!formInput[field.id]);
            return {
                shown: (richTextFields === null || richTextFields === void 0 ? void 0 : richTextFields.length) || 0,
                filled: (filledFields === null || filledFields === void 0 ? void 0 : filledFields.length) || 0
            };
        }, this.getEntitlementPickerAnalytics = (formInput)=>{
            var _this$props$formData2;
            const entitlementField = (_this$props$formData2 = this.props.formData) === null || _this$props$formData2 === void 0 ? void 0 : _this$props$formData2.fields.find((field)=>field.type === 'entitlementpicker');
            return {
                shown: !!entitlementField,
                filled: !!entitlementField && !!formInput[entitlementField === null || entitlementField === void 0 ? void 0 : entitlementField.id]
            };
        }, this.getUserMentions = (formInput)=>{
            var _this$props$formData3;
            const adfFields = (_this$props$formData3 = this.props.formData) === null || _this$props$formData3 === void 0 ? void 0 : _this$props$formData3.fields.filter((field)=>field.type === 'textarea' && field.rendererType === 'atlassian-wiki-renderer');
            try {
                const accountIds = adfFields === null || adfFields === void 0 ? void 0 : adfFields.reduce((accIds, field)=>{
                    // Suppressing existing violation. Please fix this.
                    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
                    const content = formInput[field.id];
                    if (!content) return accIds;
                    const adfFieldContent = (0, $2Zepk.parseAdf)(content);
                    const userIds = Array.from((0, $2Zepk.getAccountIdsFromComment)(adfFieldContent));
                    return accIds.concat(userIds);
                }, []);
                return accountIds;
            } catch  {
                return [];
            }
        }, this.onSubmit = async (formInput)=>{
            const { portalId: portalId, requestTypeId: requestTypeId, xsrfToken: xsrfToken, projectId: projectId, contactLink: contactLink, userAuthenticated: userAuthenticated, analyticsPayload: analyticsPayload, isProjectAdmin: isProjectAdmin, isProjectSimplified: isProjectSimplified, projectKey: projectKey, intl: intl, shareRequestAction: shareRequestAction, createAnalyticsEvent: createAnalyticsEvent, showSuccessFlagAction: showSuccessFlagAction, showWarningFlagAction: showWarningFlagAction } = this.props;
            this.formSubmissionId = (0, $eL3zl.v4)();
            this.proformaSerializationTraceAttributes = {
                registerProformaForm_invoked: this.proformaSerializationTraceAttributes.registerProformaForm_invoked,
                renderForm_completed: this.proformaSerializationTraceAttributes.renderForm_completed
            };
            (0, $5oBRG.traceProformaSerialization)((0, $5oBRG.ProformaSerializationTraceStep).PreSubmit, {
                ...this.getProformaTraceBaseAttributes(),
                ...this.proformaSerializationTraceAttributes
            });
            this.setState({
                submitting: true
            });
            const resolveStatus = await this.resolveForgeCustomFields();
            if (resolveStatus === (0, $dQ3Zn.FORM_SUBMISSION_RE_SUBMIT_AND_PROCEED)) {
                var _this$formRef;
                // Re-submitting the form this way to have function arguments updated with the latest values.
                (_this$formRef = this.formRef) === null || _this$formRef === void 0 || (_this$formRef = _this$formRef.current) === null || _this$formRef === void 0 || _this$formRef.requestSubmit();
                return;
            }
            const fieldErrors = this.getFieldErrors(formInput);
            const isFormValid = (0, $4ZMmh.isEmpty)(fieldErrors) && this.ifForgeFormValid(this.state.forgeFormData);
            const richTextAnalyticsPayload = (0, $lFpPv.isRichTextAreaEnabled)() ? this.getRichTextAnalytics(formInput) : undefined;
            const entitlementPickerAnalyticsPayload = this.getEntitlementPickerAnalytics(formInput);
            const searchParams = new URLSearchParams((0, $gYDJY.search)());
            const isProformaFormValid = this.validateProformaFormFields();
            if (!isFormValid) {
                this.setState((previousState)=>({
                        submitting: false,
                        errors: {
                            ...previousState.errors,
                            fieldErrors: fieldErrors
                        }
                    }));
                this.focusFirstErrorField(fieldErrors);
                return;
            }
            if (!isProformaFormValid) {
                this.setState({
                    submitting: false
                });
                this.focusElement('[data-testid="proforma-form"]', {
                    useSelector: true
                });
                return;
            }
            if (portalId && requestTypeId && xsrfToken && projectId) {
                this.setState({
                    submitting: true
                });
                try {
                    const connectRequestProperties = this.props.onSubmit && await this.props.onSubmit() || [];
                    const forgeRequestProperties = (0, $4ZMmh.map)(this.state.forgeFormData, (value, key)=>({
                            [key]: value
                        }));
                    const requestProperties = [
                        ...connectRequestProperties,
                        ...forgeRequestProperties
                    ];
                    let serializedRequestProperties;
                    try {
                        serializedRequestProperties = JSON.stringify(requestProperties.reduce((acc, data)=>({
                                ...acc,
                                ...(0, $4ZMmh.mapValues)(data, JSON.stringify)
                            }), {}));
                    } catch (error) {
                        (0, $jBiia.trackError)('Failed to serialize request properties.', {}, error);
                    }
                    const newFormInputs = {
                        ...formInput,
                        ...requestProperties.length && {
                            requestProperties: serializedRequestProperties
                        }
                    };
                    const serializedProformaFormData = this.serializeProformaFormFields();
                    const proformaFormDataForRequest = serializedProformaFormData ? {
                        answers: serializedProformaFormData.answers,
                        templateFormId: serializedProformaFormData.templateFormId
                    } : undefined;
                    // If a Proforma form is expected but the serialized output is empty, the form data
                    // is silently omitted from the outgoing request body. Include the parent-owned
                    // diagnostics only for this unexpected failure.
                    if (this.props.hasProformaForm && !serializedProformaFormData) (0, $5oBRG.traceProformaSerialization)((0, $5oBRG.ProformaSerializationTraceStep).PostSerialization, {
                        ...this.getProformaTraceBaseAttributes(),
                        ...this.proformaSerializationTraceAttributes
                    });
                    const { issue: issue, issueType: issueType, requestDetailsBaseUrl: requestDetailsBaseUrl, key: issueKey } = await (0, $9GQhj.createRequest)(portalId, requestTypeId, projectId, xsrfToken, newFormInputs, proformaFormDataForRequest);
                    if ((0, $gdUUy.fg)('jsm_portal_rovo_integration') && searchParams.has('rovoChatTriggeringAction')) {
                        // Notify Rovo Chat about successful request creation
                        const portalRequestURL = `${window.location.origin}${requestDetailsBaseUrl}`;
                        (0, $2r1Ci.notifyRovoRequestCreated)(portalRequestURL, searchParams.get('rovoChatTriggeringAction') || '');
                    }
                    // Suppressing existing violation. Please fix this.
                    const completeData = {
                        issueKey: issueKey,
                        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
                        email: userAuthenticated ? undefined : formInput.email
                    };
                    let analyticsMentions;
                    // we send the participants to request details page only when the user is logged in
                    if (userAuthenticated) {
                        const usersMentionedInDescription = this.getUserMentions(formInput);
                        this.shareRequestWithMentionedUsers(completeData, usersMentionedInDescription, shareRequestAction, formInput === null || formInput === void 0 ? void 0 : formInput.reporter);
                        analyticsMentions = {
                            mentionedUsersLength: usersMentionedInDescription === null || usersMentionedInDescription === void 0 ? void 0 : usersMentionedInDescription.length
                        };
                    }
                    this.props.notifySuccess();
                    if (showSuccessFlagAction) {
                        if (this.state.failedOrTimedOutForgeCustomFields.length > 0) showWarningFlagAction((0, $fnB99.default).requestSubmittedFcfWarningTitle, (0, $fnB99.default).requestSubmittedFcfWarningMessageDescription, undefined, undefined, {
                            field: this.state.failedOrTimedOutForgeCustomFields.join(', ')
                        });
                        else if (projectKey && issueKey && isProjectAdmin && !isProjectSimplified) showSuccessFlagAction((0, $fnB99.default).requestSubmittedMessage, {}, (0, $fnB99.default).requestSubmittedDescription, [
                            {
                                contentNode: /*#__PURE__*/ $bSJIT.createElement((0, $2OuWT.Link), {
                                    // eslint-disable-next-line rulesdir/do-not-manually-build-jsm-agent-view-url
                                    href: `/jira/servicedesk/projects/${projectKey}/issue/${issueKey}`,
                                    target: "_blank",
                                    actionSubjectId: "viewWorkItemFromPortalSuccessPopup"
                                }, /*#__PURE__*/ $bSJIT.createElement((0, $2IITT.Inline), {
                                    space: "space.050",
                                    alignBlock: "center"
                                }, intl.formatMessage((0, $fnB99.default).requestSubmittedAction), /*#__PURE__*/ $bSJIT.createElement((0, (/*@__PURE__*/$parcel$interopDefault($92LrB))), {
                                    label: ''
                                })))
                            }
                        ]);
                        else showSuccessFlagAction((0, $fnB99.default).requestSubmittedMessage);
                    }
                    if (createAnalyticsEvent) {
                        const rovoAnalyticsAttributes = this.getRovoAnalyticsAttributes(formInput, searchParams);
                        (0, $gEVth.trackIssueEventNext)({
                            projectId: projectId,
                            issueId: issue.id,
                            action: 'created',
                            attributes: {
                                ...rovoAnalyticsAttributes,
                                ...analyticsMentions,
                                requestTypeId: String(requestTypeId),
                                portalId: String(portalId),
                                issueTypeId: String(issueType),
                                richTextEditorShown: richTextAnalyticsPayload === null || richTextAnalyticsPayload === void 0 ? void 0 : richTextAnalyticsPayload.shown,
                                richTextEditorFilled: richTextAnalyticsPayload === null || richTextAnalyticsPayload === void 0 ? void 0 : richTextAnalyticsPayload.filled,
                                entitlementPickerShown: entitlementPickerAnalyticsPayload === null || entitlementPickerAnalyticsPayload === void 0 ? void 0 : entitlementPickerAnalyticsPayload.shown,
                                entitlementPickerFilled: entitlementPickerAnalyticsPayload === null || entitlementPickerAnalyticsPayload === void 0 ? void 0 : entitlementPickerAnalyticsPayload.filled,
                                createdWithinEmbedWindow: this.props.isEmbeddedRoute,
                                requestFormSource: searchParams.get('source') ?? '',
                                hasProformaForm: this.props.hasProformaForm
                            }
                        }, analyticsPayload.user, createAnalyticsEvent, analyticsPayload.portal);
                    }
                    this.setState({
                        complete: completeData
                    });
                } catch (errors) {
                    const { submissionError: submissionError, traceId: traceId, fieldErrors: fieldErrorsReceived } = errors;
                    const shouldNotifyFAMAFailure = submissionError === null || submissionError === void 0 ? void 0 : submissionError.isGeneric;
                    if (shouldNotifyFAMAFailure) {
                        if (submissionError !== null && submissionError !== void 0 && submissionError.statusCode) this.props.notifyFailure(`Failed to submit form (${String(submissionError.statusCode).charAt(0)}xx error): ${JSON.stringify({
                            submissionError: submissionError,
                            fieldErrors: fieldErrorsReceived
                        })}`, traceId);
                        else this.props.notifyFailure(`Unknown Exception: Failed to submit form (5xx error): ${JSON.stringify({
                            submissionError: submissionError,
                            fieldErrors: fieldErrorsReceived
                        })}`, traceId);
                    } else (0, $gEVth.trackRequestCreateNonGenericErrors)(errors, createAnalyticsEvent);
                    if (!this.isUnmounted) // We use this count as a unique key to make sure the error message autofocuses on every error
                    this.setState((previousState)=>({
                            submissionErrorCount: submissionError ? previousState.submissionErrorCount + 1 : previousState.submissionErrorCount,
                            // Suppressing existing violation. Please fix this.
                            // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
                            errors: {
                                ...errors,
                                contactLink: contactLink
                            },
                            submitting: false,
                            isFormExpanded: true
                        }));
                }
                this.props.onSubmitComplete && this.props.onSubmitComplete();
            }
        }, this.disableSubmitButton = ()=>{
            this.setState({
                submitDisabled: true
            });
        }, this.preloadRequestDetails = ()=>{
            // this check is added to fix the chunk load issue in fedramp environment for preloaded script
            if ((0, $9hihM.isFedRamp) && (0, $9hihM.isFedRamp)()) return;
            (0, $7VUtk.default).preload();
        }, this.enableSubmitButton = ()=>{
            this.setState({
                submitDisabled: false
            });
        }, this.blockFormSubmission = (blocking)=>{
            this.setState({
                isAttachmentUploading: blocking
            });
        }, this.registerProformaForm = (validateProformaForm, serializeProformaForm)=>{
            this.validateProformaForm = validateProformaForm;
            this.serializeProformaForm = serializeProformaForm;
            this.proformaSerializationTraceAttributes = {
                ...this.proformaSerializationTraceAttributes,
                registerProformaForm_invoked: true
            };
        }, this.onProformaFormRendered = ()=>{
            this.proformaSerializationTraceAttributes = {
                ...this.proformaSerializationTraceAttributes,
                renderForm_completed: true
            };
        }, this.setResolveForgeCustomFields = (fn)=>{
            this.setState({
                resolveForgeCustomFields: fn
            });
        }, this.setFailedOrTimedOutForgeCustomFields = (fields)=>{
            this.setState({
                failedOrTimedOutForgeCustomFields: fields
            });
        }, this.resolveForgeCustomFields = async ()=>{
            return this.state.resolveForgeCustomFields();
        }, /**
   * Focuses an element by ID or selector, with automatic retry logic.
   * Uses the form ref to scope queries (more React-idiomatic than document queries).
   * Uses requestAnimationFrame to sync with browser paint cycles instead of arbitrary timeouts.
   */ this.focusElement = (identifier, options = {})=>{
            const { useSelector: useSelector = false, retries: retries = 2, scrollBehavior: scrollBehavior = 'smooth', scrollBlock: scrollBlock = 'center' } = options;
            const focusAndScroll = (element)=>{
                element.focus();
                element.scrollIntoView({
                    behavior: scrollBehavior,
                    block: scrollBlock
                });
            };
            const attemptFocus = (retriesLeft)=>{
                let element = null;
                // Try to find element within the form first (scoped to our component)
                if (this.formRef.current) element = useSelector ? this.formRef.current.querySelector(identifier) : this.formRef.current.querySelector(`#${identifier}`);
                if (element) {
                    focusAndScroll(element);
                    return;
                }
                // Retry if element not yet in DOM (for slow renders)
                if (retriesLeft > 0) requestAnimationFrame(()=>attemptFocus(retriesLeft - 1));
            };
            // Use requestAnimationFrame to wait for next paint cycle
            requestAnimationFrame(()=>attemptFocus(retries));
        }, this.focusFirstErrorField = (fieldErrors)=>{
            var _Object$keys;
            const firstErrorFieldId = (_Object$keys = Object.keys(fieldErrors)) === null || _Object$keys === void 0 ? void 0 : _Object$keys[0];
            if (!firstErrorFieldId) return;
            this.focusElement(firstErrorFieldId);
        }, this.renderForm = ({ values: values, initialValues: initialValues, setFieldValue: setFieldValue, handleSubmit: handleSubmit })=>{
            const { formData: formData, onFieldChangedByUser: onFieldChangedByUser, accountId: accountId, portalId: portalId, requestTypeId: requestTypeId, projectId: projectId, canCreateUsers: canCreateUsers, dateFormat: dateFormat, dateTimeFormat: dateTimeFormat, firstDay: firstDay, useISO8601WeekNumbers: useISO8601WeekNumbers, isDirtyCheckDisabled: isDirtyCheckDisabled, hasProformaForm: hasProformaForm, proformaFormIsDirty: proformaFormIsDirty, intl: intl, locale: locale } = this.props;
            // TODO: Move this into <Formik /> when upgraded to formik@1.x.x
            // See: https://github.com/jaredpalmer/formik#the-gist
            const { errors: errors, submitting: submitting, submitDisabled: submitDisabled, submissionErrorCount: submissionErrorCount, isAttachmentUploading: isAttachmentUploading } = this.state;
            if (!portalId || !requestTypeId || !formData) return null;
            const { fields: fields, form: form, knowledgeBase: knowledgeBase } = formData;
            if (!form) return null;
            if (fields !== undefined) this.checkIfFormIsDirty(values, initialValues, fields);
            // We use any for value here to maintain consistency with the type signature for setFieldValue
            const onFieldChange = (field, value, notFromUserInteraction, additionalFieldData)=>{
                if (!notFromUserInteraction) {
                    (0, $gEVth.firstInteraction)({
                        actionSubject: (0, $gEVth.AnalyticsActionSubjects).FORM,
                        source: 'portalScreen',
                        isNewPortal: true
                    });
                    // on user interaction, clear Forge UIM field override
                    onFieldChangedByUser === null || onFieldChangedByUser === void 0 || onFieldChangedByUser({
                        field: field,
                        notFromUserInteraction: notFromUserInteraction,
                        additionalFieldData: additionalFieldData,
                        value: value
                    });
                }
                return setFieldValue(field, value);
            };
            const onCancel = ()=>{
                const cancelPath = (0, $hCnLH.getIsHelpHub)() ? `/portal/${portalId}` : `/portal/${portalId}/group/-1`;
                if ((0, $hCnLH.getIsHelpHub)() && (0, $lFpPv.isRequestFormCancelGoBackEnabled)() && (0, $c7bWK.canNavigateBackFromRequestCreate)()) {
                    (0, $eDcdn.default).goBack();
                    return;
                }
                (0, $eDcdn.default).push(cancelPath);
            };
            const updateForgeRequestPropertyData = (payload)=>{
                this.setState((prevState)=>({
                        forgeFormData: {
                            ...prevState.forgeFormData,
                            [payload.extensionId]: payload.data
                        }
                    }));
            };
            const preventNavigation = (this.state.isDirty || proformaFormIsDirty) && !isDirtyCheckDisabled;
            return /*#__PURE__*/ $bSJIT.createElement($bSJIT.Fragment, null, (0, $lFpPv.isUiModificationsSupportEnabled)() && /*#__PURE__*/ $bSJIT.createElement($bSJIT.Fragment, null, /*#__PURE__*/ $bSJIT.createElement((0, $chubD.UiModificationsSectionsMessages), null), /*#__PURE__*/ $bSJIT.createElement((0, $kcqdg.UiModificationsFormValuesApplier), {
                fieldValues: values,
                setFieldValue: setFieldValue,
                fields: fields
            })), /*#__PURE__*/ $bSJIT.createElement((0, $pj5PM.ForgeCustomFieldsResolver), {
                setResolve: this.setResolveForgeCustomFields,
                setFailedOrTimedOut: this.setFailedOrTimedOutForgeCustomFields,
                requestTypeId: requestTypeId,
                fields: fields
            }), /*#__PURE__*/ $bSJIT.createElement((0, $gLV5g.default), {
                accountId: accountId,
                canCreateUsers: canCreateUsers,
                projectId: projectId,
                portalId: portalId,
                requestTypeId: requestTypeId,
                knowledgeBase: knowledgeBase,
                fields: fields,
                fieldValues: values,
                urlParamFieldValueOverrides: formData.urlParamFieldValueOverrides,
                onFieldChange: onFieldChange,
                onFieldBlurredByUser: this.props.onFieldBlurredByUser,
                onCancel: onCancel,
                onSubmit: handleSubmit,
                errors: errors,
                submissionErrorCount: submissionErrorCount,
                submitting: submitting,
                submitDisabled: submitDisabled,
                captchaEnabled: form.captchaEnabled,
                sitekey: form.sitekey,
                enableSubmitButton: this.enableSubmitButton,
                disableSubmitButton: this.disableSubmitButton,
                onHoverSubmitButton: this.preloadRequestDetails,
                onToggleFormExpanded: this.onToggleFormExpanded,
                isFormExpanded: this.state.isFormExpanded,
                dateFormat: dateFormat,
                dateTimeFormat: dateTimeFormat,
                firstDay: firstDay,
                useISO8601WeekNumbers: useISO8601WeekNumbers,
                isAttachmentUploading: isAttachmentUploading,
                blockFormSubmission: this.blockFormSubmission,
                registerProformaForm: hasProformaForm ? this.registerProformaForm : undefined,
                onProformaFormRendered: this.onProformaFormRendered,
                locale: locale ? locale : intl.locale,
                updateForgeRequestPropertyData: updateForgeRequestPropertyData,
                formRef: this.formRef,
                proformaField: this.props.proformaField
            }), /*#__PURE__*/ $bSJIT.createElement((0, $oDZyG.default), {
                preventNavigation: preventNavigation
            }));
        };
    }
}
const $6853c130a8ba3447$var$selector = (0, $BOq7h.createSelector)((state, props)=>{
    const accountId = (0, $aI0YR.getAccountId)(state);
    const portalId = (0, $aYbXa.toNumber)(props.portalId);
    const requestTypeId = (0, $aYbXa.toNumber)(props.requestTypeId);
    const xsrfToken = (0, $6GvED.getXsrfToken)(state);
    const contactLink = (0, $6GvED.getContactLink)(state);
    const userAuthenticated = (0, $aI0YR.isLoggedIn)(state);
    const canAdministerJira = (0, $aI0YR.getCanAdministerJIRA)(state);
    const locale = (0, $aI0YR.getLocale)(state).trim();
    let formData;
    let projectId;
    let dateFormat;
    let dateTimeFormat;
    let canCreateUsers = false;
    let firstDay;
    let useISO8601WeekNumbers;
    let hasProformaForm;
    let proformaFormIsDirty = false;
    let error = false;
    let projectKey;
    let isProjectAdmin = false;
    let isProjectSimplified;
    let isPrefillPending = false;
    if (portalId && requestTypeId) {
        const requestData = (0, $ay2XP.getRequestCreateOrError)(state, portalId, requestTypeId);
        formData = requestData && 'error' in requestData ? undefined : requestData;
        error = !!(requestData && 'error' in requestData) ? true : false;
        canCreateUsers = (0, $ay2XP.getCanCreateUsers)(state, portalId, requestTypeId);
        dateFormat = (0, $ay2XP.getDateFormat)(state, portalId, requestTypeId);
        dateTimeFormat = (0, $ay2XP.getDateTimeFormat)(state, portalId, requestTypeId);
        firstDay = (0, $ay2XP.getFirstDay)(state, portalId, requestTypeId);
        useISO8601WeekNumbers = (0, $ay2XP.getUseISO8601WeekNumbers)(state, portalId, requestTypeId);
        projectId = (0, $aYbXa.toString)((0, $ay2XP.getProjectId)(state, portalId, requestTypeId));
        hasProformaForm = (0, $ay2XP.getRequestTypeHasProformaForm)(state, portalId, requestTypeId);
        proformaFormIsDirty = (0, $ay2XP.getIsProformaFormDirty)(state, portalId, requestTypeId);
        if ((0, $gdUUy.fg)('jsm_portal_rovo_integration')) isPrefillPending = (0, $ay2XP.getIsPrefillPending)(state, portalId, requestTypeId);
        projectKey = (0, $ik9zp.getProjectKey)(state, portalId);
        isProjectSimplified = (0, $ik9zp.getIsProjectSimplified)(state, portalId);
        isProjectAdmin = (0, $ik9zp.getCanAdministerProject)(state, portalId) ?? false;
    }
    const analyticsPayload = (0, $6NtVd.getIssueAnalyticsContext)(state, portalId);
    return {
        accountId: accountId,
        portalId: portalId,
        requestTypeId: requestTypeId,
        formData: formData,
        xsrfToken: xsrfToken,
        projectId: projectId,
        contactLink: contactLink,
        canCreateUsers: canCreateUsers,
        dateFormat: dateFormat,
        dateTimeFormat: dateTimeFormat,
        firstDay: firstDay,
        useISO8601WeekNumbers: useISO8601WeekNumbers,
        userAuthenticated: userAuthenticated,
        analyticsPayload: analyticsPayload,
        hasProformaForm: hasProformaForm,
        proformaFormIsDirty: proformaFormIsDirty,
        canAdministerJira: canAdministerJira,
        locale: locale,
        error: error,
        projectKey: projectKey,
        isProjectSimplified: isProjectSimplified,
        isProjectAdmin: isProjectAdmin,
        isPrefillPending: isPrefillPending
    };
}, (requestFormData)=>requestFormData);
const $6853c130a8ba3447$var$RequestCreateFormWithAnalyticsNextOld = (0, $egQxE.connect)($6853c130a8ba3447$var$selector, {
    fetchRequestCreate: (0, $1biTA.fetchRequestCreateAction),
    shareRequestAction: (0, $bkU3q.shareRequest),
    showSuccessFlagAction: (0, $xb2jO.showSuccessFlag),
    showWarningFlagAction: (0, $xb2jO.showWarningFlag)
})((0, $2usNr.default)({
    source: 'portalScreen'
})((0, $kIbto.default)()((0, $9MGCy.default)((0, $fK3tS.default)($6853c130a8ba3447$export$23aadacdae45e79)))));
const $6853c130a8ba3447$var$RequestCreateFormWithAnalyticsNextNew = (0, $egQxE.connect)($6853c130a8ba3447$var$selector, {
    fetchRequestCreate: (0, $1biTA.fetchRequestCreateAction),
    shareRequestAction: (0, $bkU3q.shareRequest),
    showSuccessFlagAction: (0, $xb2jO.showSuccessFlag),
    showWarningFlagAction: (0, $xb2jO.showWarningFlag)
})((0, $2usNr.default)({
    source: 'portalScreen'
})((0, $kIbto.default)()((0, $9MGCy.default)((0, $fK3tS.default)((0, $if8pw.withUiModificationsFormDecorator)()($6853c130a8ba3447$export$23aadacdae45e79))))));
var $6853c130a8ba3447$export$2e2bcd8739ae039 = (0, $l6qfM.componentWithCondition)((0, $lFpPv.isUiModificationsSupportEnabled), $6853c130a8ba3447$var$RequestCreateFormWithAnalyticsNextNew, $6853c130a8ba3447$var$RequestCreateFormWithAnalyticsNextOld);
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $6853c130a8ba3447$var$Root = /*#__PURE__*/ (0, $4v2A7.default).div.withConfig({
    componentId: "sc-bucp0v-0"
})`position:relative;min-height:${$9K7mZ.multiple(50).px};`;

});
parcelRegister("9GQhj", function(module, exports) {
$parcel$export(module.exports, "createRequest", () => $f9e471b14202e401$export$72e3afa9ac8966be);

var $llRGw = parcelRequire("llRGw");

var $4ZMmh = parcelRequire("4ZMmh");

var $h92tT = parcelRequire("h92tT");

var $eDcdn = parcelRequire("eDcdn");
const $f9e471b14202e401$export$72e3afa9ac8966be = (portalId, requestId, projectId, xsrfToken, formInput, proformaFormInput)=>{
    const url = `${(0, $eDcdn.contextPath)}${(0, $eDcdn.getRelativeBasePath)()}/portal/${portalId}/create/${requestId}`;
    const body = $f9e471b14202e401$var$serializeFormInput(formInput, projectId, xsrfToken, proformaFormInput);
    const headers = {
        'Content-Type': 'application/x-www-form-urlencoded;'
    };
    return (0, $llRGw.post)(url, body, headers).map(({ response: response })=>response).toPromise().catch((err)=>$f9e471b14202e401$var$handleSubmissionErrors(err));
};
/** Turns a potentially undefined or null input and outputs a string */ const $f9e471b14202e401$var$handleUndefinedInput = (input)=>!(0, $4ZMmh.isNil)(input) ? input : '';
const $f9e471b14202e401$export$36be7bd82d456d61 = (fieldId, fieldValue)=>{
    let result = [];
    // If fieldValue is undefined or null it'll be sent as an empty string
    const value = $f9e471b14202e401$var$handleUndefinedInput(fieldValue);
    // If the value is an array we want to handle it, each value of the array will be added as a separate entry
    // all with the same field id
    if (Array.isArray(value)) {
        if (fieldId === 'attachment') value.forEach((val)=>{
            result.push({
                name: 'filetoconvert',
                value: val.id
            });
        });
        else value.forEach((val)=>{
            result.push({
                name: fieldId,
                value: $f9e471b14202e401$var$handleUndefinedInput(val)
            });
        });
        return result;
    }
    if ((0, $4ZMmh.has)(value, 'children')) {
        // For nested fields like cascading select, we add both the value of the primary select as well
        // as the value of any nested children. The field id of child field is the field id of the primary field
        // appended with ':1'
        const { primaryValue: primaryValue, children: children } = value;
        result.push({
            name: fieldId,
            value: $f9e471b14202e401$var$handleUndefinedInput(primaryValue)
        });
        result = result.concat($f9e471b14202e401$export$36be7bd82d456d61(`${fieldId}:1`, children));
        return result;
    }
    // If the field is neither an object nor an array we will serialise the value into a string, undefined and null
    // values will be sent too as empty strings
    result.push({
        value: value,
        name: fieldId
    });
    return result;
};
// Some fields require mulitple values for the same key - which can't be handled by a plain JS object.
// here fieldValues is an array with the shape [ { fieldId: fieldValue } ], which gets transformed into a x-www-form-urlencoded string.
function $f9e471b14202e401$var$serializeFormInput(formInput, projectId, xsrfToken, proformaFormInput) {
    const fieldValues = Object.keys(formInput).reduce((result, fieldId)=>result.concat($f9e471b14202e401$export$36be7bd82d456d61(fieldId, formInput[fieldId])), []);
    fieldValues.push({
        name: 'atl_token',
        value: xsrfToken
    });
    fieldValues.push({
        name: 'projectId',
        value: projectId
    });
    const formUrlEncoded = fieldValues.map(({ name: name, value: value })=>{
        return `${encodeURIComponent(name)}=${encodeURIComponent(value)}`;
    }).join('&');
    // Append proforma form fields JSON if there is a proforma form in this request type.
    if (proformaFormInput) return `${formUrlEncoded}&proformaFormData=${encodeURIComponent(JSON.stringify(proformaFormInput))}`;
    return formUrlEncoded;
}
function $f9e471b14202e401$var$handleSubmissionErrors({ response: response, xhr: xhr, ...err }) {
    const DEFAULT_ERROR_MESSAGES = [];
    const errorMessages = (0, $4ZMmh.get)(response, 'errors', DEFAULT_ERROR_MESSAGES);
    const errorReasonKey = (0, $4ZMmh.get)(response, 'reasonKey', undefined);
    const RATE_LIMITING_STATUS_CODE = 429;
    const fieldErrorsList = errorMessages.filter((error)=>!!error.field);
    const submissionErrors = errorMessages.filter((error)=>!error.field);
    const hasFieldErrors = fieldErrorsList.length > 0;
    const hasSubmissionError = submissionErrors.length > 0;
    const fieldErrors = hasFieldErrors ? fieldErrorsList.reduce((allErrors, error)=>{
        allErrors[error.field] = error.errorMessage;
        return allErrors;
    }, {}) : {};
    const traceId = xhr.getResponseHeader('Atl-Traceid');
    if (hasSubmissionError) // oxlint-disable-next-line prefer-promise-reject-errors
    return Promise.reject({
        fieldErrors: fieldErrors,
        errorReasonKey: errorReasonKey,
        traceId: traceId,
        submissionError: submissionErrors[0]
    });
    if (hasFieldErrors) // Suppressing existing violation. Please fix this.
    // oxlint-disable-next-line prefer-promise-reject-errors
    return Promise.reject({
        fieldErrors: fieldErrors,
        errorReasonKey: errorReasonKey,
        traceId: traceId,
        submissionError: undefined
    });
    if (err.status === 0) // oxlint-disable-next-line prefer-promise-reject-errors
    return Promise.reject({
        fieldErrors: fieldErrors,
        traceId: traceId,
        submissionError: {
            isOfflineError: true
        }
    });
    /* Any errors between Status code 400 and 499 are considered client errors. */ const isClientError = (0, $h92tT.isClientErrorCode)(err.status);
    const isThrottled = err.status === RATE_LIMITING_STATUS_CODE;
    /* If the traceId is null, that means that the request never reached Atlassian network.
     So, we will not log it as an error since its not from our systems. */ const hasEmptyTraceId = traceId === null;
    const isGeneric = !(isThrottled || isClientError || hasEmptyTraceId);
    const submissionError = {
        isGeneric: isGeneric,
        statusCode: err.status
    };
    // oxlint-disable-next-line prefer-promise-reject-errors
    return Promise.reject({
        fieldErrors: fieldErrors,
        submissionError: submissionError,
        traceId: traceId
    });
}

});

parcelRegister("67fJ8", function(module, exports) {
$parcel$export(module.exports, "ConnectFields", () => $178cb8bbc5d596b9$export$724cef702e79a3fb);
$parcel$export(module.exports, "withConnectFieldSupport", () => (parcelRequire("9MGCy")).default);

var $egQxE = parcelRequire("egQxE");

var $BOq7h = parcelRequire("BOq7h");

var $1Gp5B = parcelRequire("1Gp5B");

var $84x3k = parcelRequire("84x3k");

var $2usNr = parcelRequire("2usNr");

var $kIbto = parcelRequire("kIbto");

var $kP5tW = parcelRequire("kP5tW");
parcelRequire("lrQHI");
var $fLZ30 = parcelRequire("fLZ30");
parcelRequire("5rlOh");
var $9MGCy = parcelRequire("9MGCy");
const $178cb8bbc5d596b9$export$aea217a45095ce11 = (0, $BOq7h.createSelector)((state, props)=>(0, $84x3k.getConnectAddonPanels)({
        state: state,
        pageName: 'CREATE_REQUEST',
        location: 'propertyPanels',
        portalId: props.portalId,
        requestTypeId: props.requestTypeId
    }), (connectFragments)=>({
        connectFragments: connectFragments
    }));
const $178cb8bbc5d596b9$export$724cef702e79a3fb = (0, $2usNr.default)({
    componentName: 'ConnectFields'
})((0, $kIbto.default)({})((0, $egQxE.connect)($178cb8bbc5d596b9$export$aea217a45095ce11, {
    fetchConnectFragments: (0, $1Gp5B.fetchConnectFragmentsAction)
})((0, $fLZ30.asConnectFields)((0, $kP5tW.default)))));

});
parcelRegister("kP5tW", function(module, exports) {
$parcel$export(module.exports, "default", () => $3817876f4b2e4ca4$export$2e2bcd8739ae039);

var $bSJIT = parcelRequire("bSJIT");

var $4v2A7 = parcelRequire("4v2A7");

var $haAAx = parcelRequire("haAAx");

var $gEVth = parcelRequire("gEVth");

var $hbEJt = parcelRequire("hbEJt");
parcelRequire("2YGTn");
var $bqaN9 = parcelRequire("bqaN9");
class $3817876f4b2e4ca4$var$ConnectFields extends $bSJIT.PureComponent {
    componentDidMount() {
        const { fetchConnectFragments: fetchConnectFragments, connectFragments: connectFragments, requestTypeId: requestTypeId, portalId: portalId } = this.props;
        if (!connectFragments) {
            fetchConnectFragments({
                portalId: portalId,
                requestTypeId: requestTypeId,
                portalPage: 'CREATE_REQUEST'
            });
            this.fireConnectFragmentsDataFetchAnalytics();
        } else this.fireConnectFragmentAnalytics();
        this.props.onConnectFieldMount(this);
    }
    componentDidUpdate(prevProps) {
        const { fetchConnectFragments: fetchConnectFragments, connectFragments: connectFragments, requestTypeId: requestTypeId, portalId: portalId } = this.props;
        const requestTypeUpdated = prevProps.requestTypeId !== requestTypeId || prevProps.portalId !== portalId;
        if (requestTypeUpdated) fetchConnectFragments({
            portalId: portalId,
            requestTypeId: requestTypeId,
            portalPage: 'CREATE_REQUEST'
        });
        if (!prevProps.connectFragments && connectFragments) this.fireConnectFragmentAnalytics();
        else if (prevProps.connectFragments && connectFragments) {
            const previouslyErrored = 'error' in prevProps.connectFragments;
            const currentlyErrored = 'error' in connectFragments;
            if (previouslyErrored !== currentlyErrored) this.fireConnectFragmentAnalytics();
        }
    }
    render() {
        const { connectFragments: connectFragments, className: className, location: location } = this.props;
        if (!!connectFragments && !('error' in connectFragments) && connectFragments.length) return(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Disabled to rollout go/ui-styling-standard tooling, please resolve
        /*#__PURE__*/ $bSJIT.createElement($3817876f4b2e4ca4$var$Root, {
            className: className
        }, connectFragments.map((fragment)=>/*#__PURE__*/ $bSJIT.createElement((0, $bqaN9.default), {
                ref: this.onRef,
                key: fragment.key,
                connectKey: fragment.key,
                fragmentHtml: fragment.html,
                location: location
            }))));
        return null;
    }
    constructor(...args){
        super(...args), this.connectFieldRefs = [], this.fireConnectFragmentsDataFetchAnalytics = ()=>{
            const { createAnalyticsEvent: createAnalyticsEvent, location: location } = this.props;
            if (createAnalyticsEvent) {
                const analyticsEvent = createAnalyticsEvent({
                    location: location,
                    analyticsType: (0, $haAAx.OPERATIONAL_EVENT_TYPE),
                    action: 'data_fetched'
                });
                // Hack to override the componentName set in ./index.tsx. We do this to offer consistent naming across all Connect fragment operational events
                analyticsEvent.context.push({
                    componentName: 'ConnectFragment'
                });
                analyticsEvent.fire();
            }
        }, this.fireConnectFragmentAnalytics = ()=>{
            const { createAnalyticsEvent: createAnalyticsEvent, connectFragments: connectFragments, location: location, portalId: portalId, requestTypeId: requestTypeId } = this.props;
            if (!createAnalyticsEvent || !connectFragments) return;
            const isError = 'error' in connectFragments;
            if (!isError && connectFragments.length === 0) return;
            const uniqueAppKeys = !isError ? (0, $hbEJt.getUniqueAppKeysFromConnectFragments)(connectFragments) : [];
            const analyticsEvent = createAnalyticsEvent({
                portalId: portalId,
                requestTypeId: requestTypeId,
                location: location,
                analyticsType: (0, $haAAx.OPERATIONAL_EVENT_TYPE),
                action: isError ? 'failed' : 'loaded',
                appKeys: uniqueAppKeys
            });
            // Hack to override the componentName set in ./index.tsx. We do this to offer consistent naming across all Connect fragment operational events
            analyticsEvent.context.push({
                componentName: 'ConnectFragment'
            });
            analyticsEvent.fire();
        }, this.onRef = (el)=>{
            el && this.connectFieldRefs.push(el);
        }, this.validate = (requestTypeId)=>{
            return Promise.all(this.connectFieldRefs.map((ref)=>ref.validate())).then((validateResults)=>{
                this.sendConnectTimeoutEventForTimedOutResults((0, $gEVth.ConnectRequestCreateEventType).VALIDATE, validateResults, requestTypeId);
                return validateResults.map((result)=>{
                    return {
                        connectKey: result.connectKey,
                        valid: Boolean(result.data),
                        timedOut: result.timedOut
                    };
                });
            });
        }, this.serialize = (validatedConnectFields, requestTypeId)=>{
            const serializeValidatedRefs = this.connectFieldRefs.filter((ref)=>validatedConnectFields.includes(ref.props.connectKey)).map((ref)=>ref.serialize());
            return Promise.all(serializeValidatedRefs).then((allData)=>{
                this.sendConnectTimeoutEventForTimedOutResults((0, $gEVth.ConnectRequestCreateEventType).SERIALIZE, allData, requestTypeId);
                // This used to return stringified serialized data, but now we are returning the data in array form
                // which is then used in src/view/request-create-form/request-create-form.tsx to and allows us to
                // add additional data from Forge apps.
                return allData.filter((result)=>result && !result.timedOut).map((result)=>result.data);
            });
        }, this.sendConnectTimeoutEventForTimedOutResults = (eventType, results, requestTypeId)=>{
            results.forEach((result)=>result.timedOut && (0, $gEVth.sendConnectTimeoutEventForRequestCreation)(eventType, result.connectKey, requestTypeId));
        };
    }
}
var $3817876f4b2e4ca4$export$2e2bcd8739ae039 = $3817876f4b2e4ca4$var$ConnectFields;
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $3817876f4b2e4ca4$var$Root = /*#__PURE__*/ (0, $4v2A7.default).div.withConfig({
    componentId: "sc-h6iqb8-0"
})`margin-top:${"var(--ds-space-400, 32px)"};`;

});
parcelRegister("2YGTn", function(module, exports) {
$parcel$export(module.exports, "ConnectField", () => (parcelRequire("bqaN9")).default);

var $bqaN9 = parcelRequire("bqaN9");

});
parcelRegister("bqaN9", function(module, exports) {
$parcel$export(module.exports, "default", () => $e5c8e6b7e79a3efd$export$2e2bcd8739ae039);

var $bSJIT = parcelRequire("bSJIT");

var $eazQ4 = parcelRequire("eazQ4");

var $8jOUp = parcelRequire("8jOUp");
var $gJqoA = parcelRequire("gJqoA");

var $hbEJt = parcelRequire("hbEJt");
class $e5c8e6b7e79a3efd$var$ConnectFieldDumb extends $bSJIT.PureComponent {
    validate() {
        if (this.validateSubject) this.validateSubject.unsubscribe();
        this.validateSubject = new (0, $gJqoA.Subject)();
        (0, $hbEJt.validate)(this.props.connectKey);
        return this.validateSubject.race(this.timeOutHandler()).first().toPromise();
    }
    serialize() {
        if (this.serializeSubject) this.serializeSubject.unsubscribe();
        this.serializeSubject = new (0, $gJqoA.Subject)();
        (0, $hbEJt.serialize)(this.props.connectKey);
        return this.serializeSubject.race(this.timeOutHandler()).first().toPromise();
    }
    componentDidMount() {
        (0, $hbEJt.register)(this.props.connectKey, this.onSerialized, this.onValidated);
    }
    componentWillUnmount() {
        (0, $hbEJt.unregister)(this.props.connectKey);
    }
    render() {
        const { fragmentHtml: fragmentHtml, location: location, connectKey: connectKey } = this.props;
        return /*#__PURE__*/ $bSJIT.createElement((0, $eazQ4.ConnectFragmentDumb), {
            fragmentHtml: fragmentHtml,
            location: location,
            fullKey: connectKey
        });
    }
    constructor(...args){
        super(...args), this.onValidated = (isValid)=>{
            this.validateSubject && this.validateSubject.next(this.connectFieldResult(isValid, false));
        }, this.onSerialized = (data)=>{
            this.serializeSubject && this.serializeSubject.next(this.connectFieldResult(data, false));
        }, this.connectFieldResult = (data, timedOut = false)=>({
                data: data,
                timedOut: timedOut,
                connectKey: this.props.connectKey
            }), this.timeOutHandler = ()=>{
            const emitWhenTimeOut = (0, $8jOUp.Observable).of(this.connectFieldResult(undefined, true));
            return (0, $8jOUp.Observable).never().timeoutWith(1000, emitWhenTimeOut);
        };
    }
}
var $e5c8e6b7e79a3efd$export$2e2bcd8739ae039 = $e5c8e6b7e79a3efd$var$ConnectFieldDumb;

});



parcelRegister("lrQHI", function(module, exports) {
$parcel$export(module.exports, "ConnectFieldContext", () => (parcelRequire("fLZ30")).default);
$parcel$export(module.exports, "asConnectFields", () => (parcelRequire("fLZ30")).asConnectFields);

var $fLZ30 = parcelRequire("fLZ30");

});
parcelRegister("fLZ30", function(module, exports) {
$parcel$export(module.exports, "asConnectFields", () => $cd87632e824d8324$export$eea0f4ab01eeb10e);
$parcel$export(module.exports, "default", () => $cd87632e824d8324$export$2e2bcd8739ae039);

var $bSJIT = parcelRequire("bSJIT");

var $4ZMmh = parcelRequire("4ZMmh");
const $cd87632e824d8324$var$ConnectFieldContext = /*#__PURE__*/ $bSJIT.createContext({
    onConnectFieldMount: (0, $4ZMmh.noop)
});
const $cd87632e824d8324$export$eea0f4ab01eeb10e = (options)=>{
    const Child = options;
    const Component = (props)=>/*#__PURE__*/ $bSJIT.createElement($cd87632e824d8324$var$ConnectFieldContext.Consumer, null, (value)=>/*#__PURE__*/ $bSJIT.createElement(Child, {
                ...props,
                onConnectFieldMount: value.onConnectFieldMount
            }));
    const childDisplayName = Child.displayName ?? Child.name ?? 'Component';
    Component.displayName = `asConnectFields(${childDisplayName})`;
    return Component;
};
var $cd87632e824d8324$export$2e2bcd8739ae039 = $cd87632e824d8324$var$ConnectFieldContext;

});


parcelRegister("5rlOh", function(module, exports) {
$parcel$export(module.exports, "withConnectFieldSupport", () => (parcelRequire("9MGCy")).default);

var $9MGCy = parcelRequire("9MGCy");

});
parcelRegister("9MGCy", function(module, exports) {
$parcel$export(module.exports, "default", () => $9577cde5ce940923$export$2e2bcd8739ae039);

var $bSJIT = parcelRequire("bSJIT");
parcelRequire("lrQHI");
var $fLZ30 = parcelRequire("fLZ30");
const $9577cde5ce940923$var$withConnectFieldSupport = (options)=>{
    return class ConnectFieldSupport extends $bSJIT.PureComponent {
        render() {
            const Child = options;
            return /*#__PURE__*/ $bSJIT.createElement((0, $fLZ30.default).Provider, {
                value: this.contextValue
            }, /*#__PURE__*/ $bSJIT.createElement(Child, {
                ...this.props,
                onSubmit: this.onSubmit
            }));
        }
        constructor(...args){
            super(...args), this.onConnectFieldMount = (el)=>{
                this.connectFieldApi = el;
            }, this.contextValue = {
                onConnectFieldMount: this.onConnectFieldMount
            }, this.onSubmit = async ()=>{
                const { portalId: portalId, requestTypeId: requestTypeId, projectId: projectId, xsrfToken: xsrfToken } = this.props;
                if (this.connectFieldApi && portalId && requestTypeId && projectId && xsrfToken) return Promise.resolve(this.connectFieldApi.validate(requestTypeId)).then((allConnectFieldValid)=>{
                    if (!this.connectFieldApi) throw new Error('connect field unavailable');
                    const validatedItems = allConnectFieldValid.filter((validationResult)=>!validationResult.timedOut);
                    if (validatedItems.every((validationResult)=>Boolean(validationResult.valid))) {
                        const validConnectKeys = validatedItems.map((validationResult)=>validationResult.connectKey);
                        return this.connectFieldApi.serialize(validConnectKeys, requestTypeId);
                    }
                    throw new Error('validation failed');
                }).then((data)=>{
                    return data;
                }).catch((e)=>{
                    throw e;
                });
                return [];
            };
        }
    };
};
var $9577cde5ce940923$export$2e2bcd8739ae039 = $9577cde5ce940923$var$withConnectFieldSupport;

});



parcelRegister("frMhy", function(module, exports) {
$parcel$export(module.exports, "ForgeCustomFieldsResolver", () => (parcelRequire("pj5PM")).ForgeCustomFieldsResolver);

var $pj5PM = parcelRequire("pj5PM");

});
parcelRegister("pj5PM", function(module, exports) {
$parcel$export(module.exports, "ForgeCustomFieldsResolver", () => $0ea498fa61fae48e$export$51f6c5a4a6ee455d);
/* oxlint-disable no-void */ 
var $bSJIT = parcelRequire("bSJIT");

var $4ZMmh = parcelRequire("4ZMmh");

var $3eoOe = parcelRequire("3eoOe");

var $dQ3Zn = parcelRequire("dQ3Zn");

var $ls7vK = parcelRequire("ls7vK");
parcelRequire("iJll0");
var $6nOFu = parcelRequire("6nOFu");
const $0ea498fa61fae48e$export$51f6c5a4a6ee455d = ({ setResolve: setResolve, setFailedOrTimedOut: setFailedOrTimedOut, fields: fields, requestTypeId: requestTypeId })=>{
    const [, { resetState: resetState }] = (0, $ls7vK.useInlineFields)();
    const [failedOrTimedOutInlineFields] = (0, $ls7vK.useFailedOrTimedOutInlineFields)();
    const [resolver, setResolver] = (0, $bSJIT.useState)();
    const resolverRef = (0, $bSJIT.useRef)(resolver);
    const resetStateRef = (0, $bSJIT.useRef)(resetState);
    const prevRequestTypeId = (0, $3eoOe.usePrevious)(requestTypeId);
    const failedOrTimedOutFieldLabels = (0, $bSJIT.useMemo)(()=>failedOrTimedOutInlineFields.map((fieldId)=>{
            var _fields$find;
            return ((_fields$find = fields.find((field)=>field.id === fieldId)) === null || _fields$find === void 0 ? void 0 : _fields$find.label) || fieldId;
        }), [
        fields,
        failedOrTimedOutInlineFields
    ]);
    (0, $6nOFu.useForgeCustomFieldsResolver)(resolver);
    const resolve = (0, $bSJIT.useCallback)(async ()=>{
        // In case the form was previously re-submitted, the next resolution should take that into account (to avoid looping).
        // We have to be careful here, because the previous promise might have been rejected (no matter what the reason was), thus a separate try/catch block is needed.
        // We also want to void the previous promise to entering this check again.
        try {
            var _resolverRef$current;
            const prevValue = await ((_resolverRef$current = resolverRef.current) === null || _resolverRef$current === void 0 ? void 0 : _resolverRef$current.promise);
            if (prevValue === (0, $dQ3Zn.FORM_SUBMISSION_RE_SUBMIT_AND_PROCEED)) {
                setResolver(undefined);
                return 0, $dQ3Zn.FORM_SUBMISSION_PROCEED;
            }
        } catch  {
        // nothing to do here
        }
        // Create a new promise and set the resolver to the state.
        // Later on it is used to resolve or reject the promise during the form submission to reflect Forge custom fields status.
        try {
            // Setting default values to avoid TS errors, they are overridden in the next block
            const newResolver = {
                promise: Promise.resolve((0, $dQ3Zn.FORM_SUBMISSION_PROCEED)),
                resolve: (0, $4ZMmh.noop),
                reject: (0, $4ZMmh.noop)
            };
            const promise = new Promise((res, rej)=>{
                newResolver.resolve = res;
                newResolver.reject = rej;
            });
            newResolver.promise = promise;
            setResolver(newResolver);
            return await promise;
        } catch (error) {
            return 0, $dQ3Zn.FORM_SUBMISSION_PROCEED;
        }
    }, []);
    (0, $bSJIT.useEffect)(()=>{
        setResolve(resolve);
    }, [
        setResolve,
        resolve
    ]);
    (0, $bSJIT.useEffect)(()=>{
        setFailedOrTimedOut(failedOrTimedOutFieldLabels);
    }, [
        setFailedOrTimedOut,
        failedOrTimedOutFieldLabels
    ]);
    (0, $bSJIT.useEffect)(()=>{
        resolverRef.current = resolver;
        resetStateRef.current = resetState;
    }, [
        resolver,
        resetState
    ]);
    (0, $bSJIT.useEffect)(()=>{
        if (prevRequestTypeId && prevRequestTypeId !== requestTypeId) resetState();
    }, [
        prevRequestTypeId,
        requestTypeId,
        resetState
    ]);
    // Reset on unmount, do not add any dependencies to avoid resetting when not needed
    (0, $bSJIT.useEffect)(()=>()=>void resetStateRef.current(), []);
    return null;
};

});
parcelRegister("dQ3Zn", function(module, exports) {
$parcel$export(module.exports, "FORM_SUBMISSION_PROCEED", () => $14416d234e535665$export$15defefb49c55d9b);
$parcel$export(module.exports, "FORM_SUBMISSION_RE_SUBMIT_AND_PROCEED", () => $14416d234e535665$export$305cd9e043ace5dc);
$parcel$export(module.exports, "FORM_SUBMISSION_TIMEOUT", () => $14416d234e535665$export$51b463f57ef72b72);
/**
 * Indicates that the form submission should proceed without interruption.
 */ const $14416d234e535665$export$15defefb49c55d9b = 'PROCEED';
const $14416d234e535665$export$305cd9e043ace5dc = 'RE-SUBMIT-AND-PROCEED';
const $14416d234e535665$export$51b463f57ef72b72 = 10000;

});

parcelRegister("iJll0", function(module, exports) {
$parcel$export(module.exports, "useForgeCustomFieldsResolver", () => (parcelRequire("6nOFu")).useForgeCustomFieldsResolver);

var $6nOFu = parcelRequire("6nOFu");

});
parcelRegister("6nOFu", function(module, exports) {
$parcel$export(module.exports, "useForgeCustomFieldsResolver", () => $0c9b431af51f56e0$export$eb2be9f18555934e);
/* oxlint-disable no-void */ 
var $bSJIT = parcelRequire("bSJIT");

var $ls7vK = parcelRequire("ls7vK");

var $dQ3Zn = parcelRequire("dQ3Zn");

var $k65BD = parcelRequire("k65BD");
const $0c9b431af51f56e0$export$eb2be9f18555934e = (resolver)=>{
    const [fieldsState, { setFieldState: setFieldState }] = (0, $ls7vK.useInlineFields)();
    const fieldsStateRef = (0, $bSJIT.useRef)(fieldsState);
    const timeoutRef = (0, $bSJIT.useRef)();
    const [shouldResolveWhenSettled, setShouldResolveWhenSettled] = (0, $bSJIT.useState)(false);
    const areFieldsReadyToBeSubmitted = (0, $bSJIT.useMemo)(()=>$0c9b431af51f56e0$var$areAllResolved(Object.values(fieldsState)), [
        fieldsState
    ]);
    (0, $bSJIT.useEffect)(()=>{
        fieldsStateRef.current = fieldsState;
    }, [
        fieldsState
    ]);
    (0, $bSJIT.useEffect)(()=>{
        if (shouldResolveWhenSettled && areFieldsReadyToBeSubmitted) {
            clearTimeout(timeoutRef.current);
            resolver === null || resolver === void 0 || resolver.resolve((0, $dQ3Zn.FORM_SUBMISSION_RE_SUBMIT_AND_PROCEED));
        }
    }, [
        shouldResolveWhenSettled,
        areFieldsReadyToBeSubmitted,
        resolver
    ]);
    (0, $bSJIT.useEffect)(()=>{
        if (!resolver) return undefined;
        // No Forge custom fields to wait for (well, there might be some, but they are all already resolved).
        if ($0c9b431af51f56e0$var$areAllResolved(Object.values(fieldsStateRef.current))) {
            resolver.resolve((0, $dQ3Zn.FORM_SUBMISSION_PROCEED));
            return undefined;
        }
        // Marking that we should resolve once the fields are settled.
        setShouldResolveWhenSettled(true);
        // Let all the fields with a form submission handler to submit their values.
        Object.values(fieldsStateRef.current).forEach(({ onFormSubmit: onFormSubmit })=>onFormSubmit === null || onFormSubmit === void 0 ? void 0 : onFormSubmit());
        // It might be the case that some field goes crazy and does not submit its value.
        // In this case we will resolve the promise after the timeout to unblock the request creation.
        clearTimeout(timeoutRef.current);
        timeoutRef.current = setTimeout(()=>{
            Object.entries(fieldsStateRef.current).forEach(([fieldId, fieldState])=>{
                if (fieldState.status === (0, $k65BD.FIELD_STATE_PENDING)) setFieldState({
                    fieldId: fieldId,
                    status: (0, $k65BD.FIELD_STATE_TIMED_OUT)
                });
            });
            resolver === null || resolver === void 0 || resolver.resolve((0, $dQ3Zn.FORM_SUBMISSION_RE_SUBMIT_AND_PROCEED));
        }, (0, $dQ3Zn.FORM_SUBMISSION_TIMEOUT));
        return ()=>{
            resolver === null || resolver === void 0 || resolver.reject();
            setShouldResolveWhenSettled(false);
            clearTimeout(timeoutRef.current);
        };
    }, // The only dependency that could be added here is the resolver.
    // We do not want the timeout to randomly restart.
    // If you need to add more dependencies, please use refs.
    // oxlint-disable-next-line react-hooks/exhaustive-deps
    [
        resolver
    ]);
};
const $0c9b431af51f56e0$var$UNRESOLVED_STATES = [
    (0, $k65BD.FIELD_STATE_PENDING),
    (0, $k65BD.FIELD_STATE_FOCUSED)
];
const $0c9b431af51f56e0$var$areAllResolved = (fieldsState)=>{
    return fieldsState.every(({ status: status })=>!$0c9b431af51f56e0$var$UNRESOLVED_STATES.includes(status));
};

});




parcelRegister("cQRu3", function(module, exports) {
$parcel$export(module.exports, "FormHeader", () => $23401055f43a5f57$export$97ee2cbf37e5ebfe);
/* form-header.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $dc70d = parcelRequire("dc70d");
parcelRequire("bSJIT");

var $9fU1q = parcelRequire("9fU1q");

var $7WQx2 = parcelRequire("7WQx2");
const $23401055f43a5f57$var$formHeaderContentStyles = null;
const $23401055f43a5f57$var$formHeaderDescriptionStyles = null;
const $23401055f43a5f57$export$97ee2cbf37e5ebfe = ({ children: children, description: description, title: title })=>{
    return /*#__PURE__*/ (0, $dc70d.jsxs)("div", {
        children: [
            title && /*#__PURE__*/ (0, $dc70d.jsx)((0, $7WQx2.default), {
                size: "large",
                children: title
            }),
            description && /*#__PURE__*/ (0, $dc70d.jsx)("div", {
                className: (0, $9fU1q.default)([
                    "_1pfhu2gc"
                ]),
                children: description
            }),
            children && /*#__PURE__*/ (0, $dc70d.jsx)("div", {
                className: (0, $9fU1q.default)([
                    "_1ul91osq _1pfhu2gc"
                ]),
                children: children
            })
        ]
    });
};

});

parcelRegister("5oBRG", function(module, exports) {
$parcel$export(module.exports, "ProformaSerializationTraceStep", () => $dd8ef0e11e917e4a$export$1b2fc3d8d738811d);
$parcel$export(module.exports, "traceProformaSerialization", () => $dd8ef0e11e917e4a$export$23d4470250746a0f);

var $87QgR = parcelRequire("87QgR");

var $gEVth = parcelRequire("gEVth");
/**
 * Gates the operational analytics events that trace the Proforma form
 * serialization flow during Help Center request creation. Used to diagnose an
 * intermittent bug where a request submitted with a Proforma form omits the
 * form data on submission even though a form is rendered.
 */ const $dd8ef0e11e917e4a$var$PROFORMA_TRACK_PORTAL_CREATE_FORM_SERIALIZATION = 'proforma_track_portal_create_form_serialisation';
const $dd8ef0e11e917e4a$export$e6a10ff12951a5f8 = ()=>(0, $87QgR.default).checkGate($dd8ef0e11e917e4a$var$PROFORMA_TRACK_PORTAL_CREATE_FORM_SERIALIZATION);
const $dd8ef0e11e917e4a$export$1b2fc3d8d738811d = {
    PreSubmit: 'preSubmit',
    PostSerialization: 'postSerialization'
};
const $dd8ef0e11e917e4a$export$23d4470250746a0f = (step, attributes = {})=>{
    if (!$dd8ef0e11e917e4a$export$e6a10ff12951a5f8()) return;
    (0, $gEVth.operationalEvent)({
        action: 'traced',
        actionSubject: 'proformaFormSerializationTrace',
        source: 'proforma-serialization-trace',
        attributes: {
            step: step,
            ...attributes
        }
    });
};

});

parcelRegister("kcqdg", function(module, exports) {
$parcel$export(module.exports, "UiModificationsFormValuesApplier", () => $4665c06b02bb7662$export$62bec47a1e660aed);

var $bSJIT = parcelRequire("bSJIT");

var $81Pre = parcelRequire("81Pre");

var $dtngf = parcelRequire("dtngf");

var $8MlrR = parcelRequire("8MlrR");
const $4665c06b02bb7662$export$62bec47a1e660aed = ({ fieldValues: fieldValues, setFieldValue: setFieldValue, fields: fields })=>{
    const [overrides] = (0, $81Pre.useAdjustedFields)();
    const fieldValuesRef = (0, $bSJIT.useRef)(fieldValues);
    // always refresh fieldValuesRef with the latest value
    fieldValuesRef.current = fieldValues;
    const fieldConfigurations = (0, $bSJIT.useMemo)(()=>{
        const configs = {};
        fields.filter(({ jiraFieldType: jiraFieldType })=>(0, $dtngf.isFieldTypeSupported)((0, $8MlrR.REQUEST_CREATE_VIEW_TYPE), jiraFieldType)).forEach(({ id: id, jiraFieldType: jiraFieldType })=>{
            configs[id] = (0, $dtngf.getSupportedFieldConfiguration)((0, $8MlrR.REQUEST_CREATE_VIEW_TYPE), jiraFieldType);
        });
        return configs;
    }, [
        fields
    ]);
    (0, $bSJIT.useEffect)(()=>{
        if (!overrides || Object.keys(fieldConfigurations).length === 0) return;
        for (const [fieldId, override] of Object.entries(overrides)){
            const fieldConfig = fieldConfigurations[fieldId];
            // Only process if field is supported, has override value, and transformation function is available
            if (fieldConfig !== null && fieldConfig !== void 0 && fieldConfig.modifyValueToBasic && (override === null || override === void 0 ? void 0 : override.value) !== undefined) {
                const transformedValue = fieldConfig.modifyValueToBasic(override.value);
                if (transformedValue !== fieldValuesRef.current[fieldId]) setFieldValue(fieldId, transformedValue);
            }
        }
    }, [
        overrides,
        fieldConfigurations,
        setFieldValue
    ]);
    return null;
};

});

parcelRegister("chubD", function(module, exports) {
$parcel$export(module.exports, "UiModificationsSectionsMessages", () => $f86032a4bc3322ea$export$28416a123e56ccab);

var $bSJIT = parcelRequire("bSJIT");

var $buKRr = parcelRequire("buKRr");

var $b56HN = parcelRequire("b56HN");

var $kCbtz = parcelRequire("kCbtz");
function $f86032a4bc3322ea$export$28416a123e56ccab() {
    const [uiModificationError] = (0, $b56HN.useUiModificationsErrors)();
    const [uiModificationsNotification] = (0, $kCbtz.useUiModificationsNotifications)();
    const hasError = uiModificationError !== null;
    const hasNotification = uiModificationsNotification !== null;
    if (!hasError && !hasNotification) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).Fragment, null, hasError && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $buKRr.default), {
        appearance: "error",
        testId: "issue-create.ui.modal.create-form.section-messages.ui-modifications-error-message"
    }, uiModificationError.message), hasNotification && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $buKRr.default), {
        appearance: uiModificationsNotification.type,
        testId: "issue-create.ui.modal.create-form.section-messages.ui-modifications-notification-message"
    }, uiModificationsNotification.message));
}

});
parcelRegister("b56HN", function(module, exports) {
$parcel$export(module.exports, "useUiModificationsErrors", () => $68cff6e6254a21b3$export$72f28c8f041a8bab);

var $bSJIT = parcelRequire("bSJIT");

var $4vLTk = parcelRequire("4vLTk");

var $2XzQF = parcelRequire("2XzQF");

var $aLOSv = parcelRequire("aLOSv");
const $68cff6e6254a21b3$export$72f28c8f041a8bab = ()=>{
    const error = (0, $2XzQF.useError)();
    const { formatMessage: formatMessage } = (0, $4vLTk.default)();
    const [errorMessage, setErrorMessage] = (0, $bSJIT.useState)(null);
    (0, $bSJIT.useEffect)(()=>{
        if (!error) setErrorMessage(null);
        else {
            const message = (0, $aLOSv.errorCodeToErrorMessageMap)[error.errorCode];
            const formattedMessage = formatMessage(message);
            setErrorMessage(formattedMessage);
        }
    }, [
        error,
        formatMessage
    ]);
    return errorMessage ? [
        {
            message: errorMessage
        }
    ] : [
        null
    ];
};

});
parcelRegister("2XzQF", function(module, exports) {
$parcel$export(module.exports, "useError", () => $85022af78df43983$export$5027865de34f9ec6);

var $gfNVK = parcelRequire("gfNVK");

var $81Pre = parcelRequire("81Pre");
const $85022af78df43983$export$5027865de34f9ec6 = (0, $gfNVK.createStateHook)((0, $81Pre.store), {
    selector: (state)=>state.error
});

});

parcelRegister("aLOSv", function(module, exports) {
$parcel$export(module.exports, "errorCodeToErrorMessageMap", () => $dd6f245127c608f8$export$c36ca6969b1c2a38);

var $cpzkX = parcelRequire("cpzkX");
const $dd6f245127c608f8$export$c36ca6969b1c2a38 = {
    ON_BRIDGE_ERROR_ERROR_CODE: (0, $cpzkX.default).applyingUimFailed,
    USE_REGISTER_FIELDS_ERROR_CODE: (0, $cpzkX.default).applyingUimFailed,
    USE_SUBMIT_ERROR_CODE: (0, $cpzkX.default).applyingUimFailed,
    PER_FIELD_HOOK_ERROR_CODE: (0, $cpzkX.default).applyingUimFailed,
    SCOPES_MISSING_ERROR_CODE: (0, $cpzkX.default).appDoesNotHaveRequiredScopes,
    ERROR_BOUNDARY_HANDLER_ERROR_CODE: (0, $cpzkX.default).applyingUimFailed,
    ON_INIT_FIELDS_INITIALIZATION_TIMEOUT: (0, $cpzkX.default).loadingUimFailed
};

});
parcelRegister("cpzkX", function(module, exports) {
$parcel$export(module.exports, "default", () => $af2a13bb4b28eaac$export$2e2bcd8739ae039);

var $f0Pt4 = parcelRequire("f0Pt4");
var $af2a13bb4b28eaac$export$2e2bcd8739ae039 = (0, $f0Pt4.defineMessages)({
    loadingUimFailed: {
        id: 'ui-modifications-view-request-create.use-ui-modifications-errors.loading-uim-failed',
        defaultMessage: "We couldn't load the UI modifications for this form.",
        description: 'A warning that gets displayed when unknown error occurred during UI modifications processing in Jira'
    },
    loadingUimDataFailed: {
        id: 'ui-modifications-view-request-create.use-ui-modifications-errors.loading-uim-data-failed',
        defaultMessage: "We couldn't load the UI modifications configuration for this form.",
        description: 'A warning that gets displayed when known error occurred during UI modifications data loading in Jira'
    },
    applyingUimFailed: {
        id: 'ui-modifications-view-request-create.use-ui-modifications-errors.applying-uim-failed',
        defaultMessage: 'We encountered an error while applying UI modifications to this form.',
        description: 'A warning that gets displayed when known error occurred during UI modifications processing in Jira'
    },
    appDoesNotHaveRequiredScopes: {
        id: 'ui-modifications-view-request-create.use-ui-modifications-errors.app-does-not-have-required-scopes',
        defaultMessage: "We couldn't load some of the UI modifications apps for this page, because they don't have required scopes.",
        description: 'A warning that gets displayed when an app with UI modifications module does not have required scopes in the manifest'
    }
});

});



parcelRegister("kCbtz", function(module, exports) {
$parcel$export(module.exports, "useUiModificationsNotifications", () => $8153b85625064c07$export$3a867504a28cd936);

var $bSJIT = parcelRequire("bSJIT");

var $4vLTk = parcelRequire("4vLTk");

var $l4VJe = parcelRequire("l4VJe");

var $fMgjB = parcelRequire("fMgjB");
const $8153b85625064c07$export$3a867504a28cd936 = ()=>{
    const notification = (0, $l4VJe.useNotification)();
    const { formatMessage: formatMessage } = (0, $4vLTk.default)();
    const [notificationProperties, setNotificationProperties] = (0, $bSJIT.useState)(null);
    (0, $bSJIT.useEffect)(()=>{
        if (!notification) setNotificationProperties(null);
        else {
            const properties = (0, $fMgjB.notificationTypeToNotificationProperties)[notification.type];
            const formattedMessage = formatMessage(properties.message);
            setNotificationProperties({
                message: formattedMessage,
                type: properties.type
            });
        }
    }, [
        notification,
        formatMessage
    ]);
    return notificationProperties ? [
        notificationProperties
    ] : [
        null
    ];
};

});
parcelRegister("l4VJe", function(module, exports) {
$parcel$export(module.exports, "useNotification", () => $1e8e78777a729b5c$export$9949bd9c713ba425);

var $gfNVK = parcelRequire("gfNVK");

var $81Pre = parcelRequire("81Pre");
const $1e8e78777a729b5c$export$9949bd9c713ba425 = (0, $gfNVK.createStateHook)((0, $81Pre.store), {
    selector: (state)=>state.notification
});

});

parcelRegister("fMgjB", function(module, exports) {
$parcel$export(module.exports, "notificationTypeToNotificationProperties", () => $3a984f90748beda9$export$3dd11dfb655fc1de);

var $bG3fJ = parcelRequire("bG3fJ");
const $3a984f90748beda9$export$3dd11dfb655fc1de = {
    MULTIPLE_APPS_CONFLICTS: {
        message: (0, $bG3fJ.default).multipleAppsConflicted,
        type: 'warning'
    }
};

});
parcelRegister("bG3fJ", function(module, exports) {
$parcel$export(module.exports, "default", () => $9bceb2bc6e7061f9$export$2e2bcd8739ae039);

var $f0Pt4 = parcelRequire("f0Pt4");
var $9bceb2bc6e7061f9$export$2e2bcd8739ae039 = (0, $f0Pt4.defineMessages)({
    multipleAppsConflicted: {
        id: 'ui-modifications-view-gic.use-ui-modifications-notifications.multiple-apps-conflicted',
        defaultMessage: 'Multiple UI modification apps are trying to change the same field property. If you see unexpected changes to a field, report them to your Jira admin.',
        description: 'A information that gets displayed when UI modifications misconfiguration was detected'
    }
});

});




parcelRegister("if8pw", function(module, exports) {
$parcel$export(module.exports, "withUiModificationsFormDecorator", () => $9384afb7aead1ab7$export$da1a7ee776db6dec);

var $bSJIT = parcelRequire("bSJIT");

var $gdUUy = parcelRequire("gdUUy");

var $81Pre = parcelRequire("81Pre");

var $inaNq = parcelRequire("inaNq");

var $cXMgQ = parcelRequire("cXMgQ");

var $6WIJF = parcelRequire("6WIJF");

var $4a8RC = parcelRequire("4a8RC");
const $9384afb7aead1ab7$export$a16989d3bc106880 = /*#__PURE__*/ (0, $bSJIT.memo)(({ formData: formData, setOverrideProps: setOverrideProps })=>{
    (0, $6WIJF.useInitializeFields)({
        fields: formData.fields,
        urlParamFieldValueOverrides: formData.urlParamFieldValueOverrides
    });
    (0, $4a8RC.useInitializeNoScreenTab)();
    const { fields: fields } = (0, $cXMgQ.useFieldsOverrides)({
        fields: formData.fields
    });
    const { clearAppliedValue: clearAppliedValue, processChange: processChange } = (0, $81Pre.useIssueAdjustmentsActions)();
    const formDataWithOverrides = (0, $bSJIT.useMemo)(()=>{
        return {
            ...formData,
            fields: fields
        };
    }, [
        formData,
        fields
    ]);
    const onFieldChangedByUser = (0, $bSJIT.useCallback)(({ field: field, additionalFieldData: additionalFieldData })=>{
        processChange({
            fieldId: field,
            fieldValue: additionalFieldData === null || additionalFieldData === void 0 ? void 0 : additionalFieldData.rawValue,
            eventType: 'change'
        });
        // Once we have applied the value, we clear it from the state, so we don't apply it again
        // in the future and overwrite whatever the user has changed between now and then
        clearAppliedValue(field);
    }, [
        clearAppliedValue,
        processChange
    ]);
    const onFieldBlurredByUser = (0, $bSJIT.useCallback)(({ field: field, additionalFieldData: additionalFieldData })=>{
        processChange({
            fieldId: field,
            fieldValue: additionalFieldData === null || additionalFieldData === void 0 ? void 0 : additionalFieldData.rawValue,
            eventType: 'blur'
        });
        // Once we have applied the value, we clear it from the state, so we don't apply it again
        // in the future and overwrite whatever the user has changed between now and then
        clearAppliedValue(field);
    }, [
        clearAppliedValue,
        processChange
    ]);
    (0, $bSJIT.useEffect)(()=>{
        setOverrideProps({
            onFieldChangedByUser: onFieldChangedByUser,
            onFieldBlurredByUser: onFieldBlurredByUser,
            formData: formDataWithOverrides
        });
    }, [
        formDataWithOverrides,
        setOverrideProps,
        onFieldChangedByUser,
        onFieldBlurredByUser
    ]);
    return null;
});
$9384afb7aead1ab7$export$a16989d3bc106880.displayName = 'EnabledUiModificationsDecorator';
const $9384afb7aead1ab7$export$396c5968a56552f2 = (props)=>{
    const [overrideProps, setOverrideProps] = (0, $bSJIT.useState)({});
    const isUiModificationsEnabled = (0, $inaNq.useAdjustmentsEnabled)();
    const { RequestCreateForm: RequestCreateForm, ...requestCreateFormProps } = props;
    const { formData: formData, portalId: portalId, requestTypeId: requestTypeId, isPrefillPending: isPrefillPending } = requestCreateFormProps;
    // Do not mount EnabledUiModificationsDecorator while URL-param pre-fill is still being
    // resolved by the epic (isPrefillPending === true). useInitializeFields fires its effect
    // only once (on mount), so if it mounts before hydratedUrlParamOverrides arrives from the
    // epic, it will initialise UIM with an empty urlParamFieldValueOverrides and getValue()
    // will return null in onInit even though the field visually shows the pre-selected value.
    // Delaying the mount until isPrefillPending is false ensures the correct values are
    // available on the first (and only) call to initializeFields.
    const isReadyToMount = !(0, $gdUUy.fg)('jsm_uim_queryparam_prefill_fix') || !isPrefillPending;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement(RequestCreateForm, {
        ...requestCreateFormProps,
        ...overrideProps
    }), isUiModificationsEnabled && formData && portalId && requestTypeId && isReadyToMount && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement($9384afb7aead1ab7$export$a16989d3bc106880, {
        setOverrideProps: setOverrideProps,
        formData: formData
    }));
};
const $9384afb7aead1ab7$export$da1a7ee776db6dec = ()=>{
    return (RequestCreateForm)=>{
        const Decorator = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement($9384afb7aead1ab7$export$396c5968a56552f2, {
                RequestCreateForm: RequestCreateForm,
                ...props
            });
        Decorator.displayName = `withUiModificationsFormDecorator(${RequestCreateForm.displayName || RequestCreateForm.name})`;
        return Decorator;
    };
};

});
parcelRegister("cXMgQ", function(module, exports) {
$parcel$export(module.exports, "useFieldsOverrides", () => $9379c5b7f704c25f$export$38f8a49b78f98f9f);

var $bSJIT = parcelRequire("bSJIT");

var $2BKOF = parcelRequire("2BKOF");

var $jU0od = parcelRequire("jU0od");

var $i2WqQ = parcelRequire("i2WqQ");

var $81Pre = parcelRequire("81Pre");
const $9379c5b7f704c25f$var$pickPropertiesToOverride = (field)=>{
    const overrideProperties = {
        fieldName: 'label',
        description: 'description',
        descriptionRaw: 'description',
        isReadOnly: 'disabled',
        isRequired: 'required',
        isVisible: 'displayed',
        value: 'valueOverride',
        // For options visibility, field like select uses options.
        options: 'options',
        // For options visibility, field like radio uses items.
        items: 'items'
    };
    return Object.entries(overrideProperties).reduce((acc, [uimProperty, jsmProperty])=>{
        if ((0, (/*@__PURE__*/$parcel$interopDefault($jU0od)))(field, uimProperty)) acc[jsmProperty] = (0, (/*@__PURE__*/$parcel$interopDefault($2BKOF)))(field, uimProperty);
        return acc;
    }, {});
};
const $9379c5b7f704c25f$export$38f8a49b78f98f9f = ({ fields: fields })=>{
    const [overrides] = (0, $81Pre.useAdjustedFields)();
    return (0, $bSJIT.useMemo)(()=>{
        if (!overrides) return {
            fields: fields
        };
        const overridenFields = fields.map((field)=>{
            const fieldOverrides = overrides[field.id];
            if (!fieldOverrides) return field;
            const supportedOverrides = $9379c5b7f704c25f$var$pickPropertiesToOverride(fieldOverrides);
            if ((0, (/*@__PURE__*/$parcel$interopDefault($i2WqQ)))(supportedOverrides)) return field;
            return {
                ...field,
                ...supportedOverrides
            };
        });
        return {
            fields: overridenFields
        };
    }, [
        overrides,
        fields
    ]);
};

});
parcelRegister("jU0od", function(module, exports) {

var $gIckL = parcelRequire("gIckL");

var $l0irv = parcelRequire("l0irv");
/**
 * Checks if `path` is a direct property of `object`.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = { 'a': { 'b': 2 } };
 * var other = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.has(object, 'a');
 * // => true
 *
 * _.has(object, 'a.b');
 * // => true
 *
 * _.has(object, ['a', 'b']);
 * // => true
 *
 * _.has(other, 'a');
 * // => false
 */ function $e7d38ca665a761ba$var$has(object, path) {
    return object != null && $l0irv(object, path, $gIckL);
}
module.exports = $e7d38ca665a761ba$var$has;

});
parcelRegister("gIckL", function(module, exports) {
/** Used for built-in method references. */ var $c2aa52a86913d91d$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $c2aa52a86913d91d$var$hasOwnProperty = $c2aa52a86913d91d$var$objectProto.hasOwnProperty;
/**
 * The base implementation of `_.has` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */ function $c2aa52a86913d91d$var$baseHas(object, key) {
    return object != null && $c2aa52a86913d91d$var$hasOwnProperty.call(object, key);
}
module.exports = $c2aa52a86913d91d$var$baseHas;

});



parcelRegister("6WIJF", function(module, exports) {
$parcel$export(module.exports, "useInitializeFields", () => $a298cc75ed33a723$export$869a1c0d0d07c224);

var $bSJIT = parcelRequire("bSJIT");

var $gdUUy = parcelRequire("gdUUy");

var $dtngf = parcelRequire("dtngf");

var $81Pre = parcelRequire("81Pre");

var $lFpPv = parcelRequire("lFpPv");

var $8MlrR = parcelRequire("8MlrR");

var $kxLuH = parcelRequire("kxLuH");
const $a298cc75ed33a723$var$hasRendererType = (field)=>{
    // Indeed it is typed as any, replace with Object.hasOwn once available in help-center.
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    return Object.prototype.hasOwnProperty.call(field, 'rendererType');
};
const $a298cc75ed33a723$var$getFieldConfigId = (field)=>'fieldConfigId' in field && typeof field.fieldConfigId === 'string' ? field.fieldConfigId : undefined;
/**
 * Extra field data for the field configuration's transformers. It is never sent to apps.
 * The user picker passes `fieldConfigId` to the Portal user search, which uses it to apply
 * the field's user filter. Typed with `UserPickerExtraData`, which the user picker's transformer
 * reads with the same type.
 */ const $a298cc75ed33a723$var$getExtraData = (field)=>{
    const fieldConfigId = $a298cc75ed33a723$var$getFieldConfigId(field);
    return (0, $lFpPv.isUserPickerEmailSupportEnabled)() && fieldConfigId ? {
        fieldConfigId: fieldConfigId
    } : undefined;
};
const $a298cc75ed33a723$export$869a1c0d0d07c224 = ({ fields: fields, urlParamFieldValueOverrides: urlParamFieldValueOverrides = {} })=>{
    const { initializeFields: initializeFields } = (0, $81Pre.useIssueAdjustmentsActions)();
    (0, $bSJIT.useEffect)(()=>{
        const fieldsToInitialize = fields// Remove 'as string' on isUiModificationsSupportEnabled, ditto_uim_-_jsm_support_main FF cleanup
        .filter(({ jiraFieldType: jiraFieldType })=>(0, $dtngf.isFieldTypeSupported)((0, $8MlrR.REQUEST_CREATE_VIEW_TYPE), jiraFieldType)).map((field)=>{
            // When a field value was pre-populated via a URL query parameter, the URL param
            // override (already parsed into the correct internal shape by parseFieldUrlParams /
            // hydrateUrlParamOverrides) takes precedence over the field's server-side default.
            // This is necessary because some field types (e.g. select, multiselect,
            // cascadingselect) store their UIM-visible value in `field.defaultValue` rather
            // than `field.value` (via initializeFieldPropertyMapping), but `defaultValue` is
            // never populated for URL-param-only pre-fills — only `initialFieldValues` is
            // updated in the reducer. Without this override, getValue() returns null in onInit
            // even though the field visually shows the pre-selected option.
            const urlParamOverrideValue = urlParamFieldValueOverrides[field.id];
            const hasUrlParamOverride = (0, $gdUUy.fg)('jsm_uim_queryparam_prefill_fix') && urlParamOverrideValue !== undefined;
            const fieldType = field.jiraFieldType;
            const initializedValue = (0, $kxLuH.getValueByInitializeFieldPropertyMapping)({
                field: field,
                fieldType: fieldType,
                property: 'value',
                defaultValue: null
            });
            const value = hasUrlParamOverride ? (0, $kxLuH.transformUrlParamValueForField)(urlParamOverrideValue, field, fieldType) : (0, $kxLuH.transformInitialValueForField)(initializedValue, field, fieldType);
            return {
                field: {
                    value: value,
                    allowedValues: (0, $kxLuH.getValueByInitializeFieldPropertyMapping)({
                        field: field,
                        fieldType: field.jiraFieldType,
                        property: 'allowedValues',
                        defaultValue: undefined
                    }),
                    fieldName: field.label,
                    fieldId: field.id,
                    description: field.description,
                    descriptionRaw: field.description,
                    isRequired: field.required ?? false,
                    isVisible: field.displayed,
                    isReadOnly: field.disabled ?? false,
                    // Remove 'as string' on isUiModificationsSupportEnabled, ditto_uim_-_jsm_support_main FF cleanup
                    fieldType: field.jiraFieldType
                },
                metadata: {
                    fieldRenderer: $a298cc75ed33a723$var$hasRendererType(field) ? field.rendererType : undefined,
                    extraData: $a298cc75ed33a723$var$getExtraData(field)
                }
            };
        });
        initializeFields(fieldsToInitialize);
    // No deps, intialize once
    // oxlint-disable-next-line react-hooks/exhaustive-deps
    }, []);
};

});
parcelRegister("kxLuH", function(module, exports) {
$parcel$export(module.exports, "getValueByInitializeFieldPropertyMapping", () => $75eca7bca896fa5e$export$6f6ce0daf6a52c22);
$parcel$export(module.exports, "transformUrlParamValueForField", () => $75eca7bca896fa5e$export$15779ca21f2894e1);
$parcel$export(module.exports, "transformInitialValueForField", () => $75eca7bca896fa5e$export$ef1e272266d3e8f7);

var $dtngf = parcelRequire("dtngf");

var $8MlrR = parcelRequire("8MlrR");
const $75eca7bca896fa5e$export$6f6ce0daf6a52c22 = ({ field: field, fieldType: fieldType, property: property, defaultValue: defaultValue })=>{
    var _getSupportedFieldCon;
    const mappedProperty = ((_getSupportedFieldCon = (0, $dtngf.getSupportedFieldConfiguration)((0, $8MlrR.REQUEST_CREATE_VIEW_TYPE), fieldType)) === null || _getSupportedFieldCon === void 0 || (_getSupportedFieldCon = _getSupportedFieldCon.initializeFieldPropertyMapping) === null || _getSupportedFieldCon === void 0 ? void 0 : _getSupportedFieldCon[property]) ?? property;
    return (field === null || field === void 0 ? void 0 : field[mappedProperty]) ?? defaultValue;
};
const $75eca7bca896fa5e$export$15779ca21f2894e1 = (urlParamValue, field, fieldType)=>{
    var _getSupportedFieldCon2;
    const transformer = (_getSupportedFieldCon2 = (0, $dtngf.getSupportedFieldConfiguration)((0, $8MlrR.REQUEST_CREATE_VIEW_TYPE), fieldType)) === null || _getSupportedFieldCon2 === void 0 ? void 0 : _getSupportedFieldCon2.transformUrlParamValue;
    return transformer ? transformer(urlParamValue, field) : urlParamValue;
};
const $75eca7bca896fa5e$export$ef1e272266d3e8f7 = (value, field, fieldType)=>{
    var _getSupportedFieldCon3;
    const transformer = (_getSupportedFieldCon3 = (0, $dtngf.getSupportedFieldConfiguration)((0, $8MlrR.REQUEST_CREATE_VIEW_TYPE), fieldType)) === null || _getSupportedFieldCon3 === void 0 ? void 0 : _getSupportedFieldCon3.transformInitialValue;
    return transformer ? transformer(value, field) : value;
};

});


parcelRegister("4a8RC", function(module, exports) {
$parcel$export(module.exports, "useInitializeNoScreenTab", () => $bd774acc568858aa$export$ce80bc59af7f0b45);

var $bSJIT = parcelRequire("bSJIT");

var $81Pre = parcelRequire("81Pre");
const $bd774acc568858aa$export$ce80bc59af7f0b45 = ()=>{
    const { initializeNoScreenTab: initializeNoScreenTab } = (0, $81Pre.useIssueAdjustmentsActions)();
    (0, $bSJIT.useEffect)(()=>{
        initializeNoScreenTab();
    // No deps, intialize once
    // oxlint-disable-next-line react-hooks/exhaustive-deps
    }, []);
};

});


parcelRegister("2r1Ci", function(module, exports) {
$parcel$export(module.exports, "notifyRovoRequestCreated", () => $6cec08e9e613f296$export$cf40d32161311763);

var $jBiia = parcelRequire("jBiia");

var $6JJ8C = parcelRequire("6JJ8C");

var $5ETah = parcelRequire("5ETah");

var $jmUpm = parcelRequire("jmUpm");

var $972xM = parcelRequire("972xM");

var $5hqQs = parcelRequire("5hqQs");
function $6cec08e9e613f296$export$cf40d32161311763(portalUrl, action) {
    // Notify Rovo Chat about successful request creation
    try {
        const bridge = (0, $5ETah.getBrowserBridgeAPI)();
        bridge.ready((0, $972xM.HELP_CENTER_FORM_REQUEST_CLIENT_ID));
        bridge.send((0, $5hqQs.NotifySuccessCommand), {
            message: portalUrl,
            requestUrl: portalUrl,
            action: action || '',
            senderId: (0, $972xM.HELP_CENTER_FORM_REQUEST_CLIENT_ID),
            receiverId: (0, $jmUpm.ROVO_CHAT_CLIENT_ID)
        });
    } catch (e) {
        (0, $jBiia.trackError)('Error notifying Rovo Chat of successful request creation', {
            command: 'notify-success-command'
        }, e);
        (0, $6JJ8C.devLog)('Error notifying Rovo Chat of successful request creation', e);
    }
}

});
parcelRegister("5ETah", function(module, exports) {
$parcel$export(module.exports, "getBrowserBridgeAPI", () => $ae057980e3286f68$export$948c8d79381235ac);

var $kHnw0 = parcelRequire("kHnw0");

var $3YeDO = parcelRequire("3YeDO");

var $l5apZ = parcelRequire("l5apZ");
/**
 * A singleton instance to the Rovo bridge API, for bidirectional communication between Rovo Chat and fully immersive content
 * representations. Available in the scope of a single JavaScript context.
 *
 * @description For browser use cases, use {@link getBrowserBridgeAPI}.
 *
 * @description Note: A content frame in this context can refer to either (1) preview of content in a 'staging' view (
 * see @atlassian/smart-creation), or (2) the content actually rendered in an application (e.g. a Confluence page).
 *
 * @description Note: Here, a single JavaScript context can mean any of the following scenarios:
 * - a web application and React component mounted inside of it (e.g. Confluence + Confluence Pages)
 * - a web application and same-origin `<iframe>` mounted inside of it (e.g. Confluence + Confluence Whiteboards / Databases)
 *
 * The following cases represent distinct JavaScript contexts:
 * - a web application and a cross-origin `<iframe>` mounted inside of it (e.g. a third-party Smart Link embed)
 * - the main thread and a worker thread in a web application
 * - the main thread and renderer thread in a desktop application
 *
 * In the case that you have a distinct JavaScript context, ensure you use a transport protocol optimised for your use case.
 * @see {@link getBrowserBridgeAPI} for usage in a browser context.
 */ let $ae057980e3286f68$var$bridgeApiInstance = null;
const $ae057980e3286f68$export$948c8d79381235ac = (options = {})=>{
    // 1) read singleton instance
    if ($ae057980e3286f68$var$bridgeApiInstance) return $ae057980e3286f68$var$bridgeApiInstance;
    // 2) read singleton instance from window.top
    const api = (0, $3YeDO.readAPI)();
    if (api) return api;
    // 3) create and yield
    const source = window.origin;
    $ae057980e3286f68$var$bridgeApiInstance = new (0, $kHnw0.RovoContentBridgeAPI)(source, new (0, $l5apZ.BrowserTransport)(source, {
        resolveTarget: options.resolveTarget,
        allowedOrigins: options.allowedOrigins
    }));
    (0, $3YeDO.mountAPI)($ae057980e3286f68$var$bridgeApiInstance);
    return $ae057980e3286f68$var$bridgeApiInstance;
};
const $ae057980e3286f68$export$ba1db4e691f11d50 = ()=>{
    // Ensure bridge instance is fully destroyed first to clean up all internal state
    if ($ae057980e3286f68$var$bridgeApiInstance) $ae057980e3286f68$var$bridgeApiInstance.destroy();
    $ae057980e3286f68$var$bridgeApiInstance = null;
    (0, $3YeDO.clearAPI)();
};

});
parcelRegister("kHnw0", function(module, exports) {
$parcel$export(module.exports, "RovoContentBridgeAPI", () => $86a77a8970ed1fec$export$d90806e6eab0cb0a);
// eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead

var $7RHfd = parcelRequire("7RHfd");

var $gdUUy = parcelRequire("gdUUy");

var $7vG3Z = parcelRequire("7vG3Z");

var $d6sum = parcelRequire("d6sum");

var $hmtci = parcelRequire("hmtci");

var $bGrVW = parcelRequire("bGrVW");

var $dXq3a = parcelRequire("dXq3a");

var $6Svem = parcelRequire("6Svem");

var $cxhPv = parcelRequire("cxhPv");

var $llZYC = parcelRequire("llZYC");

var $dfqF9 = parcelRequire("dfqF9");

var $1bjC0 = parcelRequire("1bjC0");

var $iYdh9 = parcelRequire("iYdh9");

var $ITDGX = parcelRequire("ITDGX");
class $86a77a8970ed1fec$export$d90806e6eab0cb0a {
    constructor(instanceId, transport){
        this.registry = new (0, $7vG3Z.ClientRegistry)();
        this.queue = new (0, $dfqF9.BufferedInvocationQueue)();
        this.transport = transport;
        // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
        this.identifier = (0, $d6sum.client)(instanceId ? instanceId : `bridge-api-${(0, $7RHfd.default)()}`);
        this.rpc = {
            request: new (0, $iYdh9.RequestHandler)(this.transport),
            response: new (0, $ITDGX.ResponseHandler)()
        };
        // setup emitter for all events
        (0, $cxhPv.emitter)().setBridgeId(this.identifier);
        // start listening for any incoming messages
        this.transport.onMessage(this.onMessage.bind(this));
        // setup tick handler for sending discovery commands to pending clients
        this.queue.onTick((pendingConnections)=>{
            for (const { senderId: senderId, receiverId: receiverId } of pendingConnections)this.sendCommand((0, $dXq3a.DiscoveryCommand), {
                senderId: senderId,
                receiverId: receiverId
            });
        });
        // setup dropped message handler to cancel orphaned promises
        this.queue.onInvocationDroppped((m)=>{
            this.rpc.response.cancel(m.invocationId);
            (0, $cxhPv.emitter)().emit({
                type: 'message-dropped',
                messageCount: this.queue.messageCount,
                messageId: m.invocationId,
                message: {
                    ...m.params
                },
                clientId: m.senderId,
                reason: 'queue-overflow'
            });
        });
        // setup client added handler to drain commands when clients are ready
        this.registry.onClientAdded((clientId)=>{
            this.drainCommands(clientId);
        });
        // observe readiness of bridge API
        (0, $cxhPv.emitter)().emit({
            type: 'bridge-ready'
        });
    }
    /**
   * Unique ID for this specific bridge API instance.
   *
   * @description Should be the 1 instance in a given JS context.
   */ get id() {
        return this.identifier;
    }
    /**
   * Indicates a specific client is ready to start sending and accepting messages.
   *
   * @param clientId unique identifier for the client.
   */ ready(clientId) {
        this.registry.addLocalClient(clientId);
        // client-specific handlers - sent by a remote client -> this bridge API instance,
        // targeting the client which we are setting up in this method
        this.createDiscoveryHandler(clientId);
        this.createReachableHandler(clientId);
        this.createTeardownHandler(clientId);
        // emit client registration event
        (0, $cxhPv.emitter)().emit({
            type: 'client-registered',
            clientId: clientId
        });
    }
    /**
   * Send a command with strongly-typed parameters to a recipient.
   *
   * @description It is possible to wait for the response of a command via the following:
   * ```typescript
   * const command = send(MyCommand, {});
   * await command.result(); // promise with result of the command
   * // optionally, to cancel:
   * command.cancel();
   * ```
   * Command invocations should be treated similarly in concept to network requests to an upstream system.
   * The upstream system can time out, disappear, crash, etc. Hence, all command results yield an optional
   * result, with resiliency baked in for connectivity with a client see {@link BufferedInvocationQueue}.
   *
   * Deferrables are used to expose a stable promise API for the result of a command. I.e., if the receiver
   * of a command is not seen as 'ready' yet, commands will be buffered until a time limit. Once that time
   * limit is expended, the message will be dropped, and its associated deferrable cancelled.
   *
   * @returns {CommandInvocation} api for handling the response of the command.
   */ send(command, params) {
        // assign a unique ID to this command invocation
        if (!params._invocationId) // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
        params._invocationId = (0, $7RHfd.default)();
        // unique, stable ID for this command
        const id = (0, $1bjC0.createInvocationId)(command, params);
        const message = (0, $1bjC0.rpcCommand)(id, command, params);
        const senderId = params.senderId;
        const receiverId = params.receiverId;
        // emit command creation event
        (0, $cxhPv.emitter)().emit({
            type: 'command-created',
            commandId: id,
            commandType: command.identifier,
            senderId: senderId,
            receiverId: receiverId,
            properties: {
                ...params
            },
            groupId: params.groupId
        });
        let promise;
        // not ready to send to a known, communicable client yet - buffer & defer (if allowed)
        if (!this.registry.has(receiverId) || !this.transport.canSend(message) || this.registry.isPendingClient(receiverId)) {
            // default to buffering the sending of all commands
            const buffer = params.buffer ?? true;
            if (buffer) {
                this.queue.enqueue(id, senderId, receiverId, command, params);
                promise = this.rpc.response.getOrCreate(id, senderId, receiverId);
            } else // opted out of buffering - resolve immediately to undefined
            promise = Promise.resolve(undefined);
        } else if (this.registry.isLocalClient(receiverId)) {
            // emit command sent event for local invocation
            (0, $cxhPv.emitter)().emit({
                type: 'command-sent',
                commandId: id,
                commandType: command.identifier,
                senderId: senderId,
                receiverId: receiverId,
                properties: params,
                groupId: params.groupId
            });
            const result = this.rpc.request.invoke(command, params);
            const existing = this.rpc.response.get(id);
            // if a local client was not ready yet and we tried to communicate with it,
            // we do not want to instantiate a new promise. Hence, we need to latch onto
            // the same deferrable as before, and yield it with the result of invoking the
            // handler provided by the local client which is ready & we are communicating to
            if (existing) {
                existing.resolve(result);
                promise = existing.promise;
            } else promise = result;
        } else {
            // emit command sent event
            (0, $cxhPv.emitter)().emit({
                type: 'command-sent',
                commandId: id,
                commandType: command.identifier,
                senderId: senderId,
                receiverId: receiverId,
                properties: params,
                groupId: params.groupId
            });
            this.transport.send(message);
            promise = this.rpc.response.getOrCreate(id, senderId, receiverId);
        }
        return new (0, $bGrVW.CommandInvocation)(id, promise, (invocationId)=>this.cancel(invocationId), (groupId)=>this.cancelGroup(groupId));
    }
    /**
   * Broadcasts a command to all registered clients except those that are pending or filtered out.
   *
   * @typeParam C - The type of command properties, which must include a `receiverId` of type `ClientId`.
   * @param command - The constructor for the broadcastable command to be sent.
   * @param params - The parameters for the command, excluding the `receiverId` which will be set for each recipient.
   * @param options - Optional broadcast options, including a filter function to select specific clients.
   *
   * @remarks
   * - Only commands that pass `isBroadcastableCommand` are sent.
   * - The method retrieves all client IDs from the registry, filters out pending clients, and applies any additional filter provided in `options`.
   * - For each eligible client, the command is sent with the appropriate `receiverId`.
   * - Errors during broadcasting are caught and logged to the console.
   */ broadcast(command, params, options) {
        try {
            var _this$registry$getAll;
            if (!(0, $hmtci.isBroadcastableCommand)(command)) return;
            const receiverIds = ((_this$registry$getAll = this.registry.getAllClientIds()) === null || _this$registry$getAll === void 0 || (_this$registry$getAll = _this$registry$getAll.filter((clientId)=>!this.registry.isPendingClient(clientId) && String(params.senderId) !== clientId)) === null || _this$registry$getAll === void 0 ? void 0 : _this$registry$getAll.filter((clientId)=>options !== null && options !== void 0 && options.filter ? options.filter(clientId) : true)) ?? [];
            for (const receiverId of receiverIds)this.send(command, {
                ...params,
                receiverId: receiverId
            });
            if (receiverIds.length) (0, $cxhPv.emitter)().emit({
                type: 'command-broadcast',
                senderId: params.senderId,
                receiverIds: receiverIds,
                commandType: command.identifier
            });
        } catch (err) {
            console.error('broadcast failed', err);
        }
    }
    /**
   * Register a handler for a specific command type for a specific client.
   */ on(clientId, Command, handler) {
        this.rpc.request.register(clientId, Command, handler);
        (0, $cxhPv.emitter)().emit({
            type: 'handler-registered',
            clientId: clientId,
            commandType: Command.identifier
        });
    }
    /**
   * Unregister a handler for a specific command type for a specific client.
   */ off(clientId, Command) {
        this.rpc.request.unregister(clientId, Command);
        (0, $cxhPv.emitter)().emit({
            type: 'handler-unregistered',
            clientId: clientId,
            commandType: Command.identifier
        });
    }
    /**
   * Tears down a specific client, removing it from the registry and notifying all remote clients.
   *
   * @description This method performs the following actions:
   * 1. Removes the client from the local registry
   * 2. Sends teardown commands to all known remote clients
   * 3. Drops all buffered messages for the client
   * 4. Unregisters all command handlers for the client
   * 5. Clears any pending response handlers for the client
   * 6. Removes transport target references for the client
   *
   * @param clientId unique identifier for the client to tear down
   */ teardown(clientId) {
        // 1. remove the client from the registry
        const wasRemoved = this.registry.removeClient(clientId);
        if (!wasRemoved) return;
        // 2. notify all remote clients about the teardown
        const allClientIds = this.registry.getAllClientIds();
        for (const otherClientId of allClientIds)// irrespective of state, we should communicate we are tearing down
        // this handles any potential race conditions with in-flight messages
        // across JS contexts (e.g., actively shaking hands with a pending client)
        if (this.registry.isPendingClient(otherClientId) || this.registry.isRemoteClient(otherClientId)) this.sendCommand((0, $dXq3a.TeardownCommand), {
            senderId: clientId,
            receiverId: otherClientId
        });
        // 3. drop all buffered messages for this client
        this.queue.clear(clientId);
        // 4. unregister all command handlers for this client
        this.rpc.request.unregisterAll(clientId);
        // 5. clear any pending response handlers for this client
        this.rpc.response.teardown(clientId);
        // 6. remove transport target references (Window/WebContents) for this client
        this.transport.teardown(clientId);
        // 7. emit client teardown event
        (0, $cxhPv.emitter)().emit({
            type: 'client-teardown',
            clientId: clientId
        });
    }
    /**
   * Clear all state prior to the application being destroyed.
   *
   * @description NOTE: Ensure all containing state is destroyed to avoid memory leaks during
   * SPA transitions away from application contexts which use the bridge API.
   */ destroy() {
        this.queue.destroy();
        this.rpc.request.destroy();
        this.rpc.response.clear();
        this.registry.destroy();
        this.transport.destroy();
        // stop emitting any events & drop memory
        (0, $cxhPv.emitter)().emit({
            type: 'bridge-destroyed'
        });
        // clean up all event emitter state
        (0, $cxhPv.destroyGlobalEventEmitter)();
        (0, $6Svem.destroyGlobalDebugConsumer)();
        (0, $llZYC.destroyGlobalObservabilityConsumer)();
    }
    /**
   * Registers a message listener for RPC events received over {@link transport}.
   * @param data RPC message received by this JS context
   */ async onMessage(data) {
        try {
            if ((0, $1bjC0.isRPCRequest)(data)) return await this.rpc.request.handleRequest(data);
            if ((0, $1bjC0.isRPCResponse)(data)) return this.rpc.response.resolveWithResponse(data);
        } catch (err) {
            console.error('failed to handle message:', err);
        }
    }
    /**
   * Sets up a reachable handler for a specific client ID
   * @summary the {@link senderId} is the remote client who sent this command, expressing they are now reachable.
   * @param senderId
   */ createReachableHandler(senderId) {
        this.on(senderId, (0, $dXq3a.ReachableCommand), (params)=>{
            this.registry.addRemoteClient(params.senderId);
            (0, $cxhPv.emitter)().emit({
                type: 'client-discovered',
                clientId: params.senderId,
                metadata: {
                    discoveryMethod: 'reachable-command',
                    localClientId: senderId
                }
            });
        });
    }
    /**
   * Sets up a discoverable handler for a specific client ID
   * @summary the {@link senderId} is the remote client who sent this command, expressing they are looking for {@link senderId}.
   * @param senderId
   */ createDiscoveryHandler(senderId) {
        this.on(senderId, (0, $dXq3a.DiscoveryCommand), (params)=>{
            this.sendCommand((0, $dXq3a.ReachableCommand), {
                senderId: params.receiverId,
                receiverId: params.senderId
            });
            this.registry.addRemoteClient(params.senderId);
            (0, $cxhPv.emitter)().emit({
                type: 'client-discovered',
                clientId: params.senderId,
                metadata: {
                    discoveryMethod: 'discovery-command',
                    localClientId: senderId
                }
            });
        });
    }
    /**
   * Sets up a teardown handler for a specific client ID
   * @summary the {@link senderId} is the remote client who sent this command, expressing they are shutting down.
   * @param receiverId the local client that should handle teardown notifications
   */ createTeardownHandler(receiverId) {
        this.on(receiverId, (0, $dXq3a.TeardownCommand), (params)=>{
            // remove the client that is tearing down from our registry
            this.registry.removeClient(params.senderId);
            // drop all buffered messages for the client that is tearing down
            this.queue.clear(params.senderId);
            if ((0, $gdUUy.fg)('rovo_bridge_remote_teardown_cleanup')) this.transport.teardown(params.senderId);
        });
    }
    /**
   * Immediately send a command over the configured {@link transport}.
   *
   * @description Used for handshake between clients, to simplify logic.
   * @description Re-used to send all commands in the bridge API.
   *
   * @param command command to send
   * @param params command properties to provide
   */ sendCommand(command, params) {
        const id = (0, $1bjC0.createInvocationId)(command, params);
        const message = (0, $1bjC0.rpcCommand)(id, command, params);
        this.transport.send(message);
    }
    /**
   * Drain commands for a given client ID from the queue.
   * @param clientId unique identifier for the client
   */ drainCommands(clientId) {
        const messages = this.queue.flush(clientId);
        if (!messages) return;
        for (const message of messages)this.send(message.command, message.params);
    }
    /**
   * Cancel all commands in a specific group.
   *
   * @param groupId The group identifier of commands to cancel
   * @returns number of commands that were cancelled
   */ cancelGroup(groupId) {
        // remove the buffered commands with this group ID from the queue, if they exist; will also clean up
        // the RPC response handler deferrable for each command
        return this.queue.cancelGroup(groupId);
    }
    /**
   * Cancel a specific command invocation by its ID.
   *
   * @param invocationId The unique identifier of the command invocation to cancel
   * @returns true if the command was found and cancelled, false otherwise
   */ cancel(invocationId) {
        // remove the buffered command from the queue, if it exists on it; this will also clean up
        // the RPC response handler deferrable for this command
        return this.queue.cancel(invocationId);
    }
}

});
parcelRegister("7vG3Z", function(module, exports) {
$parcel$export(module.exports, "ClientRegistry", () => $85dec5dd801ae084$export$c7eb95d2cb93befa);
class $85dec5dd801ae084$export$c7eb95d2cb93befa {
    /**
   * Yields the current state of a client.
   * @param clientId
   * @returns current state
   */ get(clientId) {
        return this.registry.get(clientId);
    }
    /**
   * Yields whether a given client is known or not to the registry.
   * @param clientId unique identifier for the client
   */ has(clientId) {
        return this.registry.has(clientId);
    }
    /**
   * Adds an entry for a new, pending client. It will be marked as `ready` once a successful handshake transpires.
   *
   * @description Will early exit with a warning if the client being marked as `pending` is already `ready`. This
   * is an anomalous state transition which we do not expect.
   *
   * @param clientId unique identifier for the client
   * @returns void
   */ addPendingClient(clientId) {
        const client = this.get(clientId);
        if (client && client.state === 'ready') {
            console.warn('tried to mark', clientId, 'as `pending` when already in `ready` state');
            return;
        }
        this.registry.set(clientId, {
            id: clientId,
            state: 'pending'
        });
    }
    /**
   * Adds an entry for a local client. It will be immediately ready for direct communication in the same JS context.
   *
   * @description Will early exit with a warning if the client being marked as `local` if already `remote`. This
   * is an anomalous state transition which we do not expect.
   *
   * @param clientId unique identifier for the client
   * @returns void
   */ addLocalClient(clientId) {
        if (this.isRemoteClient(clientId)) {
            console.warn('tried to mark', clientId, 'as `local` when already tracked as `remote`');
            return;
        }
        const wasAlreadyPresent = this.has(clientId);
        this.registry.set(clientId, {
            id: clientId,
            type: 'local',
            state: 'ready'
        });
        // only emit the event if this is a new client
        if (!wasAlreadyPresent) this.emitClientAdded(clientId);
    }
    /**
   * Adds an entry for a remote client. It will be ready for asynchronous communication once a handshake transpires.
   *
   * @description Will early exit with a warning if the client being marked as `remote` if already `local`. This
   * is an anomalous state transition which we do not expect.
   *
   * @param clientId unique identifier for the client
   * @returns void
   */ addRemoteClient(clientId) {
        if (this.isLocalClient(clientId)) {
            console.warn('tried to mark', clientId, 'as `remote` when already tracked as `local`');
            return;
        }
        const wasAlreadyPresent = this.has(clientId);
        this.registry.set(clientId, {
            id: clientId,
            type: 'remote',
            state: 'ready'
        });
        // only emit the event if this is a new client
        if (!wasAlreadyPresent) this.emitClientAdded(clientId);
    }
    isPendingClient(clientId) {
        const client = this.get(clientId);
        return (client === null || client === void 0 ? void 0 : client.state) === 'pending';
    }
    isLocalClient(clientId) {
        const client = this.get(clientId);
        return (client === null || client === void 0 ? void 0 : client.state) === 'ready' && client.type === 'local';
    }
    isRemoteClient(clientId) {
        const client = this.get(clientId);
        return (client === null || client === void 0 ? void 0 : client.state) === 'ready' && client.type === 'remote';
    }
    get size() {
        return this.registry.size;
    }
    /**
   * Removes a client from the registry.
   *
   * @param clientId unique identifier for the client to remove
   * @returns true if the client was removed, false if it wasn't found
   */ removeClient(clientId) {
        return this.registry.delete(clientId);
    }
    /**
   * Gets all client IDs currently in the registry.
   *
   * @returns array of all client IDs
   */ getAllClientIds() {
        return Array.from(this.registry.keys());
    }
    /**
   * Register a handler to be called when a client is added to the registry.
   *
   * @param handler Function to call when a client is added
   */ onClientAdded(handler) {
        this.onClientAddedHandlers.add(handler);
    }
    /**
   * Emit client added event to all registered handlers.
   *
   * @param clientId The client ID that was added
   */ emitClientAdded(clientId) {
        for (const handler of this.onClientAddedHandlers)try {
            handler(clientId);
        } catch (error) {
            console.error('Error in client added handler:', error);
        }
    }
    /**
   * Clean up all event handlers.
   */ destroy() {
        this.onClientAddedHandlers.clear();
        this.registry.clear();
    }
    constructor(){
        /**
   * A registry of all clients known to the current bridge API instance.
   *
   * @description NOTE: Clients undergo state transitions from pending -> ready until the current bridge
   * API instance is able to communicate with them.
   */ this.registry = new Map();
        /**
   * Event handlers for when clients are added to the registry.
   */ this.onClientAddedHandlers = new Set();
    }
}

});

parcelRegister("d6sum", function(module, exports) {
$parcel$export(module.exports, "client", () => $a4421f6dfb4ad8dc$export$388e0302ca0d9a41);
/**
 * A unique ID for referring to a client of the bridge API.
 *
 * @description Can either be a producer or receiver of events.
 */ const $a4421f6dfb4ad8dc$export$388e0302ca0d9a41 = (s)=>s;

});

parcelRegister("hmtci", function(module, exports) {
$parcel$export(module.exports, "isBroadcastableCommand", () => $9be0ed5e1efd5578$export$761a9dd8b8d30326);
function $9be0ed5e1efd5578$export$761a9dd8b8d30326(command) {
    return typeof command === 'function' && command.__broadcastable === true;
}

});

parcelRegister("bGrVW", function(module, exports) {
$parcel$export(module.exports, "CommandInvocation", () => $592c93ac0b900ab9$export$aa5e57f9f8c1afec);
class $592c93ac0b900ab9$export$aa5e57f9f8c1afec {
    constructor(invocationId, resultPromise, cancelCallback, cancelGroupCallback){
        this.invocationId = invocationId;
        this.resultPromise = resultPromise;
        this.cancelCallback = cancelCallback;
        this.cancelGroupCallback = cancelGroupCallback;
    }
    /**
   * Get the result of the command invocation.
   *
   * @description Returns a promise that resolves to the command result, or undefined if cancelled.
   *
   * @returns Promise that resolves to the command result, or undefined if cancelled
   */ result() {
        return this.resultPromise;
    }
    /**
   * Cancel this specific command invocation.
   *
   * @description Attempts to cancel the command if it's still buffered or in-flight.
   * If the command has already completed, this will have no effect.
   *
   * @returns true if the command was found and cancelled, false if it was already completed/cancelled
   */ cancel() {
        return this.cancelCallback(this.invocationId);
    }
    /**
   * Cancel all commands in a specific group.
   *
   * @description Cancels all buffered commands that share the same groupId.
   * This is useful for cancelling related commands that were sent as part of the same operation.
   *
   * @param groupId The group identifier of commands to cancel
   * @returns number of commands that were cancelled
   */ cancelGroup(groupId) {
        return this.cancelGroupCallback(groupId);
    }
}

});

parcelRegister("dXq3a", function(module, exports) {
$parcel$export(module.exports, "DiscoveryCommand", () => $14fecdff05c66874$export$ae5619804e22bb3b);
$parcel$export(module.exports, "ReachableCommand", () => $14fecdff05c66874$export$bf4ce67fda5f9b9f);
$parcel$export(module.exports, "TeardownCommand", () => $14fecdff05c66874$export$6884e468caa75174);

var $12gQu = parcelRequire("12gQu");
const $14fecdff05c66874$export$ae5619804e22bb3b = (0, $12gQu.createCommand)('discovery-command');
const $14fecdff05c66874$export$bf4ce67fda5f9b9f = (0, $12gQu.createCommand)('reachable-command');
const $14fecdff05c66874$export$6884e468caa75174 = (0, $12gQu.createCommand)('teardown-command');

});
parcelRegister("12gQu", function(module, exports) {
$parcel$export(module.exports, "createCommand", () => $fb76749d7cd4458c$export$8d4021544bdece00);

var $fFTpF = parcelRequire("fFTpF");
function $fb76749d7cd4458c$export$8d4021544bdece00(commandName) {
    return class NamedCommand extends (0, $fFTpF.Command) {
        static #_ = /**
     * @see {@link Command.identifier}
     */ this.identifier = commandName;
    };
}
function $fb76749d7cd4458c$export$87c8f2eea65200a8(commandName) {
    // We create a class and then assert the broadcastable marker.
    return class NamedBroadcastCommand extends (0, $fFTpF.Command) {
        static #_ = this.identifier = commandName;
        static #_2 = this.__broadcastable = true;
    };
}

});
parcelRegister("fFTpF", function(module, exports) {
$parcel$export(module.exports, "Command", () => $6fc6647ba05d1736$export$cc7e12c76513e857);
class $6fc6647ba05d1736$export$cc7e12c76513e857 {
    constructor(properties, result){
        this.properties = properties;
        this.result = result;
    }
}

});



parcelRegister("6Svem", function(module, exports) {
$parcel$export(module.exports, "getDebugConsumer", () => $70b857aaa693eb27$export$f646f8b6276e8a5d);
$parcel$export(module.exports, "destroyGlobalDebugConsumer", () => $70b857aaa693eb27$export$7e0c663a378d377a);

var $cxhPv = parcelRequire("cxhPv");
/**
 * Default debug configuration.
 */ const $70b857aaa693eb27$var$DEFAULT_CONFIG = {
    enabled: false,
    maxHistory: 1000
};
class $70b857aaa693eb27$export$6144c928b2a81851 {
    /**
   * Start consuming and logging bridge API events.
   */ enable() {
        if (this.subscription) return; // Already enabled
        this.config.enabled = true;
        this.subscription = (0, $cxhPv.emitter)().onAny((event)=>{
            if (this.config.enabled && this.shouldLogEvent(event)) {
                this.logEvent(event);
                this.addToHistory(event);
            }
        });
        console.log("%c\uD83C\uDF09 Rovo Bridge API Debug Mode Enabled", 'color: #4ECDC4; font-weight: bold; font-size: 14px;');
    }
    /**
   * Stop consuming bridge API events.
   */ disable() {
        if (this.subscription) {
            this.subscription.unsubscribe();
            this.subscription = null;
        }
        this.config.enabled = false;
        console.log("%c\uD83C\uDF09 Rovo Bridge API Debug Mode Disabled", 'color: #FF6B6B; font-weight: bold; font-size: 14px;');
    }
    /**
   * Update debug configuration.
   */ configure(newConfig) {
        this.config = {
            ...this.config,
            ...newConfig
        };
        console.log("%c\uD83D\uDD27 Debug configuration updated", 'color: #96CEB4; font-weight: bold;', this.config);
    }
    /**
   * Get current configuration.
   */ getConfig() {
        return {
            ...this.config
        };
    }
    /**
   * Get event history.
   */ getHistory() {
        return [
            ...this.eventHistory
        ];
    }
    /**
   * Clear event history.
   */ clearHistory() {
        this.eventHistory = [];
        console.log("%c\uD83E\uDDF9 Event history cleared", 'color: #FFEAA7; font-weight: bold;');
    }
    /**
   * Get debug statistics.
   */ getStats() {
        const eventCounts = this.eventHistory.reduce((counts, event)=>{
            counts[event.type] = (counts[event.type] || 0) + 1;
            return counts;
        }, {});
        return {
            enabled: this.config.enabled,
            totalEvents: this.eventHistory.length,
            eventCounts: eventCounts,
            uniqueClients: new Set(this.eventHistory.filter((e)=>'clientId' in e).map((e)=>e.clientId)).size,
            uniqueCommands: new Set(this.eventHistory.filter((e)=>'commandType' in e).map((e)=>e.commandType)).size
        };
    }
    /**
   * Export event history as JSON.
   */ exportHistory() {
        return JSON.stringify({
            exportedAt: new Date().toISOString(),
            config: this.config,
            events: this.eventHistory,
            stats: this.getStats()
        }, null, 2);
    }
    /**
   * Log an event to the console with simple formatting.
   */ logEvent(event) {
        const icon = this.eventIcons[event.type] || "\uD83D\uDCCB";
        const timestamp = this.formatTimestamp(event.timestamp);
        const bridgeId = event.bridgeId;
        // Create collapsible group with basic info
        const groupTitle = `${icon} ${timestamp} ${event.type} [${bridgeId}]`;
        console.groupCollapsed(`%c${groupTitle}`, this.getEventTypeStyle(event.type));
        // Add key details in a simple format
        this.logKeyDetails(event);
        // Log raw event data
        console.log('%cRaw Event:', 'color: #888; font-style: italic;', event);
        console.groupEnd();
    }
    /**
   * Log key event details in a simple format.
   */ logKeyDetails(event) {
        // Client ID (if present)
        if ('clientId' in event) {
            const clientEvent = event;
            console.log(`%c\u{1F464} Client: %c${clientEvent.clientId}`, 'font-weight: bold;', this.getClientStyle(clientEvent.clientId));
        }
        // Command details (if present)
        if ('commandType' in event) {
            const cmdEvent = event;
            console.log(`%c\u{26A1} Command: %c${cmdEvent.commandType}`, 'font-weight: bold;', this.getCommandStyle(cmdEvent.commandType));
            if (cmdEvent.senderId && cmdEvent.receiverId) console.log(`%c\u{1F4E4} %c${cmdEvent.senderId} %c\u{2192} %c\u{1F4E5} %c${cmdEvent.receiverId}`, 'font-weight: bold;', this.getClientStyle(cmdEvent.senderId), 'color: #888;', 'font-weight: bold;', this.getClientStyle(cmdEvent.receiverId));
            if (cmdEvent.duration !== undefined) console.log(`%c\u{23F1}\u{FE0F} Duration: %c${this.formatDuration(cmdEvent.duration)}`, 'font-weight: bold;', this.getDurationStyle(cmdEvent.duration));
        }
        // Error (if present)
        if ('error' in event && event.error) {
            const errorEvent = event;
            console.log("%c\u274C Error:", 'color: #FF6B6B; font-weight: bold;', errorEvent.error);
        }
        // Queue size (if present)
        if ('queueSize' in event) {
            const queueEvent = event;
            console.log(`%c\u{1F4CB} Queue Size: %c${queueEvent.queueSize}`, 'font-weight: bold;', this.getQueueSizeStyle(queueEvent.queueSize));
        }
    }
    /**
   * Check if an event should be logged (with debouncing for transport errors).
   */ shouldLogEvent(event) {
        // Apply event filter if configured
        if (this.config.eventFilter && this.config.eventFilter.length > 0) {
            const matchesFilter = this.config.eventFilter.some((filter)=>{
                // Support category filters
                if (filter === 'commands') return event.type.startsWith('command-');
                if (filter === 'clients') return event.type.startsWith('client-');
                if (filter === 'transport') return event.type.startsWith('transport-');
                if (filter === 'queue') return event.type.includes('queue') || event.type.includes('message-');
                if (filter === 'handlers') return event.type.startsWith('handler-');
                if (filter === 'bridge') return event.type.startsWith('bridge-');
                if (filter === 'errors') return event.type.includes('error') || event.type.includes('failed') || event.type.includes('dropped');
                // Support exact event type matching
                return event.type === filter;
            });
            if (!matchesFilter) return false;
        }
        // Debounce transport errors to prevent spam during tick loops
        if (event.type === 'transport-error') {
            var _transportEvent$error;
            const transportEvent = event;
            const errorKey = `${event.type}-${transportEvent.messageId || 'unknown'}-${((_transportEvent$error = transportEvent.error) === null || _transportEvent$error === void 0 ? void 0 : _transportEvent$error.message) || 'unknown'}`;
            const lastLogged = this.recentErrors.get(errorKey) || 0;
            const now = Date.now();
            if (now - lastLogged < this.ERROR_DEBOUNCE_MS) return false; // Skip this duplicate error
            this.recentErrors.set(errorKey, now);
        }
        return true;
    }
    /**
   * Add event to history with size management.
   */ addToHistory(event) {
        this.eventHistory.push(event);
        // Trim history if it exceeds max size
        if (this.eventHistory.length > this.config.maxHistory) this.eventHistory.shift();
    }
    /**
   * Get color for a client ID.
   */ getClientColor(clientId) {
        if (!this.clientColors.has(clientId)) {
            const colorIndex = this.clientColors.size % this.colors.length;
            this.clientColors.set(clientId, this.colors[colorIndex]);
        }
        return this.clientColors.get(clientId);
    }
    /**
   * Get color for a command type.
   */ getCommandColor(commandType) {
        if (!this.commandColors.has(commandType)) {
            const colorIndex = this.commandColors.size % this.colors.length;
            this.commandColors.set(commandType, this.colors[colorIndex]);
        }
        return this.commandColors.get(commandType);
    }
    /**
   * Get CSS style for event type.
   */ getEventTypeStyle(eventType) {
        const baseStyle = 'font-weight: bold; font-size: 12px;';
        if (eventType.includes('error') || eventType.includes('failed')) return `${baseStyle} color: #FF6B6B;`;
        if (eventType.includes('completed') || eventType.includes('ready')) return `${baseStyle} color: #4ECDC4;`;
        if (eventType.includes('created') || eventType.includes('sent')) return `${baseStyle} color: #45B7D1;`;
        return `${baseStyle} color: #666;`;
    }
    /**
   * Get CSS style for client ID.
   */ getClientStyle(clientId) {
        return `color: ${this.getClientColor(clientId)}; font-weight: bold;`;
    }
    /**
   * Get CSS style for command type.
   */ getCommandStyle(commandType) {
        return `color: ${this.getCommandColor(commandType)}; font-weight: bold;`;
    }
    /**
   * Get CSS style for duration based on performance.
   */ getDurationStyle(duration) {
        if (duration < 10) return 'color: #4ECDC4; font-weight: bold;';
         // Fast
        if (duration < 100) return 'color: #FFEAA7; font-weight: bold;';
         // Medium
        return 'color: #FF6B6B; font-weight: bold;'; // Slow
    }
    /**
   * Get CSS style for queue size.
   */ getQueueSizeStyle(size) {
        if (size === 0) return 'color: #4ECDC4; font-weight: bold;';
        if (size < 5) return 'color: #FFEAA7; font-weight: bold;';
        return 'color: #FF6B6B; font-weight: bold;';
    }
    /**
   * Format timestamp for display.
   */ formatTimestamp(timestamp) {
        const date = new Date(timestamp);
        return date.toLocaleTimeString('en-US', {
            hour12: false
        });
    }
    /**
   * Format duration in milliseconds.
   */ formatDuration(ms) {
        if (ms < 1) return `${(ms * 1000).toFixed(0)}\u{3BC}s`;
        if (ms < 1000) return `${ms.toFixed(1)}ms`;
        return `${(ms / 1000).toFixed(2)}s`;
    }
    constructor(){
        this.config = {
            ...$70b857aaa693eb27$var$DEFAULT_CONFIG
        };
        this.subscription = null;
        this.eventHistory = [];
        this.clientColors = new Map();
        this.commandColors = new Map();
        this.recentErrors = new Map();
        this.ERROR_DEBOUNCE_MS = 5000; // 5 seconds
        /**
   * Color palette for consistent coloring.
   */ this.colors = [
            '#FF6B6B',
            '#4ECDC4',
            '#45B7D1',
            '#96CEB4',
            '#FFEAA7',
            '#DDA0DD',
            '#98D8C8',
            '#F7DC6F',
            '#BB8FCE',
            '#85C1E9'
        ];
        /**
   * Event type icons for visual distinction.
   */ this.eventIcons = {
            // Bridge events
            'bridge-ready': "\uD83C\uDF09",
            'bridge-destroyed': "\uD83D\uDCA5",
            // Client events
            'client-registered': "\uD83D\uDCDD",
            'client-ready': "\u2705",
            'client-discovered': "\uD83D\uDD0D",
            'client-teardown': "\uD83D\uDD04",
            // Command events
            'command-created': "\u26A1",
            'command-sent': "\uD83D\uDCE4",
            'command-received': "\uD83D\uDCE5",
            'command-completed': "\u2705",
            'command-failed': "\u274C",
            // Queue events
            'message-queued': "\uD83D\uDCCB",
            'queue-flushed': "\uD83D\uDE80",
            'queue-cleared': "\uD83E\uDDF9",
            'message-dropped': "\uD83D\uDDD1\uFE0F",
            // Transport events
            'transport-ready': "\uD83D\uDE9B",
            'transport-message-sent': "\uD83D\uDCE1",
            'transport-message-received': "\uD83D\uDCFB",
            'transport-error': "\u26A0\uFE0F",
            'transport-destroyed': "\uD83D\uDC80",
            // Handler events
            'handler-registered': "\uD83D\uDD27",
            'handler-unregistered': "\uD83D\uDD13",
            // Broadcast events
            'command-broadcast': "\uD83D\uDCE2"
        };
    }
}
/**
 * Global debug consumer instance.
 */ let $70b857aaa693eb27$var$globalDebugConsumer = null;
function $70b857aaa693eb27$export$f646f8b6276e8a5d() {
    if (!$70b857aaa693eb27$var$globalDebugConsumer) $70b857aaa693eb27$var$globalDebugConsumer = new $70b857aaa693eb27$export$6144c928b2a81851();
    return $70b857aaa693eb27$var$globalDebugConsumer;
}
function $70b857aaa693eb27$export$7e0c663a378d377a() {
    if ($70b857aaa693eb27$var$globalDebugConsumer) {
        $70b857aaa693eb27$var$globalDebugConsumer.disable();
        $70b857aaa693eb27$var$globalDebugConsumer = null;
    }
}

});
parcelRegister("cxhPv", function(module, exports) {
$parcel$export(module.exports, "emitter", () => $73561aebff837b16$export$bad24218ebd77223);
$parcel$export(module.exports, "destroyGlobalEventEmitter", () => $73561aebff837b16$export$9e5e7c9e5a788cf7);
class $73561aebff837b16$export$543ba59d3cb254aa {
    constructor(config = {}){
        this.handlers = new Map();
        this.globalHandlers = new Set();
        this.bridgeId = null;
        this.config = {
            enabled: true,
            ...config
        };
    }
    /**
   * Set the bridge ID for this emitter instance.
   * Should be called once when the bridge API is initialized.
   *
   * @param bridgeId The unique identifier for the bridge API instance
   */ setBridgeId(bridgeId) {
        this.bridgeId = bridgeId;
    }
    /**
   * Emit an event to all registered handlers.
   * Automatically adds timestamp and bridge ID to the event.
   *
   * @param event The event to emit (without timestamp and bridgeId)
   */ emit(event) {
        // Early return if emitter is disabled
        if (!this.config.enabled) return;
        // Automatically add timestamp and bridge ID
        const fullEvent = {
            ...event,
            timestamp: Date.now(),
            bridgeId: this.bridgeId ?? 'unknown-bridge'
        };
        // Emit to type-specific handlers
        const typeHandlers = this.handlers.get(fullEvent.type);
        if (typeHandlers) for (const handler of typeHandlers)this.safeInvoke(handler, fullEvent);
        // Emit to global handlers
        for (const handler of this.globalHandlers)this.safeInvoke(handler, fullEvent);
    }
    /**
   * Listen for events of a specific type.
   *
   * @param eventType The type of event to listen for
   * @param handler The handler function to call when the event occurs
   * @returns A subscription handle
   */ on(eventType, handler) {
        if (!this.handlers.has(eventType)) this.handlers.set(eventType, new Set());
        const handlers = this.handlers.get(eventType);
        handlers.add(handler);
        return this.createSubscription(()=>{
            handlers.delete(handler);
            if (handlers.size === 0) this.handlers.delete(eventType);
        });
    }
    /**
   * Listen for all events regardless of type.
   *
   * @param handler The handler function to call for any event
   * @returns A subscription handle
   */ onAny(handler) {
        this.globalHandlers.add(handler);
        return this.createSubscription(()=>{
            this.globalHandlers.delete(handler);
        });
    }
    /**
   * Remove a specific handler for an event type.
   *
   * @param eventType The event type to remove the handler from
   * @param handler The handler to remove
   */ off(eventType, handler) {
        const handlers = this.handlers.get(eventType);
        if (handlers) {
            handlers.delete(handler);
            if (handlers.size === 0) this.handlers.delete(eventType);
        }
    }
    /**
   * Remove all handlers for a specific event type.
   *
   * @param eventType The event type to clear handlers for
   */ removeAllListeners(eventType) {
        if (eventType) this.handlers.delete(eventType);
        else {
            this.handlers.clear();
            this.globalHandlers.clear();
        }
    }
    /**
   * Update emitter configuration.
   *
   * @param config New configuration options
   */ configure(config) {
        this.config = {
            ...this.config,
            ...config
        };
    }
    /**
   * Enable or disable the emitter.
   *
   * @param enabled Whether to enable event emission
   */ setEnabled(enabled) {
        this.config.enabled = enabled;
    }
    /**
   * Check if the emitter is currently enabled.
   */ isEnabled() {
        return this.config.enabled;
    }
    /**
   * Destroy the emitter and clean up all resources.
   */ destroy() {
        this.handlers.clear();
        this.globalHandlers.clear();
        this.config.enabled = false;
    }
    /**
   * Safely invoke a handler, catching any errors.
   */ safeInvoke(handler, event) {
        try {
            handler(event);
        } catch  {
        // we do not want to produce error logs for the observer
        // if you need to add logs, go for it - just remove them afterwards!
        }
    }
    /**
   * Create a subscription handle.
   */ createSubscription(unsubscribeFn) {
        let active = true;
        return {
            unsubscribe: ()=>{
                if (active) {
                    unsubscribeFn();
                    active = false;
                }
            },
            isActive: ()=>active
        };
    }
}
/**
 * Default global event emitter instance.
 *
 * This can be used as a singleton across the bridge API, or individual
 * bridge instances can create their own emitters.
 */ let $73561aebff837b16$var$globalEmitter = null;
function $73561aebff837b16$export$bad24218ebd77223() {
    if (!$73561aebff837b16$var$globalEmitter) $73561aebff837b16$var$globalEmitter = new $73561aebff837b16$export$543ba59d3cb254aa();
    return $73561aebff837b16$var$globalEmitter;
}
function $73561aebff837b16$export$9e5e7c9e5a788cf7() {
    if ($73561aebff837b16$var$globalEmitter) {
        $73561aebff837b16$var$globalEmitter.destroy();
        $73561aebff837b16$var$globalEmitter = null;
    }
}

});


parcelRegister("llZYC", function(module, exports) {
$parcel$export(module.exports, "destroyGlobalObservabilityConsumer", () => $b137159e9132b243$export$19aa922f09a1d9de);

var $cxhPv = parcelRequire("cxhPv");
const $b137159e9132b243$var$DEFAULT_CONFIG = {
    registrationGapThresholdMs: 10000,
    queueDepthWarningThreshold: 50,
    registrationGapDebounceMs: 60000
};
class $b137159e9132b243$export$43f799969b7f8bad {
    enable(sink, config) {
        if (this.subscription) return;
        if (config) this.config = {
            ...$b137159e9132b243$var$DEFAULT_CONFIG,
            ...config
        };
        this.sink = sink;
        this.subscription = (0, $cxhPv.emitter)().onAny((event)=>this.handle(event));
    }
    disable() {
        var _this$subscription;
        (_this$subscription = this.subscription) === null || _this$subscription === void 0 || _this$subscription.unsubscribe();
        this.subscription = null;
        this.sink = null;
        for (const { timer: timer } of this.pendingReceivers.values())clearTimeout(timer);
        this.pendingReceivers.clear();
        this.registeredClients.clear();
        this.lastGapEmittedAt.clear();
    }
    isEnabled() {
        return this.subscription !== null;
    }
    handle(event) {
        switch(event.type){
            case 'client-registered':
            case 'client-discovered':
                {
                    const { clientId: clientId } = event;
                    this.registeredClients.add(clientId);
                    this.resolvePendingReceiver(clientId, 'registration-succeeded');
                    break;
                }
            case 'client-teardown':
                {
                    const { clientId: clientId } = event;
                    this.registeredClients.delete(clientId);
                    this.resolvePendingReceiver(clientId, 'registration-aborted');
                    break;
                }
            case 'message-queued':
                {
                    const queueEvent = event;
                    const receiverId = queueEvent.clientId;
                    if (receiverId && !this.registeredClients.has(receiverId)) this.trackPendingReceiver(receiverId);
                    if ((queueEvent.messageCount ?? 0) >= this.config.queueDepthWarningThreshold) this.forward('message-queued', event, {
                        clientId: receiverId,
                        reason: queueEvent.reason,
                        queueDepth: queueEvent.messageCount
                    });
                    break;
                }
            case 'queue-flushed':
                {
                    const receiverId = event.clientId;
                    if (receiverId) this.resolvePendingReceiver(receiverId, 'registration-succeeded');
                    break;
                }
            case 'queue-cleared':
                {
                    const receiverId = event.clientId;
                    if (receiverId) this.resolvePendingReceiver(receiverId, 'registration-aborted');
                    break;
                }
            case 'message-dropped':
                {
                    const queueEvent = event;
                    this.forward('message-dropped', event, {
                        clientId: queueEvent.clientId,
                        reason: queueEvent.reason,
                        queueDepth: queueEvent.messageCount
                    });
                    break;
                }
            default:
                break;
        }
    }
    trackPendingReceiver(receiverId) {
        var _this$sink;
        if (this.pendingReceivers.has(receiverId)) return;
        const timer = setTimeout(()=>this.emitRegistrationGap(receiverId), this.config.registrationGapThresholdMs);
        this.pendingReceivers.set(receiverId, {
            firstQueuedAt: Date.now(),
            timer: timer
        });
        (_this$sink = this.sink) === null || _this$sink === void 0 || _this$sink.call(this, {
            signal: 'registration-pending',
            clientId: receiverId,
            timestamp: Date.now()
        });
    }
    resolvePendingReceiver(receiverId, outcome) {
        var _this$sink2;
        const pending = this.pendingReceivers.get(receiverId);
        if (!pending) return;
        clearTimeout(pending.timer);
        this.pendingReceivers.delete(receiverId);
        const now = Date.now();
        (_this$sink2 = this.sink) === null || _this$sink2 === void 0 || _this$sink2.call(this, {
            signal: outcome,
            clientId: receiverId,
            waitedMs: now - pending.firstQueuedAt,
            timestamp: now
        });
    }
    emitRegistrationGap(receiverId) {
        var _this$sink3;
        const pending = this.pendingReceivers.get(receiverId);
        this.pendingReceivers.delete(receiverId);
        if (!pending || this.registeredClients.has(receiverId)) return;
        const now = Date.now();
        const lastEmitted = this.lastGapEmittedAt.get(receiverId);
        if (lastEmitted !== undefined && now - lastEmitted < this.config.registrationGapDebounceMs) return;
        this.lastGapEmittedAt.set(receiverId, now);
        (_this$sink3 = this.sink) === null || _this$sink3 === void 0 || _this$sink3.call(this, {
            signal: 'registration-gap',
            clientId: receiverId,
            waitedMs: now - pending.firstQueuedAt,
            timestamp: now
        });
    }
    forward(signal, source, fields) {
        var _this$sink4;
        (_this$sink4 = this.sink) === null || _this$sink4 === void 0 || _this$sink4.call(this, {
            signal: signal,
            timestamp: source.timestamp ?? Date.now(),
            bridgeId: source.bridgeId,
            ...fields
        });
    }
    constructor(){
        this.subscription = null;
        this.sink = null;
        this.config = {
            ...$b137159e9132b243$var$DEFAULT_CONFIG
        };
        this.registeredClients = new Set();
        this.pendingReceivers = new Map();
        this.lastGapEmittedAt = new Map();
    }
}
let $b137159e9132b243$var$globalObservabilityConsumer = null;
function $b137159e9132b243$export$4c639b188cc02177() {
    if (!$b137159e9132b243$var$globalObservabilityConsumer) $b137159e9132b243$var$globalObservabilityConsumer = new $b137159e9132b243$export$43f799969b7f8bad();
    return $b137159e9132b243$var$globalObservabilityConsumer;
}
function $b137159e9132b243$export$19aa922f09a1d9de() {
    if ($b137159e9132b243$var$globalObservabilityConsumer) {
        $b137159e9132b243$var$globalObservabilityConsumer.disable();
        $b137159e9132b243$var$globalObservabilityConsumer = null;
    }
}

});

parcelRegister("dfqF9", function(module, exports) {
$parcel$export(module.exports, "BufferedInvocationQueue", () => $3b2f2bb4a776a21a$export$b0fcb10052c4c5ff);

var $cxhPv = parcelRequire("cxhPv");

var $6Kbk7 = parcelRequire("6Kbk7");
class $3b2f2bb4a776a21a$export$b0fcb10052c4c5ff {
    /**
   * Buffers an invocation into a queue tied to the intended {@link receiverId}.
   *
   * @description Once the receiver is reachable, this message will be flushed alongside any other messages
   * which were previously enqueued against the provided {@link receiverId}.
   *
   * @param invocationId
   * @param senderId
   * @param receiverId
   * @param command
   * @param params
   */ enqueue(invocationId, senderId, receiverId, command, params) {
        const queue = this.queue.get(receiverId) ?? [];
        const now = performance.now();
        const groupId = params.groupId;
        // check the receiver is not overwhelmed with too many pending messages; if it is, drop the oldest message
        if (queue.length >= (0, $6Kbk7.MAX_MESSAGES_PER_RECEIVER)) {
            console.warn(`Message queue for receiver ${receiverId} is full, dropping oldest message`);
            const expired = queue.shift();
            if (expired) {
                var _this$onInvocationDro;
                (_this$onInvocationDro = this.onInvocationDropped) === null || _this$onInvocationDro === void 0 || _this$onInvocationDro.call(this, expired);
            }
        }
        // check if the overall queue isn't overwhelmed; if it is, drop the oldest message from each receiver
        if (this.messageCount >= (0, $6Kbk7.MAX_TOTAL_MESSAGES)) {
            console.warn('Total message queue is full, dropping oldest messages');
            this.checkAndDropOldestMessage();
        }
        // If this command has a groupId, reset the timer for all commands with the same groupId
        if (groupId) this.resetGroupTimers(groupId, now);
        queue.push({
            invocationId: invocationId,
            senderId: senderId,
            receiverId: receiverId,
            command: command,
            params: params,
            enqueuedAt: now
        });
        this.queue.set(receiverId, queue);
        (0, $cxhPv.emitter)().emit({
            type: 'message-queued',
            messageCount: this.messageCount,
            messageId: invocationId,
            clientId: receiverId,
            reason: 'receiver-not-ready'
        });
        // now that we have >1 message (at least), start a tick which executes every N millis
        // and drop any messages which go beyond the lifetime limit
        this.startTick();
    }
    /**
   * Flush all messages associated with a speciifc receiver.
   *
   * @description Typically called once the receiver is marked as ready.
   *
   * @param receiverId unique identifier for the receiver
   */ flush(receiverId) {
        const messages = this.queue.get(receiverId);
        // no messages found
        if (!messages) return;
        // we know we have a reference in the message list now - remove it
        this.deleteClientFromQueue(receiverId);
        // empty message list
        if (messages.length === 0) return;
        // emit queue flush event
        (0, $cxhPv.emitter)().emit({
            type: 'queue-flushed',
            clientId: receiverId,
            messageCount: messages.length,
            reason: 'client-ready'
        });
        // return no-empty message list
        return messages;
    }
    /**
   * Returns the total number of messages across all receivers.
   * @returns count of messages across all buffered receivers
   */ get messageCount() {
        return Array.from(this.queue.values()).reduce((sum, q)=>sum + q.length, 0);
    }
    /**
   * Registers a callback to be called on every tick with unique senderId/receiverId pairs
   * for clients that are still waiting to connect.
   *
   * @param callback Function to call with pending connection pairs
   */ onTick(callback) {
        this.onTickCallback = callback;
    }
    /**
   * Registers a callback to be called when a message is dropped due to expiration or queue overflow.
   *
   * @param callback Callback to invoke with the dropped message
   */ onInvocationDroppped(callback) {
        this.onInvocationDropped = callback;
    }
    /**
   * Drops all buffered messages for a specific client (both as sender and receiver).
   *
   * @param clientId unique identifier for the client whose messages should be dropped
   * @returns number of messages that were dropped
   */ clear(clientId) {
        let droppedCount = 0;
        const toDelete = new Set();
        // remove all messages where this client is the receiver
        if (this.queue.has(clientId)) {
            const messages = this.queue.get(clientId) ?? [];
            if (messages.length > 0) (0, $cxhPv.emitter)().emit({
                type: 'queue-cleared',
                clientId: clientId,
                messageCount: this.messageCount - messages.length,
                reason: 'client-teardown'
            });
            // notify before dropping messages
            if (this.onInvocationDropped) for (const message of messages)this.onInvocationDropped(message);
            droppedCount += messages.length;
            // delete immediately - we do not want to process this queue below
            this.queue.delete(clientId);
        }
        // remove all messages where this client is the sender
        for (const [receiverId, messages] of this.queue){
            const messagesLength = messages.length;
            const messagesToKeep = messages.filter((message)=>{
                if (message.senderId === clientId) {
                    // notify before dropping message
                    if (this.onInvocationDropped) this.onInvocationDropped(message);
                    return false;
                }
                return true;
            });
            const removedCount = messagesLength - messagesToKeep.length;
            if (removedCount > 0) {
                droppedCount += removedCount;
                if (messagesToKeep.length === 0) toDelete.add(receiverId);
                else this.queue.set(receiverId, messagesToKeep);
            }
        }
        // clean up empty queues and stop tick
        this.deleteClientsFromQueue(toDelete);
        return droppedCount;
    }
    /**
   * Drops a specific buffered message by its invocation ID.
   *
   * @param invocationId The unique identifier of the message to drop
   * @returns true if the message was found and dropped, false otherwise
   */ cancel(invocationId) {
        for (const [receiverId, messages] of this.queue){
            const messageIndex = messages.findIndex((msg)=>msg.invocationId === invocationId);
            if (messageIndex !== -1) {
                const droppedMessage = messages[messageIndex];
                // notify before dropping message
                if (this.onInvocationDropped) this.onInvocationDropped(droppedMessage);
                // remove the message
                messages.splice(messageIndex, 1);
                // if no more messages for this receiver, clean up
                if (messages.length === 0) this.deleteClientFromQueue(receiverId);
                return true;
            }
        }
        return false;
    }
    /**
   * Cancels all buffered messages that match a specific group ID.
   *
   * @param groupId The group identifier of messages to cancel
   * @returns number of messages that were cancelled
   */ cancelGroup(groupId) {
        let droppedCount = 0;
        const toDelete = new Set();
        for (const [receiverId, messages] of this.queue){
            const messagesToKeep = messages.filter((message)=>{
                if (message.params.groupId === groupId) {
                    // notify before dropping message
                    if (this.onInvocationDropped) this.onInvocationDropped(message);
                    droppedCount++;
                    return false;
                }
                return true;
            });
            if (messagesToKeep.length === 0) toDelete.add(receiverId);
            else if (messagesToKeep.length !== messages.length) this.queue.set(receiverId, messagesToKeep);
        }
        // clean up empty queues
        this.deleteClientsFromQueue(toDelete);
        return droppedCount;
    }
    /**
   * Clear all state relevant to the queue.
   */ destroy() {
        this.queue.clear();
        if (this.tick) {
            clearInterval(this.tick);
            this.tick = undefined;
        }
        // clear callback references
        this.onTickCallback = undefined;
        this.onInvocationDropped = undefined;
    }
    /**
   * Checks the lifetime of all messages in the queue and drops them if they have exceeded their
   * maximum allowed lifetime of {@link MESSAGE_LIFETIME_IN_MILLIS}.
   */ checkLifetimeAndDrop() {
        const now = performance.now();
        const toDelete = new Set();
        // cull all messages for each receiver which have expired
        for (const [receiverId, messages] of this.queue){
            let needle = 0;
            // find the first message that has not expired (since messages are chronologically ordered)
            for(let idx = 0; idx < messages.length; idx++){
                const waitTime = now - messages[idx].enqueuedAt;
                if (waitTime <= (0, $6Kbk7.MESSAGE_LIFETIME_IN_MILLIS)) {
                    needle = idx;
                    break;
                } else needle = messages.length;
            }
            // remove all expired messages in one sweep
            if (needle > 0) {
                // notify before dropping messages
                if (this.onInvocationDropped) for(let idx = 0; idx < needle; idx++)this.onInvocationDropped(messages[idx]);
                // remove expired messages
                messages.splice(0, needle);
            }
            // if we no longer have any messages, we should clear this entry entirely
            if (messages.length === 0) toDelete.add(receiverId);
        }
        // clean up all empty entries
        this.deleteClientsFromQueue(toDelete);
    }
    /**
   * Drops the oldest messages across all receivers when the total queue size is exceeded.
   */ checkAndDropOldestMessage() {
        let oldest = Infinity;
        let receiver = null;
        for (const [receiverId, messages] of this.queue)if (messages.length > 0 && messages[0].enqueuedAt < oldest) {
            oldest = messages[0].enqueuedAt;
            receiver = receiverId;
        }
        // drop the oldest message
        if (receiver) {
            const queue = this.queue.get(receiver) ?? [];
            queue.shift();
            // if no more messages - clean up
            if (queue.length === 0) this.deleteClientFromQueue(receiver);
        }
    }
    /**
   * Resets the enqueuedAt time for all messages with the specified groupId across all receivers.
   * This ensures that when a new message with a groupId is enqueued, all messages in the same
   * group get their timer reset, allowing the entire group to stay alive for MESSAGE_LIFETIME_IN_MILLIS
   * after the last message in the group.
   *
   * @param groupId The group identifier to reset timers for
   * @param newTime The new enqueuedAt time to set for all messages in the group
   */ resetGroupTimers(groupId, newTime) {
        for (const messages of this.queue.values()){
            for (const message of messages)if (message.params.groupId === groupId) message.enqueuedAt = newTime;
        }
    }
    /**
   * Extracts unique senderId/receiverId pairs from all buffered messages.
   * @returns Array of unique sender/receiver pairs that are still waiting to connect
   */ getUniquePendingConnections() {
        const uniquePairs = new Map();
        for (const messages of this.queue.values())for (const message of messages){
            const key = `${message.senderId}:${message.receiverId}`;
            if (!uniquePairs.has(key)) uniquePairs.set(key, {
                senderId: message.senderId,
                receiverId: message.receiverId
            });
        }
        return Array.from(uniquePairs.values());
    }
    /**
   * Safely deletes a single client from the queue and handles cleanup.
   *
   * @param clientId The client to remove from the queue
   * @private
   */ deleteClientFromQueue(clientId) {
        this.queue.delete(clientId);
        this.stopTick();
    }
    /**
   * Safely deletes multiple clients from the queue and handles cleanup.
   *
   * @param clientIds Set of client IDs to remove from the queue
   * @private
   */ deleteClientsFromQueue(clientIds) {
        for (const clientId of clientIds)this.queue.delete(clientId);
        this.stopTick();
    }
    constructor(){
        /**
   * A queue of messages keyed against a recipient client ID.
   *
   * @description Once the receiver is ready, we will flush all messages to them, IF they have not expired.
   */ this.queue = new Map();
        /**
   * A lazy tick which is executed only if there are buffered messages, and cleans up a message after
   * {@link MESSAGE_LIFETIME_IN_MILLIS} have elapsed since the message was enqueued.
   *
   * @description NOTE: It is important to ensure there is only one interval which can run at any given time.
   * Too many timers can clog up the event loop and slow execution:
   */ this.tick = undefined;
        /**
   * Starts an interval which does a full sweep every {@link MESSAGE_TICK_TIME_IN_MILLIS} to drop messages
   * which have gone beyond their lifetime.
   *
   * @description NOTE: The use of {@link setInterval} is deliberate here, as browsers will try their best
   * to continue executing {@link setInterval} callbacks even if a tab is unfocused. If the tab enters the
   * 'frozen' state in Chromium browsers, then execution is completely paused as per:
   * @see {@link https://developer.chrome.com/docs/web-platform/page-lifecycle-api}
   */ this.startTick = ()=>{
            if (this.tick) return;
            this.tick = setInterval(()=>{
                this.checkLifetimeAndDrop();
                // Call the onTick callback if registered and there are buffered messages
                if (this.onTickCallback && this.queue.size > 0) {
                    const pendingConnections = this.getUniquePendingConnections();
                    this.onTickCallback(pendingConnections);
                }
            }, (0, $6Kbk7.MESSAGE_TICK_TIME_IN_MILLIS));
        };
        /**
   * Stops the tick if there are no more messages to process.
   */ this.stopTick = ()=>{
            if (this.queue.size > 0) return;
            clearInterval(this.tick);
            this.tick = undefined;
        };
    }
}

});
parcelRegister("6Kbk7", function(module, exports) {
$parcel$export(module.exports, "MESSAGE_LIFETIME_IN_MILLIS", () => $73f8927b52ff78fd$export$ac4b6c122e5e5626);
$parcel$export(module.exports, "MESSAGE_TICK_TIME_IN_MILLIS", () => $73f8927b52ff78fd$export$5176aa4eceb2405e);
$parcel$export(module.exports, "MAX_MESSAGES_PER_RECEIVER", () => $73f8927b52ff78fd$export$1552419560d53c41);
$parcel$export(module.exports, "MAX_TOTAL_MESSAGES", () => $73f8927b52ff78fd$export$2805cdefd9b18065);
// Max time in millis an enqueued invocation message is allowed to live on the queue.
// NOTE: we choose a number which represents a reasonable portion of a user's session.
// I.e., if a user is SPA navigating a web / desktop app, we expect them to stick around
// for more than a typical web page. The longer they stay, the more the probability of objects
// starting to hang around in memory. But also: we don't want to clean up too soon in case we
// have a flakey receiver / want to peform a full event replay / rehydration. Hence the number
// chosen below. For future readers consider AI networking streams & events (long-running).
const $73f8927b52ff78fd$export$ac4b6c122e5e5626 = 90000;
const $73f8927b52ff78fd$export$5176aa4eceb2405e = 100;
const $73f8927b52ff78fd$export$1552419560d53c41 = 1000;
const $73f8927b52ff78fd$export$2805cdefd9b18065 = 10000;

});


parcelRegister("1bjC0", function(module, exports) {
$parcel$export(module.exports, "createInvocationId", () => $7984f182ccba3e71$export$4f25fe9107a7301c);
$parcel$export(module.exports, "rpcCommand", () => $7984f182ccba3e71$export$e414fa4333835a96);
$parcel$export(module.exports, "rpcSuccess", () => $7984f182ccba3e71$export$8dddc5c53da4c063);
$parcel$export(module.exports, "rpcError", () => $7984f182ccba3e71$export$97e0f665ead0e435);
$parcel$export(module.exports, "isRPCRequest", () => $7984f182ccba3e71$export$94e3360fcddccc76);
$parcel$export(module.exports, "isRPCResponse", () => $7984f182ccba3e71$export$c2a53faed5b3a8da);

var $lbNvM = parcelRequire("lbNvM");
function $7984f182ccba3e71$export$4f25fe9107a7301c(commandClass, commandProperties) {
    const parts = [
        'rovo-bridge-api',
        commandProperties.senderId,
        commandProperties.receiverId,
        commandClass.identifier,
        commandProperties._invocationId ?? 'unspecified-id'
    ];
    return parts.join(':');
}
function $7984f182ccba3e71$export$e414fa4333835a96(id, commandClass, commandProperties) {
    return (0, $lbNvM.createJSONRPCRequest)(id, commandClass.identifier, commandProperties);
}
function $7984f182ccba3e71$export$8dddc5c53da4c063(id, senderId, receiverId, result) {
    const response = (0, $lbNvM.createJSONRPCSuccessResponse)(id, result);
    return {
        ...response,
        params: {
            senderId: senderId,
            receiverId: receiverId
        }
    };
}
function $7984f182ccba3e71$export$97e0f665ead0e435(id, senderId, receiverId, code = (0, $lbNvM.JSONRPCErrorCode).InternalError, error) {
    const response = (0, $lbNvM.createJSONRPCErrorResponse)(id, code, error.message, error.stack);
    return {
        ...response,
        params: {
            senderId: senderId,
            receiverId: receiverId
        }
    };
}
function $7984f182ccba3e71$export$94e3360fcddccc76(request) {
    return Boolean((0, $lbNvM.isJSONRPCRequest)(request) && request.id && typeof request.id === 'string');
}
function $7984f182ccba3e71$export$c2a53faed5b3a8da(response) {
    return Boolean((0, $lbNvM.isJSONRPCResponse)(response) && response.id && typeof response.id === 'string');
}

});
parcelRegister("lbNvM", function(module, exports) {
"use strict";
var $03fb1d08628115fd$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $03fb1d08628115fd$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $03fb1d08628115fd$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$03fb1d08628115fd$var$__exportStar((parcelRequire("klOZo")), module.exports);

$03fb1d08628115fd$var$__exportStar((parcelRequire("aLgOD")), module.exports);

$03fb1d08628115fd$var$__exportStar((parcelRequire("6GzY1")), module.exports);

$03fb1d08628115fd$var$__exportStar((parcelRequire("4VkXI")), module.exports);

$03fb1d08628115fd$var$__exportStar((parcelRequire("coXoV")), module.exports);

});
parcelRegister("klOZo", function(module, exports) {
"use strict";
var $ed0d523b624a24d7$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $ed0d523b624a24d7$var$__generator = module.exports && module.exports.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.JSONRPCClient = void 0;

var $6GzY1 = parcelRequire("6GzY1");

var $eOCwa = parcelRequire("eOCwa");
var $ed0d523b624a24d7$var$JSONRPCClient = /** @class */ function() {
    function JSONRPCClient(_send, createID) {
        this._send = _send;
        this.createID = createID;
        this.idToResolveMap = new Map();
        this.id = 0;
    }
    JSONRPCClient.prototype._createID = function() {
        if (this.createID) return this.createID();
        else return ++this.id;
    };
    JSONRPCClient.prototype.timeout = function(delay, overrideCreateJSONRPCErrorResponse) {
        var _this = this;
        if (overrideCreateJSONRPCErrorResponse === void 0) overrideCreateJSONRPCErrorResponse = function(id) {
            return (0, $6GzY1.createJSONRPCErrorResponse)(id, $eOCwa.DefaultErrorCode, "Request timeout");
        };
        var timeoutRequest = function(ids, request) {
            var timeoutID = setTimeout(function() {
                ids.forEach(function(id) {
                    var resolve = _this.idToResolveMap.get(id);
                    if (resolve) {
                        _this.idToResolveMap.delete(id);
                        resolve(overrideCreateJSONRPCErrorResponse(id));
                    }
                });
            }, delay);
            return request().then(function(result) {
                clearTimeout(timeoutID);
                return result;
            }, function(error) {
                clearTimeout(timeoutID);
                return Promise.reject(error);
            });
        };
        var requestAdvanced = function(request, clientParams) {
            var ids = (!Array.isArray(request) ? [
                request
            ] : request).map(function(request) {
                return request.id;
            }).filter($ed0d523b624a24d7$var$isDefinedAndNonNull);
            return timeoutRequest(ids, function() {
                return _this.requestAdvanced(request, clientParams);
            });
        };
        return {
            request: function(method, params, clientParams) {
                var id = _this._createID();
                return timeoutRequest([
                    id
                ], function() {
                    return _this.requestWithID(method, params, clientParams, id);
                });
            },
            requestAdvanced: function(request, clientParams) {
                return requestAdvanced(request, clientParams);
            }
        };
    };
    JSONRPCClient.prototype.request = function(method, params, clientParams) {
        return this.requestWithID(method, params, clientParams, this._createID());
    };
    JSONRPCClient.prototype.requestWithID = function(method, params, clientParams, id) {
        return $ed0d523b624a24d7$var$__awaiter(this, void 0, void 0, function() {
            var request, response;
            return $ed0d523b624a24d7$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        request = (0, $6GzY1.createJSONRPCRequest)(id, method, params);
                        return [
                            4 /*yield*/ ,
                            this.requestAdvanced(request, clientParams)
                        ];
                    case 1:
                        response = _a.sent();
                        if (response.result !== undefined && !response.error) return [
                            2 /*return*/ ,
                            response.result
                        ];
                        else if (response.result === undefined && response.error) return [
                            2 /*return*/ ,
                            Promise.reject(new $6GzY1.JSONRPCErrorException(response.error.message, response.error.code, response.error.data))
                        ];
                        else return [
                            2 /*return*/ ,
                            Promise.reject(new Error("An unexpected error occurred"))
                        ];
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    JSONRPCClient.prototype.requestAdvanced = function(requests, clientParams) {
        var _this = this;
        var areRequestsOriginallyArray = Array.isArray(requests);
        if (!Array.isArray(requests)) requests = [
            requests
        ];
        var requestsWithID = requests.filter(function(request) {
            return $ed0d523b624a24d7$var$isDefinedAndNonNull(request.id);
        });
        var promises = requestsWithID.map(function(request) {
            return new Promise(function(resolve) {
                return _this.idToResolveMap.set(request.id, resolve);
            });
        });
        var promise = Promise.all(promises).then(function(responses) {
            if (areRequestsOriginallyArray || !responses.length) return responses;
            else return responses[0];
        });
        return this.send(areRequestsOriginallyArray ? requests : requests[0], clientParams).then(function() {
            return promise;
        }, function(error) {
            requestsWithID.forEach(function(request) {
                _this.receive((0, $6GzY1.createJSONRPCErrorResponse)(request.id, $eOCwa.DefaultErrorCode, error && error.message || "Failed to send a request"));
            });
            return promise;
        });
    };
    JSONRPCClient.prototype.notify = function(method, params, clientParams) {
        var request = (0, $6GzY1.createJSONRPCNotification)(method, params);
        this.send(request, clientParams).then(undefined, function() {
            return undefined;
        });
    };
    JSONRPCClient.prototype.send = function(payload, clientParams) {
        return $ed0d523b624a24d7$var$__awaiter(this, void 0, void 0, function() {
            return $ed0d523b624a24d7$var$__generator(this, function(_a) {
                return [
                    2 /*return*/ ,
                    this._send(payload, clientParams)
                ];
            });
        });
    };
    JSONRPCClient.prototype.rejectAllPendingRequests = function(message) {
        this.idToResolveMap.forEach(function(resolve, id) {
            return resolve((0, $6GzY1.createJSONRPCErrorResponse)(id, $eOCwa.DefaultErrorCode, message));
        });
        this.idToResolveMap.clear();
    };
    JSONRPCClient.prototype.receive = function(responses) {
        var _this = this;
        if (!Array.isArray(responses)) responses = [
            responses
        ];
        responses.forEach(function(response) {
            var resolve = _this.idToResolveMap.get(response.id);
            if (resolve) {
                _this.idToResolveMap.delete(response.id);
                resolve(response);
            }
        });
    };
    return JSONRPCClient;
}();
module.exports.JSONRPCClient = $ed0d523b624a24d7$var$JSONRPCClient;
var $ed0d523b624a24d7$var$isDefinedAndNonNull = function(value) {
    return value !== undefined && value !== null;
};

});
parcelRegister("6GzY1", function(module, exports) {
"use strict";
var $4de2909d51a1a245$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.createJSONRPCNotification = module.exports.createJSONRPCRequest = module.exports.createJSONRPCSuccessResponse = module.exports.createJSONRPCErrorResponse = module.exports.JSONRPCErrorCode = module.exports.JSONRPCErrorException = module.exports.isJSONRPCResponses = module.exports.isJSONRPCResponse = module.exports.isJSONRPCRequests = module.exports.isJSONRPCRequest = module.exports.isJSONRPCID = module.exports.JSONRPC = void 0;
module.exports.JSONRPC = "2.0";
var $4de2909d51a1a245$var$isJSONRPCID = function(id) {
    return typeof id === "string" || typeof id === "number" || id === null;
};
module.exports.isJSONRPCID = $4de2909d51a1a245$var$isJSONRPCID;
var $4de2909d51a1a245$var$isJSONRPCRequest = function(payload) {
    return payload.jsonrpc === module.exports.JSONRPC && payload.method !== undefined && payload.result === undefined && payload.error === undefined;
};
module.exports.isJSONRPCRequest = $4de2909d51a1a245$var$isJSONRPCRequest;
var $4de2909d51a1a245$var$isJSONRPCRequests = function(payload) {
    return Array.isArray(payload) && payload.every(module.exports.isJSONRPCRequest);
};
module.exports.isJSONRPCRequests = $4de2909d51a1a245$var$isJSONRPCRequests;
var $4de2909d51a1a245$var$isJSONRPCResponse = function(payload) {
    return payload.jsonrpc === module.exports.JSONRPC && payload.id !== undefined && (payload.result !== undefined || payload.error !== undefined);
};
module.exports.isJSONRPCResponse = $4de2909d51a1a245$var$isJSONRPCResponse;
var $4de2909d51a1a245$var$isJSONRPCResponses = function(payload) {
    return Array.isArray(payload) && payload.every(module.exports.isJSONRPCResponse);
};
module.exports.isJSONRPCResponses = $4de2909d51a1a245$var$isJSONRPCResponses;
var $4de2909d51a1a245$var$createJSONRPCError = function(code, message, data) {
    var error = {
        code: code,
        message: message
    };
    if (data != null) error.data = data;
    return error;
};
var $4de2909d51a1a245$var$JSONRPCErrorException = /** @class */ function(_super) {
    $4de2909d51a1a245$var$__extends(JSONRPCErrorException, _super);
    function JSONRPCErrorException(message, code, data) {
        var _this = _super.call(this, message) || this;
        // Manually set the prototype to fix TypeScript issue:
        // https://github.com/Microsoft/TypeScript-wiki/blob/main/Breaking-Changes.md#extending-built-ins-like-error-array-and-map-may-no-longer-work
        Object.setPrototypeOf(_this, JSONRPCErrorException.prototype);
        _this.code = code;
        _this.data = data;
        return _this;
    }
    JSONRPCErrorException.prototype.toObject = function() {
        return $4de2909d51a1a245$var$createJSONRPCError(this.code, this.message, this.data);
    };
    return JSONRPCErrorException;
}(Error);
module.exports.JSONRPCErrorException = $4de2909d51a1a245$var$JSONRPCErrorException;
var $4de2909d51a1a245$var$JSONRPCErrorCode;
(function(JSONRPCErrorCode) {
    JSONRPCErrorCode[JSONRPCErrorCode["ParseError"] = -32700] = "ParseError";
    JSONRPCErrorCode[JSONRPCErrorCode["InvalidRequest"] = -32600] = "InvalidRequest";
    JSONRPCErrorCode[JSONRPCErrorCode["MethodNotFound"] = -32601] = "MethodNotFound";
    JSONRPCErrorCode[JSONRPCErrorCode["InvalidParams"] = -32602] = "InvalidParams";
    JSONRPCErrorCode[JSONRPCErrorCode["InternalError"] = -32603] = "InternalError";
})($4de2909d51a1a245$var$JSONRPCErrorCode = module.exports.JSONRPCErrorCode || (module.exports.JSONRPCErrorCode = {}));
var $4de2909d51a1a245$var$createJSONRPCErrorResponse = function(id, code, message, data) {
    return {
        jsonrpc: module.exports.JSONRPC,
        id: id,
        error: $4de2909d51a1a245$var$createJSONRPCError(code, message, data)
    };
};
module.exports.createJSONRPCErrorResponse = $4de2909d51a1a245$var$createJSONRPCErrorResponse;
var $4de2909d51a1a245$var$createJSONRPCSuccessResponse = function(id, result) {
    return {
        jsonrpc: module.exports.JSONRPC,
        id: id,
        result: result !== null && result !== void 0 ? result : null
    };
};
module.exports.createJSONRPCSuccessResponse = $4de2909d51a1a245$var$createJSONRPCSuccessResponse;
var $4de2909d51a1a245$var$createJSONRPCRequest = function(id, method, params) {
    return {
        jsonrpc: module.exports.JSONRPC,
        id: id,
        method: method,
        params: params
    };
};
module.exports.createJSONRPCRequest = $4de2909d51a1a245$var$createJSONRPCRequest;
var $4de2909d51a1a245$var$createJSONRPCNotification = function(method, params) {
    return {
        jsonrpc: module.exports.JSONRPC,
        method: method,
        params: params
    };
};
module.exports.createJSONRPCNotification = $4de2909d51a1a245$var$createJSONRPCNotification;

});

parcelRegister("eOCwa", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DefaultErrorCode = void 0;
module.exports.DefaultErrorCode = 0;

});


parcelRegister("aLgOD", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("4VkXI", function(module, exports) {
"use strict";
var $395cbef16d420827$var$__assign = module.exports && module.exports.__assign || function() {
    $395cbef16d420827$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $395cbef16d420827$var$__assign.apply(this, arguments);
};
var $395cbef16d420827$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $395cbef16d420827$var$__generator = module.exports && module.exports.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var $395cbef16d420827$var$__spreadArray = module.exports && module.exports.__spreadArray || function(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.JSONRPCServer = void 0;

var $6GzY1 = parcelRequire("6GzY1");

var $eOCwa = parcelRequire("eOCwa");
var $395cbef16d420827$var$createParseErrorResponse = function() {
    return (0, $6GzY1.createJSONRPCErrorResponse)(null, $6GzY1.JSONRPCErrorCode.ParseError, "Parse error");
};
var $395cbef16d420827$var$createInvalidRequestResponse = function(request) {
    return (0, $6GzY1.createJSONRPCErrorResponse)((0, $6GzY1.isJSONRPCID)(request.id) ? request.id : null, $6GzY1.JSONRPCErrorCode.InvalidRequest, "Invalid Request");
};
var $395cbef16d420827$var$createMethodNotFoundResponse = function(id) {
    return (0, $6GzY1.createJSONRPCErrorResponse)(id, $6GzY1.JSONRPCErrorCode.MethodNotFound, "Method not found");
};
var $395cbef16d420827$var$JSONRPCServer = /** @class */ function() {
    function JSONRPCServer(options) {
        if (options === void 0) options = {};
        var _a;
        this.mapErrorToJSONRPCErrorResponse = $395cbef16d420827$var$defaultMapErrorToJSONRPCErrorResponse;
        this.nameToMethodDictionary = {};
        this.middleware = null;
        this.errorListener = (_a = options.errorListener) !== null && _a !== void 0 ? _a : console.warn;
    }
    JSONRPCServer.prototype.hasMethod = function(name) {
        return !!this.nameToMethodDictionary[name];
    };
    JSONRPCServer.prototype.addMethod = function(name, method) {
        this.addMethodAdvanced(name, this.toJSONRPCMethod(method));
    };
    JSONRPCServer.prototype.removeMethod = function(name) {
        delete this.nameToMethodDictionary[name];
    };
    JSONRPCServer.prototype.toJSONRPCMethod = function(method) {
        return function(request, serverParams) {
            var response = method(request.params, serverParams);
            return Promise.resolve(response).then(function(result) {
                return $395cbef16d420827$var$mapResultToJSONRPCResponse(request.id, result);
            });
        };
    };
    JSONRPCServer.prototype.addMethodAdvanced = function(name, method) {
        var _a;
        this.nameToMethodDictionary = $395cbef16d420827$var$__assign($395cbef16d420827$var$__assign({}, this.nameToMethodDictionary), (_a = {}, _a[name] = method, _a));
    };
    JSONRPCServer.prototype.receiveJSON = function(json, serverParams) {
        var request = this.tryParseRequestJSON(json);
        if (request) return this.receive(request, serverParams);
        else return Promise.resolve($395cbef16d420827$var$createParseErrorResponse());
    };
    JSONRPCServer.prototype.tryParseRequestJSON = function(json) {
        try {
            return JSON.parse(json);
        } catch (_a) {
            return null;
        }
    };
    JSONRPCServer.prototype.receive = function(request, serverParams) {
        if (Array.isArray(request)) return this.receiveMultiple(request, serverParams);
        else return this.receiveSingle(request, serverParams);
    };
    JSONRPCServer.prototype.receiveMultiple = function(requests, serverParams) {
        return $395cbef16d420827$var$__awaiter(this, void 0, void 0, function() {
            var responses;
            var _this = this;
            return $395cbef16d420827$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            Promise.all(requests.map(function(request) {
                                return _this.receiveSingle(request, serverParams);
                            }))
                        ];
                    case 1:
                        responses = _a.sent().filter($395cbef16d420827$var$isNonNull);
                        if (responses.length === 1) return [
                            2 /*return*/ ,
                            responses[0]
                        ];
                        else if (responses.length) return [
                            2 /*return*/ ,
                            responses
                        ];
                        else return [
                            2 /*return*/ ,
                            null
                        ];
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    JSONRPCServer.prototype.receiveSingle = function(request, serverParams) {
        return $395cbef16d420827$var$__awaiter(this, void 0, void 0, function() {
            var method, response;
            return $395cbef16d420827$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        method = this.nameToMethodDictionary[request.method];
                        if (!!(0, $6GzY1.isJSONRPCRequest)(request)) return [
                            3 /*break*/ ,
                            1
                        ];
                        return [
                            2 /*return*/ ,
                            $395cbef16d420827$var$createInvalidRequestResponse(request)
                        ];
                    case 1:
                        return [
                            4 /*yield*/ ,
                            this.callMethod(method, request, serverParams)
                        ];
                    case 2:
                        response = _a.sent();
                        return [
                            2 /*return*/ ,
                            $395cbef16d420827$var$mapResponse(request, response)
                        ];
                }
            });
        });
    };
    JSONRPCServer.prototype.applyMiddleware = function() {
        var middlewares = [];
        for(var _i = 0; _i < arguments.length; _i++)middlewares[_i] = arguments[_i];
        if (this.middleware) this.middleware = this.combineMiddlewares($395cbef16d420827$var$__spreadArray([
            this.middleware
        ], middlewares, true));
        else this.middleware = this.combineMiddlewares(middlewares);
    };
    JSONRPCServer.prototype.combineMiddlewares = function(middlewares) {
        if (!middlewares.length) return null;
        else return middlewares.reduce(this.middlewareReducer);
    };
    JSONRPCServer.prototype.middlewareReducer = function(prevMiddleware, nextMiddleware) {
        return function(next, request, serverParams) {
            return prevMiddleware(function(request, serverParams) {
                return nextMiddleware(next, request, serverParams);
            }, request, serverParams);
        };
    };
    JSONRPCServer.prototype.callMethod = function(method, request, serverParams) {
        var _this = this;
        var callMethod = function(request, serverParams) {
            if (method) return method(request, serverParams);
            else if (request.id !== undefined) return Promise.resolve($395cbef16d420827$var$createMethodNotFoundResponse(request.id));
            else return Promise.resolve(null);
        };
        var onError = function(error) {
            _this.errorListener("An unexpected error occurred while executing \"".concat(request.method, "\" JSON-RPC method:"), error);
            return Promise.resolve(_this.mapErrorToJSONRPCErrorResponseIfNecessary(request.id, error));
        };
        try {
            return (this.middleware || $395cbef16d420827$var$noopMiddleware)(callMethod, request, serverParams).then(undefined, onError);
        } catch (error) {
            return onError(error);
        }
    };
    JSONRPCServer.prototype.mapErrorToJSONRPCErrorResponseIfNecessary = function(id, error) {
        if (id !== undefined) return this.mapErrorToJSONRPCErrorResponse(id, error);
        else return null;
    };
    return JSONRPCServer;
}();
module.exports.JSONRPCServer = $395cbef16d420827$var$JSONRPCServer;
var $395cbef16d420827$var$isNonNull = function(value) {
    return value !== null;
};
var $395cbef16d420827$var$noopMiddleware = function(next, request, serverParams) {
    return next(request, serverParams);
};
var $395cbef16d420827$var$mapResultToJSONRPCResponse = function(id, result) {
    if (id !== undefined) return (0, $6GzY1.createJSONRPCSuccessResponse)(id, result);
    else return null;
};
var $395cbef16d420827$var$defaultMapErrorToJSONRPCErrorResponse = function(id, error) {
    var _a;
    var message = (_a = error === null || error === void 0 ? void 0 : error.message) !== null && _a !== void 0 ? _a : "An unexpected error occurred";
    var code = $eOCwa.DefaultErrorCode;
    var data;
    if (error instanceof $6GzY1.JSONRPCErrorException) {
        code = error.code;
        data = error.data;
    }
    return (0, $6GzY1.createJSONRPCErrorResponse)(id, code, message, data);
};
var $395cbef16d420827$var$mapResponse = function(request, response) {
    if (response) return response;
    else if (request.id !== undefined) return (0, $6GzY1.createJSONRPCErrorResponse)(request.id, $6GzY1.JSONRPCErrorCode.InternalError, "Internal error");
    else return null;
};

});

parcelRegister("coXoV", function(module, exports) {
"use strict";
var $9075cdba76b2d957$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $9075cdba76b2d957$var$__generator = module.exports && module.exports.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.JSONRPCServerAndClient = void 0;

var $6GzY1 = parcelRequire("6GzY1");
var $9075cdba76b2d957$var$JSONRPCServerAndClient = /** @class */ function() {
    function JSONRPCServerAndClient(server, client, options) {
        if (options === void 0) options = {};
        var _a;
        this.server = server;
        this.client = client;
        this.errorListener = (_a = options.errorListener) !== null && _a !== void 0 ? _a : console.warn;
    }
    JSONRPCServerAndClient.prototype.applyServerMiddleware = function() {
        var _a;
        var middlewares = [];
        for(var _i = 0; _i < arguments.length; _i++)middlewares[_i] = arguments[_i];
        (_a = this.server).applyMiddleware.apply(_a, middlewares);
    };
    JSONRPCServerAndClient.prototype.hasMethod = function(name) {
        return this.server.hasMethod(name);
    };
    JSONRPCServerAndClient.prototype.addMethod = function(name, method) {
        this.server.addMethod(name, method);
    };
    JSONRPCServerAndClient.prototype.addMethodAdvanced = function(name, method) {
        this.server.addMethodAdvanced(name, method);
    };
    JSONRPCServerAndClient.prototype.removeMethod = function(name) {
        this.server.removeMethod(name);
    };
    JSONRPCServerAndClient.prototype.timeout = function(delay) {
        return this.client.timeout(delay);
    };
    JSONRPCServerAndClient.prototype.request = function(method, params, clientParams) {
        return this.client.request(method, params, clientParams);
    };
    JSONRPCServerAndClient.prototype.requestAdvanced = function(jsonRPCRequest, clientParams) {
        return this.client.requestAdvanced(jsonRPCRequest, clientParams);
    };
    JSONRPCServerAndClient.prototype.notify = function(method, params, clientParams) {
        this.client.notify(method, params, clientParams);
    };
    JSONRPCServerAndClient.prototype.rejectAllPendingRequests = function(message) {
        this.client.rejectAllPendingRequests(message);
    };
    JSONRPCServerAndClient.prototype.receiveAndSend = function(payload, serverParams, clientParams) {
        return $9075cdba76b2d957$var$__awaiter(this, void 0, void 0, function() {
            var response, message;
            return $9075cdba76b2d957$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        if (!((0, $6GzY1.isJSONRPCResponse)(payload) || (0, $6GzY1.isJSONRPCResponses)(payload))) return [
                            3 /*break*/ ,
                            1
                        ];
                        this.client.receive(payload);
                        return [
                            3 /*break*/ ,
                            4
                        ];
                    case 1:
                        if (!((0, $6GzY1.isJSONRPCRequest)(payload) || (0, $6GzY1.isJSONRPCRequests)(payload))) return [
                            3 /*break*/ ,
                            3
                        ];
                        return [
                            4 /*yield*/ ,
                            this.server.receive(payload, serverParams)
                        ];
                    case 2:
                        response = _a.sent();
                        if (response) return [
                            2 /*return*/ ,
                            this.client.send(response, clientParams)
                        ];
                        return [
                            3 /*break*/ ,
                            4
                        ];
                    case 3:
                        message = "Received an invalid JSON-RPC message";
                        this.errorListener(message, payload);
                        return [
                            2 /*return*/ ,
                            Promise.reject(new Error(message))
                        ];
                    case 4:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    return JSONRPCServerAndClient;
}();
module.exports.JSONRPCServerAndClient = $9075cdba76b2d957$var$JSONRPCServerAndClient;

});



parcelRegister("iYdh9", function(module, exports) {
$parcel$export(module.exports, "RequestHandler", () => $1ed697e81aa433d2$export$d51c578aa8736606);

var $lbNvM = parcelRequire("lbNvM");

var $gdUUy = parcelRequire("gdUUy");

var $cxhPv = parcelRequire("cxhPv");

var $1bjC0 = parcelRequire("1bjC0");
class $1ed697e81aa433d2$export$d51c578aa8736606 {
    constructor(transport){
        this.transport = transport;
        /**
   * A mapping from clientId:commandName -> handlers for those commands.
   *
   * @description We enforce only 1 handler per clientId+command pair, so that callees can listen for responses to a command.
   * This allows multiple clients to register handlers for the same command type.
   */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
        // oxlint-disable-next-line typescript-eslint/no-explicit-any
        this.handlers = new Map();
    }
    /**
   * Register a handler for a specific command type for a specific client.
   *
   * @description When a command of type {@link CommandClass} is received, the handler will be invoked in a 1-1 manner.
   * This is to ensure the result of the command invocation can be cleanly passed to the callee.
   *
   * @param clientId The client identifier that this handler is registered for
   * @param CommandClass The command class to register a handler for
   * @param handler The handler function to invoke when the command is received
   * @returns void
   */ register(clientId, CommandClass, handler) {
        const handlerKey = this.createHandlerKey(clientId, CommandClass.identifier);
        this.handlers.set(handlerKey, handler);
    }
    /**
   * Unregisters a handler for a specific command type for a specific client.
   */ unregister(clientId, CommandClass) {
        const handlerKey = this.createHandlerKey(clientId, CommandClass.identifier);
        this.handlers.delete(handlerKey);
    }
    /**
   * Unregisters all handlers for a specific client.
   *
   * @param clientId The client identifier to remove all handlers for
   * @returns number of handlers removed
   */ unregisterAll(clientId) {
        const keysToDelete = [];
        const prefix = `${clientId}:`;
        // find all relevant keys
        for (const key of this.handlers.keys())if (key.startsWith(prefix)) keysToDelete.push(key);
        // drop them
        for (const key of keysToDelete)this.handlers.delete(key);
        return keysToDelete.length;
    }
    /**
   * Invokes the appropriate handler for a given {@link RPCRequest}, and yields the result via
   * {@link transport} to the appropriate JavaScript context. If the handler throws, propagates an
   * {@link RPCResponse} with an error body. Vice versa for a successful handler response.
   *
   * @param request incoming RPC request (delegated method call, as a command)
   */ async handleRequest(request) {
        const params = request.params;
        const handlerKey = this.createHandlerKey(params.receiverId, request.method);
        const handler = this.handlers.get(handlerKey);
        (0, $cxhPv.emitter)().emit({
            type: 'command-received',
            commandId: request.id,
            commandType: request.method,
            senderId: params.senderId,
            receiverId: params.receiverId,
            properties: {
                ...params
            },
            groupId: params.groupId
        });
        if (!handler) {
            const err = `handler not found for ${request.method} with clientId ${params.receiverId}`;
            console.warn(err);
            // emit command failed event
            (0, $cxhPv.emitter)().emit({
                type: 'command-failed',
                commandId: request.id,
                commandType: request.method,
                senderId: params.senderId,
                receiverId: params.receiverId,
                error: {
                    message: err,
                    code: 'METHOD_NOT_FOUND'
                },
                groupId: params.groupId
            });
            // communicate to sender that handler failed
            this.sendResponse(request, (0, $1bjC0.rpcError)(request.id, params.receiverId, params.senderId, (0, $lbNvM.JSONRPCErrorCode).MethodNotFound, new Error(err)));
            return;
        }
        const startTime = performance.now();
        try {
            const result = await handler(request.params);
            const duration = performance.now() - startTime;
            // emit command completed event
            (0, $cxhPv.emitter)().emit({
                type: 'command-completed',
                commandId: request.id,
                commandType: request.method,
                senderId: params.senderId,
                receiverId: params.receiverId,
                result: result,
                duration: duration,
                groupId: params.groupId
            });
            this.sendResponse(request, (0, $1bjC0.rpcSuccess)(request.id, params.receiverId, params.senderId, result));
        } catch (error) {
            const err = error instanceof Error ? error : new Error(String(error));
            const duration = performance.now() - startTime;
            // emit command failed event
            (0, $cxhPv.emitter)().emit({
                type: 'command-failed',
                commandId: request.id,
                commandType: request.method,
                senderId: params.senderId,
                receiverId: params.receiverId,
                error: {
                    message: err.message,
                    code: 'HANDLER_ERROR',
                    stack: err.stack
                },
                duration: duration,
                groupId: params.groupId
            });
            this.sendResponse(request, (0, $1bjC0.rpcError)(request.id, params.receiverId, params.senderId, (0, $lbNvM.JSONRPCErrorCode).InternalError, err));
            console.error(err);
        }
    }
    sendResponse(request, response) {
        if ((0, $gdUUy.fg)('rovo_bridge_validate_message_origin')) this.transport.send(response, request);
        else this.transport.send(response);
    }
    /**
   * Directly invoke a handler of a specific command for a specific client.
   */ async invoke(command, params) {
        const handlerKey = this.createHandlerKey(params.receiverId, command.identifier);
        const handler = this.handlers.get(handlerKey);
        (0, $cxhPv.emitter)().emit({
            type: 'command-received',
            commandId: params._invocationId ?? 'local-invocation',
            commandType: command.identifier,
            senderId: params.senderId,
            receiverId: params.receiverId,
            properties: params,
            groupId: params.groupId
        });
        if (!handler) {
            const err = `handler not found for command ${command.identifier} with clientId ${params.receiverId}`;
            console.error(err);
            // emit command failed event
            (0, $cxhPv.emitter)().emit({
                type: 'command-failed',
                commandId: params._invocationId ?? 'local-invocation',
                commandType: command.identifier,
                senderId: params.senderId,
                receiverId: params.receiverId,
                error: {
                    message: err,
                    code: 'METHOD_NOT_FOUND'
                },
                groupId: params.groupId
            });
            return undefined;
        }
        const startTime = performance.now();
        try {
            const result = handler === null || handler === void 0 ? void 0 : handler(params);
            const duration = performance.now() - startTime;
            // emit command completed event
            (0, $cxhPv.emitter)().emit({
                type: 'command-completed',
                commandId: params._invocationId || 'local-invocation',
                commandType: command.identifier,
                senderId: params.senderId,
                receiverId: params.receiverId,
                result: result,
                duration: duration,
                groupId: params.groupId
            });
            return result;
        } catch (error) {
            const err = error instanceof Error ? error : new Error(String(error));
            const duration = performance.now() - startTime;
            // emit command failed event
            (0, $cxhPv.emitter)().emit({
                type: 'command-failed',
                commandId: params._invocationId || 'local-invocation',
                commandType: command.identifier,
                senderId: params.senderId,
                receiverId: params.receiverId,
                error: {
                    message: err.message,
                    code: 'HANDLER_ERROR',
                    stack: err.stack
                },
                duration: duration,
                groupId: params.groupId
            });
            throw err;
        }
    }
    /**
   * Clear all relevant state for handling of responses.
   */ destroy() {
        this.handlers.clear();
    }
    /**
   * Creates a unique key for the handler mapping using clientId and command name.
   */ createHandlerKey(clientId, commandName) {
        return `${clientId}:${commandName}`;
    }
}

});

parcelRegister("ITDGX", function(module, exports) {
$parcel$export(module.exports, "ResponseHandler", () => $e55b73963ac2eee6$export$f456c9835cc63582);
class $e55b73963ac2eee6$export$f456c9835cc63582 {
    /**
   * Creates a deferred promise handler for a given command invocation.
   * @param id unique ID for the command invocation
   * @param senderId the callee
   * @param receiverId the receiver which implements a handler for the command
   * @returns a deferrable which is resolved upon a response being yielded by the receiver
   */ getOrCreate(id, senderId, receiverId) {
        // if we already have a deferred promise waiting for this specific invocation, we do not need another one.
        const existing = this.get(id);
        if (existing) return existing.promise;
        let deferredResolve;
        let deferredReject;
        const promise = new Promise((resolve, reject)=>{
            deferredResolve = resolve;
            deferredReject = reject;
        });
        const result = {
            senderId: senderId,
            receiverId: receiverId,
            promise: promise,
            // @ts-expect-error - Promise executor runs synchronously so deferredResolve is guaranteed assigned; TypeScript cannot infer this
            resolve: deferredResolve,
            // @ts-expect-error - Promise executor runs synchronously so deferredReject is guaranteed assigned; TypeScript cannot infer this
            reject: deferredReject
        };
        this.responses.set(id, result);
        return promise;
    }
    /**
   * Yields the current deferrable state for a command invocation.
   * @param id unique ID for the command invocation.
   * @returns deferrable state for a command invocation.
   */ get(id) {
        return this.responses.get(id);
    }
    /**
   * Resolves a promise reference based upon the ID of an RPC response.
   *
   * @description If the RPC response is successful, will resolve the promise with the expected return shape.
   * @description If the RPC response is unsuccessful, will reject the promise with an error.
   *
   * @param _response response yielded by the receiver of the original message.
   */ resolveWithResponse(response) {
        const id = response.id;
        const deferred = this.responses.get(id);
        // no one waiting - exit
        if (!deferred) return;
        // drop the deferrable from storage now
        this.responses.delete(id);
        // yield correct outcome
        if (response.error) deferred.reject(new Error(response.error.message));
        else deferred.resolve(response.result);
    }
    /**
   * Cancels a specific promise by resolving it to undefined to avoid unhandled rejections
   * in fire-and-forget scenarios.
   *
   * @description In JavaScript if you do the following:
   * ```typescript
   * const promise = () => new Promise((_, reject) => reject(new Error('oh boy')));
   * promise();
   * ```
   * Even though you are not explicitly calling `await` on the result of the promise, it will
   * reject and result in an unhandled rejection. Specifically when working with commands, we
   * often want to send them in a fire-and-forget manner. When a 'cancellation' takes place,
   * we therefore DO NOT want an unhandled rejection to result. Hence, we treat all command
   * results similar to distributed system communications - as always nullable.
   *
   * Cancellation events to consider: component unmounts, route transitions.
   *
   * For more, see:
   * - {@link https://developer.mozilla.org/en-US/docs/Web/API/Window/unhandledrejection_event}
   * - {@link https://developer.mozilla.org/en-US/docs/Web/JavaScript/Guide/Using_promises#promise_rejection_events}
   * - {@link https://typescript-eslint.io/rules/no-floating-promises/}
   *
   * @param id unique ID for the command invocation to cancel
   */ cancel(id) {
        const deferred = this.responses.get(id);
        if (!deferred) return;
        // clear out in-memory reference
        this.responses.delete(id);
        // resolve to undefined to avoid unhandled promise rejections
        deferred.resolve(undefined);
    }
    /**
   * Clears response handlers for a specific client to prevent memory leaks during client teardown.
   *
   * @param clientId The client ID to clear responses for (as sender or receiver)
   */ teardown(clientId) {
        const toDelete = [];
        for (const [id, deferred] of this.responses)if (deferred.senderId === clientId || deferred.receiverId === clientId) {
            // Resolve to undefined to avoid unhandled promise rejections
            deferred.resolve(undefined);
            toDelete.push(id);
        }
        for (const id of toDelete)this.responses.delete(id);
    }
    /**
   * Destroy all relevant state.
   */ clear() {
        // Resolve all pending promises to avoid unhandled rejections
        for (const deferred of this.responses.values())deferred.resolve(undefined);
        this.responses.clear();
    }
    constructor(){
        /**
   * A mapping from unique command invocations to deferred promises waiting
   * for their result. Used for match-making the result of a delegated RPC call
   * back to its callee. TODO - hook up to methods in CNS-18261.
   */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
        // oxlint-disable-next-line typescript-eslint/no-explicit-any
        this.responses = new Map();
    }
}

});


parcelRegister("3YeDO", function(module, exports) {
$parcel$export(module.exports, "mountAPI", () => $1411b0a6a901d240$export$aca538b4585bd0c8);
$parcel$export(module.exports, "readAPI", () => $1411b0a6a901d240$export$7f2206c1a009e207);
$parcel$export(module.exports, "clearAPI", () => $1411b0a6a901d240$export$d61f9ff9c1abb253);

var $l4i9H = parcelRequire("l4i9H");
const $1411b0a6a901d240$export$aca538b4585bd0c8 = (bridgeAPI)=>{
    try {
        const topmostSameOriginWindow = (0, $l4i9H.findTopmostSameOriginWindow)(window);
        // do not override if already existing on topmost same-origin window
        if (topmostSameOriginWindow.__rovoContentBridgeAPI__) return;
        topmostSameOriginWindow.__rovoContentBridgeAPI__ = bridgeAPI;
        topmostSameOriginWindow.__rovoBridgeDebuggerStart__ = $1411b0a6a901d240$var$startDebugger;
    } catch  {
        // bail out if any errors take place (browser quirks on accessing window.top from a cross-origin frame)
        return;
    }
};
const $1411b0a6a901d240$export$7f2206c1a009e207 = ()=>{
    try {
        const topmostSameOriginWindow = (0, $l4i9H.findTopmostSameOriginWindow)(window);
        return topmostSameOriginWindow.__rovoContentBridgeAPI__ ?? null;
    } catch  {
        return null;
    }
};
const $1411b0a6a901d240$export$d61f9ff9c1abb253 = ()=>{
    try {
        const topmostSameOriginWindow = (0, $l4i9H.findTopmostSameOriginWindow)(window);
        topmostSameOriginWindow.__rovoContentBridgeAPI__ = undefined;
        // Also clear debug API to prevent memory leaks
        topmostSameOriginWindow.__rovoBridgeDebuggerStart__ = undefined;
    } catch  {
        return;
    }
};

async function $1411b0a6a901d240$var$startDebugger() {
    try {
        await (parcelRequire("a2Tl7"));
    } catch (err) {
        console.error('failed to initialise rovo-debug API', err);
    }
}

});
parcelRegister("l4i9H", function(module, exports) {
$parcel$export(module.exports, "isSameOrigin", () => $73cd81669e74801a$export$655d79b04044cb4a);
$parcel$export(module.exports, "isTop", () => $73cd81669e74801a$export$9be37efcc8d5d23a);
$parcel$export(module.exports, "findTopmostSameOriginWindow", () => $73cd81669e74801a$export$8d6146aae4595d39);
/**
 * Utility which computes whether a target window and {@link window.top} conform to the same origin policy.
 *
 * @description If they do, then they share JavaScript execution contexts.
 * @description If they do not, they are the traditional cross-origin `iframe` and host.
 *
 * @param window
 * @returns true if same origin, false if not - if true, then {@link window.top} must be defined.
 */ const $73cd81669e74801a$export$655d79b04044cb4a = (window)=>{
    try {
        var _window$top;
        return Boolean(window.origin && window.origin === ((_window$top = window.top) === null || _window$top === void 0 ? void 0 : _window$top.origin));
    } catch  {
        return false;
    }
};
const $73cd81669e74801a$export$9be37efcc8d5d23a = (window)=>{
    try {
        return Boolean(window.top && window === window.top);
    } catch  {
        return false;
    }
};
/**
 * Maximum depth to traverse when finding topmost same-origin window.
 * Prevents infinite loops in edge cases while supporting deep nesting.
 */ const $73cd81669e74801a$var$MAX_PARENT_TRAVERSAL_DEPTH = 16;
const $73cd81669e74801a$export$8d6146aae4595d39 = (window)=>{
    let current = window;
    let depth = 0;
    while(depth < $73cd81669e74801a$var$MAX_PARENT_TRAVERSAL_DEPTH)try {
        // If we're at the top, return current
        if (current.parent === current) return current;
        // Try to access parent.origin (will throw SecurityError if cross-origin)
        const parentOrigin = current.parent.origin;
        // Check if parent is same origin
        if (current.origin !== parentOrigin) return current;
        // Parent is same-origin, keep going up
        current = current.parent;
        depth++;
    } catch  {
        // Parent is cross-origin (accessing parent.origin threw)
        return current;
    }
    // Safety: return current window if max depth reached
    return current;
};

});

parcelRegister("a2Tl7", function(module, exports) {

var $kOunM = parcelRequire("kOunM");
module.exports = $kOunM("ccPIh").then(()=>parcelRequire('jbcXL'));

});


parcelRegister("l5apZ", function(module, exports) {
$parcel$export(module.exports, "BrowserTransport", () => $7e29ec768f5cb6a9$export$7f6b50c45cbf4d90);

var $gdUUy = parcelRequire("gdUUy");

var $cxhPv = parcelRequire("cxhPv");

var $1bjC0 = parcelRequire("1bjC0");

var $71vlT = parcelRequire("71vlT");

var $l4i9H = parcelRequire("l4i9H");

var $bLx51 = parcelRequire("bLx51");

var $4EOCt = parcelRequire("4EOCt");
const $7e29ec768f5cb6a9$var$MESSAGE_ORIGIN_VALIDATION_GATE = 'rovo_bridge_validate_message_origin';
const $7e29ec768f5cb6a9$var$DEDUPE_TARGET_WARNING_GATE = 'rovo_bridge_dedupe_target_warning';
const $7e29ec768f5cb6a9$var$normaliseOrigins = (origins)=>{
    const result = new Set();
    for (const value of origins ?? [])try {
        const origin = new URL(value).origin;
        if (origin !== 'null') result.add(origin);
    } catch  {
    // An invalid value must not accidentally widen the trust boundary.
    }
    return result;
};
/**
 * Narrows a {@link MessageEvent.source} to a window.
 *
 * @description A window proxy exposes `window` as a self-reference even across an origin boundary,
 * which message ports and service workers do not.
 */ const $7e29ec768f5cb6a9$var$isWindowSource = (source)=>{
    try {
        return Boolean(source) && source.window === source;
    } catch  {
        return false;
    }
};
class $7e29ec768f5cb6a9$export$7f6b50c45cbf4d90 {
    constructor(source, options = {}){
        this.source = source;
        this.options = options;
        /**
   * A mapping of receiver IDs to known targets.
   *
   * Communication will ultimately take place with this target, via the {@link HTMLIFrameElement.contentWindow} property.
   */ this.targets = new Map();
        /**
   * Receivers whose missing target has already been logged.
   *
   * @description Discovery retries a pending receiver every tick, so without this a receiver which never mounts
   * (e.g. Rovo chat before its panel is opened) logs a warning every 100ms until its messages expire.
   */ this.unreachableReceivers = new Set();
        // New requests can use an authenticated peer origin; replies retain their own request's destination.
        this.authenticatedOrigins = new WeakMap();
        this.replyTargets = new WeakMap();
        /**
   * Handles incoming messages received via {@link window.postMessage}.
   */ this.handler = undefined;
        /**
   * Cleanup handler registered for incoming messages
   */ this.cleanup = undefined;
        this.allowedOrigins = $7e29ec768f5cb6a9$var$normaliseOrigins(options.allowedOrigins);
        (0, $cxhPv.emitter)().emit({
            type: 'transport-ready',
            transportType: this.source
        });
    }
    /**
   * Check to see if this message can be sent to its intended cross-origin target currently.
   *
   * @description Determined by availability of the target window in the DOM.
   * @description If this method does not yield true, the message will be buffered & tried again later.
   *
   * @param message intended RPC message for the receiver
   * @returns true if the transport target is queryable via DOM, otherwise false
   */ canSend(message) {
        // trying to communicate with desktop process
        if ((0, $bLx51.isWebviewContext)()) return true;
        // passthrough for same-origin communication
        if ((0, $l4i9H.isSameOrigin)(window)) return true;
        // otherwise find the cross-origin target & communicate with it
        const target = this.findTarget(message.params.receiverId);
        return Boolean(target);
    }
    /**
   * Sends a cross-origin message using {@link window.postMessage}.
   * @param message intended RPC message for the receiver
   * @param replyTo original accepted request, required for browser replies while origin validation is enabled
   * @returns void
   */ send(message, replyTo) {
        // in a webview context and trying to communicate with main process
        if ((0, $bLx51.isWebviewContext)()) {
            (0, $bLx51.sendToMainProcess)(message, this.source);
            return;
        }
        const validateOrigin = (0, $gdUUy.fg)($7e29ec768f5cb6a9$var$MESSAGE_ORIGIN_VALIDATION_GATE);
        const target = validateOrigin && (0, $1bjC0.isRPCResponse)(message) ? replyTo && this.replyTargets.get(replyTo) : this.findTarget(message.params.receiverId);
        if (!target) {
            (0, $cxhPv.emitter)().emit({
                type: 'transport-error',
                transportType: this.source,
                direction: 'outbound',
                messageId: message.id,
                error: {
                    message: `Transport target not found for receiver: ${message.params.receiverId}`,
                    code: 'TARGET_NOT_FOUND'
                }
            });
            return;
        }
        const envelope = {
            version: 1,
            source: this.source,
            message: message
        };
        (0, $cxhPv.emitter)().emit({
            type: 'transport-message-sent',
            transportType: this.source,
            direction: 'outbound',
            messageId: message.id,
            message: {
                ...envelope
            }
        });
        target.target.postMessage(envelope, validateOrigin ? this.outboundOrigin(target) : '*');
        if (validateOrigin && replyTo) this.replyTargets.delete(replyTo);
        return;
    }
    /**
   * Handles incoming events from other bridge API clients.
   * @param handler responds to a given RPC message from a remote client.
   */ onMessage(handler) {
        // do not allow overriding of handlers.
        if (this.handler) return;
        // stable reference so we can destroy it later
        this.handler = (envelope)=>this.handleEnvelope(envelope, handler);
        // listen for messsages from webview context
        if ((0, $bLx51.isWebviewContext)()) {
            const webviewAPI = (0, $bLx51.getWebviewAPI)();
            if (!webviewAPI) return;
            this.cleanup = webviewAPI.onMessageFromMain((envelope)=>{
                var _this$handler;
                return (_this$handler = this.handler) === null || _this$handler === void 0 ? void 0 : _this$handler.call(this, envelope);
            });
        } else {
            // Find topmost same-origin window to listen on
            const targetWindow = (0, $l4i9H.findTopmostSameOriginWindow)(window);
            // web-compatible handler
            const handler = (event)=>{
                if (!(0, $gdUUy.fg)($7e29ec768f5cb6a9$var$MESSAGE_ORIGIN_VALIDATION_GATE)) {
                    var _this$handler2;
                    (_this$handler2 = this.handler) === null || _this$handler2 === void 0 || _this$handler2.call(this, event.data);
                    return;
                }
                if (this.isTrustedSender(event, targetWindow)) {
                    var _this$handler3;
                    this.recordAuthenticatedPeer(event);
                    (_this$handler3 = this.handler) === null || _this$handler3 === void 0 || _this$handler3.call(this, event.data);
                }
            };
            targetWindow.addEventListener('message', handler);
            this.cleanup = ()=>targetWindow.removeEventListener('message', handler);
        }
    }
    /**
   * Tears down a specific client by removing its target reference.
   * @description This is important to release iframe / window references fully.
   */ teardown(clientId) {
        this.targets.delete(clientId);
        this.unreachableReceivers.delete(clientId);
    }
    /**
   * Clears all relevant state.
   */ destroy() {
        // clean up handler
        if (this.cleanup) {
            this.cleanup();
            this.cleanup = undefined;
        }
        // clean up handler reference
        if (this.handler) this.handler = undefined;
        // clear all target references
        this.targets.clear();
        this.unreachableReceivers.clear();
        this.authenticatedOrigins = new WeakMap();
        this.replyTargets = new WeakMap();
        // emit transport destroyed event
        (0, $cxhPv.emitter)().emit({
            type: 'transport-destroyed',
            transportType: this.source
        });
    }
    /**
   * Find a target for the given receiver in one of three ways:
   * - Using the existing mapping of known targets ({@link #targets})
   * - Using a DOM query for a cross-origin `iframe`, based on a specific DOM selector contract
   * - Using {@link window.top} if communicating cross-origin from inside of a frame
   *
   * @description If a target is find with one of the latter strategies, it is added to {@link #targets} for subsequent reads.
   *
   * @param receiverId intended target of the current message
   * @returns target if found, otherwise undefined
   */ findTarget(receiverId) {
        var _this$options$resolve, _this$options;
        // if existing, return
        const target = this.targets.get(receiverId);
        if (target) {
            if (!(0, $gdUUy.fg)('rovo_bridge_remote_teardown_cleanup') || !target.target.closed) return target;
            // A teardown reply can recache a target before its iframe is removed.
            // Discard destroyed browsing contexts, including those without a teardown.
            this.targets.delete(receiverId);
        }
        // Find target using a provided resolution strategy
        const resolvedTarget = (_this$options$resolve = (_this$options = this.options).resolveTarget) === null || _this$options$resolve === void 0 ? void 0 : _this$options$resolve.call(_this$options, {
            receiverId: receiverId,
            source: this.source
        });
        if (resolvedTarget) {
            const resolved = {
                target: resolvedTarget
            };
            this.targets.set(receiverId, resolved);
            return resolved;
        }
        // Find target using resolution strategies
        const browserTarget = (0, $4EOCt.findCrossOriginTarget)(receiverId);
        if (browserTarget) {
            this.targets.set(receiverId, browserTarget);
            return browserTarget;
        }
        if (!(0, $gdUUy.fg)($7e29ec768f5cb6a9$var$DEDUPE_TARGET_WARNING_GATE) || !this.unreachableReceivers.has(receiverId)) {
            this.unreachableReceivers.add(receiverId);
            console.warn(`transport target not found for message with intended recipient: ${receiverId}`);
        }
        return undefined;
    }
    recordAuthenticatedPeer(event) {
        if (!$7e29ec768f5cb6a9$var$isWindowSource(event.source)) return;
        this.authenticatedOrigins.set(event.source, event.origin);
        if ((0, $1bjC0.isRPCRequest)(event.data.message)) this.replyTargets.set(event.data.message, {
            target: event.source,
            origin: event.origin
        });
    }
    outboundOrigin(target) {
        return target.origin ?? this.authenticatedOrigins.get(target.target) ?? '*';
    }
    /**
   * Whether the envelope's self-declared source agrees with the origin the browser stamped on the event.
   */ hasAttestedOrigin(event) {
        return (0, $71vlT.isTransportEnvelope)(event.data) && event.data.source === event.origin;
    }
    /**
   * Whether an inbound message satisfies the transport's origin and peer checks.
   *
   * Same-origin messages are accepted after their envelope source is checked. Cross-origin messages
   * must also match a resolved peer using two fields supplied by the browser:
   * - {@link MessageEvent.source}: a live reference to the actual sending window. Compared by identity
   *   against the window resolved by {@link findTarget}, so another window cannot claim its identity.
   * - {@link MessageEvent.origin}: the sender's origin when the message was sent. Matched against
   *   the peer origin we derived ourselves (an iframe `src` or ancestor origin) or, only when unknown, an origin in
   *   {@link BrowserTransportOptions.allowedOrigins}.
   *
   * @description Everything inside {@link MessageEvent.data} is attacker-controlled and treated only as
   * a claim: the self-declared envelope `source` and the `senderId` / `receiverId`. `senderId` is used
   * purely as a lookup key whose result is then re-checked against the unforgeable fields above, and
   * {@link hasAttestedOrigin} ties the self-declared `source` back to the browser-stamped origin.
   */ isTrustedSender(event, targetWindow) {
        var _event$data$message$p;
        if (!this.hasAttestedOrigin(event)) return false;
        if (event.origin === targetWindow.location.origin) return true;
        const senderId = (_event$data$message$p = event.data.message.params) === null || _event$data$message$p === void 0 ? void 0 : _event$data$message$p.senderId;
        if (typeof senderId !== 'string') return false;
        const sender = this.findTarget(senderId);
        const trustedOrigin = (sender === null || sender === void 0 ? void 0 : sender.origin) !== undefined ? sender.origin === event.origin : this.allowedOrigins.has(event.origin);
        return Boolean(event.source && sender && event.source === sender.target && trustedOrigin);
    }
    /**
   * Handles a transport envelope received from a remote source.
   * @param envelope the transport envelope containing the RPC message
   * @param handler the handler to invoke for the RPC message contained in the envelope
   * @returns void
   */ handleEnvelope(envelope, handler) {
        // always validate first - if invalid, ignore
        if (!(0, $71vlT.isTransportEnvelope)(envelope)) return;
        // ensure message is not from the current window to itself
        if (envelope.source === this.source) return;
        (0, $cxhPv.emitter)().emit({
            type: 'transport-message-received',
            transportType: this.source,
            direction: 'inbound',
            messageId: envelope.message.id,
            transportData: {
                source: envelope.source,
                version: envelope.version,
                message: envelope.message
            }
        });
        handler(envelope.message);
    }
}

});
parcelRegister("71vlT", function(module, exports) {
$parcel$export(module.exports, "isTransportEnvelope", () => $b52f5d4dab0bb629$export$d22e131e673e4be0);

var $1bjC0 = parcelRequire("1bjC0");
const $b52f5d4dab0bb629$export$d22e131e673e4be0 = (envelope)=>{
    return Boolean(envelope && typeof envelope.version === 'number' && typeof envelope.source === 'string' && envelope.message && typeof envelope.message === 'object' && ((0, $1bjC0.isRPCRequest)(envelope.message) || (0, $1bjC0.isRPCResponse)(envelope.message)));
};

});

parcelRegister("bLx51", function(module, exports) {
$parcel$export(module.exports, "isWebviewContext", () => $f3f43d2031f39922$export$a06801d4af98f3a3);
$parcel$export(module.exports, "getWebviewAPI", () => $f3f43d2031f39922$export$60ac5c5fdfd88da);
$parcel$export(module.exports, "sendToMainProcess", () => $f3f43d2031f39922$export$7f13f4efe0e0c1f3);

var $cxhPv = parcelRequire("cxhPv");
const $f3f43d2031f39922$export$a06801d4af98f3a3 = ()=>{
    try {
        return Boolean(typeof window !== 'undefined' && window.webviewAPI && typeof window.webviewAPI.isElectron === 'function' && window.webviewAPI.isElectron());
    } catch  {
        return false;
    }
};
const $f3f43d2031f39922$export$60ac5c5fdfd88da = ()=>{
    try {
        if ($f3f43d2031f39922$export$a06801d4af98f3a3()) return window.webviewAPI;
        return undefined;
    } catch  {
        return undefined;
    }
};
const $f3f43d2031f39922$export$7f13f4efe0e0c1f3 = (message, transportSource)=>{
    const electronAPI = $f3f43d2031f39922$export$60ac5c5fdfd88da();
    if (!electronAPI) {
        (0, $cxhPv.emitter)().emit({
            type: 'transport-error',
            transportType: transportSource,
            direction: 'outbound',
            messageId: message.id,
            error: {
                message: 'Webview API not available',
                code: 'WEBVIEW_API_UNAVAILABLE'
            }
        });
        return;
    }
    const envelope = {
        version: 1,
        source: transportSource,
        message: message
    };
    (0, $cxhPv.emitter)().emit({
        type: 'transport-message-sent',
        transportType: transportSource,
        direction: 'outbound',
        messageId: message.id,
        message: {
            ...envelope
        }
    });
    // use the exposed to send to main
    electronAPI.postMessageToMain(envelope);
};
const $f3f43d2031f39922$export$206d5b20b7c5c9d6 = 'rovo-bridge-message-channel';
const $f3f43d2031f39922$export$c2e3eb4b2d131505 = 'desktop-main';

});

parcelRegister("4EOCt", function(module, exports) {
$parcel$export(module.exports, "findCrossOriginTarget", () => $dae14e225ef884d8$export$6052a3134234724b);

var $gdUUy = parcelRequire("gdUUy");

var $l4i9H = parcelRequire("l4i9H");
const $dae14e225ef884d8$var$MAX_FRAME_TRAVERSAL_DEPTH = 16;
const $dae14e225ef884d8$var$findIframe = (targetDocument, receiverId)=>{
    if ((0, $gdUUy.fg)('rovo_bridge_validate_message_origin')) // Client IDs come from messages and must not be interpreted as selector syntax.
    return Array.from((targetDocument === null || targetDocument === void 0 ? void 0 : targetDocument.querySelectorAll('iframe[data-rovo-receiver-id]')) ?? []).find((frame)=>frame.getAttribute('data-rovo-receiver-id') === receiverId);
    return (targetDocument === null || targetDocument === void 0 ? void 0 : targetDocument.querySelector(`[data-rovo-receiver-id="${receiverId}"]`)) ?? undefined;
};
const $dae14e225ef884d8$var$getDocument = (targetWindow)=>{
    try {
        return targetWindow.document;
    } catch  {
        return undefined;
    }
};
const $dae14e225ef884d8$var$getFrames = (targetWindow)=>{
    try {
        return Array.from(targetWindow.frames);
    } catch  {
        return [];
    }
};
/**
 * Traverses through all child frames (same-origin) which the current window has access to.
 * Required to discover child frames which are deeply nested as transport targets.
 *
 * @param receiverId bridge API client we are attempting to communicate with
 * @param rootWindow the current host / root window we are traversing down
 * @param visited windows we have already searched through
 * @param depth current depth - to enforce a maximum depth in our DFS
 *
 * @returns the relevant window or undefined
 */ const $dae14e225ef884d8$var$resolveChildIframeFromWindow = (receiverId, rootWindow, visited, depth)=>{
    // if we have already searched this window, early exit
    if (visited.has(rootWindow)) return undefined;
    // if we can no longer traverse further downwards, early exit
    if (depth > $dae14e225ef884d8$var$MAX_FRAME_TRAVERSAL_DEPTH) return undefined;
    // mark as visited
    visited.add(rootWindow);
    // get hold of the document & look for the current receiver of interest
    const rootDocument = $dae14e225ef884d8$var$getDocument(rootWindow);
    const frame = $dae14e225ef884d8$var$findIframe(rootDocument, receiverId);
    if (frame !== null && frame !== void 0 && frame.contentWindow) return frame;
    // if not found at the top-level, traverse down
    for (const childWindow of $dae14e225ef884d8$var$getFrames(rootWindow)){
        const target = $dae14e225ef884d8$var$resolveChildIframeFromWindow(receiverId, childWindow, visited, depth + 1);
        // found in sub-frame
        if (target) return target;
    }
    // not found amongst this window & all of its sub-frames
    return undefined;
};
/**
 * Resolves a target window by querying same-origin reachable DOM trees for an iframe with a
 * specific data attribute.
 *
 * @description The bridge API is mounted on the topmost same-origin window, but the target iframe
 * may be nested inside another same-origin iframe. Starting from the topmost same-origin window and
 * walking accessible child frame documents lets the shared transport discover cross-origin frames
 * that are only present inside nested same-origin containers.
 *
 * @param receiverId - The receiver ID to search for
 * @returns The iframe's contentWindow if found, otherwise undefined
 */ const $dae14e225ef884d8$var$resolveChildIframe = (receiverId)=>{
    var _window;
    const frame = $dae14e225ef884d8$var$findIframe((_window = window) === null || _window === void 0 ? void 0 : _window.document, receiverId);
    if (!frame || !frame.contentWindow) return undefined;
    return $dae14e225ef884d8$var$resolveChildIframeFromWindow(receiverId, (0, $l4i9H.findTopmostSameOriginWindow)(window), new WeakSet(), 0);
};
const $dae14e225ef884d8$export$3888b6e26a971bed = (receiverId)=>{
    var _resolveChildIframe;
    return ((_resolveChildIframe = $dae14e225ef884d8$var$resolveChildIframe(receiverId)) === null || _resolveChildIframe === void 0 ? void 0 : _resolveChildIframe.contentWindow) ?? undefined;
};
const $dae14e225ef884d8$export$b2c3e80b3e42c109 = ()=>{
    if (window.top && !(0, $l4i9H.isTop)(window)) return window.top;
    return undefined;
};
const $dae14e225ef884d8$var$getOrigin = (url)=>{
    if (!url) return undefined;
    try {
        const origin = new URL(url, window.location.href).origin;
        return origin === 'null' ? undefined : origin;
    } catch  {
        return undefined;
    }
};
const $dae14e225ef884d8$var$getTopmostAncestorOrigin = ()=>{
    try {
        const { ancestorOrigins: ancestorOrigins } = window.location;
        if (ancestorOrigins.length > 0) return ancestorOrigins.item(ancestorOrigins.length - 1) ?? undefined;
    } catch  {}
    const referrerOrigin = $dae14e225ef884d8$var$getOrigin(window.document.referrer);
    return referrerOrigin === window.location.origin ? undefined : referrerOrigin;
};
const $dae14e225ef884d8$export$6052a3134234724b = (receiverId)=>{
    const frame = $dae14e225ef884d8$var$resolveChildIframe(receiverId);
    if (frame !== null && frame !== void 0 && frame.contentWindow) return {
        target: frame.contentWindow,
        origin: $dae14e225ef884d8$var$getOrigin(frame.src)
    };
    const parent = $dae14e225ef884d8$export$b2c3e80b3e42c109();
    return parent ? {
        target: parent,
        origin: $dae14e225ef884d8$var$getTopmostAncestorOrigin()
    } : undefined;
};

});



parcelRegister("jmUpm", function(module, exports) {
$parcel$export(module.exports, "ROVO_CHAT_CLIENT_ID", () => $5ce0d0e992372f9c$export$849380b7ef7c6423);

var $d6sum = parcelRequire("d6sum");
const $5ce0d0e992372f9c$export$849380b7ef7c6423 = (0, $d6sum.client)('rovo-chat');

});

parcelRegister("972xM", function(module, exports) {
$parcel$export(module.exports, "HELP_CENTER_FORM_REQUEST_CLIENT_ID", () => $01f4194863286f59$export$6c08ef6d43996fe4);

var $d6sum = parcelRequire("d6sum");
const $01f4194863286f59$export$6c08ef6d43996fe4 = (0, $d6sum.client)('help-center-form-content-renderer');

});

parcelRegister("5hqQs", function(module, exports) {
$parcel$export(module.exports, "NotifySuccessCommand", () => $ea4a2909abf07b3e$export$fa7e3d4efc038293);

var $12gQu = parcelRequire("12gQu");
const $ea4a2909abf07b3e$export$fa7e3d4efc038293 = (0, $12gQu.createCommand)('notify-success-command');

});


parcelRegister("fDjPz", function(module, exports) {
$parcel$export(module.exports, "SimpleIconPage", () => (parcelRequire("bnpCY")).default);

var $bnpCY = parcelRequire("bnpCY");

});
parcelRegister("bnpCY", function(module, exports) {
$parcel$export(module.exports, "default", () => $0deb0215987cc346$export$2e2bcd8739ae039);

var $bSJIT = parcelRequire("bSJIT");

var $4v2A7 = parcelRequire("4v2A7");

var $2ERPT = parcelRequire("2ERPT");

var $c6H7d = parcelRequire("c6H7d");

var $cAJ8B = parcelRequire("cAJ8B");

var $7WQx2 = parcelRequire("7WQx2");

var $aRsbV = parcelRequire("aRsbV");
const $0deb0215987cc346$var$SimpleIconPage = ({ actionHrefTarget: actionHrefTarget, title: title, header: header, description: description, callToActionHref: callToActionHref, callToActionText: callToActionText, dataTestId: dataTestId, icon: Icon })=>{
    return /*#__PURE__*/ $bSJIT.createElement((0, $2ERPT.default), {
        title: title
    }, /*#__PURE__*/ $bSJIT.createElement((0, $cAJ8B.PaperContent), null, /*#__PURE__*/ $bSJIT.createElement($0deb0215987cc346$export$e193322e8b0256b9, {
        "data-testId": dataTestId
    }, !!Icon && /*#__PURE__*/ $bSJIT.createElement(Icon, null), !!header && /*#__PURE__*/ $bSJIT.createElement((0, $7WQx2.default), {
        as: "h1",
        size: "medium"
    }, header), !!description && /*#__PURE__*/ $bSJIT.createElement((0, $aRsbV.Text), null, description), !!callToActionHref && /*#__PURE__*/ $bSJIT.createElement($0deb0215987cc346$export$5efa7f588d56dda0, {
        to: callToActionHref,
        actionSubjectId: "callToAction",
        target: actionHrefTarget
    }, callToActionText))));
};
var $0deb0215987cc346$export$2e2bcd8739ae039 = $0deb0215987cc346$var$SimpleIconPage;
const $0deb0215987cc346$export$e193322e8b0256b9 = /*#__PURE__*/ (0, $4v2A7.default).div.withConfig({
    componentId: "sc-1640ypc-0"
})({
    display: 'flex',
    flexFlow: 'column wrap',
    alignItems: 'center',
    gap: "var(--ds-space-100, 8px)",
    marginTop: "var(--ds-space-600, 48px)"
});
const $0deb0215987cc346$export$5efa7f588d56dda0 = /*#__PURE__*/ (0, $4v2A7.default)((0, $c6H7d.default)).withConfig({
    componentId: "sc-1640ypc-1"
})`text-align:center;text-decoration:underline;`;

});


parcelRegister("fnB99", function(module, exports) {
$parcel$export(module.exports, "default", () => $a54cc622d13b84e1$export$2e2bcd8739ae039);

var $f0Pt4 = parcelRequire("f0Pt4");
var $a54cc622d13b84e1$export$2e2bcd8739ae039 = (0, $f0Pt4.defineMessages)({
    sendForm: {
        defaultMessage: 'Send',
        description: 'Send button for request create form',
        id: 'cv.request.create.form.button.send'
    },
    cancelForm: {
        defaultMessage: 'Cancel',
        description: 'Cancel button for request create form',
        id: 'cv.request.create.form.button.cancel'
    },
    fieldValidationError: {
        defaultMessage: `Please provide a value for required field \u2019{fieldLabel}\u2019`,
        description: 'Field error validation message shown under field when there is an error.',
        id: 'cv.request.create.field.validation.error.message'
    },
    fieldLimitExceededError: {
        defaultMessage: `This field can only store {objectLimit, plural, one {# object} other {# objects}}.`,
        description: 'Field error validation message shown under field when the field limit is exceeded.',
        id: 'cv.request.create.field.limit.exceeded.error.message'
    },
    fieldInvalidConfigError: {
        defaultMessage: 'This required field is missing configuration and therefore cannot be displayed.',
        description: 'Field error validation message shown under field when the field does not have a valid configuration.',
        id: 'cv.request.create.field.invalid.config.error.message'
    },
    affectedServicesFieldLimitError: {
        defaultMessage: 'This field can only store a maximum of {serviceLimit, plural, one {# service} other {# services}}.',
        description: 'Field error validation message shown under field when the field limit is exceeded.',
        id: 'cv.request.create.field.affected-services.limit.exceeded.error.message'
    },
    thanksTitle: {
        defaultMessage: 'Thanks',
        description: 'Header message for a page after they have successfully created a request.',
        id: 'cv.request.create.embeddable.create.success.title'
    },
    referenceDescription: {
        defaultMessage: 'Your request has been raised.',
        description: 'Description message for a page after they have successfully created a request.',
        id: 'cv.request.create.embeddable.create.success.description'
    },
    callToAction: {
        defaultMessage: 'View request',
        description: 'Call to action link that takes the user the help center in a new tab, after they have successfully created a request.',
        id: 'cv.request.create.embeddable.create.success.callToActionText'
    },
    instructionForMandatoryField: {
        defaultMessage: 'Required fields are marked with an asterisk',
        description: 'This is an instruction which states fields with an asterisk (*) are compulsary',
        id: 'cv.request.create.embeddable.instructionForMandatoryField'
    },
    requestSubmittedMessage: {
        defaultMessage: 'Request submitted successfully',
        description: 'The title shown in the flag when the request is submitted successfully',
        id: 'help-center.request-create-form.requestSubmittedMessage'
    },
    requestSubmittedDescription: {
        defaultMessage: 'Your request will show up in your project queues as a new work item.',
        description: 'The description shown in the flag when the request is submitted successfully',
        id: 'help-center.request-create-form.requestSubmittedDescription'
    },
    requestSubmittedAction: {
        defaultMessage: 'View work item',
        description: 'The link label to navigate user to newly created work item',
        id: 'help-center.request-create-form.requestSubmittedAction'
    },
    requestSubmittedFcfWarningTitle: {
        defaultMessage: 'Request submitted with exceptions',
        description: 'The message title shown in the flag when the request is submitted with warnings',
        id: 'help-center.request-create-form.requestSubmittedFcfWarningTitle'
    },
    requestSubmittedFcfWarningMessageDescription: {
        defaultMessage: 'We submitted your request but without the value of the {field} field. If this happens again, notify your admin.',
        description: 'The message description shown in the flag when the request is submitted with warnings',
        id: 'help-center.request-create-form.requestSubmittedFcfWarningMessageDescription'
    }
});

});

parcelRegister("gLV5g", function(module, exports) {
$parcel$export(module.exports, "default", () => $c93311874e3fe3c8$export$2e2bcd8739ae039);
// The code run in the case statements in this file should be wrapped in blocks.
/* eslint-disable no-case-declarations */ 
var $bSJIT = parcelRequire("bSJIT");

var $kPxiY = parcelRequire("kPxiY");

var $lFpPv = parcelRequire("lFpPv");

var $i5HDF = parcelRequire("i5HDF");

var $lCAV6 = parcelRequire("lCAV6");

var $4ZMmh = parcelRequire("4ZMmh");

var $5cKiX = parcelRequire("5cKiX");

var $iBcfi = parcelRequire("iBcfi");

var $lc3yJ = parcelRequire("lc3yJ");
parcelRequire("kOajk");
var $61tcz = parcelRequire("61tcz");
parcelRequire("1U3rG");
var $5kkQ8 = parcelRequire("5kkQ8");
parcelRequire("7dhfB");
var $25dMu = parcelRequire("25dMu");
parcelRequire("9RbxT");
var $ijCiB = parcelRequire("ijCiB");

var $67fJ8 = parcelRequire("67fJ8");
parcelRequire("554XC");
var $30UiE = parcelRequire("30UiE");
var $554XC = parcelRequire("554XC");

var $bo2U3 = parcelRequire("bo2U3");
var $1MztO = parcelRequire("1MztO");
parcelRequire("fZxJ3");
var $9VdzC = parcelRequire("9VdzC");
parcelRequire("esufH");
var $2KfHs = parcelRequire("2KfHs");
parcelRequire("1sU5z");
var $1vV30 = parcelRequire("1vV30");
parcelRequire("lxaPu");
var $1VvAK = parcelRequire("1VvAK");
parcelRequire("acDtw");
var $lHthJ = parcelRequire("lHthJ");
parcelRequire("aLbXO");
var $1Sb5C = parcelRequire("1Sb5C");
parcelRequire("hJaAk");
var $hssCz = parcelRequire("hssCz");
parcelRequire("l4hB6");
var $86Hmw = parcelRequire("86Hmw");
parcelRequire("esIdH");
var $gxtE7 = parcelRequire("gxtE7");
parcelRequire("8UJBN");
var $4tm1w = parcelRequire("4tm1w");
parcelRequire("bny4J");
var $26Nuz = parcelRequire("26Nuz");

var $2XFLQ = parcelRequire("2XFLQ");
parcelRequire("4uFRA");
var $c4tGx = parcelRequire("c4tGx");
parcelRequire("j2g7T");
var $7pA9H = parcelRequire("7pA9H");

var $3gTkE = parcelRequire("3gTkE");
parcelRequire("lHUBw");
var $8IOO6 = parcelRequire("8IOO6");
parcelRequire("dgSpO");
var $iDsx5 = parcelRequire("iDsx5");
parcelRequire("l0uAN");
var $fcFs7 = parcelRequire("fcFs7");

var $eZ9Sa = parcelRequire("eZ9Sa");

var $fnB99 = parcelRequire("fnB99");

var $8BxxY = parcelRequire("8BxxY");

var $2usNr = parcelRequire("2usNr");

var $kIbto = parcelRequire("kIbto");

var $87QgR = parcelRequire("87QgR");

var $1qPbZ = parcelRequire("1qPbZ");

var $hDkm2 = parcelRequire("hDkm2");

var $haAAx = parcelRequire("haAAx");
parcelRequire("8PrUg");
var $iPY20 = parcelRequire("iPY20");

var $iydAA = parcelRequire("iydAA");

var $fFdP5 = parcelRequire("fFdP5");

var $ePuyT = parcelRequire("ePuyT");

var $kTwJo = parcelRequire("kTwJo");
parcelRequire("cPxQb");
var $hVMHI = parcelRequire("hVMHI");
/**
 * Feature gate: block_request_create_submit_for_form_loading
 *
 * Disables the Send/Cancel buttons on portal request create while the Proforma form
 * has not finished rendering, so requests can't be submitted without form answers.
 */ const $c93311874e3fe3c8$var$BLOCK_REQUEST_CREATE_SUBMIT_FOR_FORM_LOADING = 'block_request_create_submit_for_form_loading';
const $c93311874e3fe3c8$var$isBlockRequestCreateSubmitForFormLoadingEnabled = ()=>(0, $87QgR.default).checkGate($c93311874e3fe3c8$var$BLOCK_REQUEST_CREATE_SUBMIT_FOR_FORM_LOADING);
class $c93311874e3fe3c8$export$d3eed393162f64da extends $bSJIT.Component {
    static #_ = this.defaultProps = {
        errors: {
            fieldErrors: {}
        }
    };
    shouldComponentUpdate(nextProps, nextState) {
        // shouldComponentUpdate override is implemented for performance improvement, see FSD-2741
        const { fieldValues: nextFieldValues, ...nextRemainingProps } = nextProps;
        const { fieldValues: fieldValues, ...remainingProps } = this.props;
        if (!(0, $4ZMmh.isEqual)(this.state, nextState) || !(0, $4ZMmh.isEqual)(remainingProps, nextRemainingProps)) return true;
        // The organisation picker is dependent on the reporter field, so we should rerender in this case
        return nextFieldValues.reporter !== fieldValues.reporter;
    }
    componentDidMount() {
        const { createAnalyticsEvent: createAnalyticsEvent } = this.props;
        if (createAnalyticsEvent) {
            const analyticsEvent = createAnalyticsEvent({
                analyticsType: (0, $haAAx.OPERATIONAL_EVENT_TYPE),
                action: this.unknownField ? 'failed' : 'loaded',
                actionSubjectId: 'fields',
                attributes: {
                    unknownField: this.unknownField
                }
            });
            analyticsEvent.fire();
        }
    }
    renderFields(fields, submitting) {
        return fields.filter((field)=>field.displayed).map((field)=>this.renderField(field, submitting));
    }
    renderReporterField(reporterState, baseProps, submitting, fieldErrors, // eslint-disable-next-line @typescript-eslint/no-explicit-any
    urlParamValueOverride, canCreateUsers) {
        const defaultReporter = reporterState.defaultReporter ? {
            email: reporterState.defaultReporter.emailAddress,
            iconUrl: reporterState.defaultReporter.avatar,
            value: reporterState.defaultReporter.id,
            label: reporterState.defaultReporter.displayName,
            accountId: reporterState.defaultReporter.accountId
        } : undefined;
        const defaultReporterOverride = (0, $lFpPv.isJsmPortalRovoIntegrationEnabled)() ? urlParamValueOverride : undefined;
        return /*#__PURE__*/ $bSJIT.createElement((0, $gxtE7.default), {
            ...baseProps,
            portalId: this.props.portalId,
            label: reporterState.label || '',
            onChange: this.onReporterFieldChange,
            key: reporterState.id,
            errorMessage: fieldErrors[reporterState.id],
            disabled: submitting || !!reporterState.disabled,
            defaultReporter: defaultReporterOverride ?? defaultReporter,
            canCreateUser: canCreateUsers,
            createLabelType: "create",
            fieldConfigId: reporterState.fieldConfigId
        });
    }
    renderField(fieldState, submitting) {
        const { type: type, value: _, valueOverride: __, ...baseProps } = fieldState;
        const { projectId: projectId, portalId: portalId, requestTypeId: requestTypeId, onFieldChange: onFieldChange, knowledgeBase: knowledgeBase, enableSubmitButton: enableSubmitButton, disableSubmitButton: disableSubmitButton, canCreateUsers: canCreateUsers, locale: locale, dateFormat: dateFormat, dateTimeFormat: dateTimeFormat, firstDay: firstDay, useISO8601WeekNumbers: useISO8601WeekNumbers, fieldValues: fieldValues, urlParamFieldValueOverrides: urlParamFieldValueOverrides, fields: fields } = this.props;
        const fieldErrors = this.props.errors && this.props.errors.fieldErrors || {};
        const errorReasonKey = this.props.errors && this.props.errors.errorReasonKey;
        // Suppressing existing violation. Please fix this.
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
        const urlParamValueOverride = urlParamFieldValueOverrides[fieldState.id];
        const { reporter: reporter } = this.props.fieldValues;
        const shouldAttachmentRender = fields.some((field)=>field.type === 'attachment' && field.displayed);
        switch(type){
            case 'text':
                const textState = fieldState;
                if (textState.id === 'summary') return /*#__PURE__*/ $bSJIT.createElement((0, $c4tGx.default), {
                    ...baseProps,
                    requestTypeId: requestTypeId,
                    knowledgeBase: knowledgeBase,
                    // We need to rehydrate the default value if its defined.
                    // If we don't do this the internal state is thrown away when re-rendered
                    // and the field can never get back the current value.
                    // This is currently handling the case when the summary field re-renders
                    // from request tour onboarding dismissal.
                    defaultValue: $c93311874e3fe3c8$var$calculateDefaultSummaryValue(urlParamValueOverride, fieldValues[textState.id], textState.value),
                    valueOverride: (0, $lFpPv.isUiModificationsSupportEnabled)() ? textState.valueOverride : undefined,
                    onChange: onFieldChange,
                    onFieldBlurredByUser: this.props.onFieldBlurredByUser,
                    key: textState.id,
                    errorMessage: fieldErrors[textState.id],
                    disabled: submitting || !!textState.disabled
                });
                if (textState.id === 'email') return /*#__PURE__*/ $bSJIT.createElement((0, $61tcz.default), {
                    ...baseProps,
                    key: textState.id,
                    // Suppressing existing violation. Please fix this.
                    defaultValue: // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
                    urlParamValueOverride === undefined ? textState.value : urlParamValueOverride,
                    onChange: onFieldChange,
                    errorMessage: fieldErrors.email,
                    disabled: submitting || !!textState.disabled,
                    errorReasonKey: errorReasonKey
                });
                if ((0, $lFpPv.isTextFieldSupportEnabled)()) return /*#__PURE__*/ $bSJIT.createElement((0, $3gTkE.ControlledTextField), {
                    ...baseProps,
                    // Suppressing existing violation. Please fix this.
                    defaultValue: // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
                    urlParamValueOverride === undefined ? textState.value : urlParamValueOverride,
                    valueOverride: (0, $lFpPv.isUiModificationsSupportEnabled)() ? textState.valueOverride : undefined,
                    onChange: onFieldChange,
                    onFieldBlurredByUser: this.props.onFieldBlurredByUser,
                    key: textState.id,
                    errorMessage: fieldErrors[textState.id],
                    disabled: submitting || !!textState.disabled,
                    testId: 'request-create-form-text-field'
                });
                return /*#__PURE__*/ $bSJIT.createElement((0, $3gTkE.TextField), {
                    ...baseProps,
                    // Suppressing existing violation. Please fix this.
                    defaultValue: // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
                    urlParamValueOverride === undefined ? textState.value : urlParamValueOverride,
                    onChange: onFieldChange,
                    key: textState.id,
                    errorMessage: fieldErrors[textState.id],
                    disabled: submitting || !!textState.disabled,
                    testId: 'request-create-form-text-field'
                });
            case 'checkbox':
                {
                    const checkboxState = fieldState;
                    const checkboxItems = checkboxState.items.map((item)=>({
                            label: item.label,
                            value: item.value
                        }));
                    const checkboxProps = {
                        ...baseProps,
                        items: checkboxItems,
                        // Suppressing existing violation. Please fix this.
                        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
                        defaultValue: urlParamValueOverride || checkboxState.value,
                        onChange: onFieldChange,
                        key: checkboxState.id,
                        errorMessage: fieldErrors[checkboxState.id],
                        disabled: submitting || !!checkboxState.disabled
                    };
                    return (0, $lFpPv.isMultiCheckboxSupportEnabled)() ? /*#__PURE__*/ $bSJIT.createElement((0, $ijCiB.ControlledCheckboxGroup), {
                        ...checkboxProps,
                        valueOverride: (0, $lFpPv.isUiModificationsSupportEnabled)() ? checkboxState.valueOverride : undefined
                    }) : /*#__PURE__*/ $bSJIT.createElement((0, $ijCiB.default), checkboxProps);
                }
            case 'textarea':
                const textAreaState = fieldState;
                const hasMediaContext = (0, $87QgR.default).checkGate('request_create_inline_attachment') && shouldAttachmentRender;
                if ((0, $lFpPv.isRichTextAreaEnabled)() && textAreaState.rendererType === 'atlassian-wiki-renderer') {
                    const mediaContextProps = hasMediaContext && portalId ? {
                        mediaContext: {
                            portalId: portalId,
                            requestId: undefined
                        }
                    } : {};
                    return /*#__PURE__*/ $bSJIT.createElement((0, $26Nuz.FormRichTextArea), {
                        ...baseProps,
                        onChange: onFieldChange,
                        defaultValue: $c93311874e3fe3c8$var$calculateDefaultRichTextValue(urlParamValueOverride, fieldValues[textAreaState.id], textAreaState.value),
                        key: textAreaState.id,
                        errorMessage: fieldErrors[textAreaState.id],
                        disabled: submitting || !!textAreaState.disabled,
                        fieldConfigs: {
                            portalId: this.props.portalId,
                            fieldConfigId: textAreaState.fieldConfigId,
                            fieldName: textAreaState.id
                        },
                        valueOverride: (0, $lFpPv.isUiModificationsSupportEnabled)() ? textAreaState.valueOverride : undefined,
                        onFieldBlurredByUser: (0, $lFpPv.isUiModificationsSupportEnabled)() ? this.props.onFieldBlurredByUser : undefined,
                        ...mediaContextProps
                    });
                }
                return /*#__PURE__*/ $bSJIT.createElement((0, $7pA9H.FormTextArea), {
                    ...baseProps,
                    minimumRows: 6,
                    onChange: onFieldChange,
                    // Suppressing existing violation. Please fix this.
                    defaultValue: // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
                    urlParamValueOverride === undefined ? textAreaState.value : urlParamValueOverride,
                    key: textAreaState.id,
                    errorMessage: fieldErrors[textAreaState.id],
                    disabled: submitting || !!textAreaState.disabled,
                    valueOverride: (0, $lFpPv.isUiModificationsSupportEnabled)() ? textAreaState.valueOverride : undefined,
                    onFieldBlurredByUser: (0, $lFpPv.isUiModificationsSupportEnabled)() ? this.props.onFieldBlurredByUser : undefined
                });
            case 'radio':
                const radioGroupState = fieldState;
                const radioItems = radioGroupState.items.map((item)=>{
                    return {
                        label: item.label,
                        name: item.name,
                        value: item.value
                    };
                });
                const radioProps = {
                    ...baseProps,
                    items: radioItems,
                    // Suppressing existing violation. Please fix this.
                    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
                    defaultValue: urlParamValueOverride || radioGroupState.value,
                    onChange: onFieldChange,
                    key: radioGroupState.id,
                    errorMessage: fieldErrors[radioGroupState.id],
                    disabled: submitting || !!radioGroupState.disabled
                };
                return (0, $lFpPv.isRadioButtonsSupportEnabled)() ? /*#__PURE__*/ $bSJIT.createElement((0, $86Hmw.ControlledRadioGroup), {
                    ...radioProps,
                    valueOverride: (0, $lFpPv.isUiModificationsSupportEnabled)() ? radioGroupState.valueOverride : undefined
                }) : /*#__PURE__*/ $bSJIT.createElement((0, $86Hmw.default), radioProps);
            case 'date':
                const dateState = fieldState;
                return /*#__PURE__*/ $bSJIT.createElement((0, $30UiE.ConditionalDatepicker), {
                    ...baseProps,
                    // Suppressing existing violation. Please fix this.
                    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
                    defaultValue: urlParamValueOverride || dateState.defaultDate,
                    valueOverride: (0, $lFpPv.isUiModificationsSupportEnabled)() ? dateState.valueOverride : undefined,
                    onChange: onFieldChange,
                    key: dateState.id,
                    errorMessage: fieldErrors[dateState.id],
                    disabled: submitting || !!dateState.disabled,
                    dateFormat: dateFormat,
                    firstDay: firstDay,
                    locale: locale,
                    useISO8601WeekNumbers: useISO8601WeekNumbers
                });
            case 'duedate':
                const dueDateState = fieldState;
                return (0, $lFpPv.isDueDateSupportEnabled)() ? /*#__PURE__*/ $bSJIT.createElement((0, $554XC.ControlledDatePicker), {
                    ...baseProps,
                    // Suppressing existing violation. Please fix this.
                    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
                    defaultValue: urlParamValueOverride || dueDateState.defaultDate,
                    valueOverride: (0, $lFpPv.isUiModificationsSupportEnabled)() ? dueDateState.valueOverride : undefined,
                    onChange: onFieldChange,
                    key: dueDateState.id,
                    errorMessage: fieldErrors[dueDateState.id],
                    disabled: submitting || !!dueDateState.disabled,
                    dateFormat: dateFormat,
                    firstDay: firstDay,
                    locale: locale,
                    useISO8601WeekNumbers: useISO8601WeekNumbers
                }) : /*#__PURE__*/ $bSJIT.createElement((0, $30UiE.default), {
                    ...baseProps,
                    // Suppressing existing violation. Please fix this.
                    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
                    defaultValue: urlParamValueOverride || dueDateState.defaultDate,
                    onChange: onFieldChange,
                    key: dueDateState.id,
                    errorMessage: fieldErrors[dueDateState.id],
                    disabled: submitting || !!dueDateState.disabled,
                    dateFormat: dateFormat,
                    firstDay: firstDay,
                    locale: locale,
                    useISO8601WeekNumbers: useISO8601WeekNumbers
                });
            case 'datetime':
                const dateTimeState = fieldState;
                return (0, $lFpPv.isDateTimeSupportEnabled)() ? /*#__PURE__*/ $bSJIT.createElement((0, $bo2U3.ControlledDateTimePicker), {
                    ...baseProps,
                    // Suppressing existing violation. Please fix this.
                    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
                    defaultValue: urlParamValueOverride || dateTimeState.defaultDate,
                    valueOverride: (0, $lFpPv.isUiModificationsSupportEnabled)() ? dateTimeState.valueOverride : undefined,
                    onChange: onFieldChange,
                    key: dateTimeState.id,
                    errorMessage: fieldErrors[dateTimeState.id],
                    disabled: submitting || !!dateTimeState.disabled,
                    dateTimeFormat: dateTimeFormat,
                    firstDay: firstDay,
                    useISO8601WeekNumbers: useISO8601WeekNumbers,
                    locale: locale
                }) : /*#__PURE__*/ $bSJIT.createElement((0, $1MztO.default), {
                    ...baseProps,
                    // Suppressing existing violation. Please fix this.
                    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
                    defaultValue: urlParamValueOverride || dateTimeState.defaultDate,
                    onChange: onFieldChange,
                    key: dateTimeState.id,
                    errorMessage: fieldErrors[dateTimeState.id],
                    disabled: submitting || !!dateTimeState.disabled,
                    dateTimeFormat: dateTimeFormat,
                    firstDay: firstDay,
                    useISO8601WeekNumbers: useISO8601WeekNumbers,
                    locale: locale
                });
            case 'attachment':
                const attachmentState = fieldState;
                return /*#__PURE__*/ $bSJIT.createElement((0, $4tm1w.default), {
                    ...baseProps,
                    onChange: onFieldChange,
                    key: attachmentState.id,
                    disabled: submitting || !!attachmentState.disabled,
                    errorMessage: fieldErrors[attachmentState.id],
                    portalId: this.props.portalId,
                    blockFormSubmission: this.props.blockFormSubmission
                });
            case 'reporter':
                return this.renderReporterField(fieldState, baseProps, submitting, fieldErrors, urlParamValueOverride, canCreateUsers);
            case 'userpicker':
                const userPickerState = fieldState;
                const defaultUser = userPickerState.defaultUser ? {
                    email: userPickerState.defaultUser.emailAddress,
                    iconUrl: userPickerState.defaultUser.avatar,
                    value: userPickerState.defaultUser.id,
                    label: userPickerState.defaultUser.displayName,
                    accountId: userPickerState.defaultUser.accountId
                } : undefined;
                const defaultUserOverride = (0, $lFpPv.isJsmPortalRovoIntegrationEnabled)() ? urlParamValueOverride : undefined;
                return /*#__PURE__*/ $bSJIT.createElement((0, $iDsx5.default), {
                    ...baseProps,
                    portalId: this.props.portalId,
                    label: userPickerState.label || '',
                    onChange: onFieldChange,
                    key: userPickerState.id,
                    errorMessage: fieldErrors[userPickerState.id],
                    disabled: submitting || !!userPickerState.disabled,
                    defaultUser: defaultUserOverride ?? defaultUser,
                    canCreateUser: canCreateUsers,
                    createLabelType: "add",
                    fieldConfigId: userPickerState.fieldConfigId,
                    valueOverride: (0, $lFpPv.isUiModificationsSupportEnabled)() ? userPickerState.valueOverride : undefined
                });
            case 'multiuserpicker':
                const multiUserPickerState = fieldState;
                const defaultUsers = (multiUserPickerState.defaultUsers || []).map((user)=>({
                        email: user.emailAddress,
                        iconUrl: user.avatar,
                        value: user.id,
                        label: user.displayName
                    }));
                const defaultMultiUsersOverride = (0, $lFpPv.isJsmPortalRovoIntegrationEnabled)() ? urlParamValueOverride : undefined;
                const mergedDefaultUsers = defaultMultiUsersOverride ?? defaultUsers;
                return /*#__PURE__*/ $bSJIT.createElement((0, $1Sb5C.default), {
                    ...baseProps,
                    portalId: this.props.portalId,
                    label: multiUserPickerState.label || '',
                    onChange: onFieldChange,
                    key: multiUserPickerState.id,
                    errorMessage: fieldErrors[multiUserPickerState.id],
                    disabled: submitting || !!multiUserPickerState.disabled,
                    defaultUsers: mergedDefaultUsers,
                    fieldConfigId: multiUserPickerState.fieldConfigId,
                    canAddUserByEmailAddress: canCreateUsers
                });
            case 'organduserpicker':
                // Note: We are returning an empty fragment here to avoid rendering the unknown field.
                return /*#__PURE__*/ $bSJIT.createElement($bSJIT.Fragment, null);
            case 'labelpicker':
                const labelPickerState = fieldState;
                return /*#__PURE__*/ $bSJIT.createElement((0, $1vV30.default), {
                    ...baseProps,
                    customFieldId: labelPickerState.customFieldId,
                    portalId: portalId,
                    requestTypeId: requestTypeId,
                    onChange: onFieldChange,
                    key: labelPickerState.id,
                    errorMessage: fieldErrors[labelPickerState.id],
                    disabled: submitting || !!labelPickerState.disabled,
                    // Suppressing existing violation. Please fix this.
                    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
                    defaultLabels: urlParamValueOverride || labelPickerState.defaultLabels,
                    valueOverride: (0, $lFpPv.isUiModificationsSupportEnabled)() ? labelPickerState.valueOverride : undefined
                });
            case 'organisationpicker':
                const orgState = fieldState;
                const defaultOrganisationOverride = (0, $lFpPv.isJsmPortalRovoIntegrationEnabled)() ? urlParamValueOverride : undefined;
                return(// @ts-ignore
                /*#__PURE__*/ $bSJIT.createElement((0, $hssCz.default), {
                    ...baseProps,
                    projectId: projectId,
                    portalId: portalId,
                    requestTypeId: requestTypeId,
                    onChange: onFieldChange,
                    key: orgState.id,
                    // Suppressing existing violation. Please fix this.
                    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
                    organisationUserEmail: reporter,
                    isNewReporter: this.state.isNewReporter,
                    disabled: submitting || !!orgState.disabled,
                    enableSubmitButton: enableSubmitButton,
                    disableSubmitButton: disableSubmitButton,
                    shareWithOrgByDefault: orgState.shareWithOrgByDefault,
                    defaultOrganisation: defaultOrganisationOverride
                }));
            case 'assetspicker':
                const assetPickerState = fieldState;
                return /*#__PURE__*/ $bSJIT.createElement((0, $5kkQ8.default), {
                    ...baseProps,
                    label: assetPickerState.label || '',
                    onChange: onFieldChange,
                    key: assetPickerState.id,
                    disabled: submitting || !!assetPickerState.disabled,
                    fieldConfigId: assetPickerState.fieldConfigId,
                    accountId: this.state.accountId,
                    portalId: portalId,
                    errorMessage: fieldErrors[assetPickerState.id]
                });
            case 'multiservicepicker':
                const multiServicePickerState = fieldState;
                let defaultMultiServicesOverride;
                if ((0, $lFpPv.isJsmPortalRovoIntegrationEnabled)() && urlParamValueOverride) {
                    // Handle both string and array formats
                    if (Array.isArray(urlParamValueOverride)) defaultMultiServicesOverride = urlParamValueOverride;
                    else if (typeof urlParamValueOverride === 'string') defaultMultiServicesOverride = [
                        urlParamValueOverride
                    ];
                }
                return /*#__PURE__*/ $bSJIT.createElement((0, $lHthJ.default), {
                    ...baseProps,
                    label: multiServicePickerState.label || '',
                    onChange: onFieldChange,
                    key: multiServicePickerState.id,
                    disabled: submitting || !!multiServicePickerState.disabled,
                    errorMessage: fieldErrors[multiServicePickerState.id],
                    defaultServices: defaultMultiServicesOverride,
                    value: fieldValues[multiServicePickerState.id]
                });
            case 'cmdbobjectpicker':
                const cmdbObjectPickerState = fieldState;
                const fieldValueMapReducer = (accumulator, currentField)=>{
                    var _fieldValues$currentF;
                    // Suppressing existing violation. Please fix this.
                    return accumulator.concat([
                        // eslint-disable-next-line @typescript-eslint/no-unsafe-call, @typescript-eslint/no-unsafe-member-access
                        [
                            currentField.id,
                            ((_fieldValues$currentF = fieldValues[currentField.id]) === null || _fieldValues$currentF === void 0 ? void 0 : _fieldValues$currentF.toString()) || ''
                        ]
                    ]);
                };
                // Disable field if form is submitting
                // OR if the field does not have a valid configuration (and therefore, cannot provide any values to pick)
                const isCmdbObjectPickerDisabled = submitting || !cmdbObjectPickerState.hasValidConfig || !!cmdbObjectPickerState.disabled;
                return /*#__PURE__*/ $bSJIT.createElement((0, $iPY20.default), {
                    ...baseProps,
                    ...cmdbObjectPickerState,
                    onChange: onFieldChange,
                    key: cmdbObjectPickerState.id,
                    disabled: isCmdbObjectPickerDisabled,
                    errorMessage: fieldErrors[cmdbObjectPickerState.id],
                    portalId: portalId,
                    requestTypeId: requestTypeId,
                    fieldValueMap: fields.reduce(fieldValueMapReducer, []),
                    placeholderValues: (0, $fFdP5.createPlaceholderValueMap)(fieldValues, cmdbObjectPickerState.placeholderKeys),
                    initialValues: urlParamValueOverride
                });
            case 'select':
                const selectState = fieldState;
                return /*#__PURE__*/ $bSJIT.createElement((0, $2XFLQ.SingleSelectField), {
                    ...baseProps,
                    label: selectState.label || '',
                    onChange: onFieldChange,
                    key: selectState.id,
                    errorMessage: fieldErrors[selectState.id],
                    disabled: submitting || !!selectState.disabled,
                    // Suppressing existing violation. Please fix this.
                    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
                    defaultValue: urlParamValueOverride || selectState.defaultValue,
                    valueOverride: (0, $lFpPv.isUiModificationsSupportEnabled)() ? selectState.valueOverride : undefined,
                    options: selectState.options
                });
            case 'multiselect':
                const multiSelectState = fieldState;
                return /*#__PURE__*/ $bSJIT.createElement((0, $1VvAK.default), {
                    ...baseProps,
                    label: multiSelectState.label || '',
                    onChange: onFieldChange,
                    key: multiSelectState.id,
                    errorMessage: fieldErrors[multiSelectState.id],
                    disabled: submitting || !!multiSelectState.disabled,
                    // Suppressing existing violation. Please fix this.
                    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
                    defaultValue: urlParamValueOverride || multiSelectState.defaultValue,
                    valueOverride: (0, $lFpPv.isMultiSelectEnabled)() ? multiSelectState.valueOverride : undefined,
                    options: multiSelectState.options
                });
            case 'cascadingselect':
                const cascadingSelectState = fieldState;
                return /*#__PURE__*/ $bSJIT.createElement((0, $25dMu.FormCascadingSelect), {
                    ...baseProps,
                    actionSubjectId: "cascadingSelectField",
                    label: cascadingSelectState.label || '',
                    onChange: onFieldChange,
                    key: cascadingSelectState.id,
                    errorMessage: fieldErrors[cascadingSelectState.id],
                    disabled: submitting || !!cascadingSelectState.disabled,
                    // Suppressing existing violation. Please fix this.
                    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
                    defaultValue: urlParamValueOverride || cascadingSelectState.value,
                    options: cascadingSelectState.options,
                    valueOverride: (0, $lFpPv.isUiModificationsSupportEnabled)() ? cascadingSelectState.valueOverride : undefined
                });
            case 'entitlementpicker':
                const entitlementState = fieldState;
                const defaultEntitlementOverride = (0, $lFpPv.isJsmPortalRovoIntegrationEnabled)() ? urlParamValueOverride : undefined;
                return /*#__PURE__*/ $bSJIT.createElement((0, $9VdzC.EntitlementPicker), {
                    ...baseProps,
                    onChange: onFieldChange,
                    label: entitlementState.label || '',
                    value: fieldValues[entitlementState.id],
                    key: entitlementState.id,
                    reporterId: reporter,
                    isNewReporter: this.state.isNewReporter,
                    disabled: submitting || !!entitlementState.disabled,
                    enableSubmitButton: enableSubmitButton,
                    disableSubmitButton: disableSubmitButton,
                    errorMessage: fieldErrors[entitlementState.id],
                    defaultEntitlement: defaultEntitlementOverride
                });
            case 'forge':
                const forgeState = fieldState;
                return /*#__PURE__*/ $bSJIT.createElement((0, $2KfHs.ForgeField), {
                    ...baseProps,
                    jiraFieldType: (0, $lFpPv.isForgeCustomFieldsOnPortalViewEnabled)() ? undefined : forgeState.jiraFieldType,
                    extension: (0, $lFpPv.isForgeCustomFieldsOnPortalViewEnabled)() ? forgeState.extension : undefined,
                    key: forgeState.id,
                    portalId: this.props.portalId,
                    requestTypeId: this.props.requestTypeId,
                    projectId: this.props.projectId,
                    errorMessage: fieldErrors[forgeState.id],
                    value: fieldValues[forgeState.id],
                    fallbackRender: (newType)=>{
                        return this.renderField({
                            ...fieldState,
                            type: newType
                        }, submitting);
                    },
                    disabled: submitting || !!fieldState.disabled,
                    enableSubmitButton: enableSubmitButton,
                    disableSubmitButton: disableSubmitButton,
                    onChange: onFieldChange
                });
            default:
                const unknownFieldProps = fieldState;
                this.unknownField = type;
                return this.renderUnknownField(unknownFieldProps);
        }
    }
    renderUnknownField(fieldState) {
        return /*#__PURE__*/ $bSJIT.createElement((0, $8IOO6.default), {
            id: fieldState.id,
            key: fieldState.id
        });
    }
    renderErrorMessage() {
        const { submissionErrorCount: submissionErrorCount, errors: errors } = this.props;
        if (errors && errors.submissionError) return /*#__PURE__*/ $bSJIT.createElement((0, $lc3yJ.AutoFocus), {
            key: submissionErrorCount
        }, /*#__PURE__*/ $bSJIT.createElement((0, $hVMHI.default), {
            errors: errors
        }));
        return null;
    }
    renderFormFinished() {
        var _this$props$onProform, _this$props;
        (_this$props$onProform = (_this$props = this.props).onProformaFormRendered) === null || _this$props$onProform === void 0 || _this$props$onProform.call(_this$props);
        if (this.state.shouldHoldUFO) this.setState({
            shouldHoldUFO: false
        });
        if (!this.state.isProformaFormRendered) this.setState({
            isProformaFormRendered: true
        });
    }
    render() {
        const { accountId: accountId, fields: fields, fieldValues: fieldValues, errors: errors, className: className, submitting: submitting, submitDisabled: submitDisabled, onSubmit: onSubmit, onCancel: onCancel, sitekey: sitekey, requestTypeId: requestTypeId, portalId: portalId, isFormExpanded: isFormExpanded, isAttachmentUploading: isAttachmentUploading, registerProformaForm: registerProformaForm, locale: locale, knowledgeBase: knowledgeBase, updateForgeRequestPropertyData: updateForgeRequestPropertyData, formRef: formRef } = this.props;
        const hasProformaForm = !!registerProformaForm;
        // Disable submission while the Proforma form has not finished rendering.
        const isProformaFormPending = hasProformaForm && !this.state.isProformaFormRendered && $c93311874e3fe3c8$var$isBlockRequestCreateSubmitForFormLoadingEnabled();
        const AsyncProformaRequestCreateInternal = this.AsyncProformaRequestCreateInternal;
        const FormCreateApp = this.props.proformaField;
        let renderJiraFields = Boolean(FormCreateApp);
        if (!renderJiraFields) // If Proforma is on the page, display the Jira and Proforma fields at the same time
        renderJiraFields = hasProformaForm ? this.state.asyncFormCreateAppLoaded : true;
        const ProformaView = FormCreateApp ?? AsyncProformaRequestCreateInternal; // This is using root app component from the Locally Consumable version of the package for Proforma Request Create
        return /*#__PURE__*/ $bSJIT.createElement((0, $fcFs7.default), {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Disabled to rollout go/ui-styling-standard tooling, please resolve
            className: className,
            recaptchaEnabled: this.props.captchaEnabled,
            onSubmit: onSubmit,
            sitekey: sitekey,
            onTokenChange: this.onRecaptchaTokenChange,
            formRef: formRef,
            noValidate: true
        }, ({ isExecuting: isExecuting })=>{
            const isProcessing = submitting || isExecuting;
            const isButtonDisable = isProcessing || submitDisabled || isAttachmentUploading || isProformaFormPending;
            // Reporter of issue is the one selected in the reporter user picker.
            // If reporter user picker is not displayed, then the reporter is the current user.
            // Suppressing existing violation. Please fix this.
            // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
            const reporterAccountId = fieldValues.reporter ?? accountId;
            const renderProformaFormView = hasProformaForm && /*#__PURE__*/ $bSJIT.createElement(ProformaView, {
                blockFormSubmission: this.props.blockFormSubmission,
                "data-testid": 'AsyncProformaRequestCreate',
                fieldErrors: errors === null || errors === void 0 ? void 0 : errors.fieldErrors,
                knowledgeBase: knowledgeBase,
                locale: locale,
                portalId: portalId,
                registerProformaForm: registerProformaForm,
                // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
                renderFormFinished: this.renderFormFinished.bind(this),
                // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
                reporterAccountId: reporterAccountId,
                requestTypeId: requestTypeId
            });
            return /*#__PURE__*/ $bSJIT.createElement($bSJIT.Fragment, null, this.renderErrorMessage(), /*#__PURE__*/ $bSJIT.createElement((0, (/*@__PURE__*/$parcel$interopDefault($iBcfi))), {
                allowOverflowWhenOpen: (0, $lFpPv.isRichTextAreaEnabled)(),
                expanded: !!isFormExpanded
            }, renderJiraFields && this.renderFields(fields, isProcessing), !(0, $lFpPv.isProformaTTVCUpdateMeasureEnabled)() && renderProformaFormView, (0, $lFpPv.isProformaTTVCUpdateMeasureEnabled)() && /*#__PURE__*/ $bSJIT.createElement((0, $1qPbZ.default), {
                name: "proforma-jira-portal-create",
                hold: this.state.shouldHoldUFO
            }, renderProformaFormView), /*#__PURE__*/ $bSJIT.createElement((0, $67fJ8.ConnectFields), {
                requestTypeId: requestTypeId,
                portalId: portalId,
                location: (0, $kPxiY.REQUEST_CREATE_PANEL)
            }), /*#__PURE__*/ $bSJIT.createElement((0, $eZ9Sa.RequestCreatePropertyPanelModule), {
                portalId: this.props.portalId,
                projectId: (0, $4ZMmh.toNumber)(this.props.projectId),
                requestTypeId: this.props.requestTypeId,
                onUpdateRequestPropertyData: updateForgeRequestPropertyData
            }), renderJiraFields && /*#__PURE__*/ $bSJIT.createElement((0, $8BxxY.ButtonGroup), null, /*#__PURE__*/ $bSJIT.createElement((0, $lCAV6.ThemedButton), {
                appearance: "primary",
                type: "submit",
                isDisabled: isButtonDisable,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Disabled to rollout go/ui-styling-standard tooling, please resolve
                className: "request-create-form-submit",
                actionSubjectId: "submitRequest",
                interactionName: "request-create-submit",
                onMouseEnter: this.props.onHoverSubmitButton,
                testId: "request-create-form-submit-button"
            }, /*#__PURE__*/ $bSJIT.createElement((0, $5cKiX.default), (0, $fnB99.default).sendForm)), /*#__PURE__*/ $bSJIT.createElement((0, $iydAA.FireScreenEventOnMount), null), /*#__PURE__*/ $bSJIT.createElement((0, $lCAV6.ThemedButton), {
                appearance: "subtle",
                isDisabled: isButtonDisable,
                onClick: onCancel,
                actionSubjectId: "cancelRequest",
                testId: "request-create-form-cancel-button"
            }, /*#__PURE__*/ $bSJIT.createElement((0, $5cKiX.default), (0, $fnB99.default).cancelForm)), (isProcessing || isAttachmentUploading) && /*#__PURE__*/ $bSJIT.createElement((0, $hDkm2.default), {
                size: "small"
            }))));
        });
    }
    constructor(...args){
        super(...args), this.state = {
            accountId: undefined,
            isNewReporter: undefined,
            asyncFormCreateAppLoaded: false,
            shouldHoldUFO: true,
            isProformaFormRendered: false
        }, this.unknownField = null, this.AsyncProformaRequestCreateInternal = (0, $kTwJo.createAsyncProformaRequestCreate)({
            LoadingSkeleton: (0, $i5HDF.SkeletonLoadingWrapper),
            onLoaded: ()=>{
                this.setState({
                    asyncFormCreateAppLoaded: true
                });
            }
        }), this.onReporterFieldChange = (name, value, _ = false, additionalFieldData)=>{
            var _additionalFieldData$;
            const accountId = additionalFieldData && additionalFieldData.rawObject && additionalFieldData.rawObject.accountId;
            const isNewReporter = name === 'reporter' && (additionalFieldData === null || additionalFieldData === void 0 || (_additionalFieldData$ = additionalFieldData.rawObject) === null || _additionalFieldData$ === void 0 ? void 0 : _additionalFieldData$.isNew);
            this.setState({
                accountId: accountId,
                isNewReporter: isNewReporter
            });
            this.props.onFieldChange(name, value);
        }, this.onRecaptchaTokenChange = (token)=>{
            this.props.onFieldChange('g-recaptcha-response', token);
        };
    }
}
var $c93311874e3fe3c8$export$2e2bcd8739ae039 = (0, $2usNr.default)({
    componentName: 'requestCreateForm'
})((0, $kIbto.default)()($c93311874e3fe3c8$export$d3eed393162f64da));
const $c93311874e3fe3c8$var$calculateDefaultSummaryValue = (urlParamOverride, fieldValue, defaultValueFromState)=>{
    return urlParamOverride ?? fieldValue ?? defaultValueFromState;
};
const $c93311874e3fe3c8$var$getRichTextAreaFieldValue = (urlParamOverride, fieldValue, defaultValueFromState)=>{
    return urlParamOverride || fieldValue || defaultValueFromState || undefined;
};
const $c93311874e3fe3c8$var$calculateDefaultRichTextValue = (0, $ePuyT.default)($c93311874e3fe3c8$var$getRichTextAreaFieldValue);

});
parcelRegister("kOajk", function(module, exports) {
$parcel$export(module.exports, "AnonymousEmailField", () => (parcelRequire("61tcz")).default);

var $61tcz = parcelRequire("61tcz");

});
parcelRegister("61tcz", function(module, exports) {
$parcel$export(module.exports, "default", () => $9e4bc36da0ed5dff$export$2e2bcd8739ae039);

var $bSJIT = parcelRequire("bSJIT");

var $4ZMmh = parcelRequire("4ZMmh");

var $hIGwG = parcelRequire("hIGwG");

var $j2RlN = parcelRequire("j2RlN");

var $3gTkE = parcelRequire("3gTkE");
parcelRequire("fOqQw");
var $3ptbP = parcelRequire("3ptbP");

var $kIbto = parcelRequire("kIbto");

var $2usNr = parcelRequire("2usNr");
parcelRequire("frRWB");
var $3TYOz = parcelRequire("3TYOz");

var $5txC1 = parcelRequire("5txC1");
const $9e4bc36da0ed5dff$var$REQUIRED = 'REQUIRED';
const $9e4bc36da0ed5dff$export$97afc76c65b5683b = (props)=>{
    const { id: id, label: label, required: required, defaultValue: defaultValue, description: description, errorMessage: errorMessage, disabled: disabled, shouldFitContainer: shouldFitContainer, placeholder: placeholder, isLabelHidden: isLabelHidden, type: type, autoFocus: autoFocus, onFocus: onFocus, onChange: onChange } = props;
    const [showWarningMessage, setShowWarningMessage] = $bSJIT.useState(false);
    const [email, setEmail] = $bSJIT.useState(defaultValue || '');
    const onBlur = $bSJIT.useCallback(()=>{
        if ((0, $3ptbP.isEmail)(email)) // Disabling existing violations, should be fixed when revisited.
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        (0, $hIGwG.checkSignupStatus)(email).map((response)=>{
            if (response.status === $9e4bc36da0ed5dff$var$REQUIRED) setShowWarningMessage(true);
            else setShowWarningMessage(false);
        }).toPromise();
    }, [
        email,
        setShowWarningMessage
    ]);
    const onChangeCallback = $bSJIT.useCallback((name, value)=>{
        if (onChange) onChange(name, value);
        setEmail(value);
    }, [
        onChange
    ]);
    const isSignupRequiredError = props.errorReasonKey === (0, $5txC1.ERROR_REASON_KEYS).SIGNUP_REQUIRED;
    const isInvalid = !(0, $4ZMmh.isEmpty)(errorMessage);
    const inputType = type;
    const field = /*#__PURE__*/ $bSJIT.createElement((0, $3gTkE.TextField), {
        id: id,
        label: '',
        isLabelHidden: true,
        defaultValue: defaultValue,
        value: email,
        onChange: onChangeCallback,
        isInvalid: isInvalid,
        shouldFitContainer: shouldFitContainer,
        disabled: disabled,
        placeholder: placeholder,
        type: inputType,
        autoFocus: autoFocus,
        onFocus: onFocus,
        onBlur: onBlur,
        "aria-describedby": `${id}-field-description`
    });
    return /*#__PURE__*/ $bSJIT.createElement((0, $j2RlN.FieldBase), {
        htmlFor: id,
        label: label,
        required: required,
        description: description,
        noLabel: isLabelHidden,
        errorMessage: isSignupRequiredError ? '' : errorMessage
    }, field, (showWarningMessage || isSignupRequiredError) && /*#__PURE__*/ $bSJIT.createElement((0, $3TYOz.default), {
        isError: isSignupRequiredError
    }));
};
$9e4bc36da0ed5dff$export$97afc76c65b5683b.defaultProps = {
    shouldFitContainer: true,
    type: 'text'
};
var $9e4bc36da0ed5dff$export$2e2bcd8739ae039 = (0, $2usNr.default)({
    componentName: 'AnonymousEmailField'
})((0, $kIbto.default)()($9e4bc36da0ed5dff$export$97afc76c65b5683b));

});
parcelRegister("hIGwG", function(module, exports) {
$parcel$export(module.exports, "checkSignupStatus", () => $c156fdc0369eb9f6$export$661ddfa66e89c4e8);

var $llRGw = parcelRequire("llRGw");

var $8jOUp = parcelRequire("8jOUp");

var $jBiia = parcelRequire("jBiia");

var $eDcdn = parcelRequire("eDcdn");
const $c156fdc0369eb9f6$export$661ddfa66e89c4e8 = (email)=>{
    const body = {
        email: email
    };
    const headers = {
        'Content-Type': 'application/json',
        Accept: 'application/json'
    };
    const uri = `${(0, $eDcdn.contextPath)}/rest/servicedesk/1/customer/user/signup-status`;
    // Suppressing existing violation. Please fix this.
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    return (0, $llRGw.post)(uri, body, headers).map((ajaxResponse)=>{
        return ajaxResponse.response;
    }).catch((e)=>{
        (0, $jBiia.trackError)('signup-status.fetch.failed', {}, e);
        return (0, $8jOUp.Observable).throw(e);
    });
};

});

parcelRegister("fOqQw", function(module, exports) {
$parcel$export(module.exports, "isEmail", () => (parcelRequire("3ptbP")).isEmail);

var $3ptbP = parcelRequire("3ptbP");

});
parcelRegister("3ptbP", function(module, exports) {
$parcel$export(module.exports, "isEmail", () => $74b1332912bdc6df$export$7fbbfbca30081d0);
// eslint-disable-next-line no-useless-escape
const $74b1332912bdc6df$var$EMAIL_PATTERN = /^[a-zA-Z0-9_\-\+'`\?=\*%\$#!/^\{\|}~\.]+@([a-zA-Z0-9\-]+\.)+([a-zA-Z0-9]+)$/;
const $74b1332912bdc6df$export$7fbbfbca30081d0 = (inputValue)=>{
    let valid = false;
    // limit the number of matches required by a complicated regex, and make it simple, with some full stop checks
    // for good measure, to be certain we should be dealing with a valid looking email address.
    // this mirrors the approach in EmailUtil.java
    if ($74b1332912bdc6df$var$EMAIL_PATTERN.test(inputValue)) {
        const name = inputValue.split('@')[0].trim();
        valid = !name.startsWith('.') && !name.endsWith('.') && !name.includes('..');
    }
    return valid;
};

});


parcelRegister("frRWB", function(module, exports) {
$parcel$export(module.exports, "AnonymousEmailSignupMessage", () => (parcelRequire("3TYOz")).default);

var $3TYOz = parcelRequire("3TYOz");

});
parcelRegister("3TYOz", function(module, exports) {
$parcel$export(module.exports, "default", () => $4d8f6d368317589e$export$2e2bcd8739ae039);

var $bSJIT = parcelRequire("bSJIT");

var $4v2A7 = parcelRequire("4v2A7");

var $98sDU = parcelRequire("98sDU");

var $c6H7d = parcelRequire("c6H7d");

var $5cKiX = parcelRequire("5cKiX");
var $fK3tS = parcelRequire("fK3tS");

var $hkLEY = parcelRequire("hkLEY");

var $dsw4B = parcelRequire("dsw4B");

var $Nkk1E = parcelRequire("Nkk1E");
const $4d8f6d368317589e$export$631c5895a8697bfd = ({ isError: isError, intl: intl })=>{
    return /*#__PURE__*/ $bSJIT.createElement($4d8f6d368317589e$var$Wrapper, null, isError ? /*#__PURE__*/ $bSJIT.createElement((0, (/*@__PURE__*/$parcel$interopDefault($hkLEY))), {
        label: "error",
        color: "var(--ds-icon-danger, #FF5630)"
    }) : /*#__PURE__*/ $bSJIT.createElement((0, (/*@__PURE__*/$parcel$interopDefault($dsw4B))), {
        label: "warning",
        color: "var(--ds-icon-warning, #FFAB00)"
    }), /*#__PURE__*/ $bSJIT.createElement($4d8f6d368317589e$var$SignupMessage, {
        isError: isError
    }, /*#__PURE__*/ $bSJIT.createElement((0, $5cKiX.default), {
        ...(0, $Nkk1E.default).signupWarningMessage,
        values: {
            signUpLink: // eslint-disable-next-line @atlassian/i18n/no-unsafe-message-composition -- Pre-existing; to be migrated
            /*#__PURE__*/ $bSJIT.createElement((0, $c6H7d.default), {
                to: '/user/login',
                target: "_blank",
                actionSubjectId: "signupLink"
            }, intl.formatMessage((0, $Nkk1E.default).signupLink))
        }
    })));
};
var $4d8f6d368317589e$export$2e2bcd8739ae039 = (0, $fK3tS.default)($4d8f6d368317589e$export$631c5895a8697bfd);
const $4d8f6d368317589e$var$requestCreateFieldErrorColor = "var(--ds-text-danger, #BF2600)";
const $4d8f6d368317589e$var$anonymousEmailSignupWarningTextColor = "var(--ds-text-subtlest, #6B778C)";
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $4d8f6d368317589e$var$SignupMessage = /*#__PURE__*/ (0, $4v2A7.default).span.withConfig({
    componentId: "sc-1xptymo-0"
})`${$98sDU.xsmall};color:${(props)=>props.isError ? $4d8f6d368317589e$var$requestCreateFieldErrorColor : $4d8f6d368317589e$var$anonymousEmailSignupWarningTextColor};font-weight:500;`;
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $4d8f6d368317589e$var$Wrapper = /*#__PURE__*/ (0, $4v2A7.default).div.withConfig({
    componentId: "sc-1xptymo-1"
})`display:flex;margin-top:${"var(--ds-space-050, 4px)"};`;

});
parcelRegister("Nkk1E", function(module, exports) {
$parcel$export(module.exports, "default", () => $cee1db8d57f08271$export$2e2bcd8739ae039);

var $f0Pt4 = parcelRequire("f0Pt4");
var $cee1db8d57f08271$export$2e2bcd8739ae039 = (0, $f0Pt4.defineMessages)({
    signupWarningMessage: {
        defaultMessage: 'Before you can send this request, {signUpLink} to continue',
        description: 'Message to redirect to sign up page before creating request.',
        id: 'cv.request.create.form.anonymousEmail.signupWarningMessage'
    },
    signupLink: {
        defaultMessage: 'sign up',
        description: 'Label for the sign up link in the anonymous email signup warning message.',
        id: 'cv.request.create.form.anonymousEmail.signupLink'
    }
});

});



parcelRegister("5txC1", function(module, exports) {
$parcel$export(module.exports, "ERROR_REASON_KEYS", () => $a01baa08a1207b22$export$c9847750ab7b4d36);
var $a01baa08a1207b22$export$c9847750ab7b4d36 = /*#__PURE__*/ function(ERROR_REASON_KEYS) {
    // Note: These error reason keys are not exhaustive
    // When the recaptcha validation fails
    ERROR_REASON_KEYS["RECAPTCHA_ERROR"] = "sd.recaptcha.user.may.be.a.robot";
    // when the user is raising a request anonymously in the portal using an domain that requires signing up
    ERROR_REASON_KEYS["SIGNUP_REQUIRED"] = "signup.required.error";
    ERROR_REASON_KEYS["SIGNUP_VALIDATION_ERROR"] = "signup.validation.errors";
    ERROR_REASON_KEYS["RECAPTCHA_SHARED_KEY_NOT_SET"] = "sd.recaptcha.shared.key.not.set";
    ERROR_REASON_KEYS["RECAPTCHA_DOMAIN_MISMATCH"] = "sd.recaptcha.domain.not.match";
    // When the user do not have permission to create requests using the Portal
    ERROR_REASON_KEYS["NEED_PERMISSION"] = "sd.request.create.error.permission";
    // When the user do not have permission to create requests on behalf of other users
    ERROR_REASON_KEYS["NEED_PERMISSION_ON_BEHALF_OF"] = "sd.request.create.error.permission.onbehalfof";
    // When user can't raise a request on behalf of a user as they need the customer role on their site managed by their organization's admins
    ERROR_REASON_KEYS["NEED_PERMISSION_REQUESTOR"] = "sd.request.create.error.permission.requestor";
    // When user does not have permission to set issue property
    ERROR_REASON_KEYS["NEED_PERMISSION_SET_ISSUE_PROPERTY"] = "sd.request.create.error.permission.setIssueProperty";
    // When the issue type of the request raised isn't found
    ERROR_REASON_KEYS["ISSUE_TYPE_NOT_FOUND"] = "sd.request.create.error.issuetype.not.found";
    // When default value for a field is missing
    ERROR_REASON_KEYS["NO_DEFAULT_FOUND"] = "sd.request.create.error.no.default.found";
    // When certain fields have errors
    ERROR_REASON_KEYS["FAILED_FIELD_OPERATION"] = "sd.request.create.error.failed.field.operation";
    // Unable to create request because of some errors
    ERROR_REASON_KEYS["FAILED_MSG"] = "sd.request.create.error.failed.msg";
    // When account id is not valid user's id
    ERROR_REASON_KEYS["UNKNOWN_ACCOUNT_ID"] = "sd.request.create.error.unknown.account.id";
    // When proforma form properties are not valid
    ERROR_REASON_KEYS["PROFORMA_FORM_PROPERTIES_ERROR"] = "sd.request.create.error.proforma.form.properties.error";
    // When user does not have permission to view the request
    ERROR_REASON_KEYS["NO_PERMISSION"] = "sd.request.view.error.no.permission";
    return ERROR_REASON_KEYS;
}({});

});



parcelRegister("1U3rG", function(module, exports) {
$parcel$export(module.exports, "AssetsPicker", () => (parcelRequire("5kkQ8")).default);

var $5kkQ8 = parcelRequire("5kkQ8");

});
parcelRegister("5kkQ8", function(module, exports) {
$parcel$export(module.exports, "default", () => $1dd18f0e77785e5e$export$2e2bcd8739ae039);

var $bSJIT = parcelRequire("bSJIT");

var $egQxE = parcelRequire("egQxE");

var $BOq7h = parcelRequire("BOq7h");

var $4ZMmh = parcelRequire("4ZMmh");

var $6qzpN = parcelRequire("6qzpN");

var $aI0YR = parcelRequire("aI0YR");
parcelRequire("axAig");
var $jsLJD = parcelRequire("jsLJD");
class $1dd18f0e77785e5e$export$ea034712530a02d4 extends $bSJIT.PureComponent {
    static #_ = this.searchAssetDebounceWaitTime = 400;
    componentDidMount() {
        return (0, $6qzpN.getFieldConfig)(this.props.fieldConfigId, this.props.portalId).toPromise().then((fieldConfig)=>this.setState({
                fieldConfig: fieldConfig,
                isFieldConfigLoaded: true
            })).catch((_)=>{
            // TODO: Consider re-visiting this error handling. If the field config exists and fails for some
            // unknown reason, the search will potentially fetch incorrectly typed assets.
            this.setState({
                isFieldConfigLoaded: true
            });
        });
    }
    render() {
        return /*#__PURE__*/ $bSJIT.createElement((0, $jsLJD.default), {
            ...this.props,
            loadOptions: this.loadOptions,
            isFieldConfigLoaded: this.state.isFieldConfigLoaded,
            doInitialSearch: true
        });
    }
    constructor(...args){
        super(...args), this.state = {
            fieldConfig: {
                types: []
            },
            isFieldConfigLoaded: false
        }, this.loadOptions = (inputValue, callback)=>{
            // Disabling existing violations, should be fixed when revisited.
            // eslint-disable-next-line @typescript-eslint/no-floating-promises
            this.searchAssetsDebounced(inputValue, callback);
        }, this.fetchAssets = (inputValue, callback)=>{
            if (!this.state.isFieldConfigLoaded) // We can't fetch assets until the field config is loaded.
            return Promise.resolve([]);
            const { accountId: accountId } = this.props;
            if (!accountId) return Promise.resolve();
            return (0, $6qzpN.searchAssets)(accountId, inputValue, this.state.fieldConfig).map((response)=>response.values.map((asset)=>({
                        label: asset.label.value,
                        value: `${asset.origin.appKey}/${asset.origin.originId}`,
                        origin: asset.origin
                    }))).toPromise().then(callback);
        }, this.searchAssetsDebounced = (0, $4ZMmh.debounce)(this.fetchAssets, $1dd18f0e77785e5e$export$ea034712530a02d4.searchAssetDebounceWaitTime);
    }
}
const $1dd18f0e77785e5e$var$selector = (0, $BOq7h.createSelector)((state, props)=>props.accountId || (0, $aI0YR.getAccountId)(state), (accountId)=>({
        accountId: accountId
    }));
var $1dd18f0e77785e5e$export$2e2bcd8739ae039 = (0, $egQxE.connect)($1dd18f0e77785e5e$var$selector)($1dd18f0e77785e5e$export$ea034712530a02d4);

});
parcelRegister("6qzpN", function(module, exports) {
$parcel$export(module.exports, "searchAssets", () => $88e86482361b738b$export$d3522f67fd6c26f9);
$parcel$export(module.exports, "getFieldConfig", () => $88e86482361b738b$export$1fafb7a30b5a01b3);

var $llRGw = parcelRequire("llRGw");

var $fvUqa = parcelRequire("fvUqa");

var $8jOUp = parcelRequire("8jOUp");

var $jBiia = parcelRequire("jBiia");

var $eDcdn = parcelRequire("eDcdn");
const $88e86482361b738b$export$d3522f67fd6c26f9 = (assignee, query, fieldConfig, context = (0, $eDcdn.contextPath))=>{
    var _fieldConfig$types;
    const assignees = [
        assignee
    ];
    assignees.push('unassigned');
    const queryString = $fvUqa.stringify({
        query: query,
        // get assets assigned to user and all other unassigned assets
        assignee: assignees,
        prioritizedAssignee: assignee,
        type: fieldConfig === null || fieldConfig === void 0 || (_fieldConfig$types = fieldConfig.types) === null || _fieldConfig$types === void 0 ? void 0 : _fieldConfig$types.map((type)=>{
            // type to serialized type origin
            return `${type.appKey}/${type.originId}`.toLowerCase();
        })
    });
    const uri = `${context}/rest/assetapi/asset/search?${queryString}`;
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    return (0, $llRGw.get)(uri)// eslint-disable-next-line @typescript-eslint/no-unsafe-return
    .map(({ response: response })=>response).catch((e)=>{
        (0, $jBiia.trackError)('search.assets.failed', {}, e);
        // Rethrow error
        return (0, $8jOUp.Observable).throw(e);
    });
};
const $88e86482361b738b$export$1fafb7a30b5a01b3 = (fieldConfigId, portalId)=>{
    const uri = `${(0, $eDcdn.contextPath)}/rest/assetinternalapi/1/field/portal/${portalId}/config/${fieldConfigId}`;
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    return (0, $llRGw.get)(uri)// eslint-disable-next-line @typescript-eslint/no-unsafe-return
    .map(({ response: response })=>response).catch((e)=>{
        (0, $jBiia.trackError)('assets.get.field.config.id.failed', {}, e);
        // Rethrow error
        return (0, $8jOUp.Observable).throw(e);
    });
};

});

parcelRegister("axAig", function(module, exports) {
$parcel$export(module.exports, "AssetsPickerDumb", () => (parcelRequire("jsLJD")).default);

var $jsLJD = parcelRequire("jsLJD");

});
parcelRegister("jsLJD", function(module, exports) {
$parcel$export(module.exports, "default", () => $008edeca69ba0ce1$export$2e2bcd8739ae039);

var $bSJIT = parcelRequire("bSJIT");

var $82wak = parcelRequire("82wak");

var $fK3tS = parcelRequire("fK3tS");

var $30F9J = parcelRequire("30F9J");

var $6eACG = parcelRequire("6eACG");
class $008edeca69ba0ce1$export$91d8c4dc52817ba2 extends $bSJIT.Component {
    render() {
        const { disabled: disabled, doInitialSearch: doInitialSearch, intl: intl, isLoading: isLoading, isFieldConfigLoaded: isFieldConfigLoaded, accountId: accountId, ...otherProps } = this.props;
        return /*#__PURE__*/ $bSJIT.createElement((0, $82wak.FormAsyncMultiSelect), {
            ...otherProps,
            actionSubjectId: "assetsPickerField",
            // We set a key on this component so that it re-mounts when the field configuration is loaded, or,
            // the account id changes. The re-mounting triggers the initial search, which is skipped when the
            // field configuration is not loaded.
            // TypeScript upgrade (v4.4.3). Please correct when you revisit this code. Please correct when this code is revisited.
            // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
            key: `asset-loaded-${isFieldConfigLoaded}-${accountId}`,
            placeholder: intl.formatMessage((0, $6eACG.default).searchPlaceholder),
            noOptionsMessage: this.noOpt,
            isDisabled: disabled,
            isLoading: isLoading,
            onChange: this.onChangeForMultiSelect,
            defaultOptions: doInitialSearch
        });
    }
    constructor(...args){
        super(...args), this.onChangeForMultiSelect = (options)=>{
            var _this$props$onChange, _this$props;
            (_this$props$onChange = (_this$props = this.props).onChange) === null || _this$props$onChange === void 0 || _this$props$onChange.call(_this$props, this.props.id, (0, $30F9J.toMultiSelectValue)(options).map((v)=>v.value));
        }, this.noOpt = (inputValues)=>{
            return inputValues.inputValue === '' ? this.props.intl.formatMessage((0, $6eACG.default).typeToSearch) : this.props.intl.formatMessage((0, $6eACG.default).noOptions);
        };
    }
}
var $008edeca69ba0ce1$export$2e2bcd8739ae039 = (0, $fK3tS.default)($008edeca69ba0ce1$export$91d8c4dc52817ba2);

});
parcelRegister("82wak", function(module, exports) {
$parcel$export(module.exports, "FormMultiSelect", () => $1dfd826763b50d10$export$8cf908d07cc79854);
$parcel$export(module.exports, "FormAsyncMultiSelect", () => $1dfd826763b50d10$export$285798b94a2121fb);
$parcel$export(module.exports, "FormAsyncCreatableMultiSelect", () => $1dfd826763b50d10$export$9a1bea4037f21326);

var $bSJIT = parcelRequire("bSJIT");

var $lFpPv = parcelRequire("lFpPv");

var $aCOGK = parcelRequire("aCOGK");

var $96iPn = parcelRequire("96iPn");

var $l6qfM = parcelRequire("l6qfM");

var $7qMCI = parcelRequire("7qMCI");
const $1dfd826763b50d10$var$FieldMultiSelect = (0, $7qMCI.default)((0, $aCOGK.ThemedSelect));
const $1dfd826763b50d10$var$FieldAsyncCreatableMultiSelect = (0, $7qMCI.default)((0, $aCOGK.ThemedAsyncCreatableSelect));
const $1dfd826763b50d10$var$FieldAsyncMultiSelect = (0, $7qMCI.default)((0, $aCOGK.ThemedAsyncSelect));
const $1dfd826763b50d10$var$FormMultiSelectWithControlledValue = (0, $96iPn.withControlledFormComponentValue)((options)=>options)((props)=>/*#__PURE__*/ $bSJIT.createElement($1dfd826763b50d10$var$FieldMultiSelect, {
        ...props,
        isMulti: true,
        isClearable: true
    }));
const $1dfd826763b50d10$export$8cf908d07cc79854 = (0, $l6qfM.componentWithCondition)((0, $lFpPv.isMultiSelectEnabled), $1dfd826763b50d10$var$FormMultiSelectWithControlledValue, (props)=>/*#__PURE__*/ $bSJIT.createElement($1dfd826763b50d10$var$FieldMultiSelect, {
        ...props,
        isMulti: true,
        isClearable: true
    }));
const $1dfd826763b50d10$export$285798b94a2121fb = (props)=>/*#__PURE__*/ $bSJIT.createElement($1dfd826763b50d10$var$FieldAsyncMultiSelect, {
        ...props,
        isMulti: true,
        isClearable: true
    });
const $1dfd826763b50d10$var$FormAsyncCreatableMultiSelectUncontrolled = (props)=>/*#__PURE__*/ $bSJIT.createElement($1dfd826763b50d10$var$FieldAsyncCreatableMultiSelect, {
        ...props,
        isMulti: true,
        isClearable: true
    });
const $1dfd826763b50d10$var$FormAsyncCreatableMultiSelectControlled = (0, $96iPn.withControlledFormComponentValue)((options)=>options)($1dfd826763b50d10$var$FormAsyncCreatableMultiSelectUncontrolled);
const $1dfd826763b50d10$export$9a1bea4037f21326 = $1dfd826763b50d10$var$FormAsyncCreatableMultiSelectControlled;

});

parcelRegister("6eACG", function(module, exports) {
$parcel$export(module.exports, "default", () => $a42e410d30c8f552$export$2e2bcd8739ae039);

var $f0Pt4 = parcelRequire("f0Pt4");
var $a42e410d30c8f552$export$2e2bcd8739ae039 = (0, $f0Pt4.defineMessages)({
    searchPlaceholder: {
        defaultMessage: 'Search all',
        description: 'Placeholder for assets picker field to advise the user to search for all assets (even after an initial load of assets)',
        id: 'cv.request.create.form.assets.picker.search'
    },
    noOptions: {
        defaultMessage: 'No options',
        description: 'Text that appears in the dropdown for the assets picker if there are no assets to select',
        id: 'cv.request.create.form.assets.picker.no.options'
    },
    typeToSearch: {
        defaultMessage: 'Type to search',
        description: 'Text that appears in the dropdown for the assets picker if the user needs to search to find assets',
        id: 'cv.request.create.form.assets.picker.type.to.search'
    }
});

});





parcelRegister("7dhfB", function(module, exports) {
$parcel$export(module.exports, "CascadingSelect", () => (parcelRequire("25dMu")).default);
$parcel$export(module.exports, "FormCascadingSelect", () => (parcelRequire("25dMu")).FormCascadingSelect);

var $25dMu = parcelRequire("25dMu");

});
parcelRegister("25dMu", function(module, exports) {
$parcel$export(module.exports, "FormCascadingSelect", () => $3353836acc744c34$export$94e649b5ff9739c1);
$parcel$export(module.exports, "default", () => $3353836acc744c34$export$2e2bcd8739ae039);

var $bSJIT = parcelRequire("bSJIT");

var $4v2A7 = parcelRequire("4v2A7");

var $lFpPv = parcelRequire("lFpPv");

var $9K7mZ = parcelRequire("9K7mZ");

var $j2RlN = parcelRequire("j2RlN");

var $aCOGK = parcelRequire("aCOGK");

var $l6qfM = parcelRequire("l6qfM");

var $30F9J = parcelRequire("30F9J");

var $cc3rE = parcelRequire("cc3rE");

var $96iPn = parcelRequire("96iPn");
class $3353836acc744c34$var$ThemedSelectGroup extends $bSJIT.PureComponent {
    constructor(props){
        super(props), this.state = {}, this.onGroupSelected = (groupSelected)=>{
            var _toSingleSelectValue;
            const groupValue = (_toSingleSelectValue = (0, $30F9J.toSingleSelectValue)(groupSelected)) === null || _toSingleSelectValue === void 0 ? void 0 : _toSingleSelectValue.value;
            this.setState({
                groupValue: groupValue,
                childValue: undefined
            });
            if ((0, $lFpPv.isCascadingSelectSupportEnabled)()) {
                var _this$props$onChange, _this$props;
                (_this$props$onChange = (_this$props = this.props).onChange) === null || _this$props$onChange === void 0 || _this$props$onChange.call(_this$props, this.props.id, {
                    primaryValue: groupValue ?? null,
                    children: undefined
                }, false, {
                    rawObject: {},
                    rawValue: {
                        primaryValue: groupSelected,
                        children: undefined
                    }
                });
            } else {
                var _this$props$onChange2, _this$props2;
                (_this$props$onChange2 = (_this$props2 = this.props).onChange) === null || _this$props$onChange2 === void 0 || _this$props$onChange2.call(_this$props2, this.props.id, {
                    primaryValue: groupValue ?? null,
                    children: undefined
                });
            }
        }, this.onChildSelected = (childSelected)=>{
            var _toSingleSelectValue2;
            const groupValue = this.getGroupStateValue();
            const childValue = (_toSingleSelectValue2 = (0, $30F9J.toSingleSelectValue)(childSelected)) === null || _toSingleSelectValue2 === void 0 ? void 0 : _toSingleSelectValue2.value;
            const selectedGroup = this.getSelectedGroup();
            if (groupValue) {
                this.setState({
                    childValue: childValue
                });
                if ((0, $lFpPv.isCascadingSelectSupportEnabled)()) {
                    var _this$props$onChange3, _this$props3;
                    (_this$props$onChange3 = (_this$props3 = this.props).onChange) === null || _this$props$onChange3 === void 0 || _this$props$onChange3.call(_this$props3, this.props.id, {
                        primaryValue: groupValue,
                        children: childValue ?? null
                    }, false, {
                        rawObject: {},
                        rawValue: {
                            primaryValue: selectedGroup,
                            children: childSelected
                        }
                    });
                } else {
                    var _this$props$onChange4, _this$props4;
                    (_this$props$onChange4 = (_this$props4 = this.props).onChange) === null || _this$props$onChange4 === void 0 || _this$props$onChange4.call(_this$props4, this.props.id, {
                        primaryValue: groupValue,
                        children: childValue ?? null
                    });
                }
            }
        };
        const { defaultValue: defaultValue, options: options } = this.props;
        if (defaultValue) {
            const defaultGroup = options.find((group)=>group.value === defaultValue.primaryValue);
            const defaultChild = defaultGroup && defaultGroup.children.find((g)=>g.value === defaultValue.children);
            this.state = {
                groupValue: defaultGroup && defaultGroup.value,
                childValue: defaultChild && defaultChild.value
            };
        }
    }
    getGroupStateValue() {
        const { value: value } = this.props;
        return value === undefined ? this.state.groupValue : value.primaryValue;
    }
    getChildStateValue() {
        const { value: value } = this.props;
        return value === undefined ? this.state.childValue : value.children;
    }
    getSelectedGroup() {
        const { options: options } = this.props;
        const groupValue = this.getGroupStateValue();
        // We make sure to set null instead of undefined here to ensure value is updated correctly;
        return groupValue && options.find((group)=>group.value === groupValue) || null;
    }
    getSelectedChild(selectedGroup) {
        const childValue = this.getChildStateValue();
        // We make sure to set null instead of undefined here to ensure value is updated correctly;
        return selectedGroup && selectedGroup.children.find((g)=>g.value === childValue) || null;
    }
    render() {
        const { actionSubjectId: actionSubjectId, label: label, required: required, errorMessage: errorMessage, description: description, id: id, options: options, disabled: disabled, isClearable: isClearable, selectWidth: selectWidth } = this.props;
        const selectedGroup = this.getSelectedGroup();
        const selectedChild = this.getSelectedChild(selectedGroup);
        const validationState = !!errorMessage ? 'error' : 'default';
        const clearable = isClearable === undefined ? true : isClearable;
        return /*#__PURE__*/ $bSJIT.createElement((0, $j2RlN.FieldBase), {
            htmlFor: id,
            label: label,
            required: required,
            errorMessage: errorMessage,
            description: description
        }, /*#__PURE__*/ $bSJIT.createElement($3353836acc744c34$var$Container, null, /*#__PURE__*/ $bSJIT.createElement($3353836acc744c34$var$SelectContainer, {
            marginRight: "var(--ds-space-100, 8px)",
            selectWidth: selectWidth,
            "data-test-id": `select-container-${id}`,
            "aria-describedby": `${id}-field-description`
        }, /*#__PURE__*/ $bSJIT.createElement((0, $aCOGK.ThemedSelect), {
            actionSubjectId: `${actionSubjectId}PrimarySelect`,
            inputId: id,
            options: options,
            value: selectedGroup,
            onChange: this.onGroupSelected,
            validationState: validationState,
            isDisabled: disabled,
            isClearable: clearable
        })), /*#__PURE__*/ $bSJIT.createElement($3353836acc744c34$var$SelectContainer, {
            selectWidth: selectWidth,
            "data-test-id": `select-container-${id}:1`,
            "aria-describedby": `${id}-field-description`
        }, /*#__PURE__*/ $bSJIT.createElement((0, $aCOGK.ThemedSelect), {
            actionSubjectId: `${actionSubjectId}SecondarySelect`,
            inputId: `${id}:1`,
            options: selectedGroup ? selectedGroup.children : [],
            value: selectedChild,
            onChange: this.onChildSelected,
            validationState: validationState,
            isDisabled: disabled,
            isClearable: clearable
        }))));
    }
}
const $3353836acc744c34$var$ControlledCascadingSelect = (0, $96iPn.withControlledFormComponentValue)((_field, value)=>value, (0, $cc3rE.normalizeCascadingSelectValue))($3353836acc744c34$var$ThemedSelectGroup);
const $3353836acc744c34$export$94e649b5ff9739c1 = (0, $l6qfM.componentWithCondition)(()=>(0, $lFpPv.isCascadingSelectSupportEnabled)(), $3353836acc744c34$var$ControlledCascadingSelect, $3353836acc744c34$var$ThemedSelectGroup);
var $3353836acc744c34$export$2e2bcd8739ae039 = $3353836acc744c34$var$ThemedSelectGroup;
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $3353836acc744c34$var$Container = /*#__PURE__*/ (0, $4v2A7.default).div.withConfig({
    componentId: "sc-1r04av8-0"
})`display:flex;flex-wrap:wrap;width:100%;margin-top:${"var(--ds-space-negative-050, -4px)"};`;
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $3353836acc744c34$var$SelectContainer = /*#__PURE__*/ (0, $4v2A7.default).div.withConfig({
    componentId: "sc-1r04av8-1"
})`width:${(props)=>`${props && props.selectWidth ? `${props.selectWidth}px` : `calc(50% - ${$9K7mZ.multiple(0.5).px})`}`};margin-top:${"var(--ds-space-050, 4px)"};margin-right:${(props)=>`${props && props.marginRight ? props.marginRight : '0px'}`};`;

});


parcelRegister("9RbxT", function(module, exports) {
$parcel$export(module.exports, "CheckboxGroup", () => (parcelRequire("ijCiB")).default);
$parcel$export(module.exports, "ControlledCheckboxGroup", () => (parcelRequire("ijCiB")).ControlledCheckboxGroup);

var $ijCiB = parcelRequire("ijCiB");

});
parcelRegister("ijCiB", function(module, exports) {
$parcel$export(module.exports, "ControlledCheckboxGroup", () => $bb291e7f49732c98$export$c1e527161a9140d6);
$parcel$export(module.exports, "default", () => $bb291e7f49732c98$export$2e2bcd8739ae039);

var $bSJIT = parcelRequire("bSJIT");

var $4v2A7 = parcelRequire("4v2A7");

var $j2RlN = parcelRequire("j2RlN");

var $8HhhR = parcelRequire("8HhhR");

var $dKhv1 = parcelRequire("dKhv1");

var $96iPn = parcelRequire("96iPn");
class $bb291e7f49732c98$var$CustomCheckboxGroup extends $bSJIT.PureComponent {
    constructor(props){
        super(props), this.onChange = (e)=>{
            if (this.props.onChange) {
                const currentValue = e.currentTarget.value;
                const selectedValues = this.props.value ?? this.checkedValues;
                const nextValues = selectedValues.includes(currentValue) ? selectedValues.filter((value)=>value !== currentValue) : [
                    ...selectedValues,
                    currentValue
                ];
                this.checkedValues = nextValues;
                if (this.props.value !== undefined) {
                    const selectedItems = this.props.items.filter((item)=>nextValues.includes(item.value));
                    this.props.onChange(this.props.id, nextValues, false, {
                        rawObject: selectedItems,
                        rawValue: selectedItems
                    });
                    return;
                }
                this.props.onChange(this.props.id, nextValues);
            }
        };
        this.checkedValues = props.defaultValue || [];
    }
    render() {
        const { label: label, required: required, description: description, id: id, items: items, errorMessage: errorMessage, disabled: disabled, value: value } = this.props;
        const selectedValues = value ?? this.checkedValues;
        return /*#__PURE__*/ $bSJIT.createElement((0, $j2RlN.FieldBase), {
            htmlFor: id,
            labelId: id,
            label: label,
            required: required,
            description: description,
            errorMessage: errorMessage
        }, /*#__PURE__*/ $bSJIT.createElement($bb291e7f49732c98$var$CheckboxGroup, {
            role: "group",
            "aria-labelledby": id,
            "aria-describedby": `${id}-field-description`
        }, items.map((item)=>/*#__PURE__*/ $bSJIT.createElement((0, $8HhhR.Checkbox), {
                isDisabled: disabled,
                key: item.label,
                name: item.label,
                label: item.label,
                value: item.value,
                ...value === undefined ? {
                    defaultChecked: this.checkedValues.includes(item.value)
                } : {
                    isChecked: selectedValues.includes(item.value)
                },
                onChange: this.onChange
            }))));
    }
}
const $bb291e7f49732c98$export$c1e527161a9140d6 = (0, $96iPn.withControlledFormComponentValue)((_field, value)=>value, (0, $dKhv1.normalizeMultiCheckboxValue))($bb291e7f49732c98$var$CustomCheckboxGroup);
var $bb291e7f49732c98$export$2e2bcd8739ae039 = $bb291e7f49732c98$var$CustomCheckboxGroup;
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $bb291e7f49732c98$var$CheckboxGroup = /*#__PURE__*/ (0, $4v2A7.default).div.withConfig({
    componentId: "sc-mclhti-0"
})`display:flex;flex-direction:column;`;

});


parcelRegister("554XC", function(module, exports) {
$parcel$export(module.exports, "ControlledDatePicker", () => $aef74948293b50f8$export$54c001387125b016);
$parcel$export(module.exports, "DatePicker", () => (parcelRequire("30UiE")).default);
$parcel$export(module.exports, "ConditionalDatepicker", () => (parcelRequire("30UiE")).ConditionalDatepicker);

var $30UiE = parcelRequire("30UiE");

var $96iPn = parcelRequire("96iPn");
const $aef74948293b50f8$export$54c001387125b016 = (0, $96iPn.withControlledFormComponentValue)((_field, value)=>value)((0, $30UiE.default));

});
parcelRegister("30UiE", function(module, exports) {
$parcel$export(module.exports, "default", () => $6ff84855aeae7f5f$export$2e2bcd8739ae039);
$parcel$export(module.exports, "ConditionalDatepicker", () => $6ff84855aeae7f5f$export$c4aede8d1c6e88b);
/* date-picker.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $9fU1q = parcelRequire("9fU1q");

var $bSJIT = parcelRequire("bSJIT");

var $lFpPv = parcelRequire("lFpPv");

var $hfLZh = parcelRequire("hfLZh");
var $lMRHO = parcelRequire("lMRHO");
var $OORRb = parcelRequire("OORRb");
var $5xMcQ = parcelRequire("5xMcQ");

var $4ZMmh = parcelRequire("4ZMmh");

var $fK3tS = parcelRequire("fK3tS");

var $j2RlN = parcelRequire("j2RlN");
parcelRequire("5wQdU");
var $lkAYa = parcelRequire("lkAYa");

var $aM9QT = parcelRequire("aM9QT");

var $87QgR = parcelRequire("87QgR");

var $gEVth = parcelRequire("gEVth");

var $g832e = parcelRequire("g832e");

var $ejPYW = parcelRequire("ejPYW");

var $l6qfM = parcelRequire("l6qfM");

var $96iPn = parcelRequire("96iPn");
parcelRequire("6jUM2");
var $dtfVv = parcelRequire("dtfVv");
const $6ff84855aeae7f5f$var$IsoDateFormat = /^\d{4}-\d{2}-\d{2}$/;
const $6ff84855aeae7f5f$export$240ff04a48ca99e9 = (value)=>{
    try {
        if (!value || !(0, $lMRHO.default)(new Date(value))) return undefined;
        // Fix for the one-day-off issue with new Date()
        // Link: [DateTime Picker One Day Off Issue](https://hello.atlassian.net/wiki/x/zwTjxw)
        const processedValue = value.match($6ff84855aeae7f5f$var$IsoDateFormat) ? (0, $hfLZh.default)(new Date(value.replace(/-/g, '/'))) : (0, $hfLZh.default)(new Date(value));
        // Fix for range time error when the string date passed to the date picker is not valid
        if ((0, $87QgR.default).checkGate('fix_masked_sentry_issues')) return (0, $lMRHO.default)(new Date(processedValue)) ? processedValue : undefined;
        return processedValue;
    } catch (error) {
        (0, $gEVth.operationalEvent)({
            action: `processDateValueFailed`,
            actionSubject: 'datePicker',
            attributes: {
                inputValue: value,
                error: error instanceof Error ? error.message : 'unknown'
            }
        });
        return undefined;
    }
};
// TODO: Add proper locale support so that this workaround to fix date parsing isn't needed
const $6ff84855aeae7f5f$var$parseInputValue = (date)=>{
    if ((0, $lMRHO.default)(new Date(date))) return (0, $5xMcQ.default)(new Date(date).toISOString());
    return (0, $5xMcQ.default)(new Date().toISOString());
};
const $6ff84855aeae7f5f$export$c4cebce289a65263 = (date, dateFormat)=>{
    let parsedDate;
    try {
        parsedDate = (0, $OORRb.default)(date, dateFormat, new Date());
    } catch (error) {
        // fire operational event with step information
        (0, $gEVth.operationalEvent)({
            action: `dateParseFailed`,
            actionSubject: 'datePicker',
            attributes: {
                dateFormat: dateFormat,
                inputValue: date,
                error: error instanceof Error ? error.message : 'unknown'
            }
        });
    }
    if (parsedDate && (0, $lMRHO.default)(parsedDate)) return parsedDate;
    if ((0, $lMRHO.default)(new Date(date))) return (0, $5xMcQ.default)(new Date(date).toISOString());
    return (0, $5xMcQ.default)(new Date().toISOString());
};
class $6ff84855aeae7f5f$export$f846ef91367704d3 extends $bSJIT.PureComponent {
    render() {
        const { id: id, label: label, required: required, defaultValue: defaultValue, description: description, errorMessage: errorMessage, disabled: disabled, locale: locale, firstDay: firstDay, useISO8601WeekNumbers: useISO8601WeekNumbers, value: value, intl: intl, dateFormat: dateFormat = 'yyyy-MM-dd' } = this.props;
        const isInvalid = !(0, $4ZMmh.isEmpty)(errorMessage);
        // Need to refer to id like this.
        // See: https://atlaskit.atlassian.com/packages/core/datetime-picker
        const inputId = `react-select-${id}-input`;
        const defaultDateValue = $6ff84855aeae7f5f$export$240ff04a48ca99e9(defaultValue);
        let processedValue = '';
        if (value && (0, $lFpPv.isDueDateSupportEnabled)()) processedValue = $6ff84855aeae7f5f$export$240ff04a48ca99e9(value) ?? '';
        /**
     * Support both controlled and uncontrolled component behavior.
     *
     * When UI Modifications (UIM) feature flag is enabled, the component uses the `value` prop (controlled).
     * When disabled, it falls back to `defaultValue` prop (uncontrolled).
     *
     * This dual behavior will be removed once the UIM feature flag (ditto_uim_-_jsm_support_main)
     * is fully rolled out and the component becomes fully controlled.
     */ const isValueDefined = (0, $lFpPv.isDueDateSupportEnabled)() && typeof value === 'string';
        const dateFieldValueProps = isValueDefined ? {
            value: processedValue
        } : {
            defaultValue: defaultDateValue
        };
        return /*#__PURE__*/ $bSJIT.createElement((0, $j2RlN.FieldBase), {
            htmlFor: inputId,
            label: label,
            required: required,
            description: description,
            errorMessage: errorMessage
        }, /*#__PURE__*/ $bSJIT.createElement("div", {
            className: (0, $9fU1q.default)([
                "_1bsb1lit"
            ])
        }, /*#__PURE__*/ $bSJIT.createElement((0, $aM9QT.default), {
            id: inputId,
            name: id,
            locale: locale,
            ...dateFieldValueProps,
            onChange: this.onChange,
            isInvalid: isInvalid,
            isDisabled: !!disabled,
            formatDisplayLabel: this.parseDateLabel,
            placeholder: intl.formatMessage((0, $lkAYa.default).forExample, {
                text: (0, $ejPYW.format)((0, $g832e.default)(), dateFormat)
            }),
            dateFormat: dateFormat,
            weekStartDay: (0, $ejPYW.getWeekStartDay)(firstDay, useISO8601WeekNumbers),
            parseInputValue: (0, $87QgR.default).checkGate('fix_date_picker_format_bug') ? $6ff84855aeae7f5f$export$c4cebce289a65263 : $6ff84855aeae7f5f$var$parseInputValue,
            "aria-describedby": `${inputId}-field-description`
        })));
    }
    constructor(...args){
        super(...args), this.onChange = (isoTime)=>{
            const { onChange: onChange } = this.props;
            if ((0, $lFpPv.isDueDateSupportEnabled)()) onChange && onChange(this.props.id, isoTime, false, {
                rawObject: {},
                rawValue: isoTime
            });
            else onChange && onChange(this.props.id, isoTime, false);
        }, this.parseDateLabel = (isoTime, dateFormat)=>{
            return isoTime && dateFormat ? (0, $ejPYW.format)((0, $5xMcQ.default)(isoTime), dateFormat) : isoTime;
        };
    }
}
const $6ff84855aeae7f5f$var$wrappedDatePicker = (0, $dtfVv.withPortalLocale)((0, $fK3tS.default)($6ff84855aeae7f5f$export$f846ef91367704d3));
var $6ff84855aeae7f5f$export$2e2bcd8739ae039 = $6ff84855aeae7f5f$var$wrappedDatePicker;
const $6ff84855aeae7f5f$export$54c001387125b016 = (0, $96iPn.withControlledFormComponentValue)((_field, value)=>value)($6ff84855aeae7f5f$var$wrappedDatePicker);
const $6ff84855aeae7f5f$export$c4aede8d1c6e88b = (0, $l6qfM.componentWithCondition)(()=>(0, $lFpPv.isDatePickerSupportEnabled)(), $6ff84855aeae7f5f$export$54c001387125b016, $6ff84855aeae7f5f$var$wrappedDatePicker);
const $6ff84855aeae7f5f$var$datePickerContainerCss = null;

});
parcelRegister("hfLZh", function(module, exports) {
$parcel$export(module.exports, "default", () => $c8f90faaa1006a14$export$2e2bcd8739ae039);

var $897M5 = parcelRequire("897M5");

var $cE071 = parcelRequire("cE071");

var $OPOsJ = parcelRequire("OPOsJ");
function $c8f90faaa1006a14$export$2e2bcd8739ae039(date, options) {
    var _options$format, _options$representati;
    (0, $OPOsJ.default)(1, arguments);
    var originalDate = (0, $897M5.default)(date);
    if (isNaN(originalDate.getTime())) throw new RangeError('Invalid time value');
    var format = String((_options$format = options === null || options === void 0 ? void 0 : options.format) !== null && _options$format !== void 0 ? _options$format : 'extended');
    var representation = String((_options$representati = options === null || options === void 0 ? void 0 : options.representation) !== null && _options$representati !== void 0 ? _options$representati : 'complete');
    if (format !== 'extended' && format !== 'basic') throw new RangeError("format must be 'extended' or 'basic'");
    if (representation !== 'date' && representation !== 'time' && representation !== 'complete') throw new RangeError("representation must be 'date', 'time', or 'complete'");
    var result = '';
    var tzOffset = '';
    var dateDelimiter = format === 'extended' ? '-' : '';
    var timeDelimiter = format === 'extended' ? ':' : '';
    // Representation is either 'date' or 'complete'
    if (representation !== 'time') {
        var day = (0, $cE071.default)(originalDate.getDate(), 2);
        var month = (0, $cE071.default)(originalDate.getMonth() + 1, 2);
        var year = (0, $cE071.default)(originalDate.getFullYear(), 4);
        // yyyyMMdd or yyyy-MM-dd.
        result = "".concat(year).concat(dateDelimiter).concat(month).concat(dateDelimiter).concat(day);
    }
    // Representation is either 'time' or 'complete'
    if (representation !== 'date') {
        // Add the timezone.
        var offset = originalDate.getTimezoneOffset();
        if (offset !== 0) {
            var absoluteOffset = Math.abs(offset);
            var hourOffset = (0, $cE071.default)(Math.floor(absoluteOffset / 60), 2);
            var minuteOffset = (0, $cE071.default)(absoluteOffset % 60, 2);
            // If less than 0, the sign is +, because it is ahead of time.
            var sign = offset < 0 ? '+' : '-';
            tzOffset = "".concat(sign).concat(hourOffset, ":").concat(minuteOffset);
        } else tzOffset = 'Z';
        var hour = (0, $cE071.default)(originalDate.getHours(), 2);
        var minute = (0, $cE071.default)(originalDate.getMinutes(), 2);
        var second = (0, $cE071.default)(originalDate.getSeconds(), 2);
        // If there's also date, separate it with time with 'T'
        var separator = result === '' ? '' : 'T';
        // Creates a time string consisting of hour, minute, and second, separated by delimiters, if defined.
        var time = [
            hour,
            minute,
            second
        ].join(timeDelimiter);
        // HHmmss or HH:mm:ss.
        result = "".concat(result).concat(separator).concat(time).concat(tzOffset);
    }
    return result;
}

});

parcelRegister("5wQdU", function(module, exports) {
$parcel$export(module.exports, "default", () => (parcelRequire("lkAYa")).default);

var $lkAYa = parcelRequire("lkAYa");

});
parcelRegister("lkAYa", function(module, exports) {
$parcel$export(module.exports, "default", () => $78674691a637485c$export$2e2bcd8739ae039);

var $f0Pt4 = parcelRequire("f0Pt4");
var $78674691a637485c$export$2e2bcd8739ae039 = (0, $f0Pt4.defineMessages)({
    forExample: {
        defaultMessage: 'e.g. {text}',
        description: 'Example text used in various places, for example the date picker placeholder. "e.g. 02/12/1990"',
        id: 'cv.portal.generic.for.example'
    }
});

});


parcelRegister("g832e", function(module, exports) {
$parcel$export(module.exports, "default", () => $1845e33957e65d99$export$2e2bcd8739ae039);
var $1845e33957e65d99$export$2e2bcd8739ae039 = ()=>new Date();

});

parcelRegister("ejPYW", function(module, exports) {
$parcel$export(module.exports, "format", () => $5ae7258c2032dc02$export$d9468344d3651243);
$parcel$export(module.exports, "getWeekStartDay", () => $5ae7258c2032dc02$export$99291c0265ff1d37);
/**
 * The following things will need to be fixed:
 *  - Async loading of the locales or only include the locale necessary for a bundle
 *  - Grab the user locale from somewhere other than the AJS meta.
 */ 
var $53JkC = parcelRequire("53JkC");

var $1n4Db = parcelRequire("1n4Db");

var $2DxUP = parcelRequire("2DxUP");

var $kaCoo = parcelRequire("kaCoo");

var $frtSF = parcelRequire("frtSF");

var $7fOw9 = parcelRequire("7fOw9");

var $6bIV0 = parcelRequire("6bIV0");

var $kuSiQ = parcelRequire("kuSiQ");

var $6O8Kn = parcelRequire("6O8Kn");

var $7alMJ = parcelRequire("7alMJ");

var $fA0le = parcelRequire("fA0le");

var $8iOHU = parcelRequire("8iOHU");

var $5zE4Q = parcelRequire("5zE4Q");

var $GYAxJ = parcelRequire("GYAxJ");

var $eHyQt = parcelRequire("eHyQt");

var $fwP8D = parcelRequire("fwP8D");

var $c1aBp = parcelRequire("c1aBp");

var $6cm9c = parcelRequire("6cm9c");

var $exjZ8 = parcelRequire("exjZ8");

var $dvrov = parcelRequire("dvrov");

var $fuVmc = parcelRequire("fuVmc");
const $5ae7258c2032dc02$var$supportedLocales = [
    'cs',
    'da',
    'de',
    'en',
    'es',
    'fi',
    'fr',
    'hu',
    'is',
    'it',
    'ja',
    'ko',
    'nl',
    'pl',
    'pt',
    'ro',
    'ru',
    'sk',
    'sv'
];
const $5ae7258c2032dc02$var$supportedLocale = {
    cs: $1n4Db.default,
    da: $2DxUP.default,
    de: $kaCoo.default,
    en: $frtSF.default,
    es: $7fOw9.default,
    fi: $6bIV0.default,
    fr: $kuSiQ.default,
    hu: $6O8Kn.default,
    is: $7alMJ.default,
    it: $fA0le.default,
    ja: $8iOHU.default,
    ko: $5zE4Q.default,
    nl: $GYAxJ.default,
    pl: $eHyQt.default,
    pt: $fwP8D.default,
    ro: $c1aBp.default,
    ru: $6cm9c.default,
    sk: $exjZ8.default,
    sv: $dvrov.default
};
const $5ae7258c2032dc02$var$isValidLocale = (str)=>{
    return $5ae7258c2032dc02$var$supportedLocales.includes(str);
};
const $5ae7258c2032dc02$export$d9468344d3651243 = (date, dateTimeFormat)=>{
    var _getMetaData;
    const localeKeys = (((_getMetaData = (0, $fuVmc.getMetaData)()) === null || _getMetaData === void 0 ? void 0 : _getMetaData.userLocale) || '').replace('_', '-').split('-');
    if (localeKeys && localeKeys.length > 0 && $5ae7258c2032dc02$var$isValidLocale(localeKeys[0])) {
        const localeToUse = $5ae7258c2032dc02$var$supportedLocale[localeKeys[0]];
        return (0, $53JkC.default)(date, dateTimeFormat, {
            locale: localeToUse
        });
    }
    return (0, $53JkC.default)(date, dateTimeFormat);
};
const $5ae7258c2032dc02$var$isValidWeekRange = (firstDay)=>{
    return firstDay >= 0 && firstDay <= 6;
};
const $5ae7258c2032dc02$export$43286948a3d8ddc7 = (firstDay)=>{
    if ($5ae7258c2032dc02$var$isValidWeekRange(firstDay)) return firstDay;
    return undefined;
};
const $5ae7258c2032dc02$export$99291c0265ff1d37 = (firstDay, useISO8601WeekNumbers)=>{
    return useISO8601WeekNumbers ? 1 : $5ae7258c2032dc02$export$43286948a3d8ddc7(firstDay);
};

});

parcelRegister("6jUM2", function(module, exports) {
$parcel$export(module.exports, "withPortalLocale", () => (parcelRequire("dtfVv")).withPortalLocale);

var $dtfVv = parcelRequire("dtfVv");

});
parcelRegister("dtfVv", function(module, exports) {
$parcel$export(module.exports, "withPortalLocale", () => $8f8e2ff2b2e26737$export$c58622ebd53d6350);

var $bSJIT = parcelRequire("bSJIT");

var $30REn = parcelRequire("30REn");
const $8f8e2ff2b2e26737$export$c58622ebd53d6350 = (LocaleAwareComponent)=>{
    const WithPortalLocale = (props)=>{
        const portalLocale = (0, $30REn.usePortalLocale)();
        return /*#__PURE__*/ $bSJIT.createElement(LocaleAwareComponent, {
            ...props,
            locale: portalLocale ?? props.locale
        });
    };
    WithPortalLocale.displayName = `withPortalLocale(${LocaleAwareComponent.displayName || LocaleAwareComponent.name || 'Component'})`;
    return WithPortalLocale;
};

});




parcelRegister("bo2U3", function(module, exports) {
$parcel$export(module.exports, "ControlledDateTimePicker", () => $8820b7fa5c3b13b5$export$3f58a178208b4384);
$parcel$export(module.exports, "DateTimePicker", () => (parcelRequire("1MztO")).default);

var $96iPn = parcelRequire("96iPn");

var $1MztO = parcelRequire("1MztO");
const $8820b7fa5c3b13b5$export$3f58a178208b4384 = (0, $96iPn.withControlledFormComponentValue)((_field, value)=>value)((0, $1MztO.default));

});
parcelRegister("1MztO", function(module, exports) {
$parcel$export(module.exports, "default", () => $cf3edc34c0c4df90$export$2e2bcd8739ae039);
/* date-time-picker.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $9fU1q = parcelRequire("9fU1q");

var $bSJIT = parcelRequire("bSJIT");

var $lFpPv = parcelRequire("lFpPv");

var $hfLZh = parcelRequire("hfLZh");
var $lMRHO = parcelRequire("lMRHO");
var $5xMcQ = parcelRequire("5xMcQ");

var $4ZMmh = parcelRequire("4ZMmh");

var $fK3tS = parcelRequire("fK3tS");

var $j2RlN = parcelRequire("j2RlN");
parcelRequire("5wQdU");
var $lkAYa = parcelRequire("lkAYa");

var $2frMK = parcelRequire("2frMK");

var $g832e = parcelRequire("g832e");

var $ejPYW = parcelRequire("ejPYW");

var $6hTxC = parcelRequire("6hTxC");
parcelRequire("6jUM2");
var $dtfVv = parcelRequire("dtfVv");
const $cf3edc34c0c4df90$export$bd63dbd4f777763 = (value)=>{
    if (!value || !(0, $lMRHO.default)(new Date(value))) return undefined;
    return (0, $hfLZh.default)(new Date(value));
};
const $cf3edc34c0c4df90$var$AVAILABLE_TIMES = [
    '00:00',
    '00:30',
    '01:00',
    '01:30',
    '02:00',
    '02:30',
    '03:00',
    '03:30',
    '04:00',
    '04:30',
    '05:00',
    '05:30',
    '06:00',
    '06:30',
    '07:00',
    '07:30',
    '08:00',
    '08:30',
    '09:00',
    '09:30',
    '10:00',
    '10:30',
    '11:00',
    '11:30',
    '12:00',
    '12:30',
    '13:00',
    '13:30',
    '14:00',
    '14:30',
    '15:00',
    '15:30',
    '16:00',
    '16:30',
    '17:00',
    '17:30',
    '18:00',
    '18:30',
    '19:00',
    '19:30',
    '20:00',
    '20:30',
    '21:00',
    '21:30',
    '22:00',
    '22:30',
    '23:00',
    '23:30'
];
// TODO: Add proper locale support so that this workaround to fix date parsing isn't needed
const $cf3edc34c0c4df90$var$parseInputValue = (date)=>{
    if ((0, $lMRHO.default)(new Date(date))) return (0, $5xMcQ.default)(new Date(date).toISOString());
    return (0, $5xMcQ.default)(new Date().toISOString());
};
class $cf3edc34c0c4df90$export$fdacf42198d490fd extends $bSJIT.PureComponent {
    render() {
        const { id: id, label: label, locale: locale, required: required, defaultValue: defaultValue, description: description, errorMessage: errorMessage, disabled: disabled, firstDay: firstDay, useISO8601WeekNumbers: useISO8601WeekNumbers, intl: intl, value: value, dateTimeFormat: dateTimeFormat = 'yyyy-MM-dd hh:mm a' } = this.props;
        const isInvalid = !(0, $4ZMmh.isEmpty)(errorMessage);
        const { dateFormat: dateFormat, timeFormat: timeFormat } = (0, $6hTxC.splitDateTimeFormat)(dateTimeFormat);
        // Need to refer to id like this.
        // See: https://atlaskit.atlassian.com/packages/core/datetime-picker
        const inputId = `react-select-${id}-input`;
        const defaultDateTimeValue = $cf3edc34c0c4df90$export$bd63dbd4f777763(defaultValue);
        // this logic is derived from the default value logic above
        const processedValue = value && (0, $lFpPv.isDateTimeSupportEnabled)() ? $cf3edc34c0c4df90$export$bd63dbd4f777763(value) : undefined;
        const datePickerProps = {
            dateFormat: dateFormat,
            parseInputValue: $cf3edc34c0c4df90$var$parseInputValue,
            formatDisplayLabel: this.parseDateLabel,
            placeholder: intl.formatMessage((0, $lkAYa.default).forExample, {
                text: (0, $ejPYW.format)((0, $g832e.default)(), dateFormat)
            }),
            weekStartDay: (0, $ejPYW.getWeekStartDay)(firstDay, useISO8601WeekNumbers)
        };
        const timePickerProps = {
            timeFormat: timeFormat,
            timeIsEditable: true,
            formatDisplayLabel: this.parseTimeLabel,
            times: $cf3edc34c0c4df90$var$AVAILABLE_TIMES,
            placeholder: intl.formatMessage((0, $lkAYa.default).forExample, {
                text: (0, $ejPYW.format)((0, $g832e.default)(), timeFormat)
            })
        };
        return /*#__PURE__*/ $bSJIT.createElement((0, $j2RlN.FieldBase), {
            htmlFor: inputId,
            label: label,
            required: required,
            errorMessage: errorMessage,
            description: description
        }, /*#__PURE__*/ $bSJIT.createElement("div", {
            className: (0, $9fU1q.default)([
                "_1bsb1178"
            ])
        }, /*#__PURE__*/ $bSJIT.createElement((0, $2frMK.default), {
            id: inputId,
            name: id,
            defaultValue: defaultDateTimeValue,
            onChange: this.onChange,
            isInvalid: isInvalid,
            // Assertions necessary due to broken types in @atlaskit/datetime-picker
            // requiring extra props to be passed even though they have defaults
            datePickerProps: datePickerProps,
            timePickerProps: timePickerProps,
            isDisabled: !!disabled,
            locale: locale,
            "aria-describedby": `${inputId}-field-description`,
            value: (0, $lFpPv.isDateTimeSupportEnabled)() ? processedValue : undefined
        })));
    }
    constructor(...args){
        super(...args), this.onChange = (isoTime)=>{
            const { onChange: onChange } = this.props;
            if ((0, $lFpPv.isDateTimeSupportEnabled)()) onChange && onChange(this.props.id, isoTime ? (0, $ejPYW.format)((0, $5xMcQ.default)(isoTime), "yyyy-MM-dd'T'HH:mm") : isoTime, false, {
                rawObject: {},
                rawValue: isoTime
            });
            else onChange && onChange(this.props.id, isoTime ? (0, $ejPYW.format)((0, $5xMcQ.default)(isoTime), "yyyy-MM-dd'T'HH:mm") : isoTime, false);
        }, // We need custom parse date and parse time functions here so the date and time are displayed in the right locale
        this.parseDateLabel = (value, dateFormat)=>{
            return value && dateFormat ? (0, $ejPYW.format)((0, $5xMcQ.default)(value), dateFormat) : value;
        }, this.parseTimeLabel = (value, timeFormat)=>{
            // date-fns format can't parse a time without a date prefix, in this case we will manually append
            // a date to the time so that it will format it correctly
            return value && timeFormat ? (0, $ejPYW.format)((0, $5xMcQ.default)(`1970-01-01 ${value}`), timeFormat) : value;
        };
    }
}
var $cf3edc34c0c4df90$export$2e2bcd8739ae039 = (0, $dtfVv.withPortalLocale)((0, $fK3tS.default)($cf3edc34c0c4df90$export$fdacf42198d490fd));
const $cf3edc34c0c4df90$var$dataTimePickerContainer = null;

});
parcelRegister("2frMK", function(module, exports) {
$parcel$export(module.exports, "default", () => $af337566387464ae$export$2e2bcd8739ae039);
/* date-time-picker.tsx generated by @compiled/babel-plugin v3.0.2 */ /// <reference types="node" />
// for typing `process`

var $dc70d = parcelRequire("dc70d");

var $bSJIT = parcelRequire("bSJIT");

var $53JkC = parcelRequire("53JkC");
var $lMRHO = parcelRequire("lMRHO");
var $5xMcQ = parcelRequire("5xMcQ");

var $kIUP1 = parcelRequire("kIUP1");

var $4TRbS = parcelRequire("4TRbS");

var $cBVmT = parcelRequire("cBVmT");

var $gdUUy = parcelRequire("gdUUy");

var $9PwDt = parcelRequire("9PwDt");

var $fZ0ZI = parcelRequire("fZ0ZI");

var $udzoQ = parcelRequire("udzoQ");

var $aBK0E = parcelRequire("aBK0E");

var $6556S = parcelRequire("6556S");

var $i7VIS = parcelRequire("i7VIS");

var $aM9QT = parcelRequire("aM9QT");

var $iSkY9 = parcelRequire("iSkY9");
const $af337566387464ae$var$packageName = undefined;
const $af337566387464ae$var$packageVersion = undefined;
const $af337566387464ae$var$analyticsAttributes = {
    componentName: 'dateTimePicker',
    packageName: $af337566387464ae$var$packageName,
    packageVersion: $af337566387464ae$var$packageVersion
};
const $af337566387464ae$var$compiledStyles = {
    datePickerContainerStyles: "_i0dl1ssb _16jlkb7n _1o9zidpf",
    timePickerContainerStyles: "_i0dl1ssb _16jlkb7n",
    iconContainerStyles: "_1e0c1txw _4cvr1h6o _i0dl1kw7"
};
const $af337566387464ae$var$innerCornerRadius = `calc(${"var(--ds-radius-medium, 6px)"} - ${"var(--ds-border-width, 1px)"})`;
const $af337566387464ae$var$cornerRadiusStyles = {
    start: {
        borderStartStartRadius: $af337566387464ae$var$innerCornerRadius,
        borderEndStartRadius: $af337566387464ae$var$innerCornerRadius
    },
    end: {
        borderStartEndRadius: $af337566387464ae$var$innerCornerRadius,
        borderEndEndRadius: $af337566387464ae$var$innerCornerRadius
    },
    none: {}
};
// react-select overrides (via @atlaskit/select).
const $af337566387464ae$var$getStyles = (isInputMotionEnabled, roundedCorners)=>({
        control: (style, { isDisabled: isDisabled, isFocused: isFocused })=>({
                ...style,
                ...isInputMotionEnabled && !isDisabled ? {
                    transition: "var(--ds-input, background-color border-color box-shadow 150ms cubic-bezier(0.4, 1, 0.6, 1))"
                } : {},
                backgroundColor: 'transparent',
                border: 2,
                borderRadius: 0,
                ...isInputMotionEnabled ? {
                    ...$af337566387464ae$var$cornerRadiusStyles[roundedCorners],
                    boxShadow: isFocused ? `0 0 0 ${"var(--ds-border-width, 1px)"} ${"var(--ds-border-focused, #4688EC)"}, inset 0 0 0 ${"var(--ds-border-width, 1px)"} ${"var(--ds-border-focused, #4688EC)"}` : 'none'
                } : {},
                paddingLeft: 0,
                ':hover': {
                    backgroundColor: 'transparent',
                    cursor: 'inherit'
                }
            })
    });
const $af337566387464ae$var$hasExplicitZone = (value)=>value.endsWith('Z') || Math.max(value.lastIndexOf('+'), value.lastIndexOf('-')) > 15;
const $af337566387464ae$var$parseDateTimeValueWithOffset = (value)=>{
    const parsed = (0, $5xMcQ.default)(value);
    const zoneStart = value.endsWith('Z') ? value.length - 1 : Math.max(value.lastIndexOf('+'), value.lastIndexOf('-'));
    if (!(0, $lMRHO.default)(parsed) || value[10] !== 'T' || zoneStart <= 15) return undefined;
    const zoneValue = value.slice(zoneStart);
    if (!/^(?:Z|[+-]\d{2}(?::?\d{2})?)$/.test(zoneValue)) return undefined;
    return {
        dateValue: value.slice(0, 10),
        timeValue: value.slice(11, 16),
        zoneValue: zoneValue
    };
};
const $af337566387464ae$var$parseDateTimeValue = (value)=>{
    if ((0, $gdUUy.fg)('platform-dst-dtp-preserve-offset')) {
        if ($af337566387464ae$var$hasExplicitZone(value)) return $af337566387464ae$var$parseDateTimeValueWithOffset(value);
    }
    const parsed = (0, $5xMcQ.default)(value);
    return (0, $lMRHO.default)(parsed) ? {
        dateValue: (0, $53JkC.default)(parsed, (0, $i7VIS.convertTokens)('YYYY-MM-DD')),
        timeValue: (0, $53JkC.default)(parsed, (0, $i7VIS.convertTokens)('HH:mm')),
        zoneValue: (0, $53JkC.default)(parsed, (0, $i7VIS.convertTokens)('ZZ'))
    } : undefined;
};
const $af337566387464ae$export$3b559a1219cb3c27 = 'Date';
const $af337566387464ae$export$d82cc7e53d68a428 = 'Time';
/**
 * __Date time picker__
 *
 * A date time picker allows the user to select an associated date and time.
 *
 * - [Examples](https://atlassian.design/components/datetime-picker/examples)
 * - [Code](https://atlassian.design/components/datetime-picker/code)
 * - [Usage](https://atlassian.design/components/datetime-picker/usage)
 */ const $af337566387464ae$var$DateTimePicker = /*#__PURE__*/ (0, $bSJIT.forwardRef)(({ 'aria-describedby': ariaDescribedBy, appearance: appearance = 'default', autoFocus: autoFocus = false, clearControlLabel: clearControlLabel = 'clear', datePickerProps: datePickerPropsWithSelectProps = {}, defaultValue: defaultValue = '', id: id = '', innerProps: innerProps = {}, isDisabled: isDisabled = false, isInvalid: isInvalid = false, isRequired: isRequired = false, name: name = '', onBlur: // These disables are here for proper typing when used as defaults. They
// should *not* use the `noop` function.
/* eslint-disable @repo/internal/react/use-noop */ onBlur = (_event)=>{}, onChange: onChangeProp = (_value)=>{}, onFocus: onFocus = (_event)=>{}, /* eslint-enable @repo/internal/react/use-noop */ parseValue: providedParseValue, spacing: spacing = 'default', locale: locale = 'en-US', testId: testId, timePickerProps: timePickerPropsWithSelectProps = {}, value: providedValue }, ref)=>{
    const [isFocused, setIsFocused] = (0, $bSJIT.useState)(false);
    const isInputMotionEnabled = (0, $gdUUy.fg)('platform-dst-motion-uplift-input');
    const isZoneExplicitRef = (0, $bSJIT.useRef)(false);
    /**
   * Defined inside the component so the reducer closes over `providedParseValue`
   * without needing to smuggle it through every action payload. React always
   * calls the reducer from the latest render, so stale-closure is not a concern.
   */ const reducer = (state, action)=>{
        switch(action.type){
            case 'APPLY':
                return action.payload;
            case 'SET_VALUE':
                {
                    const newValue = action.payload;
                    // Explicit empty-string handling: clear all sub-fields so the date
                    // and time pickers visually reset when a controlled value is cleared.
                    if (!newValue) return {
                        value: '',
                        dateValue: '',
                        timeValue: '',
                        zoneValue: ''
                    };
                    if (providedParseValue) {
                        const parsed = providedParseValue(newValue, state.dateValue, state.timeValue, state.zoneValue);
                        return parsed ? {
                            value: newValue,
                            ...parsed
                        } : {
                            value: newValue,
                            dateValue: state.dateValue,
                            timeValue: state.timeValue,
                            zoneValue: state.zoneValue
                        };
                    }
                    const parsed = $af337566387464ae$var$parseDateTimeValue(newValue);
                    return parsed ? {
                        value: newValue,
                        ...parsed
                    } : {
                        value: newValue,
                        dateValue: '',
                        timeValue: '',
                        zoneValue: ''
                    };
                }
            default:
                return state;
        }
    };
    const [dtState, dispatch] = (0, $bSJIT.useReducer)(reducer, null, ()=>{
        const initialValue = providedValue ?? defaultValue ?? '';
        isZoneExplicitRef.current = $af337566387464ae$var$hasExplicitZone(initialValue);
        const initialDate = (datePickerPropsWithSelectProps === null || datePickerPropsWithSelectProps === void 0 ? void 0 : datePickerPropsWithSelectProps.defaultValue) || '';
        const initialTime = (timePickerPropsWithSelectProps === null || timePickerPropsWithSelectProps === void 0 ? void 0 : timePickerPropsWithSelectProps.defaultValue) || '';
        if (!initialValue) return {
            value: '',
            dateValue: initialDate,
            timeValue: initialTime,
            zoneValue: ''
        };
        if (providedParseValue) {
            const parsed = providedParseValue(initialValue, initialDate, initialTime, '');
            return parsed ? {
                value: initialValue,
                ...parsed
            } : {
                value: initialValue,
                dateValue: initialDate,
                timeValue: initialTime,
                zoneValue: ''
            };
        }
        const parsed = $af337566387464ae$var$parseDateTimeValue(initialValue);
        return parsed ? {
            value: initialValue,
            ...parsed
        } : {
            value: initialValue,
            dateValue: initialDate,
            timeValue: initialTime,
            zoneValue: ''
        };
    });
    // if a previously controlled value becomes undefined, it clears the reducer
    // state so the hidden input no longer keeps the stale ISO timestamp.
    // Without this, components that try to clear their components by providing
    // `undefined` to the `value` prop will not clear the hidden input and will
    // cause unexpected issues.
    const hasReceivedProvidedValue = (0, $bSJIT.useRef)(providedValue !== undefined);
    const lastEmittedValueRef = (0, $bSJIT.useRef)();
    // We don't want to set the state on the first render, as it would
    // needlessly be a duplicate.
    const isFirstRender = (0, $bSJIT.useRef)(true);
    (0, $bSJIT.useEffect)(()=>{
        if (isFirstRender.current) {
            isFirstRender.current = false;
            return;
        }
        if (providedValue !== undefined) {
            hasReceivedProvidedValue.current = true;
            if (providedValue !== lastEmittedValueRef.current) isZoneExplicitRef.current = $af337566387464ae$var$hasExplicitZone(providedValue);
            dispatch({
                type: 'SET_VALUE',
                payload: providedValue
            });
        } else if (hasReceivedProvidedValue.current) {
            hasReceivedProvidedValue.current = false;
            isZoneExplicitRef.current = false;
            lastEmittedValueRef.current = undefined;
            dispatch({
                type: 'SET_VALUE',
                payload: ''
            });
        }
    }, [
        providedValue
    ]);
    const parseValue = (0, $bSJIT.useCallback)((value, providedDateValue, providedTimeValue, providedZoneValue)=>{
        if (providedParseValue) {
            const parsedFromFn = providedParseValue(value, providedDateValue, providedTimeValue, providedZoneValue);
            // This handles cases found in Jira where the parse function actually does
            // nothing and returns undefined. The previous `getSafeState` function
            // just spread the values over the state, but if it returned `undefined`,
            // it would just rely on the previous state values. Considering this is
            // what is input to this function anyway, this is a safe way to handle
            // this, colocate the behavior, and not rely on `getSafeState`.
            return parsedFromFn || {
                dateValue: providedDateValue,
                timeValue: providedTimeValue,
                zoneValue: providedZoneValue
            };
        }
        const parsed = $af337566387464ae$var$parseDateTimeValue(value);
        return parsed || {
            dateValue: dtState.dateValue,
            timeValue: dtState.timeValue,
            zoneValue: dtState.zoneValue
        };
    }, [
        providedParseValue,
        dtState.dateValue,
        dtState.timeValue,
        dtState.zoneValue
    ]);
    const onDateBlur = (event)=>{
        setIsFocused(false);
        onBlur(event);
        if (datePickerPropsWithSelectProps !== null && datePickerPropsWithSelectProps !== void 0 && datePickerPropsWithSelectProps.onBlur) datePickerPropsWithSelectProps.onBlur(event);
    };
    const onTimeBlur = (event)=>{
        setIsFocused(false);
        onBlur(event);
        if (timePickerPropsWithSelectProps !== null && timePickerPropsWithSelectProps !== void 0 && timePickerPropsWithSelectProps.onBlur) timePickerPropsWithSelectProps.onBlur(event);
    };
    const onDateFocus = (event)=>{
        setIsFocused(false);
        onFocus(event);
        if (datePickerPropsWithSelectProps !== null && datePickerPropsWithSelectProps !== void 0 && datePickerPropsWithSelectProps.onFocus) datePickerPropsWithSelectProps.onFocus(event);
    };
    const onTimeFocus = (event)=>{
        setIsFocused(false);
        onFocus(event);
        if (timePickerPropsWithSelectProps !== null && timePickerPropsWithSelectProps !== void 0 && timePickerPropsWithSelectProps.onFocus) timePickerPropsWithSelectProps.onFocus(event);
    };
    const onDateChange = (newDateValue)=>{
        const parsedValues = parseValue(dtState.value, newDateValue, dtState.timeValue, dtState.zoneValue);
        onValueChange({
            providedDateValue: newDateValue,
            providedTimeValue: parsedValues.timeValue,
            providedZoneValue: parsedValues.zoneValue
        });
        if (datePickerPropsWithSelectProps !== null && datePickerPropsWithSelectProps !== void 0 && datePickerPropsWithSelectProps.onChange) datePickerPropsWithSelectProps.onChange(newDateValue);
    };
    const onTimeChange = (newTimeValue)=>{
        const parsedValues = parseValue(dtState.value, dtState.dateValue, newTimeValue, dtState.zoneValue);
        onValueChange({
            providedDateValue: parsedValues.dateValue,
            providedTimeValue: newTimeValue,
            providedZoneValue: parsedValues.zoneValue
        });
        if (timePickerPropsWithSelectProps !== null && timePickerPropsWithSelectProps !== void 0 && timePickerPropsWithSelectProps.onChange) timePickerPropsWithSelectProps.onChange(newTimeValue);
    };
    const onClear = ()=>{
        const parsedValues = parseValue(dtState.value, dtState.dateValue, dtState.timeValue, dtState.zoneValue);
        onValueChange({
            providedDateValue: '',
            providedTimeValue: '',
            providedZoneValue: parsedValues.zoneValue
        });
        if (datePickerPropsWithSelectProps !== null && datePickerPropsWithSelectProps !== void 0 && datePickerPropsWithSelectProps.onChange) datePickerPropsWithSelectProps.onChange('');
        if (timePickerPropsWithSelectProps !== null && timePickerPropsWithSelectProps !== void 0 && timePickerPropsWithSelectProps.onChange) timePickerPropsWithSelectProps.onChange('');
    };
    const onChangePropWithAnalytics = (0, $kIUP1.usePlatformLeafEventHandler)({
        fn: onChangeProp,
        action: 'selectedDate',
        actionSubject: 'dateTimePicker',
        ...$af337566387464ae$var$analyticsAttributes
    });
    const onValueChange = ({ providedDateValue: providedDateValue, providedTimeValue: providedTimeValue, providedZoneValue: providedZoneValue })=>{
        if (providedDateValue && providedTimeValue) {
            const isoValue = (0, $6556S.formatDateTimeZoneIntoIso)(providedDateValue, providedTimeValue, providedZoneValue);
            const valueToParse = (0, $gdUUy.fg)('platform-dst-dtp-preserve-offset') && !providedParseValue && !isZoneExplicitRef.current ? (0, $6556S.formatDateTimeZoneIntoIso)(providedDateValue, providedTimeValue, '') : isoValue;
            const { zoneValue: parsedZone } = parseValue(valueToParse, providedDateValue, providedTimeValue, providedZoneValue);
            const valueWithValidZone = (0, $6556S.formatDateTimeZoneIntoIso)(providedDateValue, providedTimeValue, parsedZone);
            dispatch({
                type: 'APPLY',
                payload: {
                    value: valueWithValidZone,
                    dateValue: providedDateValue,
                    timeValue: providedTimeValue,
                    zoneValue: parsedZone
                }
            });
            lastEmittedValueRef.current = valueWithValidZone;
            onChangePropWithAnalytics(valueWithValidZone);
        // If the date or time value was cleared when there is an existing datetime value, then clear the value.
        } else if (dtState.value) {
            dispatch({
                type: 'APPLY',
                payload: {
                    value: '',
                    dateValue: providedDateValue,
                    timeValue: providedTimeValue,
                    zoneValue: providedZoneValue
                }
            });
            onChangePropWithAnalytics('');
        } else dispatch({
            type: 'APPLY',
            payload: {
                value: '',
                dateValue: providedDateValue,
                timeValue: providedTimeValue,
                zoneValue: providedZoneValue
            }
        });
    };
    // Render DateTimePicker's IconContainer when a value has been filled
    // Don't use Date or TimePicker's because they can't be customised
    const isClearable = Boolean(dtState.dateValue || dtState.timeValue);
    const hasClearButton = isClearable && !isDisabled;
    const dateStyles = (0, $bSJIT.useMemo)(()=>$af337566387464ae$var$getStyles(isInputMotionEnabled, 'start'), [
        isInputMotionEnabled
    ]);
    const timeStyles = (0, $bSJIT.useMemo)(()=>$af337566387464ae$var$getStyles(isInputMotionEnabled, hasClearButton ? 'none' : 'end'), [
        isInputMotionEnabled,
        hasClearButton
    ]);
    const { selectProps: datePickerSelectProps, ...datePickerProps } = datePickerPropsWithSelectProps;
    const datePickerAriaDescribedBy = datePickerProps['aria-describedby'] || ariaDescribedBy;
    const datePickerLabel = datePickerProps.label || 'Date';
    const mergedDatePickerSelectProps = {
        ...datePickerSelectProps,
        styles: (0, $udzoQ.mergeStyles)(dateStyles, datePickerSelectProps === null || datePickerSelectProps === void 0 ? void 0 : datePickerSelectProps.styles)
    };
    const { selectProps: timePickerSelectProps, ...timePickerProps } = timePickerPropsWithSelectProps;
    const timePickerAriaDescribedBy = timePickerProps['aria-describedby'] || ariaDescribedBy;
    const timePickerLabel = timePickerProps.label || 'Time';
    const mergedTimePickerSelectProps = {
        ...timePickerSelectProps,
        styles: (0, $udzoQ.mergeStyles)(timeStyles, timePickerSelectProps === null || timePickerSelectProps === void 0 ? void 0 : timePickerSelectProps.styles)
    };
    return /*#__PURE__*/ (0, $dc70d.jsxs)((0, $aBK0E.DateTimePickerContainer), {
        appearance: appearance,
        isDisabled: isDisabled,
        isFocused: isFocused,
        isInvalid: isInvalid,
        testId: testId,
        innerProps: innerProps,
        ref: ref,
        children: [
            /*#__PURE__*/ (0, $dc70d.jsx)("input", {
                name: name,
                type: "hidden",
                value: dtState.value,
                "data-testid": testId && `${testId}--input`
            }),
            /*#__PURE__*/ (0, $dc70d.jsx)((0, $9PwDt.Box), {
                xcss: $af337566387464ae$var$compiledStyles.datePickerContainerStyles,
                children: /*#__PURE__*/ (0, $dc70d.jsx)((0, $aM9QT.default), {
                    appearance: appearance,
                    "aria-describedby": datePickerAriaDescribedBy,
                    autoFocus: datePickerProps.autoFocus || autoFocus,
                    calendarLabel: datePickerProps.calendarLabel,
                    dateFormat: datePickerProps.dateFormat,
                    defaultIsOpen: datePickerProps.defaultIsOpen,
                    defaultValue: datePickerProps.defaultValue,
                    disabled: datePickerProps.disabled,
                    disabledDateFilter: datePickerProps.disabledDateFilter,
                    formatDisplayLabel: datePickerProps.formatDisplayLabel,
                    hideIcon: datePickerProps.hideIcon || true,
                    icon: datePickerProps.icon,
                    id: datePickerProps.id || id,
                    innerProps: datePickerProps.innerProps,
                    inputLabel: datePickerProps.inputLabel,
                    inputLabelId: datePickerProps.inputLabelId,
                    isDisabled: datePickerProps.isDisabled || isDisabled,
                    isInvalid: datePickerProps.isInvalid || isInvalid,
                    isOpen: datePickerProps.isOpen,
                    isRequired: datePickerProps.isRequired || isRequired,
                    label: datePickerLabel,
                    locale: datePickerProps.locale || locale,
                    maxDate: datePickerProps.maxDate,
                    minDate: datePickerProps.minDate,
                    name: datePickerProps.name,
                    nextMonthLabel: datePickerProps.nextMonthLabel,
                    onBlur: onDateBlur,
                    onChange: onDateChange,
                    onFocus: onDateFocus,
                    openCalendarLabel: datePickerProps.openCalendarLabel,
                    parseInputValue: datePickerProps.parseInputValue,
                    placeholder: datePickerProps.placeholder,
                    previousMonthLabel: datePickerProps.previousMonthLabel,
                    selectProps: mergedDatePickerSelectProps,
                    shouldShowCalendarButton: datePickerProps.shouldShowCalendarButton,
                    spacing: datePickerProps.spacing || spacing,
                    testId: testId && `${testId}--datepicker` || datePickerProps.testId,
                    value: dtState.dateValue,
                    weekStartDay: datePickerProps.weekStartDay
                })
            }),
            /*#__PURE__*/ (0, $dc70d.jsx)((0, $9PwDt.Box), {
                xcss: $af337566387464ae$var$compiledStyles.timePickerContainerStyles,
                children: /*#__PURE__*/ (0, $dc70d.jsx)((0, $iSkY9.default), {
                    appearance: timePickerProps.appearance || appearance,
                    "aria-describedby": timePickerAriaDescribedBy,
                    autoFocus: timePickerProps.autoFocus,
                    defaultIsOpen: timePickerProps.defaultIsOpen,
                    defaultValue: timePickerProps.defaultValue,
                    formatDisplayLabel: timePickerProps.formatDisplayLabel,
                    hideIcon: timePickerProps.hideIcon || true,
                    id: timePickerProps.id,
                    innerProps: timePickerProps.innerProps,
                    isDisabled: timePickerProps.isDisabled || isDisabled,
                    isInvalid: timePickerProps.isInvalid || isInvalid,
                    isOpen: timePickerProps.isOpen,
                    isRequired: timePickerProps.isRequired || isRequired,
                    label: timePickerLabel,
                    locale: timePickerProps.locale || locale,
                    name: timePickerProps.name,
                    openTimeLabel: timePickerProps.openTimeLabel,
                    onBlur: onTimeBlur,
                    onChange: onTimeChange,
                    onFocus: onTimeFocus,
                    parseInputValue: timePickerProps.parseInputValue,
                    placeholder: timePickerProps.placeholder,
                    selectProps: mergedTimePickerSelectProps,
                    shouldShowTimeButton: timePickerProps.shouldShowTimeButton,
                    spacing: timePickerProps.spacing || spacing,
                    testId: timePickerProps.testId || testId && `${testId}--timepicker`,
                    timeFormat: timePickerProps.timeFormat,
                    timeIsEditable: timePickerProps.timeIsEditable,
                    times: timePickerProps.times,
                    value: dtState.timeValue
                })
            }),
            hasClearButton ? /*#__PURE__*/ (0, $dc70d.jsx)((0, $fZ0ZI.Inline), {
                xcss: $af337566387464ae$var$compiledStyles.iconContainerStyles,
                children: /*#__PURE__*/ (0, $dc70d.jsx)((0, $4TRbS.default), {
                    appearance: "subtle",
                    label: clearControlLabel,
                    icon: (iconProps)=>/*#__PURE__*/ (0, $dc70d.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($cBVmT))), {
                            ...iconProps,
                            color: "var(--ds-text-subtlest, #6B6E76)",
                            size: "small"
                        }),
                    onClick: onClear,
                    testId: testId && `${testId}--icon--container`,
                    tabIndex: -1
                })
            }) : null
        ]
    });
});
var $af337566387464ae$export$2e2bcd8739ae039 = $af337566387464ae$var$DateTimePicker;

});
parcelRegister("udzoQ", function(module, exports) {
$parcel$export(module.exports, "mergeStyles", () => $cbcfb2125af51b5b$export$e618dc39ac9ad607);
function $cbcfb2125af51b5b$export$e618dc39ac9ad607(source, target = {}) {
    // initialize with source styles
    const styles = {
        ...source
    };
    // massage in target styles
    Object.keys(target).forEach((keyAsString)=>{
        const key = keyAsString;
        if (source[key]) styles[key] = (rsCss, props)=>{
            return target[key](source[key](rsCss, props), props);
        };
        else styles[key] = target[key];
    });
    return styles;
}

});

parcelRegister("aBK0E", function(module, exports) {
$parcel$export(module.exports, "DateTimePickerContainer", () => $66fa19f6f059555c$export$83034b1f07ab0b20);
/* date-time-picker-container.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $dc70d = parcelRequire("dc70d");

var $bSJIT = parcelRequire("bSJIT");

var $9fU1q = parcelRequire("9fU1q");

var $gdUUy = parcelRequire("gdUUy");
const $66fa19f6f059555c$var$isInvalidBorderStyles = null;
const $66fa19f6f059555c$var$isInvalidBorderWithShadowStyles = null;
const $66fa19f6f059555c$var$isFocusedBorderStyles = null;
const $66fa19f6f059555c$var$isFocusedStyles = null;
const $66fa19f6f059555c$var$subtleBgStyles = null;
const $66fa19f6f059555c$var$subtleFocusedBgStyles = null;
const $66fa19f6f059555c$var$noBgStyles = null;
const $66fa19f6f059555c$var$hoverStyles = null;
const $66fa19f6f059555c$var$isInvalidHoverStyles = null;
const $66fa19f6f059555c$var$isDisabledStyles = null;
const $66fa19f6f059555c$var$newBorderStyles = null;
const $66fa19f6f059555c$var$baseContainerStyles = null;
const $66fa19f6f059555c$var$inputMotionStyles = {
    legacy: "_v564r5cv",
    base: "_v56497ke"
};
const $66fa19f6f059555c$export$83034b1f07ab0b20 = /*#__PURE__*/ (0, $bSJIT.forwardRef)(({ children: children, isDisabled: isDisabled, isFocused: isFocused, appearance: appearance, isInvalid: isInvalid, innerProps: innerProps, testId: testId }, ref)=>{
    const notFocusedOrIsDisabled = !(isFocused || isDisabled);
    const isInputMotionEnabled = (0, $gdUUy.fg)('platform-dst-motion-uplift-input');
    // we cannot use Box or Flex primitives because these do not allow ...innerProps to be passed
    return /*#__PURE__*/ (0, $dc70d.jsx)("div", {
        ...innerProps,
        "data-testid": testId,
        ref: ref,
        className: (0, $9fU1q.default)([
            "_2rko1qi0 _1e0c1txw _bfhk1j9a _d0altlke",
            !isInputMotionEnabled && $66fa19f6f059555c$var$inputMotionStyles.legacy,
            isInputMotionEnabled && !isDisabled && $66fa19f6f059555c$var$inputMotionStyles.base,
            "_19itno8c",
            isDisabled && "_1h6dbk0g _bfhk187o _d0al73ad",
            isFocused && "_bfhkr01l",
            appearance === 'subtle' && isFocused && "_1h6d1j28 _bfhkr01l",
            appearance === 'subtle' && !isFocused && "_1h6d1j28 _bfhk1j28",
            isFocused && "_1h6d1v1w _16qsvyy1",
            !isInputMotionEnabled && isInvalid && "_1h6d1bqt",
            isInputMotionEnabled && isInvalid && "_1h6d1bqt _16qsizbr",
            notFocusedOrIsDisabled && isInvalid && "_4cvx1bqt _irr3l4ek",
            notFocusedOrIsDisabled && !isInvalid && "_4cvxrsbi _irr3l4ek",
            appearance === 'none' && "_1h6d1j28 _bfhk1j28 _4cvx1j28 _irr31j28"
        ]),
        children: children
    });
});

});

parcelRegister("6556S", function(module, exports) {
$parcel$export(module.exports, "formatDateTimeZoneIntoIso", () => $26931c9f77a9fc86$export$2eeb05a2ecc2ce0a);
/**
 * Formats a date, time, and zone into a ISO string.
 */ function $26931c9f77a9fc86$export$2eeb05a2ecc2ce0a(date, time, zone) {
    // 12:00 => 12:00, 1:00 => 01:00
    const needsLeadingZero = /^\d:/;
    const sanitizedTime = needsLeadingZero.test(time) ? `0${time}` : time;
    return `${date}T${sanitizedTime}${zone}`;
}

});




parcelRegister("fZxJ3", function(module, exports) {
$parcel$export(module.exports, "EntitlementPicker", () => (parcelRequire("9VdzC")).EntitlementPicker);

var $9VdzC = parcelRequire("9VdzC");

});
parcelRegister("9VdzC", function(module, exports) {
$parcel$export(module.exports, "EntitlementPicker", () => $fd2044c94eabd130$export$7c3ab7545fd6cd0d);

var $aFluK = parcelRequire("aFluK");

var $bSJIT = parcelRequire("bSJIT");

var $egQxE = parcelRequire("egQxE");

var $BOq7h = parcelRequire("BOq7h");

var $fT4XN = parcelRequire("fT4XN");

var $lFpPv = parcelRequire("lFpPv");

var $fuVmc = parcelRequire("fuVmc");

var $4vLTk = parcelRequire("4vLTk");

var $a2qIF = parcelRequire("a2qIF");

var $aI0YR = parcelRequire("aI0YR");

var $j2RlN = parcelRequire("j2RlN");

var $6WltM = parcelRequire("6WltM");

var $hkLEY = parcelRequire("hkLEY");

var $gUpf2 = parcelRequire("gUpf2");

var $9BVpB = parcelRequire("9BVpB");

var $haAAx = parcelRequire("haAAx");

var $3l191 = parcelRequire("3l191");

var $51XYw = parcelRequire("51XYw");

var $kbkME = parcelRequire("kbkME");

var $a6ENB = parcelRequire("a6ENB");
parcelRequire("kszEL");
var $1fYfn = parcelRequire("1fYfn");

var $aNnZt = parcelRequire("aNnZt");

var $9ivsr = parcelRequire("9ivsr");
const $fd2044c94eabd130$export$fd42663b909f44cb = (0, $aFluK.default);
const $fd2044c94eabd130$var$EntitlementPickerMain = (props)=>{
    const { formatMessage: formatMessage } = (0, $4vLTk.default)();
    const { reporterId: reporterId, onChange: onChange, isNewReporter: isNewReporter, disableSubmitButton: disableSubmitButton, enableSubmitButton: enableSubmitButton, value: value, defaultEntitlement: defaultEntitlement, ...fieldProps } = props;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $6WltM.useAnalyticsEvents)();
    const cloudId = (0, $fuVmc.getCloudId)();
    const [prevReporterId, setPrevReporterId] = (0, $bSJIT.useState)(null);
    const [isLoading, setIsLoading] = (0, $bSJIT.useState)(false);
    const [entitlements, setEntitlements] = (0, $bSJIT.useState)([]);
    const [error, setError] = (0, $bSJIT.useState)(false);
    const [hasAppliedDefault, setHasAppliedDefault] = (0, $bSJIT.useState)(false);
    // When the rovo integration FG is enabled, rely solely on the useEffect below to apply
    // defaultEntitlement once via onChange (single source of truth). This lets the user clear
    // the field without it being re-populated. When the FG is off, preserve the old fallback.
    const effectiveValue = (0, $lFpPv.isJsmPortalRovoIntegrationEnabled)() ? value : value || defaultEntitlement;
    // Try to match by ID first, then by product name if no match
    let selectedEntitlement = entitlements.find((entitlement)=>entitlement.value === effectiveValue) || null;
    if (!selectedEntitlement && effectiveValue) selectedEntitlement = entitlements.find((entitlement)=>entitlement.label.toLowerCase() === effectiveValue.toLowerCase()) || null;
    const updateSelectedEntitlement = (0, $bSJIT.useCallback)((option, notFromUserInteraction)=>{
        onChange === null || onChange === void 0 || onChange(props.id, (option === null || option === void 0 ? void 0 : option.value) || '', notFromUserInteraction);
    }, [
        props.id,
        onChange
    ]);
    const fetchEntitlements = (0, $bSJIT.useCallback)(async ()=>{
        if (!reporterId) return;
        setIsLoading(true);
        disableSubmitButton();
        try {
            var _data$customerService;
            const data = await (0, $a2qIF.fetchQuery)((0, $kbkME.getRelayEnvironment)(), $fd2044c94eabd130$export$fd42663b909f44cb, {
                cloudId: cloudId,
                accountId: reporterId
            }).toPromise();
            if ((data === null || data === void 0 ? void 0 : data.customerService.individualByAccountId.__typename) === 'QueryError') throw new Error(data.customerService.individualByAccountId.message ?? 'entitlementPickerQuery failed');
            if ((data === null || data === void 0 ? void 0 : data.customerService.individualByAccountId.__typename) !== 'CustomerServiceIndividual') throw new Error('entitlementPickerQuery failed');
            const entitlementList = (_data$customerService = data.customerService) === null || _data$customerService === void 0 || (_data$customerService = _data$customerService.individualByAccountId) === null || _data$customerService === void 0 ? void 0 : _data$customerService.entitlementList;
            const entitlementOptions = entitlementList.map((entitlement)=>({
                    label: entitlement.product.name,
                    value: (0, $3l191.getEntitlementIdFromAri)(entitlement.id)
                }));
            setEntitlements(entitlementOptions);
            createAnalyticsEvent({
                action: 'fetched',
                analyticsType: (0, $haAAx.TRACK_EVENT_TYPE),
                actionSubject: 'entitlements',
                numberOfEntitlements: entitlementOptions.length
            }).fire();
        } catch (e) {
            setEntitlements([]);
            setError(true);
            (0, $a6ENB.reportError)(e, {
                teamName: 'boysenberry',
                errorBoundaryId: 'EntitlementPickerMain',
                errorBoundaryPackageName: 'jsd-portal-frontend'
            });
            if ((0, $51XYw.isFetchNetworkOrClientError)(e)) (0, $aNnZt.entitlementPickerLoadExperience).abort();
            else (0, $aNnZt.entitlementPickerLoadExperience).failure();
        } finally{
            updateSelectedEntitlement(null, true);
            setIsLoading(false);
            enableSubmitButton();
        }
    }, [
        cloudId,
        createAnalyticsEvent,
        disableSubmitButton,
        enableSubmitButton,
        reporterId,
        updateSelectedEntitlement
    ]);
    const onNewReporter = (0, $bSJIT.useCallback)(()=>{
        setPrevReporterId(reporterId);
        setError(false);
        (0, $aNnZt.entitlementPickerLoadExperience).start();
    }, [
        reporterId
    ]);
    const onNoEntitlements = (0, $bSJIT.useCallback)(()=>{
        setEntitlements([]);
        updateSelectedEntitlement(null, true);
        (0, $aNnZt.entitlementPickerLoadExperience).success();
    }, [
        updateSelectedEntitlement
    ]);
    (0, $bSJIT.useEffect)(()=>{
        if (reporterId === prevReporterId) return;
        onNewReporter();
        // reporterId is '' if the reporter field has been cleared
        // reporterID is undefined if the user is anonymous
        if (isNewReporter || reporterId === '' || reporterId === undefined) {
            onNoEntitlements();
            return;
        }
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        fetchEntitlements();
    }, [
        cloudId,
        fetchEntitlements,
        isNewReporter,
        onNewReporter,
        onNoEntitlements,
        prevReporterId,
        reporterId,
        updateSelectedEntitlement
    ]);
    // When entitlements are loaded and defaultEntitlement is provided, select it.
    // When the rovo integration FG is enabled, only apply the default once so that
    // the user can clear the field without it being re-populated.
    (0, $bSJIT.useEffect)(()=>{
        const shouldApply = (0, $lFpPv.isJsmPortalRovoIntegrationEnabled)() ? !hasAppliedDefault : true;
        if (shouldApply && defaultEntitlement && entitlements.length > 0) {
            // Try to match by ID first, then by product name if no match
            const matchedEntitlement = entitlements.find((entitlement)=>entitlement.value === defaultEntitlement) || entitlements.find((entitlement)=>entitlement.label.toLowerCase() === defaultEntitlement.toLowerCase());
            if (matchedEntitlement) {
                updateSelectedEntitlement(matchedEntitlement, true);
                setHasAppliedDefault(true);
            }
        }
    }, [
        defaultEntitlement,
        entitlements,
        hasAppliedDefault,
        updateSelectedEntitlement
    ]);
    (0, $bSJIT.useEffect)(()=>{
        createAnalyticsEvent({
            action: 'viewed',
            analyticsType: (0, $haAAx.TRACK_EVENT_TYPE),
            actionSubject: 'entitlementPicker'
        }).fire();
    }, [
        createAnalyticsEvent
    ]);
    if (error) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $j2RlN.FieldBase), {
        label: fieldProps.label,
        htmlFor: "",
        required: fieldProps.required
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $gUpf2.Box), {
        xcss: $fd2044c94eabd130$var$ErrorMessageStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($hkLEY))), {
        spacing: "spacious",
        label: "",
        color: "var(--ds-icon-danger, #c9372c)"
    }), formatMessage((0, $9ivsr.default).errorMessage)));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $1fYfn.EntitlementPickerDumb), {
        ...fieldProps,
        onChange: updateSelectedEntitlement,
        isLoading: isLoading,
        selectedEntitlement: selectedEntitlement,
        entitlements: entitlements
    });
};
const $fd2044c94eabd130$var$EntitlementPickerWithErrorBoundary = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $fT4XN.default), {
        id: "entitlement-picker",
        packageName: "portal-fields"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement($fd2044c94eabd130$var$EntitlementPickerMain, props));
const $fd2044c94eabd130$var$selector = (0, $BOq7h.createSelector)(// if there is a reporter field in the form we use that value, otherwise we use the current user's account id
(state, props)=>props.reporterId === undefined ? (0, $aI0YR.getAccountId)(state) : props.reporterId, (reporterId)=>({
        reporterId: reporterId
    }));
const $fd2044c94eabd130$export$7c3ab7545fd6cd0d = (0, $egQxE.connect)($fd2044c94eabd130$var$selector)($fd2044c94eabd130$var$EntitlementPickerWithErrorBoundary);
const $fd2044c94eabd130$var$ErrorMessageStyles = (0, $9BVpB.xcss)({
    display: 'flex',
    alignItems: 'center',
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    lineHeight: '20px',
    gap: 'space.050',
    marginTop: 'space.100'
});

});
parcelRegister("aFluK", function(module, exports) {
$parcel$export(module.exports, "default", () => $4afbdfca557df16f$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<c6bb5fa6e478f4c6a8ce3a6d5efb67ff>>
 * @relayHash d648a72227e17e3ccc98e7fd2c57afbd
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID dda4ee455df530e7414799ed42e0fc926f0fd34bcd7f01eb987e038e2fe498f0
const $4afbdfca557df16f$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "accountId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v2 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        }
    ], v3 = [
        {
            "kind": "Variable",
            "name": "accountId",
            "variableName": "accountId"
        }
    ], v4 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v5 = {
        "kind": "ScalarField",
        "name": "id"
    }, v6 = {
        "kind": "ScalarField",
        "name": "name"
    }, v7 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "message"
            }
        ],
        "type": "QueryError"
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "entitlementPickerQuery",
            "selections": [
                {
                    "kind": "RequiredField",
                    "field": {
                        "args": v2 /*: any*/ ,
                        "concreteType": "CustomerServiceQueryApi",
                        "kind": "LinkedField",
                        "name": "customerService",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "RequiredField",
                                "field": {
                                    "args": v3 /*: any*/ ,
                                    "kind": "LinkedField",
                                    "name": "individualByAccountId",
                                    "plural": false,
                                    "selections": [
                                        v4 /*: any*/ ,
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                {
                                                    "kind": "RequiredField",
                                                    "field": v5 /*: any*/ ,
                                                    "action": "THROW"
                                                },
                                                {
                                                    "kind": "RequiredField",
                                                    "field": {
                                                        "concreteType": "CustomerServiceEntitlement",
                                                        "kind": "LinkedField",
                                                        "name": "entitlementList",
                                                        "plural": true,
                                                        "selections": [
                                                            v5 /*: any*/ ,
                                                            {
                                                                "concreteType": "CustomerServiceProduct",
                                                                "kind": "LinkedField",
                                                                "name": "product",
                                                                "plural": false,
                                                                "selections": [
                                                                    v6 /*: any*/ 
                                                                ]
                                                            }
                                                        ]
                                                    },
                                                    "action": "THROW"
                                                }
                                            ],
                                            "type": "CustomerServiceIndividual"
                                        },
                                        v7 /*: any*/ 
                                    ]
                                },
                                "action": "THROW"
                            }
                        ]
                    },
                    "action": "THROW"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v0 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "entitlementPickerQuery",
            "selections": [
                {
                    "args": v2 /*: any*/ ,
                    "concreteType": "CustomerServiceQueryApi",
                    "kind": "LinkedField",
                    "name": "customerService",
                    "plural": false,
                    "selections": [
                        {
                            "args": v3 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "individualByAccountId",
                            "plural": false,
                            "selections": [
                                v4 /*: any*/ ,
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        v5 /*: any*/ ,
                                        {
                                            "concreteType": "CustomerServiceEntitlement",
                                            "kind": "LinkedField",
                                            "name": "entitlementList",
                                            "plural": true,
                                            "selections": [
                                                v5 /*: any*/ ,
                                                {
                                                    "concreteType": "CustomerServiceProduct",
                                                    "kind": "LinkedField",
                                                    "name": "product",
                                                    "plural": false,
                                                    "selections": [
                                                        v6 /*: any*/ ,
                                                        v5 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        }
                                    ],
                                    "type": "CustomerServiceIndividual"
                                },
                                v7 /*: any*/ ,
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        v5 /*: any*/ 
                                    ],
                                    "type": "Node",
                                    "abstractKey": "__isNode"
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "dda4ee455df530e7414799ed42e0fc926f0fd34bcd7f01eb987e038e2fe498f0",
            "metadata": {},
            "name": "entitlementPickerQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$4afbdfca557df16f$var$node.hash = "baacf070b69f09d660710a825f4cc406";
var $4afbdfca557df16f$export$2e2bcd8739ae039 = $4afbdfca557df16f$var$node;

});

parcelRegister("3l191", function(module, exports) {
$parcel$export(module.exports, "getEntitlementIdFromAri", () => $9fda4cac388f9b83$export$c84c5e2c8353ae63);
// eslint-disable-next-line no-restricted-imports

var $8blKe = parcelRequire("8blKe");
const $9fda4cac388f9b83$export$c84c5e2c8353ae63 = (maybeAri)=>(0, $8blKe.JiraEntitlementAri).check(maybeAri) ? (0, $8blKe.JiraEntitlementAri).parse(maybeAri).entitlementId : maybeAri;

});
parcelRegister("8blKe", function(module, exports) {
$parcel$export(module.exports, "JiraEntitlementAri", () => $5f5037d93aafeca0$export$2663fadb24b282b4);

var $5v8Nv = parcelRequire("5v8Nv");

var $25Thw = parcelRequire("25Thw");

var $hxkLB = parcelRequire("hxkLB");
// src/jira/entitlement/manifest.ts
var $5f5037d93aafeca0$var$jiraEntitlementAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^[a-zA-Z0-9_\\-.]{1,255}$"),
    resourceOwner: (0, $5v8Nv.JiraEntitlementAriResourceOwner),
    resourceType: (0, $5v8Nv.JiraEntitlementAriResourceType),
    resourceIdSlug: "activation/{activationId}/{entitlementId}",
    resourceIdSegmentFormats: {
        activationId: /[a-zA-Z0-9\-]+/,
        // eslint-disable-line no-useless-escape
        entitlementId: /[0-9a-f]{8}-[0-9a-f]{4}-[0-5][0-9a-f]{3}-[089ab][0-9a-f]{3}-[0-9a-f]{12}/
    }
};
// src/jira/entitlement/index.ts
var $5f5037d93aafeca0$export$2663fadb24b282b4 = class _JiraEntitlementAri extends (0, $25Thw.RegisteredAri) {
    constructor(opts){
        super(opts), this._siteId = opts.cloudId || "", this._activationId = opts.resourceIdSegmentValues.activationId, this._entitlementId = opts.resourceIdSegmentValues.entitlementId;
    }
    get siteId() {
        return this._siteId;
    }
    get activationId() {
        return this._activationId;
    }
    get entitlementId() {
        return this._entitlementId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $5f5037d93aafeca0$var$jiraEntitlementAriStaticOpts.qualifier,
            platformQualifier: $5f5037d93aafeca0$var$jiraEntitlementAriStaticOpts.platformQualifier,
            cloudId: opts.siteId,
            resourceOwner: $5f5037d93aafeca0$var$jiraEntitlementAriStaticOpts.resourceOwner,
            resourceType: $5f5037d93aafeca0$var$jiraEntitlementAriStaticOpts.resourceType,
            resourceId: `activation/${opts.activationId}/${opts.entitlementId}`,
            resourceIdSegmentValues: {
                activationId: opts.activationId,
                entitlementId: opts.entitlementId
            }
        }, ariOpts = (0, $hxkLB.AriParser).fromOpts(derivedOpts, $5f5037d93aafeca0$var$jiraEntitlementAriStaticOpts);
        return new _JiraEntitlementAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $hxkLB.AriParser).fromString(maybeAri, $5f5037d93aafeca0$var$jiraEntitlementAriStaticOpts);
        return new _JiraEntitlementAri(opts);
    }
    getVariables() {
        return {
            siteId: this.siteId,
            activationId: this.activationId,
            entitlementId: this.entitlementId
        };
    }
};

});
parcelRegister("5v8Nv", function(module, exports) {
$parcel$export(module.exports, "JiraEntitlementAriResourceOwner", () => $4016ac01da55f8a3$export$b4b09eb5bbd0ddca);
$parcel$export(module.exports, "JiraEntitlementAriResourceType", () => $4016ac01da55f8a3$export$6126bfb6bbd3718);
// src/jira/entitlement/types.ts
var $4016ac01da55f8a3$export$b4b09eb5bbd0ddca = "jira", $4016ac01da55f8a3$export$6126bfb6bbd3718 = "entitlement";

});



parcelRegister("kszEL", function(module, exports) {
$parcel$export(module.exports, "EntitlementPickerDumb", () => (parcelRequire("1fYfn")).EntitlementPickerDumb);

var $1fYfn = parcelRequire("1fYfn");

});
parcelRegister("1fYfn", function(module, exports) {
$parcel$export(module.exports, "EntitlementPickerDumb", () => $fe92afff9085c5af$export$2e3c94441e79ffd);

var $bSJIT = parcelRequire("bSJIT");

var $1zYnp = parcelRequire("1zYnp");

var $fEl82 = parcelRequire("fEl82");

var $gUpf2 = parcelRequire("gUpf2");

var $9BVpB = parcelRequire("9BVpB");

var $f6Ax9 = parcelRequire("f6Ax9");

var $aNnZt = parcelRequire("aNnZt");
const $fe92afff9085c5af$var$renderOption = (option)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $gUpf2.Box), {
        xcss: $fe92afff9085c5af$var$optionStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $gUpf2.Box), {
        xcss: $fe92afff9085c5af$var$iconContainerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fEl82))), {
        label: ""
    })), option.label);
const $fe92afff9085c5af$export$2e3c94441e79ffd = (props)=>{
    const { isLoading: isLoading, entitlements: entitlements, selectedEntitlement: selectedEntitlement, ...fieldProps } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).Fragment, null, !isLoading && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $f6Ax9.ExperienceSuccess), {
        experience: (0, $aNnZt.entitlementPickerLoadExperience)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $1zYnp.FieldSingleSelect), {
        ...fieldProps,
        actionSubjectId: "entitlementPicker",
        value: selectedEntitlement,
        options: entitlements,
        formatOptionLabel: $fe92afff9085c5af$var$renderOption,
        isDisabled: isLoading || props.disabled,
        isLoading: isLoading,
        isClearable: true
    }));
};
const $fe92afff9085c5af$var$optionStyles = (0, $9BVpB.xcss)({
    display: 'flex',
    alignItems: 'center',
    gap: 'space.100'
});
const $fe92afff9085c5af$var$iconContainerStyles = (0, $9BVpB.xcss)({
    backgroundColor: 'color.background.neutral',
    borderRadius: 'radius.xsmall',
    padding: 'space.025'
});

});
parcelRegister("aNnZt", function(module, exports) {
$parcel$export(module.exports, "entitlementPickerLoadExperience", () => $60452b92a49f0395$export$b2d10adb02fdf78b);

var $eAZuG = parcelRequire("eAZuG");

var $7r7ey = parcelRequire("7r7ey");
var $1we90 = parcelRequire("1we90");
const $60452b92a49f0395$export$b2d10adb02fdf78b = new (0, $1we90.UFOExperience)((0, $eAZuG.requestCreateEntitlementPickerExperienceId), {
    type: (0, $7r7ey.ExperienceTypes).Experience,
    performanceType: (0, $7r7ey.ExperiencePerformanceTypes).InlineResult
});

});



parcelRegister("9ivsr", function(module, exports) {
$parcel$export(module.exports, "default", () => $b259f20d590aa651$export$2e2bcd8739ae039);

var $f0Pt4 = parcelRequire("f0Pt4");
var $b259f20d590aa651$export$2e2bcd8739ae039 = (0, $f0Pt4.defineMessages)({
    errorMessage: {
        defaultMessage: "We couldn't load this field. Refresh the page to try again.",
        description: 'Error message shown when entitlements fail to be fetched',
        id: 'cv.request.create.form.entitlement-picker.error-message'
    }
});

});



parcelRegister("esufH", function(module, exports) {
$parcel$export(module.exports, "ForgeField", () => (parcelRequire("2KfHs")).ForgeField);

var $2KfHs = parcelRequire("2KfHs");

});
parcelRegister("2KfHs", function(module, exports) {
$parcel$export(module.exports, "ForgeField", () => $a0d11eb300846ebe$export$34a15d6027142c62);

var $bSJIT = parcelRequire("bSJIT");

var $egQxE = parcelRequire("egQxE");

var $iofuG = parcelRequire("iofuG");

var $fT4XN = parcelRequire("fT4XN");

var $lFpPv = parcelRequire("lFpPv");

var $xb2jO = parcelRequire("xb2jO");

var $gYq50 = parcelRequire("gYq50");

var $i7phc = parcelRequire("i7phc");

var $fuVmc = parcelRequire("fuVmc");

var $4vLTk = parcelRequire("4vLTk");

var $9WNwm = parcelRequire("9WNwm");

var $ay2XP = parcelRequire("ay2XP");

var $cKOyj = parcelRequire("cKOyj");

var $j2RlN = parcelRequire("j2RlN");

var $ls7vK = parcelRequire("ls7vK");
parcelRequire("23pr9");
var $bij3D = parcelRequire("bij3D");
parcelRequire("dqGn5");
var $iCzk3 = parcelRequire("iCzk3");

var $4yyQi = parcelRequire("4yyQi");

var $jGRkm = parcelRequire("jGRkm");

var $kMn38 = parcelRequire("kMn38");

var $5Zf8N = parcelRequire("5Zf8N");

var $k65BD = parcelRequire("k65BD");
parcelRequire("iAH6T");
var $jWq4h = parcelRequire("jWq4h");
parcelRequire("d8ukk");
var $7aMQB = parcelRequire("7aMQB");
parcelRequire("CY3b1");
var $g5MKj = parcelRequire("g5MKj");

var $8WVYa = parcelRequire("8WVYa");

var $1bNoZ = parcelRequire("1bNoZ");

var $arUjg = parcelRequire("arUjg");
const $a0d11eb300846ebe$var$PORTAL_REQUEST_ANALYTICS_ATTRIBUTES = {
    source: (0, $kMn38.SOURCES).PORTAL_REQUEST,
    renderContext: (0, $kMn38.RENDER_CONTEXTS).PORTAL_REQUEST,
    experience: (0, $kMn38.EXPERIENCES).PORTAL_REQUEST
};
const $a0d11eb300846ebe$var$ForgeFieldWithExtension = ({ id: id, value: value, extension: extension, requestTypeId: requestTypeId, portalId: portalId, projectId: projectId, issueType: issueType, issueTypeId: issueTypeId, disabled: disabled, loadingComponent: loadingComponent, isVisible: isVisible, onChange: onChange })=>{
    const extensionData = (0, $bSJIT.useMemo)(()=>({
            fieldType: extension.id,
            fieldId: id,
            type: extension.type,
            portal: {
                id: portalId
            },
            request: {
                typeId: requestTypeId
            },
            renderContext: (0, $kMn38.RENDER_CONTEXTS).PORTAL_REQUEST,
            experience: (0, $kMn38.EXPERIENCES).PORTAL_REQUEST,
            entryPoint: 'edit',
            project: {
                id: projectId,
                type: 'service_desk'
            },
            issue: {
                type: issueType,
                typeId: issueTypeId
            }
        }), [
        extension.id,
        extension.type,
        id,
        portalId,
        requestTypeId,
        projectId,
        issueType,
        issueTypeId
    ]);
    const extensionPayload = (0, $bSJIT.useMemo)(()=>({
            fieldValue: value
        }), [
        value
    ]);
    const onSubmit = (0, $bSJIT.useCallback)((fieldValue)=>onChange(extensionData.fieldId, (0, $arUjg.transformValue)(fieldValue, extension), true), [
        extensionData.fieldId,
        extension,
        onChange
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $g5MKj.FieldState), {
        isDisabled: disabled,
        isVisible: isVisible
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $iCzk3.ForgeCustomFieldEdit), {
        extension: extension,
        extensionData: extensionData,
        extensionPayload: extensionPayload,
        loadingComponent: loadingComponent,
        onSubmit: onSubmit,
        analyticsAttributes: $a0d11eb300846ebe$var$PORTAL_REQUEST_ANALYTICS_ATTRIBUTES
    }));
};
const $a0d11eb300846ebe$var$onInitializationFinished = (0, $5Zf8N.createInitializationFinished)((0, $kMn38.SOURCES).PORTAL_REQUEST, true);
const $a0d11eb300846ebe$var$onInitializationFailed = (0, $5Zf8N.createInitializationFailed)((0, $kMn38.SOURCES).PORTAL_REQUEST, true);
const $a0d11eb300846ebe$var$ForgeFieldImplOld = (props)=>{
    const { disableSubmitButton: disableSubmitButton, enableSubmitButton: enableSubmitButton, fallbackRender: fallbackRender, jiraFieldType: jiraFieldType, id: id, analyticsAttributes: analyticsAttributes } = props;
    const [isRendered, setIsRendered] = (0, $bSJIT.useState)(false);
    const accountType = (0, $fuVmc.getMetaFromHTML)('ajs-account-type') || (0, $gYq50.AtlassianHelpConfigAccountType).ANONYMOUS;
    const hasAccess = accountType === (0, $gYq50.AtlassianHelpConfigAccountType).ATLASSIAN;
    const [fieldState] = (0, $ls7vK.useInlineField)(id);
    const { formatMessage: formatMessage } = (0, $4vLTk.default)();
    const fireScreenEventOnce = (0, $bSJIT.useMemo)(()=>(0, (/*@__PURE__*/$parcel$interopDefault($iofuG)))((0, $jGRkm.fireScreenEvent)), []);
    const fireNotFoundOnce = (0, $bSJIT.useMemo)(()=>(0, (/*@__PURE__*/$parcel$interopDefault($iofuG)))((0, $jGRkm.fireOperationalEvent)), []);
    const showNotFoundFlagOnce = (0, $bSJIT.useMemo)(()=>(0, (/*@__PURE__*/$parcel$interopDefault($iofuG)))(props.showErrorFlag), [
        props.showErrorFlag
    ]);
    const useExtensionsConfig = (0, $bSJIT.useMemo)(()=>({
            onInitializationFinished: $a0d11eb300846ebe$var$onInitializationFinished,
            onInitializationFailed: $a0d11eb300846ebe$var$onInitializationFailed,
            types: [
                (0, $i7phc.CUSTOM_FIELD),
                (0, $i7phc.CUSTOM_FIELD_TYPE)
            ],
            context: {
                portalId: String(props.portalId),
                requestTypeId: String(props.requestTypeId)
            },
            includeHidden: true,
            shouldFetch: hasAccess
        }), [
        hasAccess,
        props.portalId,
        props.requestTypeId
    ]);
    const { extensions: extensions, isLoading: isLoading, error: error } = (0, $jWq4h.useExtensions)(useExtensionsConfig);
    const onRendered = (0, $bSJIT.useCallback)(()=>{
        setIsRendered(true);
        // oxlint-disable-next-line no-void
        fireScreenEventOnce({
            attributes: {
                ...analyticsAttributes,
                entryPoint: 'edit'
            },
            id: 'customFieldEditScreen',
            source: (0, $kMn38.SOURCES).PORTAL_REQUEST
        });
    }, [
        analyticsAttributes,
        fireScreenEventOnce
    ]);
    (0, $bSJIT.useEffect)(()=>{
        isLoading ? disableSubmitButton === null || disableSubmitButton === void 0 || disableSubmitButton() : enableSubmitButton === null || enableSubmitButton === void 0 || enableSubmitButton();
    }, [
        isLoading,
        disableSubmitButton,
        enableSubmitButton
    ]);
    const extension = (0, $bSJIT.useMemo)(()=>{
        const extensionId = (0, $4yyQi.isForgeLegacyFieldType)(jiraFieldType || '') ? (0, $4yyQi.getExtensionIdFromLegacyFieldType)(jiraFieldType || '') : jiraFieldType;
        return extensions.find((field)=>field.id === extensionId);
    }, [
        extensions,
        jiraFieldType
    ]);
    // We are going to pass to the list only the extension that is found.
    // This is to avoid showing the banner for the extensions that are not added to the experience but still installed on the tenant.
    const extensionsToCheck = (0, $bSJIT.useMemo)(()=>extension ? [
            extension
        ] : [], [
        extension
    ]);
    (0, $cKOyj.default)(extensionsToCheck, (0, $i7phc.FORGE_REQUEST_CREATE), hasAccess, props.showBanner, props.resetBannerState);
    const shouldFallBackToNativeRendering = (0, $bSJIT.useMemo)(()=>{
        var _extension$properties, _extension$properties2;
        // Too early to tell, just assume we have a custom renderer
        if (!extension) return false;
        // There is no resource, so it's not a custom renderer
        if (typeof ((_extension$properties = extension.properties.edit) === null || _extension$properties === void 0 ? void 0 : _extension$properties.resource) !== 'string') return true;
        // There must be a correct experience defined, otherwise we'd need to fallback to the native rendering
        const isValidExperience = (_extension$properties2 = extension.properties.edit) === null || _extension$properties2 === void 0 || (_extension$properties2 = _extension$properties2.experience) === null || _extension$properties2 === void 0 ? void 0 : _extension$properties2.includes((0, $kMn38.EXPERIENCES).PORTAL_REQUEST);
        return !isValidExperience;
    }, [
        extension
    ]);
    const preferredFieldNode = (0, $bSJIT.useMemo)(()=>{
        if (shouldFallBackToNativeRendering && extension) return fallbackRender((0, $arUjg.getMappedFieldType)(extension));
        return null;
    }, [
        extension,
        fallbackRender,
        shouldFallBackToNativeRendering
    ]);
    const fieldBaseProps = (0, $bSJIT.useMemo)(()=>({
            label: extension ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $bij3D.ExtensionTitle), {
                extensionName: props.label,
                extensionEnvType: extension.environmentType,
                extensionEnvKey: extension.environmentKey
            }) : props.label,
            htmlFor: props.id,
            required: props.required,
            description: props.description,
            labelId: `${props.id}-label`
        }), [
        props.description,
        props.id,
        props.label,
        props.required,
        extension
    ]);
    const mergedErrorMessages = (0, $bSJIT.useMemo)(()=>[
            (fieldState === null || fieldState === void 0 ? void 0 : fieldState.status) === (0, $k65BD.FIELD_STATE_FAILED) && formatMessage((0, $8WVYa.default).errorMessage),
            props.errorMessage
        ].filter(Boolean), [
        fieldState === null || fieldState === void 0 ? void 0 : fieldState.status,
        props.errorMessage,
        formatMessage
    ]);
    const isHidden = typeof (extension === null || extension === void 0 ? void 0 : extension.hiddenBy) === 'string';
    if (!hasAccess || isHidden || error) return null;
    if (!extension && !isLoading) {
        // oxlint-disable-next-line no-void
        fireNotFoundOnce((0, $kMn38.OPERATIONAL_ACTIONS).FAILED, {
            attributes: {
                ...analyticsAttributes,
                entryPoint: 'edit',
                reason: 'notFound',
                required: props.required
            },
            id: 'customFieldEdit',
            source: (0, $kMn38.SOURCES).PORTAL_REQUEST
        });
        if (props.required) showNotFoundFlagOnce((0, $8WVYa.default).notFoundRequiredFieldTitle, (0, $8WVYa.default).notFoundRequiredFieldDescription, [], undefined, {
            fieldName: props.label
        });
        return null;
    }
    if (preferredFieldNode) return preferredFieldNode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $j2RlN.FieldBase), {
        ...fieldBaseProps,
        errorMessage: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $7aMQB.ErrorMessage), {
            errorMessages: mergedErrorMessages
        })
    }, isLoading || !isRendered ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $1bNoZ.Skeleton), null) : null, extension && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement($a0d11eb300846ebe$var$ForgeFieldWithExtension, {
        ...props,
        extension: extension,
        loadingComponent: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $1bNoZ.Skeleton), {
            onUnmount: onRendered
        }),
        isVisible: isRendered
    }));
};
const $a0d11eb300846ebe$var$ForgeFieldImplNew = (props)=>{
    const { extension: extension, fallbackRender: fallbackRender, id: id, analyticsAttributes: analyticsAttributes } = props;
    const [isRendered, setIsRendered] = (0, $bSJIT.useState)(false);
    const [fieldState] = (0, $ls7vK.useInlineField)(id);
    const { formatMessage: formatMessage } = (0, $4vLTk.default)();
    const fireScreenEventOnce = (0, $bSJIT.useMemo)(()=>(0, (/*@__PURE__*/$parcel$interopDefault($iofuG)))((0, $jGRkm.fireScreenEvent)), []);
    const fireNotFoundOnce = (0, $bSJIT.useMemo)(()=>(0, (/*@__PURE__*/$parcel$interopDefault($iofuG)))((0, $jGRkm.fireOperationalEvent)), []);
    const showNotFoundFlagOnce = (0, $bSJIT.useMemo)(()=>(0, (/*@__PURE__*/$parcel$interopDefault($iofuG)))(props.showErrorFlag), [
        props.showErrorFlag
    ]);
    const onRendered = (0, $bSJIT.useCallback)(()=>{
        setIsRendered(true);
        // oxlint-disable-next-line no-void
        fireScreenEventOnce({
            attributes: {
                ...analyticsAttributes,
                entryPoint: 'edit'
            },
            id: 'customFieldEditScreen',
            source: (0, $kMn38.SOURCES).PORTAL_REQUEST
        });
    }, [
        analyticsAttributes,
        fireScreenEventOnce
    ]);
    // Transforming the extension to the old format which is used in the blocked apps banner
    const extensionsToCheck = (0, $bSJIT.useMemo)(()=>extension ? [
            {
                ...extension,
                dataClassificationPolicyDecision: {
                    status: extension.hiddenBy === 'AppAccessRules' ? 'BLOCKED' : 'ALLOWED'
                }
            }
        ] : [], [
        extension
    ]);
    (0, $cKOyj.default)(extensionsToCheck, (0, $i7phc.FORGE_REQUEST_CREATE), true, props.showBanner, props.resetBannerState);
    const shouldFallBackToNativeRendering = (0, $bSJIT.useMemo)(()=>{
        var _extension$properties3, _extension$properties4;
        // No way to determine, so falling back to native rendering
        if (!extension) return false;
        // There is no resource, so it's not a custom renderer
        if (typeof ((_extension$properties3 = extension.properties.edit) === null || _extension$properties3 === void 0 ? void 0 : _extension$properties3.resource) !== 'string') return true;
        // There must be a correct experience defined, otherwise we'd need to fallback to the native rendering
        const isValidExperience = (_extension$properties4 = extension.properties.edit) === null || _extension$properties4 === void 0 || (_extension$properties4 = _extension$properties4.experience) === null || _extension$properties4 === void 0 ? void 0 : _extension$properties4.includes((0, $kMn38.EXPERIENCES).PORTAL_REQUEST);
        return !isValidExperience;
    }, [
        extension
    ]);
    const preferredFieldNode = (0, $bSJIT.useMemo)(()=>{
        if (shouldFallBackToNativeRendering && extension) return fallbackRender((0, $arUjg.getMappedFieldType)(extension));
        return null;
    }, [
        extension,
        fallbackRender,
        shouldFallBackToNativeRendering
    ]);
    const fieldBaseProps = (0, $bSJIT.useMemo)(()=>({
            label: extension ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $bij3D.ExtensionTitle), {
                extensionName: props.label,
                extensionEnvType: extension.environmentType,
                extensionEnvKey: extension.environmentKey
            }) : props.label,
            htmlFor: props.id,
            required: props.required,
            description: props.description,
            labelId: `${props.id}-label`
        }), [
        props.description,
        props.id,
        props.label,
        props.required,
        extension
    ]);
    const mergedErrorMessages = (0, $bSJIT.useMemo)(()=>[
            (fieldState === null || fieldState === void 0 ? void 0 : fieldState.status) === (0, $k65BD.FIELD_STATE_FAILED) && formatMessage((0, $8WVYa.default).errorMessage),
            props.errorMessage
        ].filter(Boolean), [
        fieldState === null || fieldState === void 0 ? void 0 : fieldState.status,
        props.errorMessage,
        formatMessage
    ]);
    const errorMessageContent = (0, $bSJIT.useMemo)(()=>mergedErrorMessages && mergedErrorMessages.length > 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $7aMQB.ErrorMessage), {
            errorMessages: mergedErrorMessages
        }) : undefined, [
        mergedErrorMessages
    ]);
    if (!extension) {
        // oxlint-disable-next-line no-void
        fireNotFoundOnce((0, $kMn38.OPERATIONAL_ACTIONS).FAILED, {
            attributes: {
                ...analyticsAttributes,
                entryPoint: 'edit',
                reason: 'notFound',
                required: props.required
            },
            id: 'customFieldEdit',
            source: (0, $kMn38.SOURCES).PORTAL_REQUEST
        });
        if (props.required) showNotFoundFlagOnce((0, $8WVYa.default).notFoundRequiredFieldTitle, (0, $8WVYa.default).notFoundRequiredFieldDescription, [], undefined, {
            fieldName: props.label
        });
        return null;
    }
    const isHidden = typeof (extension === null || extension === void 0 ? void 0 : extension.hiddenBy) === 'string';
    if (isHidden) return null;
    if (preferredFieldNode) return preferredFieldNode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $j2RlN.FieldBase), {
        ...fieldBaseProps,
        errorMessage: errorMessageContent
    }, !isRendered ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $1bNoZ.Skeleton), null) : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement($a0d11eb300846ebe$var$ForgeFieldWithExtension, {
        ...props,
        extension: extension,
        loadingComponent: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $1bNoZ.Skeleton), {
            onUnmount: onRendered
        }),
        isVisible: isRendered
    }));
};
const $a0d11eb300846ebe$var$ForgeFieldImpl = (props)=>{
    if ((0, $lFpPv.isForgeCustomFieldsOnPortalViewEnabled)()) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement($a0d11eb300846ebe$var$ForgeFieldImplNew, props);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement($a0d11eb300846ebe$var$ForgeFieldImplOld, props);
};
const $a0d11eb300846ebe$export$ecd216b89a458857 = (props)=>{
    const id = 'customFieldEdit';
    const rawAttributes = (0, $bSJIT.useMemo)(()=>({
            source: (0, $kMn38.SOURCES).PORTAL_REQUEST,
            renderContext: (0, $kMn38.RENDER_CONTEXTS).PORTAL_REQUEST,
            experience: (0, $kMn38.EXPERIENCES).PORTAL_REQUEST
        }), []);
    const analyticsAttributes = (0, $bSJIT.useMemo)(()=>(0, $jGRkm.createAttributes)(rawAttributes), [
        rawAttributes
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $fT4XN.default), {
        id: id,
        packageName: (0, $kMn38.PACKAGE_NAME_GASV3),
        analyticsAttributes: analyticsAttributes
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement($a0d11eb300846ebe$var$ForgeFieldImpl, {
        ...props,
        analyticsAttributes: rawAttributes
    }));
};
const $a0d11eb300846ebe$var$mapDispatchToProps = (dispatch)=>{
    return {
        ...(0, $9WNwm.mapDispatchToPropsBanner)(dispatch),
        showErrorFlag: (...args)=>dispatch((0, $xb2jO.showErrorFlag)(...args))
    };
};
const $a0d11eb300846ebe$export$34a15d6027142c62 = (0, $egQxE.connect)((state, ownProps)=>{
    return {
        issueType: (0, $ay2XP.getIssueType)(state, ownProps.portalId, ownProps.requestTypeId),
        issueTypeId: (0, $ay2XP.getIssueTypeId)(state, ownProps.portalId, ownProps.requestTypeId)
    };
}, $a0d11eb300846ebe$var$mapDispatchToProps)($a0d11eb300846ebe$export$ecd216b89a458857);

});
parcelRegister("cKOyj", function(module, exports) {
$parcel$export(module.exports, "default", () => $6f69e3df21a62c7d$export$2e2bcd8739ae039);

var $bSJIT = parcelRequire("bSJIT");

var $gYq50 = parcelRequire("gYq50");
const $6f69e3df21a62c7d$var$useShowBannerHook = (// TODO: Fix the issue with the extensions being undefined https://hello.jira.atlassian.cloud/browse/PORTAL-5931
extensions = [], page, shouldCallBanner, showBanner, resetBannerState)=>{
    const wasShowBannerCalled = (0, $bSJIT.useRef)(false);
    const allowedExtensions = (0, $bSJIT.useMemo)(()=>{
        if (!(extensions !== null && extensions !== void 0 && extensions.length)) return [];
        return extensions.filter((extension)=>{
            var _extension$dataClassi;
            return (extension === null || extension === void 0 || (_extension$dataClassi = extension.dataClassificationPolicyDecision) === null || _extension$dataClassi === void 0 ? void 0 : _extension$dataClassi.status) !== (0, $gYq50.BLOCKED);
        });
    }, [
        extensions
    ]);
    (0, $bSJIT.useEffect)(()=>{
        if (shouldCallBanner && (allowedExtensions === null || allowedExtensions === void 0 ? void 0 : allowedExtensions.length) !== (extensions === null || extensions === void 0 ? void 0 : extensions.length) && showBanner) {
            showBanner(page);
            wasShowBannerCalled.current = true;
        }
    // oxlint-disable-next-line react-hooks/exhaustive-deps
    }, [
        allowedExtensions
    ]);
    (0, $bSJIT.useEffect)(()=>{
        return ()=>{
            if (wasShowBannerCalled.current && resetBannerState) resetBannerState(page);
        };
    // Not adding all deps here since we only want to run this cleanup upon unmount and also when allowedExtensions change
    // oxlint-disable-next-line react-hooks/exhaustive-deps
    }, [
        allowedExtensions
    ]);
    return allowedExtensions;
};
var $6f69e3df21a62c7d$export$2e2bcd8739ae039 = $6f69e3df21a62c7d$var$useShowBannerHook;

});

parcelRegister("23pr9", function(module, exports) {
$parcel$export(module.exports, "ExtensionTitle", () => (parcelRequire("bij3D")).ExtensionTitle);

var $bij3D = parcelRequire("bij3D");

});
parcelRegister("bij3D", function(module, exports) {
$parcel$export(module.exports, "ExtensionTitle", () => $b7d4fa0b6558adfe$export$3aa4a75e461c581c);

var $bSJIT = parcelRequire("bSJIT");

var $5cKiX = parcelRequire("5cKiX");

var $cExzV = parcelRequire("cExzV");

var $gUpf2 = parcelRequire("gUpf2");

var $9BVpB = parcelRequire("9BVpB");

var $kzspF = parcelRequire("kzspF");
const $b7d4fa0b6558adfe$export$9af0088c49bdedb = 'PRODUCTION';
const $b7d4fa0b6558adfe$export$71acbd662c478c42 = 'STAGING';
const $b7d4fa0b6558adfe$export$978072fd3fd149 = 'DEVELOPMENT';
const $b7d4fa0b6558adfe$export$ebc15d9cebfd6063 = 'default';
const $b7d4fa0b6558adfe$export$3aa4a75e461c581c = ({ extensionEnvType: extensionEnvType, extensionEnvKey: extensionEnvKey, extensionName: extensionName })=>{
    if (!$b7d4fa0b6558adfe$var$shouldShowEnv(extensionEnvType)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).Fragment, null, extensionName);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $gUpf2.Box), {
        xcss: $b7d4fa0b6558adfe$var$wrapperStyles,
        as: "span"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).Fragment, null, $b7d4fa0b6558adfe$var$nameWithCustomEnvironment(extensionName, extensionEnvType, extensionEnvKey), " "), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement($b7d4fa0b6558adfe$export$278f8e01799d0418, {
        environmentType: extensionEnvType
    }));
};
const $b7d4fa0b6558adfe$export$278f8e01799d0418 = (props)=>{
    const { environmentType: environmentType } = props;
    const labelKey = $b7d4fa0b6558adfe$var$getEnvironmentTranslationKey(environmentType);
    return labelKey ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $cExzV.default), {
        appearance: environmentType === $b7d4fa0b6558adfe$export$978072fd3fd149 ? 'default' : 'moved'
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $5cKiX.default), labelKey)) : null;
};
const $b7d4fa0b6558adfe$var$shouldShowEnv = (extensionEnvType)=>[
        $b7d4fa0b6558adfe$export$71acbd662c478c42,
        $b7d4fa0b6558adfe$export$978072fd3fd149
    ].includes(extensionEnvType);
const $b7d4fa0b6558adfe$var$getEnvironmentTranslationKey = (environmentType)=>{
    switch(environmentType){
        case $b7d4fa0b6558adfe$export$978072fd3fd149:
            return (0, $kzspF.messages).developmentEnvironmentLozenge;
        case $b7d4fa0b6558adfe$export$71acbd662c478c42:
            return (0, $kzspF.messages).stagingEnvironmentLozenge;
        default:
            return null;
    }
};
const $b7d4fa0b6558adfe$var$nameWithCustomEnvironment = (name, environmentType, environmentKey)=>{
    if (environmentType === $b7d4fa0b6558adfe$export$978072fd3fd149 && environmentKey && environmentKey !== $b7d4fa0b6558adfe$export$ebc15d9cebfd6063) return `${name} - ${environmentKey}`;
    return name;
};
const $b7d4fa0b6558adfe$var$wrapperStyles = (0, $9BVpB.xcss)({
    alignItems: 'baseline'
});

});
parcelRegister("kzspF", function(module, exports) {
$parcel$export(module.exports, "messages", () => $c614e3c72841d7ee$export$defe85febe8b728c);

var $f0Pt4 = parcelRequire("f0Pt4");
const $c614e3c72841d7ee$export$defe85febe8b728c = (0, $f0Pt4.defineMessages)({
    developmentEnvironmentLozenge: {
        id: 'forge-ui-extension-title.environment-lozenge.development-environment-lozenge',
        defaultMessage: 'DEV',
        description: 'Navigation item lozenge label for forge apps on development environment'
    },
    stagingEnvironmentLozenge: {
        id: 'forge-ui-extension-title.environment-lozenge.staging-environment-lozenge',
        defaultMessage: 'STG',
        description: 'Navigation item lozenge label for forge apps on staging environment'
    }
});

});



parcelRegister("dqGn5", function(module, exports) {
$parcel$export(module.exports, "ForgeCustomFieldEdit", () => (parcelRequire("iCzk3")).ForgeCustomFieldEdit);
$parcel$export(module.exports, "ForgeCustomFieldView", () => (parcelRequire("iSUBM")).ForgeCustomFieldView);

var $iCzk3 = parcelRequire("iCzk3");
parcelRequire("9meO4");
var $iSUBM = parcelRequire("iSUBM");

});
parcelRegister("9meO4", function(module, exports) {
$parcel$export(module.exports, "ForgeCustomFieldView", () => (parcelRequire("iSUBM")).ForgeCustomFieldView);

var $iSUBM = parcelRequire("iSUBM");

});
parcelRegister("iSUBM", function(module, exports) {
$parcel$export(module.exports, "ForgeCustomFieldView", () => $cff3735f6eaf2c55$export$4edba301650506c5);

var $bSJIT = parcelRequire("bSJIT");

var $gYq50 = parcelRequire("gYq50");

var $fKuli = parcelRequire("fKuli");

var $7UzY5 = parcelRequire("7UzY5");

var $5TkOb = parcelRequire("5TkOb");

var $4vLTk = parcelRequire("4vLTk");

var $buKRr = parcelRequire("buKRr");

var $fNlrJ = parcelRequire("fNlrJ");
const $cff3735f6eaf2c55$export$4edba301650506c5 = ({ extension: extension, extensionData: extensionData, extensionPayload: extensionPayload, loadingComponent: loadingComponent, contextTokenType: contextTokenType = (0, $gYq50.ContextTokenType).JIRA })=>{
    const { formatMessage: formatMessage } = (0, $4vLTk.default)();
    const getComponents = (0, $bSJIT.useCallback)((defaults)=>{
        return {
            ...defaults,
            Frame: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $buKRr.default), {
                    title: formatMessage((0, $fNlrJ.default).unsupportedFrameComponentTitle),
                    appearance: "error"
                }, formatMessage((0, $fNlrJ.default).unsupportedFrameComponentDescription))
        };
    }, [
        formatMessage
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $fKuli.ExtensionPointProvider), {
        extensionType: extension.type
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $7UzY5.ExtensionProvider), {
        extension: extension
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $5TkOb.Renderer), {
        extension: extension,
        extensionData: extensionData,
        extensionPayload: extensionPayload,
        entryPoint: "view",
        loadingComponent: loadingComponent,
        contextTokenType: contextTokenType,
        getComponents: getComponents
    })));
};

});
parcelRegister("7UzY5", function(module, exports) {
$parcel$export(module.exports, "ExtensionProvider", () => $17cc64775115709b$export$c6ef18cd2d1a61a0);

var $cVM5r = parcelRequire("cVM5r");

var $cJJTb = parcelRequire("cJJTb");

const $17cc64775115709b$export$c6ef18cd2d1a61a0 = (0, $cVM5r.default)({
    loader: (0, $cJJTb.lazyForPaint)(()=>(parcelRequire("1OlFr")), {
        moduleId: "./packages/common-utils/forge-ui-utils/src/extension-provider/extension-provider.tsx"
    }),
    LoadingSkeleton: ()=>null
});

});
parcelRegister("1OlFr", function(module, exports) {

var $kOunM = parcelRequire("kOunM");
module.exports = $kOunM("kX0aw").then(()=>parcelRequire('6FYkG'));

});


parcelRegister("fNlrJ", function(module, exports) {
$parcel$export(module.exports, "default", () => $8a0124f8a54b41e2$export$2e2bcd8739ae039);

var $f0Pt4 = parcelRequire("f0Pt4");
var $8a0124f8a54b41e2$export$2e2bcd8739ae039 = (0, $f0Pt4.defineMessages)({
    unsupportedFrameComponentTitle: {
        id: 'forge-ui.common.extension.components.custom-field.view.unsupported-frame-component-title',
        defaultMessage: 'Frame not supported in view mode',
        description: 'Title of the error message shown to app developer when they try to use UI Kit Frame component for rendering custom field in the view mode'
    },
    unsupportedFrameComponentDescription: {
        id: 'forge-ui.common.extension.components.custom-field.view.unsupported-frame-component-description',
        defaultMessage: "Custom fields can\u2019t render the Frame component in view mode.",
        description: 'Description of the error message shown to app developer when they try to use UI Kit Frame component for rendering custom field in the view mode'
    }
});

});




parcelRegister("4yyQi", function(module, exports) {
$parcel$export(module.exports, "isForgeLegacyFieldType", () => $b6b99139b0a228c6$export$3fb46a1fa454ffea);
$parcel$export(module.exports, "getExtensionIdFromLegacyFieldType", () => $b6b99139b0a228c6$export$2b6a9cc67d548886);
const $b6b99139b0a228c6$export$3193d714ab54ee26 = 'ari:cloud:ecosystem::extension/';
const $b6b99139b0a228c6$export$df7774a415710cce = 'com.atlassian.forge:';
const $b6b99139b0a228c6$export$51ab2784839ce348 = `${$b6b99139b0a228c6$export$df7774a415710cce}${$b6b99139b0a228c6$export$3193d714ab54ee26}`;
const $b6b99139b0a228c6$export$3fb46a1fa454ffea = (fieldType)=>fieldType.startsWith($b6b99139b0a228c6$export$51ab2784839ce348);
const $b6b99139b0a228c6$export$2b6a9cc67d548886 = (fieldType)=>fieldType.split($b6b99139b0a228c6$export$df7774a415710cce)[1] || null;

});

parcelRegister("5Zf8N", function(module, exports) {
$parcel$export(module.exports, "createInitializationFinished", () => $17b556536e381f94$export$b0c730765ca52cfc);
$parcel$export(module.exports, "createInitializationFailed", () => $17b556536e381f94$export$730b6703c16a1943);

var $inh7J = parcelRequire("inh7J");

var $jGRkm = parcelRequire("jGRkm");

var $kMn38 = parcelRequire("kMn38");

var $cPF6v = parcelRequire("cPF6v");
// Shared debounced functions per source and action type are used to ensure that multiple components
// with the same source and action type will share the same debounced function. This prevents duplicate
// analytics events when multiple components finish or fail initialization within the debounce interval.
const $17b556536e381f94$var$sharedDebouncedEvents = new Map();
const $17b556536e381f94$var$getCompositeKey = (source, action)=>`${source}-${action}`;
const $17b556536e381f94$var$getOrCreateDebouncedFn = (key, fn)=>{
    const existingFn = $17b556536e381f94$var$sharedDebouncedEvents.get(key);
    if (existingFn) return existingFn;
    const debouncedFn = (0, (/*@__PURE__*/$parcel$interopDefault($inh7J)))(fn, (0, $kMn38.DEBOUNCE_INTERVAL));
    $17b556536e381f94$var$sharedDebouncedEvents.set(key, debouncedFn);
    return debouncedFn;
};
const $17b556536e381f94$var$isInSample = (samplingRate)=>(0, $cPF6v.default).random() * 100 < samplingRate;
const $17b556536e381f94$export$b0c730765ca52cfc = (source, shouldDebounce = false)=>{
    const fireEvent = async (attributes)=>{
        if ($17b556536e381f94$var$isInSample((0, $kMn38.FORGE_SAMPLING_RATE))) await (0, $jGRkm.fireInitializationEvent)((0, $kMn38.INITIALIZATION_ACTIONS).FINISHED, {
            source: source,
            attributes: attributes,
            id: 'fetchModulesInitialization'
        });
    };
    if (shouldDebounce) return $17b556536e381f94$var$getOrCreateDebouncedFn($17b556536e381f94$var$getCompositeKey(source, (0, $kMn38.INITIALIZATION_ACTIONS).FINISHED), fireEvent);
    return fireEvent;
};
const $17b556536e381f94$export$730b6703c16a1943 = (source, shouldDebounce = false)=>{
    const fireEvent = async (attributes)=>{
        await (0, $jGRkm.fireInitializationEvent)((0, $kMn38.INITIALIZATION_ACTIONS).FAILED, {
            source: source,
            attributes: attributes,
            id: 'fetchModulesInitialization'
        });
    };
    if (shouldDebounce) return $17b556536e381f94$var$getOrCreateDebouncedFn($17b556536e381f94$var$getCompositeKey(source, (0, $kMn38.INITIALIZATION_ACTIONS).FAILED), fireEvent);
    return fireEvent;
};

});

parcelRegister("iAH6T", function(module, exports) {
$parcel$export(module.exports, "useExtensions", () => (parcelRequire("jWq4h")).useExtensions);

var $jWq4h = parcelRequire("jWq4h");

});
parcelRegister("jWq4h", function(module, exports) {
$parcel$export(module.exports, "useExtensions", () => $568bf54fdd42628a$export$d3949313562c25d7);

var $6NMBb = parcelRequire("6NMBb");

var $bSJIT = parcelRequire("bSJIT");

var $gYq50 = parcelRequire("gYq50");

var $fuVmc = parcelRequire("fuVmc");

var $a2qIF = parcelRequire("a2qIF");

var $kbkME = parcelRequire("kbkME");
const $568bf54fdd42628a$export$d8fab312eb2aaa85 = (0, $6NMBb.default);
const $568bf54fdd42628a$export$d3949313562c25d7 = ({ types: types, context: context, includeHidden: includeHidden, shouldFetch: shouldFetch, onInitializationFinished: onInitializationFinished, onInitializationFailed: onInitializationFailed })=>{
    const cloudId = (0, $fuVmc.getCloudId)();
    const [isLoading, setIsLoading] = (0, $bSJIT.useState)(shouldFetch);
    const [extensions, setExtensions] = (0, $bSJIT.useState)([]);
    const [error, setError] = (0, $bSJIT.useState)(null);
    const fetchForgeModules = (0, $bSJIT.useCallback)(()=>{
        setIsLoading(true);
        (0, $a2qIF.fetchQuery)((0, $kbkME.getRelayEnvironment)(), $568bf54fdd42628a$export$d8fab312eb2aaa85, {
            cloudId: cloudId,
            context: context,
            types: types,
            includeHidden: includeHidden
        }).toPromise().then((data)=>{
            var _data$jira;
            const exts = ((data === null || data === void 0 || (_data$jira = data.jira) === null || _data$jira === void 0 || (_data$jira = _data$jira.forge) === null || _data$jira === void 0 ? void 0 : _data$jira.extensions) || []).filter((ext)=>types.includes(ext.type)).map($568bf54fdd42628a$export$39ee489473821fbd);
            setExtensions(exts);
            // eslint-disable-next-line @typescript-eslint/no-floating-promises
            onInitializationFinished();
        }).catch((e)=>{
            setExtensions([]);
            setError(e);
            // eslint-disable-next-line @typescript-eslint/no-floating-promises
            onInitializationFailed({
                error: e
            });
        }).finally(()=>{
            setIsLoading(false);
        });
    }, [
        cloudId,
        context,
        includeHidden,
        types,
        onInitializationFinished,
        onInitializationFailed
    ]);
    (0, $bSJIT.useEffect)(()=>{
        if (shouldFetch) fetchForgeModules();
    }, [
        shouldFetch,
        fetchForgeModules
    ]);
    return (0, $bSJIT.useMemo)(()=>({
            extensions: extensions,
            isLoading: isLoading,
            error: error
        }), [
        error,
        extensions,
        isLoading
    ]);
};
const $568bf54fdd42628a$export$39ee489473821fbd = (extension)=>{
    const license = extension.license;
    const transformedLicense = license ? {
        active: license.active,
        type: license.type ?? null,
        supportEntitlementNumber: license.supportEntitlementNumber ?? null,
        trialEndDate: license.trialEndDate ?? null,
        subscriptionEndDate: license.subscriptionEndDate ?? null,
        isEvaluation: license.isEvaluation ?? null,
        billingPeriod: license.billingPeriod ?? null,
        ccpEntitlementId: license.ccpEntitlementId ?? null,
        ccpEntitlementSlug: license.ccpEntitlementSlug ?? null,
        capabilitySet: license.capabilitySet ?? null,
        modes: null
    } : null;
    // Each Forge module has a unique id, however it may be used in different contexts.
    // In those contexts, some modules may be hidden depending on display conditions.
    // In order for Relay to not pick up hidden extensions from the cache, we need to use a unique id for each context.
    // This is done on the backend side by appending the hash to the module id.
    // This fixes the Relay cache issue but on the client side we still want to operate on the original extension id since Forge depends on it.
    // That's why we swap id with moduleId, which represents the original id; also as a fallback we strip the hash from the id just in case.
    const id = extension.moduleId ?? extension.id.replace(/-+\d+$/, '');
    return {
        ...extension,
        id: id,
        key: id,
        egress: extension.egress ?? [],
        consentUrl: extension.consentUrl ?? undefined,
        license: transformedLicense,
        dataClassificationPolicyDecision: {
            status: extension.hiddenBy === 'AppAccessRules' ? (0, $gYq50.BLOCKED) : (0, $gYq50.ALLOWED)
        }
    };
};

});
parcelRegister("6NMBb", function(module, exports) {
$parcel$export(module.exports, "default", () => $9eb1d34e320df260$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<7529279f9f3ade19d56dc8361377f002>>
 * @relayHash a62833dfd2661ff1b5ca07e6a551b824
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 8f0d4ed5503c6f67b5a7266ea07fcc9d673749ecd294218cabda51d8920bbb1e
const $9eb1d34e320df260$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "context"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "includeHidden"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "types"
    }, v4 = {
        "kind": "ScalarField",
        "name": "type"
    }, v5 = [
        {
            "concreteType": "JiraQuery",
            "kind": "LinkedField",
            "name": "jira",
            "plural": false,
            "selections": [
                {
                    "concreteType": "JiraForgeQuery",
                    "kind": "LinkedField",
                    "name": "forge",
                    "plural": false,
                    "selections": [
                        {
                            "args": [
                                {
                                    "kind": "Variable",
                                    "name": "cloudId",
                                    "variableName": "cloudId"
                                },
                                {
                                    "kind": "Variable",
                                    "name": "context",
                                    "variableName": "context"
                                },
                                {
                                    "kind": "Variable",
                                    "name": "includeHidden",
                                    "variableName": "includeHidden"
                                },
                                {
                                    "kind": "Variable",
                                    "name": "types",
                                    "variableName": "types"
                                }
                            ],
                            "concreteType": "JiraForgeExtension",
                            "kind": "LinkedField",
                            "name": "extensions",
                            "plural": true,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "hiddenBy"
                                },
                                v4 /*: any*/ ,
                                {
                                    "kind": "ScalarField",
                                    "name": "id"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "moduleId"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "environmentId"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "environmentKey"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "environmentType"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "installationId"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "appVersion"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "consentUrl"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "properties"
                                },
                                {
                                    "concreteType": "JiraUserAppAccess",
                                    "kind": "LinkedField",
                                    "name": "userAccess",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "hasAccess"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "enabled"
                                        }
                                    ]
                                },
                                {
                                    "concreteType": "JiraForgeAppEgressDeclaration",
                                    "kind": "LinkedField",
                                    "name": "egress",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "addresses"
                                        },
                                        v4 /*: any*/ ,
                                        {
                                            "kind": "ScalarField",
                                            "name": "category"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "inScopeEUD"
                                        }
                                    ]
                                },
                                {
                                    "concreteType": "JiraForgeInstallationConfigExtension",
                                    "kind": "LinkedField",
                                    "name": "installationConfig",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "key"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "value"
                                        }
                                    ]
                                },
                                {
                                    "concreteType": "JiraForgeExtensionLicense",
                                    "kind": "LinkedField",
                                    "name": "license",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "active"
                                        },
                                        v4 /*: any*/ ,
                                        {
                                            "kind": "ScalarField",
                                            "name": "supportEntitlementNumber"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "trialEndDate"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "subscriptionEndDate"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "isEvaluation"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "billingPeriod"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "ccpEntitlementId"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "ccpEntitlementSlug"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "capabilitySet"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "useExtensionsQuery",
            "selections": v5 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v3 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "useExtensionsQuery",
            "selections": v5 /*: any*/ 
        },
        "params": {
            "id": "8f0d4ed5503c6f67b5a7266ea07fcc9d673749ecd294218cabda51d8920bbb1e",
            "metadata": {},
            "name": "useExtensionsQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$9eb1d34e320df260$var$node.hash = "ca72edb566d5f0ae17dcb8d6cee09569";
var $9eb1d34e320df260$export$2e2bcd8739ae039 = $9eb1d34e320df260$var$node;

});



parcelRegister("d8ukk", function(module, exports) {
$parcel$export(module.exports, "ErrorMessage", () => (parcelRequire("7aMQB")).ErrorMessage);

var $7aMQB = parcelRequire("7aMQB");

});
parcelRegister("7aMQB", function(module, exports) {
$parcel$export(module.exports, "ErrorMessage", () => $e47d0e398fb6ff2b$export$915e9e7bd4f0f96d);

var $bSJIT = parcelRequire("bSJIT");
const $e47d0e398fb6ff2b$export$915e9e7bd4f0f96d = ({ errorMessages: errorMessages })=>{
    if (!errorMessages.length) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).Fragment, null, errorMessages.map((message, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $bSJIT.Fragment), {
            key: index
        }, message, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement("br", null))));
};

});


parcelRegister("CY3b1", function(module, exports) {
$parcel$export(module.exports, "FieldState", () => (parcelRequire("g5MKj")).FieldState);

var $g5MKj = parcelRequire("g5MKj");

});
parcelRegister("g5MKj", function(module, exports) {
$parcel$export(module.exports, "FieldState", () => $31427cde6756b2e5$export$f91d67ddd1e8123a);

var $bSJIT = parcelRequire("bSJIT");

var $gUpf2 = parcelRequire("gUpf2");

var $9BVpB = parcelRequire("9BVpB");
const $31427cde6756b2e5$export$f91d67ddd1e8123a = ({ isDisabled: isDisabled, isVisible: isVisible, children: children })=>{
    const styles = (0, $bSJIT.useMemo)(()=>[
            isVisible ? undefined : $31427cde6756b2e5$var$hiddenStyles,
            isDisabled ? $31427cde6756b2e5$var$disabledStyles : undefined
        ].filter(Boolean), [
        isVisible,
        isDisabled
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $gUpf2.Box), {
        xcss: styles
    }, children);
};
const $31427cde6756b2e5$var$hiddenStyles = (0, $9BVpB.xcss)({
    display: 'none'
});
const $31427cde6756b2e5$var$disabledStyles = (0, $9BVpB.xcss)({
    opacity: 0.4,
    // @ts-expect-error we want to disable pointer events for all the children coming from Forge apps
    '*': {
        pointerEvents: 'none !important'
    }
});

});


parcelRegister("8WVYa", function(module, exports) {
$parcel$export(module.exports, "default", () => $a58131b9eef51433$export$2e2bcd8739ae039);

var $f0Pt4 = parcelRequire("f0Pt4");
var $a58131b9eef51433$export$2e2bcd8739ae039 = (0, $f0Pt4.defineMessages)({
    errorMessage: {
        defaultMessage: "We couldn't save the value of this custom field.",
        description: 'Error message when the value of a forge custom field cannot be saved',
        id: 'cv.request.create.form.forge-field.error-message'
    },
    notFoundRequiredFieldTitle: {
        defaultMessage: 'Custom field not found',
        description: 'Title of the error message shown in the flag when a custom field is required but is not found',
        id: 'cv.request.create.form.forge-field.not-found-required-title'
    },
    notFoundRequiredFieldDescription: {
        defaultMessage: "The {fieldName} custom field is required but couldn't be displayed. If this happens again, notify your admin.",
        description: 'Description of the error message shown in the flag when a custom field is required but is not found',
        id: 'cv.request.create.form.forge-field.not-found-required-description'
    }
});

});

parcelRegister("1bNoZ", function(module, exports) {
$parcel$export(module.exports, "Skeleton", () => $2d91bc664484a646$export$8f31e4c4a37b8e9c);

var $bSJIT = parcelRequire("bSJIT");

var $hF8Ik = parcelRequire("hF8Ik");

var $gUpf2 = parcelRequire("gUpf2");

var $9BVpB = parcelRequire("9BVpB");
const $2d91bc664484a646$export$8f31e4c4a37b8e9c = ({ onUnmount: onUnmount })=>{
    (0, $bSJIT.useEffect)(()=>()=>onUnmount === null || onUnmount === void 0 ? void 0 : onUnmount(), [
        onUnmount
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $gUpf2.Box), {
        xcss: $2d91bc664484a646$var$containerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $hF8Ik.LoadingSkeleton), {
        height: 40,
        backgroundColor: "var(--ds-skeleton-subtle, #F4F5F7)"
    }));
};
const $2d91bc664484a646$var$containerStyles = (0, $9BVpB.xcss)({
    width: '100%'
});

});

parcelRegister("arUjg", function(module, exports) {
$parcel$export(module.exports, "getMappedFieldType", () => $60c49588e03c4478$export$c0b3058f961cfa89);
$parcel$export(module.exports, "transformValue", () => $60c49588e03c4478$export$98c150630afe5417);
const $60c49588e03c4478$var$fieldMap = {
    none: {
        string: 'text',
        number: 'text',
        object: 'textarea',
        user: 'userpicker',
        datetime: 'datetime',
        date: 'date'
    },
    list: {
        string: 'labelpicker',
        user: 'multiuserpicker'
    }
};
const $60c49588e03c4478$export$c0b3058f961cfa89 = (extension)=>{
    const collection = extension.properties.collection === 'list' ? 'list' : 'none';
    return $60c49588e03c4478$var$fieldMap[collection][extension.properties.type] || 'unknown';
};
const $60c49588e03c4478$export$98c150630afe5417 = (value, extension)=>{
    switch(extension.properties.type){
        case 'object':
            return value != null ? JSON.stringify(value) : value;
        case 'user':
            return value != null ? $60c49588e03c4478$var$transformUser(value) : value;
        default:
            return value;
    }
};
const $60c49588e03c4478$var$transformUser = (value)=>Array.isArray(value) ? value.map((user)=>user.accountId).join(',') : value.accountId;

});



parcelRegister("1sU5z", function(module, exports) {
$parcel$export(module.exports, "LabelPicker", () => (parcelRequire("1vV30")).default);

var $1vV30 = parcelRequire("1vV30");

});
parcelRegister("1vV30", function(module, exports) {
$parcel$export(module.exports, "default", () => $6085e371d7fc2175$export$2e2bcd8739ae039);

var $bSJIT = parcelRequire("bSJIT");

var $lJ0l5 = parcelRequire("lJ0l5");

var $jcRK7 = parcelRequire("jcRK7");

var $4ZMmh = parcelRequire("4ZMmh");

var $fK3tS = parcelRequire("fK3tS");

var $lrVGi = parcelRequire("lrVGi");
parcelRequire("3aTGu");
var $4ZR7G = parcelRequire("4ZR7G");

var $5LCaz = parcelRequire("5LCaz");
class $6085e371d7fc2175$var$LabelPicker extends $bSJIT.PureComponent {
    render() {
        const { portalId: portalId, requestTypeId: requestTypeId, ...props } = this.props;
        return /*#__PURE__*/ $bSJIT.createElement((0, $4ZR7G.default), {
            ...props,
            loadOptions: this.loadOptions,
            validationErrorMessage: this.state.validationErrorMessage
        });
    }
    constructor(...args){
        super(...args), this.state = {
            validationErrorMessage: undefined
        }, this.isValidQuery = (inputValue)=>!/\s+/.test(inputValue), this.fetchLabels = (inputValue, callback)=>{
            const { intl: intl } = this.props;
            if (this.isValidQuery(inputValue)) {
                const { portalId: portalId, requestTypeId: requestTypeId, customFieldId: customFieldId } = this.props;
                return (0, $lrVGi.searchLabel)({
                    portalId: portalId,
                    requestTypeId: requestTypeId,
                    customFieldId: customFieldId,
                    query: inputValue
                }).map((response)=>{
                    this.setState({
                        validationErrorMessage: undefined
                    });
                    return response.map((label)=>({
                            label: label,
                            value: label
                        }));
                }).catch((errors)=>{
                    // TypeScript upgrade (v4.4.3). Please correct when you revisit this code.
                    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
                    if (errors.status === 400) {
                        // Suppressing existing violation. Please fix this.
                        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access
                        this.setState({
                            validationErrorMessage: errors.response.errors[0].errorMessage
                        });
                        return (0, $lJ0l5.Observable).empty();
                    }
                    return (0, $lJ0l5.Observable).throw(errors);
                }).toPromise().then(callback);
            }
            this.setState({
                validationErrorMessage: intl.formatMessage((0, $5LCaz.default).inputValidationErrorMessage, {
                    labelInput: inputValue
                })
            });
            return (0, $lJ0l5.Observable).empty();
        }, this.fetchLabelDebounced = (0, $4ZMmh.debounce)(this.fetchLabels, (0, $jcRK7.USER_TYPING_DEBOUNCE_TIME)), this.loadOptions = (input, callback)=>{
            // Disabling existing violations, should be fixed when revisited.
            // eslint-disable-next-line @typescript-eslint/no-floating-promises
            this.fetchLabelDebounced(input, callback);
        };
    }
}
var $6085e371d7fc2175$export$2e2bcd8739ae039 = (0, $fK3tS.default)($6085e371d7fc2175$var$LabelPicker);

});
parcelRegister("lrVGi", function(module, exports) {
$parcel$export(module.exports, "searchLabel", () => $df60aab4a6139fec$export$f7d9887e8d9170ea);

var $llRGw = parcelRequire("llRGw");

var $8jOUp = parcelRequire("8jOUp");

var $fvUqa = parcelRequire("fvUqa");

var $jBiia = parcelRequire("jBiia");

var $eDcdn = parcelRequire("eDcdn");
const $df60aab4a6139fec$export$f7d9887e8d9170ea = (labelQuery)=>{
    let query = {
        query: labelQuery.query
    };
    if (labelQuery.customFieldId) query = {
        ...query,
        customFieldId: labelQuery.customFieldId
    };
    const queryString = $fvUqa.stringify(query);
    const uri = `${(0, $eDcdn.contextPath)}/rest/servicedesk/1/customer/portal/${labelQuery.portalId}/requestType/${labelQuery.requestTypeId}/labels/suggest?${queryString}`;
    // Suppressing existing violation. Please fix this.
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    return (0, $llRGw.get)(uri).map((ajaxResponse)=>{
        const response = ajaxResponse.response;
        return response.suggestions.map((suggestion)=>suggestion.label);
    }).catch((e)=>{
        (0, $jBiia.trackError)('findlabel.fetch.failed', {}, e);
        return (0, $8jOUp.Observable).throw(e);
    });
};

});

parcelRegister("3aTGu", function(module, exports) {
$parcel$export(module.exports, "LabelPickerDumb", () => (parcelRequire("4ZR7G")).default);

var $4ZR7G = parcelRequire("4ZR7G");

});
parcelRegister("4ZR7G", function(module, exports) {
$parcel$export(module.exports, "default", () => $82da0c770b0fc611$export$2e2bcd8739ae039);

var $bSJIT = parcelRequire("bSJIT");

var $82wak = parcelRequire("82wak");

var $30F9J = parcelRequire("30F9J");
class $82da0c770b0fc611$export$2e2bcd8739ae039 extends $bSJIT.PureComponent {
    componentDidMount() {
        // PORTAL-2032 - this is required to make url filling (e.g. ?customfield_10343=10657) work
        if (this.props.defaultLabels && this.props.defaultLabels.length > 0) this.onChange(this.props.defaultLabels);
    }
    render() {
        const { label: label, disabled: disabled, ...otherProps } = this.props;
        const errorMessage = this.props.validationErrorMessage ?? this.props.errorMessage;
        return /*#__PURE__*/ $bSJIT.createElement((0, $82wak.FormAsyncCreatableMultiSelect), {
            ...otherProps,
            actionSubjectId: "labelPickerField",
            label: label ?? '',
            isDisabled: disabled,
            onChange: this.onChange,
            loadOptions: this.props.loadOptions,
            defaultValue: this.state.selectedOption,
            isValidNewOption: this.isValidNewOption,
            errorMessage: errorMessage
        });
    }
    constructor(...args){
        super(...args), this.state = {
            selectedOption: this.props.defaultLabels
        }, this.isValidNewOption = (inputValue, _, existingLabels)=>{
            if (!!this.props.validationErrorMessage) return false;
            if (inputValue === '') return false;
            if (!Array.isArray(existingLabels)) return false;
            const isLabelAlreadyExisting = existingLabels.some((label)=>label.value === inputValue);
            return !isLabelAlreadyExisting;
        }, this.onChange = (value)=>{
            const { id: id, onChange: onChange } = this.props;
            const selectedValue = (0, $30F9J.toMultiSelectValue)(value);
            // The labels field requires that you pass the a value in the create request
            // lest Jira applies the default labels to it.
            const val = selectedValue.length !== 0 ? selectedValue.map((v)=>v.value) : '';
            onChange === null || onChange === void 0 || onChange(id, val, false, {
                rawObject: {},
                rawValue: selectedValue
            });
        };
    }
}

});


parcelRegister("5LCaz", function(module, exports) {
$parcel$export(module.exports, "default", () => $7cb7825fa5a22464$export$2e2bcd8739ae039);

var $f0Pt4 = parcelRequire("f0Pt4");
var $7cb7825fa5a22464$export$2e2bcd8739ae039 = (0, $f0Pt4.defineMessages)({
    inputValidationErrorMessage: {
        defaultMessage: `The label \u2019{labelInput}\u2019 can't contain spaces`,
        description: 'Request form labels input error validation messages',
        id: 'sd.customerview.field.labels.error.validation'
    }
});

});



parcelRegister("lxaPu", function(module, exports) {
$parcel$export(module.exports, "MultiSelectField", () => (parcelRequire("1VvAK")).default);
/** This is the single select form component type  */ 
var $1VvAK = parcelRequire("1VvAK");

});
parcelRegister("1VvAK", function(module, exports) {
$parcel$export(module.exports, "default", () => $3435a01f8760ce9b$export$2e2bcd8739ae039);

var $bSJIT = parcelRequire("bSJIT");

var $82wak = parcelRequire("82wak");

var $30F9J = parcelRequire("30F9J");
class $3435a01f8760ce9b$var$MultiFieldSelect extends $bSJIT.PureComponent {
    componentDidMount() {
        // PORTAL-2032 - this is required to make url filling (e.g. ?customfield_10343=10657) work
        if (this.props.defaultValue && this.props.defaultValue.length > 0) this.onChange(this.props.defaultValue);
    }
    render() {
        const { disabled: disabled, ...otherProps } = this.props;
        return /*#__PURE__*/ $bSJIT.createElement((0, $82wak.FormMultiSelect), {
            ...otherProps,
            actionSubjectId: "multiSelectField",
            onChange: this.onChange,
            isDisabled: disabled
        });
    }
    constructor(...args){
        super(...args), this.onChange = (options, meta)=>{
            const selectedOptions = (0, $30F9J.toMultiSelectValue)(options);
            // The multiselect field requires that you pass a value in the create request
            // lest Jira applies the default options to it.
            const val = selectedOptions.length !== 0 ? selectedOptions.map((v)=>v.value) : '';
            this.props.onChange && this.props.onChange(this.props.id, val, false, {
                rawObject: meta ?? {},
                rawValue: options
            });
        };
    }
}
var $3435a01f8760ce9b$export$2e2bcd8739ae039 = $3435a01f8760ce9b$var$MultiFieldSelect;

});


parcelRegister("acDtw", function(module, exports) {
$parcel$export(module.exports, "MultiServicePicker", () => (parcelRequire("lHthJ")).default);

var $lHthJ = parcelRequire("lHthJ");

});
parcelRegister("lHthJ", function(module, exports) {
$parcel$export(module.exports, "default", () => $e2407c4ff282c72a$export$2e2bcd8739ae039);

var $egQxE = parcelRequire("egQxE");

var $xb2jO = parcelRequire("xb2jO");

var $1lXjQ = parcelRequire("1lXjQ");
var $e2407c4ff282c72a$export$2e2bcd8739ae039 = (0, $egQxE.connect)(null, {
    showErrorFlag: $xb2jO.showErrorFlag
})((0, $1lXjQ.default));

});
parcelRegister("1lXjQ", function(module, exports) {
$parcel$export(module.exports, "default", () => $41c4f05c909832e0$export$2e2bcd8739ae039);

var $bSJIT = parcelRequire("bSJIT");

var $fT4XN = parcelRequire("fT4XN");

var $82wak = parcelRequire("82wak");

var $lFpPv = parcelRequire("lFpPv");

var $fK3tS = parcelRequire("fK3tS");

var $30F9J = parcelRequire("30F9J");

var $3scJo = parcelRequire("3scJo");
parcelRequire("3X5UM");
var $jb2wR = parcelRequire("jb2wR");
const $41c4f05c909832e0$var$MultiServicePicker = (props)=>{
    const { disabled: disabled, onChange: onChange, intl: intl, defaultServices: defaultServices, value: value, ...otherProps } = props;
    const { useCallback: useCallback, useEffect: useEffect, useRef: useRef, useState: useState } = $bSJIT;
    const noOptionsMessage = useCallback(()=>{
        return intl.formatMessage((0, $3scJo.default).noOptions);
    // oxlint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const { options: options, fetchMoreOptions: fetchMoreOptions, ...paginatedMultiSelectProps } = (0, $jb2wR.usePaginatedServiceOptions)(props.showErrorFlag);
    const [hasAppliedDefaults, setHasAppliedDefaults] = useState(false);
    const optionsCacheRef = useRef(new Map());
    // Keep the cache up-to-date whenever a new page of options arrives.
    useEffect(()=>{
        if ((0, $lFpPv.isJsmPortalRovoIntegrationEnabled)()) options.forEach((option)=>{
            optionsCacheRef.current.set(option.value, option);
        });
    }, [
        options
    ]);
    const onChangeForMultiSelect = useCallback((opts)=>{
        const multiSelectValue = (0, $30F9J.toMultiSelectValue)(opts);
        onChange === null || onChange === void 0 || onChange(props.id, multiSelectValue.map((v)=>v.value));
        // search again if all the options have been selected
        if (multiSelectValue.length === options.length) fetchMoreOptions();
    }, // oxlint-disable-next-line react-hooks/exhaustive-deps
    [
        onChange,
        options.length
    ]);
    // When the Rovo integration flag is on, services are loaded, and defaultServices is provided,
    // select them as an initial pre-fill. This only runs once (guarded by hasAppliedDefaults).
    useEffect(()=>{
        if ((0, $lFpPv.isJsmPortalRovoIntegrationEnabled)() && defaultServices && defaultServices.length > 0 && options.length > 0 && !hasAppliedDefaults) {
            const selectedOptions = options.filter((option)=>defaultServices.includes(option.value) || defaultServices.includes(option.label));
            if (selectedOptions.length > 0) {
                setHasAppliedDefaults(true);
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                onChangeForMultiSelect(selectedOptions);
            }
        }
    // oxlint-disable-next-line react-hooks/exhaustive-deps
    }, [
        defaultServices,
        options.length,
        onChangeForMultiSelect,
        hasAppliedDefaults
    ]);
    const displayValue = (0, $lFpPv.isJsmPortalRovoIntegrationEnabled)() && value && Array.isArray(value) && value.length > 0 ? value.reduce((acc, id)=>{
        const cached = optionsCacheRef.current.get(id);
        if (cached) acc.push(cached);
        return acc;
    }, []) : undefined;
    return /*#__PURE__*/ $bSJIT.createElement((0, $82wak.FormMultiSelect), {
        ...otherProps,
        ...paginatedMultiSelectProps,
        actionSubjectId: "multiServicePickerField",
        placeholder: intl.formatMessage((0, $3scJo.default).searchPlaceholder),
        noOptionsMessage: noOptionsMessage,
        isDisabled: disabled,
        onMenuScrollToBottom: fetchMoreOptions,
        options: options,
        onChange: onChangeForMultiSelect,
        value: displayValue
    });
};
const $41c4f05c909832e0$var$WithErrorBoundary = (props)=>/*#__PURE__*/ $bSJIT.createElement((0, $fT4XN.default), {
        id: "multi-service-picker",
        packageName: "portal_fields"
    }, /*#__PURE__*/ $bSJIT.createElement($41c4f05c909832e0$var$MultiServicePicker, props));
var $41c4f05c909832e0$export$2e2bcd8739ae039 = (0, $fK3tS.default)($41c4f05c909832e0$var$WithErrorBoundary);

});
parcelRegister("3scJo", function(module, exports) {
$parcel$export(module.exports, "default", () => $7cf9bd7d16372c76$export$2e2bcd8739ae039);

var $f0Pt4 = parcelRequire("f0Pt4");
var $7cf9bd7d16372c76$export$2e2bcd8739ae039 = (0, $f0Pt4.defineMessages)({
    searchPlaceholder: {
        defaultMessage: 'Search for services',
        description: 'Placeholder for service picker field to advise the user to search for services',
        id: 'cv.request.create.form.multiservicepickerv2.search'
    },
    noOptions: {
        defaultMessage: 'No options',
        description: 'Text that appears in the dropdown for the service picker if there are no services to select',
        id: 'cv.request.create.form.multiservicepickerv2.no.options'
    }
});

});

parcelRegister("3X5UM", function(module, exports) {
$parcel$export(module.exports, "usePaginatedServiceOptions", () => (parcelRequire("jb2wR")).usePaginatedServiceOptions);

var $jb2wR = parcelRequire("jb2wR");

});
parcelRegister("jb2wR", function(module, exports) {
$parcel$export(module.exports, "usePaginatedServiceOptions", () => $33bba981a6dd1f0d$export$48b464c13bc5007a);

var $bSJIT = parcelRequire("bSJIT");

var $inh7J = parcelRequire("inh7J");

var $gxy5f = parcelRequire("gxy5f");

var $gEVth = parcelRequire("gEVth");

var $a6ENB = parcelRequire("a6ENB");

var $c1jB8 = parcelRequire("c1jB8");
// TypeScript upgrade (v4.4.3). Please correct when you revisit this code.
// oxlint-disable-next-line no-shadow
var $33bba981a6dd1f0d$var$Action = /*#__PURE__*/ function(Action) {
    Action[Action["Append"] = 0] = "Append";
    Action[Action["Replace"] = 1] = "Replace";
    return Action;
}($33bba981a6dd1f0d$var$Action || {});
const $33bba981a6dd1f0d$export$13990ad4625571ed = (action)=>{
    (0, $gEVth.operationalEvent)({
        action: action,
        actionSubject: 'portalFetchServices',
        source: 'multiServicePicker'
    });
};
const $33bba981a6dd1f0d$export$48b464c13bc5007a = (showError)=>{
    const [options, setOptions] = (0, $bSJIT.useState)([]);
    const cursor = (0, $bSJIT.useRef)(null); // The end cursor/page number for the current search result
    const hasNextPage = (0, $bSJIT.useRef)(false); // Whether there are more options to load from fetchSearvices
    const prevSearchValue = (0, $bSJIT.useRef)(''); // The latest input value we entered in the search
    const [isLoading, setIsLoading] = (0, $bSJIT.useState)(false);
    // oxlint-disable-next-line react-hooks/exhaustive-deps
    const searchServices = async (inputValue, action)=>{
        // Don't search if doesn't have next page
        if (!hasNextPage.current && action === 0) return;
        setIsLoading(true);
        // Remove the cursor so that we could start search from first page. Set hasNextPage to true to ensure we are always searching
        if (action === 1) cursor.current = null;
        prevSearchValue.current = inputValue;
        try {
            const { services: services, endCursor: endCursor, hasNextPage: hasMorePage } = await (0, $gxy5f.fetchServices)(inputValue, cursor.current);
            cursor.current = endCursor;
            hasNextPage.current = hasMorePage;
            if (action === 1) setOptions(services);
            else if (action === 0) setOptions((prevOptions)=>[
                    ...prevOptions,
                    ...services
                ]);
            $33bba981a6dd1f0d$export$13990ad4625571ed((0, $gEVth.AnalyticsTrackActions).FETCHED);
        } catch (err) {
            (0, $a6ENB.reportError)(err);
            $33bba981a6dd1f0d$export$13990ad4625571ed((0, $gEVth.AnalyticsTrackActions).FETCHED_FAILURE);
            showError((0, $c1jB8.default).errorTitle, (0, $c1jB8.default).errorDescription);
            // We only remove all the available options if we need to replace. Otherwise, we still maintain previous options
            if (action === 1) setOptions([]);
            hasNextPage.current = false;
        } finally{
            setIsLoading(false);
        }
    };
    // Initial search
    (0, $bSJIT.useEffect)(()=>{
        // Disabling existing violations, should be fixed when revisited.
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        searchServices(prevSearchValue.current, 1);
    // oxlint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    // Search when user types input value in the search field
    const onInputChange = (0, $bSJIT.useCallback)((inputValue)=>{
        if (inputValue !== prevSearchValue.current) // Disabling existing violations, should be fixed when revisited.
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        searchServices(inputValue, 1);
    }, [
        searchServices
    ]);
    const debouncedOnInputChange = (0, $bSJIT.useRef)((0, (/*@__PURE__*/$parcel$interopDefault($inh7J)))(onInputChange, 100));
    // Search when user scrolls to bottom of the scroll menu or when all the available options have been selected
    const fetchMoreOptions = (0, $bSJIT.useCallback)(()=>{
        // Disabling existing violations, should be fixed when revisited.
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        searchServices(prevSearchValue.current, 0);
    }, [
        searchServices
    ]);
    return {
        isLoading: isLoading,
        options: options,
        fetchMoreOptions: fetchMoreOptions,
        onInputChange: debouncedOnInputChange.current
    };
};

});
parcelRegister("c1jB8", function(module, exports) {
$parcel$export(module.exports, "default", () => $89b5489ca6e49572$export$2e2bcd8739ae039);

var $f0Pt4 = parcelRequire("f0Pt4");
var $89b5489ca6e49572$export$2e2bcd8739ae039 = (0, $f0Pt4.defineMessages)({
    errorTitle: {
        defaultMessage: 'Error',
        description: 'Title of the error panel shown when a request types post has failed.',
        id: 'cv.request.create.form.multiservicepickerv2.usepaginatedservice.error.title'
    },
    errorDescription: {
        defaultMessage: "We couldn't load the affected services. Refresh the page and try again.",
        description: 'Description of the error panel shown when an affected services fetch has failed.',
        id: 'cv.request.create.form.multiservicepickerv2.usepaginatedservice.error.description'
    }
});

});






parcelRegister("aLbXO", function(module, exports) {
$parcel$export(module.exports, "MultiUserPicker", () => (parcelRequire("1Sb5C")).default);

var $1Sb5C = parcelRequire("1Sb5C");

});
parcelRegister("1Sb5C", function(module, exports) {
$parcel$export(module.exports, "default", () => $d7d394e3ec6226b9$export$2e2bcd8739ae039);

var $bSJIT = parcelRequire("bSJIT");

var $4ZMmh = parcelRequire("4ZMmh");

var $dp27t = parcelRequire("dp27t");
parcelRequire("I7Btt");
var $7JNq8 = parcelRequire("7JNq8");
class $d7d394e3ec6226b9$export$2e2bcd8739ae039 extends $bSJIT.PureComponent {
    render() {
        const { portalId: portalId, canAddUserByEmailAddress: canAddUserByEmailAddress, ...props } = this.props;
        return /*#__PURE__*/ $bSJIT.createElement((0, $7JNq8.default), {
            ...props,
            loadOptions: this.loadOptions,
            doInitialSearch: true,
            canAddUserByEmailAddress: canAddUserByEmailAddress
        });
    }
    constructor(...args){
        super(...args), this.loadOptions = (inputValue, callback)=>{
            // Disabling existing violations, should be fixed when revisited.
            // eslint-disable-next-line @typescript-eslint/no-floating-promises
            this.fetchUserDebounced(inputValue, callback);
        }, this.fetchUsers = (inputValue, callback)=>{
            return (0, $dp27t.searchUser)({
                fieldName: this.props.id,
                query: inputValue,
                portalId: this.props.portalId,
                fieldConfigId: this.props.fieldConfigId
            }).map((response)=>response.map((user)=>({
                        value: user.id,
                        label: user.displayName,
                        iconUrl: user.avatar,
                        email: user.emailAddress
                    }))).toPromise().then(callback);
        }, this.fetchUserDebounced = (0, $4ZMmh.debounce)(this.fetchUsers, 400);
    }
}

});
parcelRegister("I7Btt", function(module, exports) {
$parcel$export(module.exports, "MultiUserPickerDumb", () => (parcelRequire("7JNq8")).default);

var $7JNq8 = parcelRequire("7JNq8");

});
parcelRegister("7JNq8", function(module, exports) {
$parcel$export(module.exports, "default", () => $70a25e9740ab3d01$export$2e2bcd8739ae039);

var $bSJIT = parcelRequire("bSJIT");

var $acAb6 = parcelRequire("acAb6");

var $82wak = parcelRequire("82wak");

var $fK3tS = parcelRequire("fK3tS");

var $kjCfa = parcelRequire("kjCfa");
parcelRequire("fOqQw");
var $3ptbP = parcelRequire("3ptbP");
parcelRequire("4zp9W");
var $lvEVI = parcelRequire("lvEVI");

var $30F9J = parcelRequire("30F9J");

var $9uwAP = parcelRequire("9uwAP");
class $70a25e9740ab3d01$export$f9898dcf377cfa81 extends $bSJIT.Component {
    render() {
        const { disabled: disabled, canAddUserByEmailAddress: canAddUserByEmailAddress, defaultUsers: defaultUsers, doInitialSearch: doInitialSearch, intl: intl, onChange: onChange, ...otherProps } = this.props;
        if (canAddUserByEmailAddress) return /*#__PURE__*/ $bSJIT.createElement((0, $82wak.FormAsyncCreatableMultiSelect), {
            ...otherProps,
            actionSubjectId: "multiUserPickerField",
            formatOptionLabel: this.formatOptionLabel,
            formatCreateLabel: this.formatCreateLabel,
            isDisabled: disabled,
            isValidNewOption: this.isValidNewOption,
            onChange: this.onChangeForMultiSelect,
            defaultValue: defaultUsers,
            defaultOptions: doInitialSearch,
            noOptionsMessage: this.getNoOptionsCreatable,
            placeholder: intl.formatMessage((0, $kjCfa.default).placeholder)
        });
        return /*#__PURE__*/ $bSJIT.createElement((0, $82wak.FormAsyncMultiSelect), {
            ...otherProps,
            actionSubjectId: "multiUserPickerField",
            formatOptionLabel: this.formatOptionLabel,
            isDisabled: disabled,
            onChange: this.onChangeForMultiSelect,
            defaultValue: defaultUsers,
            defaultOptions: doInitialSearch,
            placeholder: intl.formatMessage((0, $kjCfa.default).placeholder),
            noOptionsMessage: this.getNoOptions
        });
    }
    constructor(...args){
        super(...args), this.onChangeForMultiSelect = (options)=>{
            var _this$props$onChange, _this$props;
            (_this$props$onChange = (_this$props = this.props).onChange) === null || _this$props$onChange === void 0 || _this$props$onChange.call(_this$props, this.props.id, (0, $30F9J.toMultiSelectValue)(options).map((v)=>v.value).join(','));
        }, this.formatOptionLabel = ({ iconUrl: iconUrl, label: label })=>{
            // Suppressing existing violation. Please fix this.
            return(// eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
            /*#__PURE__*/ $bSJIT.createElement((0, $lvEVI.default), {
                name: label,
                icon: iconUrl && /*#__PURE__*/ $bSJIT.createElement((0, $acAb6.default), {
                    src: iconUrl
                })
            }));
        }, this.formatCreateLabel = (input)=>{
            const { intl: intl } = this.props;
            return intl.formatMessage((0, $9uwAP.default).addAction, {
                value: input
            });
        }, this.isValidNewOption = (inputValue, _, selectOptions)=>{
            // Check whether the input value already corresponds to one of the available option.
            // We check whether the email matches the input exactly otherwise we show the option to create
            const isInputValueAnOption = selectOptions && Array.isArray(selectOptions) && selectOptions.filter((option)=>option.email === inputValue).length > 0;
            return !isInputValueAnOption && (0, $3ptbP.isEmail)(inputValue);
        }, this.getNoOptionsCreatable = ()=>{
            const { intl: intl } = this.props;
            return intl.formatMessage((0, $kjCfa.default).noOptionsCreatable);
        }, this.getNoOptions = ()=>{
            const { intl: intl } = this.props;
            return intl.formatMessage((0, $kjCfa.default).noOptions);
        };
    }
}
var $70a25e9740ab3d01$export$2e2bcd8739ae039 = (0, $fK3tS.default)($70a25e9740ab3d01$export$f9898dcf377cfa81);

});
parcelRegister("kjCfa", function(module, exports) {
$parcel$export(module.exports, "default", () => $9b7cdd16c0727059$export$2e2bcd8739ae039);

var $f0Pt4 = parcelRequire("f0Pt4");
var $9b7cdd16c0727059$export$2e2bcd8739ae039 = (0, $f0Pt4.defineMessages)({
    createAction: {
        defaultMessage: 'Create "{value}"',
        description: 'Action shown to users when they have the option to create a new user',
        id: 'cv.user.picker.create.action'
    },
    addAction: {
        defaultMessage: 'Add "{value}"',
        description: 'Action shown to users when they have the option to add a existing user',
        id: 'cv.user.picker.add.action'
    },
    placeholder: {
        defaultMessage: 'Enter name or email...',
        description: 'Placeholder shown for a user to enter a name or email.',
        id: 'cv.user.picker.placeholder'
    },
    noOptionsCreatable: {
        defaultMessage: 'Enter an email to add a user',
        description: 'Message shown to the user when no options were available and they have the option to add a new user.',
        id: 'cv.user.picker.no-options-creatable'
    },
    noOptions: {
        defaultMessage: 'No users found',
        description: 'Message shown to the user when no options were available',
        id: 'cv.user.picker.no-options'
    }
});

});

parcelRegister("4zp9W", function(module, exports) {
$parcel$export(module.exports, "UserPickerItem", () => (parcelRequire("lvEVI")).default);

var $lvEVI = parcelRequire("lvEVI");

});
parcelRegister("lvEVI", function(module, exports) {
$parcel$export(module.exports, "default", () => $97bf664401218cfd$export$2e2bcd8739ae039);

var $bSJIT = parcelRequire("bSJIT");

var $4v2A7 = parcelRequire("4v2A7");

var $acAb6 = parcelRequire("acAb6");

var $5cKiX = parcelRequire("5cKiX");

var $aFV7z = parcelRequire("aFV7z");

var $cExzV = parcelRequire("cExzV");

var $cLCyC = parcelRequire("cLCyC");
const $97bf664401218cfd$var$UserPickerItem = ({ icon: icon, name: name, email: email, isNew: isNew })=>{
    const content = email ? `${name} (${email})` : name;
    const iconComponent = typeof icon === 'string' ? /*#__PURE__*/ $bSJIT.createElement((0, $acAb6.default), {
        src: icon,
        alt: ""
    }) : icon;
    return /*#__PURE__*/ $bSJIT.createElement($97bf664401218cfd$var$UserPickerItemSectionFlex, null, /*#__PURE__*/ $bSJIT.createElement($97bf664401218cfd$var$FlexIconCardLayout, {
        leftIcon: iconComponent,
        content: content,
        iconSize: 16,
        iconMargin: 8,
        padding: 0
    }), isNew && /*#__PURE__*/ $bSJIT.createElement((0, $cExzV.default), {
        appearance: "discovery"
    }, /*#__PURE__*/ $bSJIT.createElement((0, $5cKiX.default), (0, $cLCyC.default).newUserLozengeText)));
};
var $97bf664401218cfd$export$2e2bcd8739ae039 = $97bf664401218cfd$var$UserPickerItem;
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $97bf664401218cfd$var$UserPickerItemSectionFlex = /*#__PURE__*/ (0, $4v2A7.default).div.withConfig({
    componentId: "sc-1ugscvf-0"
})`display:inline-flex;align-items:baseline;gap:${"var(--ds-space-100, 8px)"};grid-area:1 / 1 / 2 / 3;`;
// Constrains the name/email layout so it shrinks instead of pushing the lozenge off-line.
// Applied directly on IconCardLayout (via its forwarded className) rather than a parent-scoped
// nested selector, per go/ui-styling-standard.
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $97bf664401218cfd$var$FlexIconCardLayout = /*#__PURE__*/ (0, $4v2A7.default)((0, $aFV7z.IconCardLayout)).withConfig({
    componentId: "sc-1ugscvf-1"
})`flex:0 1 auto;width:auto;`;

});
parcelRegister("cLCyC", function(module, exports) {
$parcel$export(module.exports, "default", () => $faaa13d3cab79b15$export$2e2bcd8739ae039);

var $f0Pt4 = parcelRequire("f0Pt4");
var $faaa13d3cab79b15$export$2e2bcd8739ae039 = (0, $f0Pt4.defineMessages)({
    newUserLozengeText: {
        defaultMessage: 'New',
        description: 'Text for a status lozenge that shows next to users that will be newly created',
        id: 'cv.request.create.form.user.picker.new.user'
    }
});

});



parcelRegister("9uwAP", function(module, exports) {
$parcel$export(module.exports, "default", () => $d30f4206b7cdd065$export$2e2bcd8739ae039);

var $f0Pt4 = parcelRequire("f0Pt4");
var $d30f4206b7cdd065$export$2e2bcd8739ae039 = (0, $f0Pt4.defineMessages)({
    addAction: {
        defaultMessage: 'Add "{value}"',
        description: 'Action shown to users when they have the option to add a option',
        id: 'cv.multi.user.picker.add.action'
    }
});

});





parcelRegister("hJaAk", function(module, exports) {
$parcel$export(module.exports, "OrganisationPicker", () => (parcelRequire("hssCz")).default);

var $hssCz = parcelRequire("hssCz");

});
parcelRegister("hssCz", function(module, exports) {
$parcel$export(module.exports, "default", () => $af9218edb883cd79$export$2e2bcd8739ae039);

var $bSJIT = parcelRequire("bSJIT");

var $egQxE = parcelRequire("egQxE");

var $lJ0l5 = parcelRequire("lJ0l5");

var $BOq7h = parcelRequire("BOq7h");

var $aMIrF = parcelRequire("aMIrF");

var $gJqoA = parcelRequire("gJqoA");

var $ay2XP = parcelRequire("ay2XP");

var $30F9J = parcelRequire("30F9J");
parcelRequire("8yq8C");
var $fLhXC = parcelRequire("fLhXC");

var $3yYVZ = parcelRequire("3yYVZ");
class $af9218edb883cd79$export$ab2356e6e0b865c4 extends $bSJIT.PureComponent {
    static #_ = this.defaultProps = {
        organisations: []
    };
    componentDidMount() {
        const { organisations: organisations, enableSubmitButton: enableSubmitButton, defaultOrganisation: defaultOrganisation } = this.props;
        if (organisations) this.updateValue(organisations, true, defaultOrganisation);
        this.reporterChangesSub = this.reporterChanges.switchMap(({ projectId: projectId, organisationUserEmail: organisationUserEmail })=>{
            const { isNewReporter: isNewReporter } = this.props;
            if (isNewReporter) return (0, $lJ0l5.Observable).of([]);
            return (0, $aMIrF.fetchOrganisations)(projectId, organisationUserEmail)// If can error happens we'll just return an empty array so the stream stays subscribed.
            .catch((_)=>(0, $lJ0l5.Observable).of([]));
        }).subscribe((updatedOrganisations)=>{
            enableSubmitButton();
            this.setState({
                organisations: updatedOrganisations,
                isLoading: false
            });
            this.updateValue(updatedOrganisations, true, defaultOrganisation);
        }, ()=>{
            enableSubmitButton();
            this.setState({
                organisations: undefined,
                isLoading: false
            });
        });
    }
    componentWillUnmount() {
        this.reporterChangesSub.unsubscribe();
    }
    componentDidUpdate(prevProps) {
        const { projectId: projectId, organisationUserEmail: organisationUserEmail, disableSubmitButton: disableSubmitButton } = this.props;
        const reporterUpdated = prevProps.organisationUserEmail !== organisationUserEmail;
        if (reporterUpdated && projectId) {
            disableSubmitButton();
            this.setState({
                isLoading: true
            });
            this.reporterChanges.next({
                projectId: projectId,
                organisationUserEmail: organisationUserEmail
            });
        }
    }
    // In the case where we have a single organisation, we want to select that as the default
    // otherwise it should be a Private request by default
    updateValue(organisations, notFromUserInteraction, defaultOrganisation) {
        // If a default organisation is provided via URL params, select it first
        if (defaultOrganisation) {
            const selected = {
                label: defaultOrganisation.name,
                value: String(defaultOrganisation.id)
            };
            this.setState({
                selectedOrganisation: selected
            });
            this.onChange(selected, notFromUserInteraction);
            return;
        }
        if (organisations.length === 1 && this.props.shareWithOrgByDefault) {
            const [defaultOrg] = organisations;
            const selected = {
                label: defaultOrg.name,
                value: String(defaultOrg.id)
            };
            this.setState({
                selectedOrganisation: selected
            });
            this.onChange(selected, notFromUserInteraction);
        } else {
            const privateRequest = {
                label: (0, $3yYVZ.default).privateRequest.defaultMessage,
                value: ''
            };
            // @ts-ignore TS(2322) TypeScript upgrade 5.1.6, please fix this violation when you revisit this code.: Type '{ label: string | undefined; value: string; ... Remove this comment to see the full error message
            this.setState({
                selectedOrganisation: privateRequest
            });
            // @ts-ignore TS(2345) TypeScript upgrade 5.1.6, please fix this violation when you revisit this code.: Argument of type '{ label: string | undefined; val... Remove this comment to see the full error message
            this.onChange(privateRequest, notFromUserInteraction);
        }
    }
    render() {
        const { organisations: organisations, isLoading: isLoading, selectedOrganisation: selectedOrganisation } = this.state;
        const { description: description, id: id, disabled: disabled } = this.props;
        if (!organisations || !organisations.length) return null;
        return /*#__PURE__*/ $bSJIT.createElement((0, $fLhXC.default), {
            id: id,
            organisations: organisations,
            description: description,
            selected: selectedOrganisation,
            onSelectOrg: this.onChange,
            isLoading: isLoading,
            isDisabled: isLoading || disabled
        });
    }
    constructor(...args){
        super(...args), this.state = {
            organisations: this.props.organisations,
            defaultUser: this.props.organisationUserEmail,
            selectedOrganisation: undefined,
            isLoading: false
        }, this.reporterChanges = new (0, $gJqoA.Subject)(), // notFromUserInteraction here is to mark the change event as being not the result of
        // a user interaction but rather a side effect of something else. This is primarily used for
        // analytics at the moment
        this.onChange = (value, notFromUserInteraction)=>{
            var _this$props$onChange, _this$props;
            const organisation = (0, $30F9J.toSingleSelectValue)(value);
            if (organisation == null) return;
            this.setState({
                selectedOrganisation: organisation
            });
            (_this$props$onChange = (_this$props = this.props).onChange) === null || _this$props$onChange === void 0 || _this$props$onChange.call(_this$props, this.props.id, String(organisation.value), notFromUserInteraction);
        };
    }
}
const $af9218edb883cd79$var$selector = (0, $BOq7h.createSelector)((state, props)=>{
    const organisations = (0, $ay2XP.getOrganisationsForCurrentUser)(state, props.portalId, props.requestTypeId);
    return {
        organisations: organisations
    };
}, (organisationData)=>organisationData);
var $af9218edb883cd79$export$2e2bcd8739ae039 = (0, $egQxE.connect)($af9218edb883cd79$var$selector)($af9218edb883cd79$export$ab2356e6e0b865c4);

});
parcelRegister("aMIrF", function(module, exports) {
$parcel$export(module.exports, "fetchOrganisations", () => $3d69ed8d273d8155$export$7703463d715b54c6);

var $llRGw = parcelRequire("llRGw");

var $8jOUp = parcelRequire("8jOUp");

var $jBiia = parcelRequire("jBiia");

var $eDcdn = parcelRequire("eDcdn");
const $3d69ed8d273d8155$export$7703463d715b54c6 = (projectId, reporter, context = (0, $eDcdn.contextPath))=>{
    const uri = `${context}/rest/servicedesk/1/customer/organisations/project/${projectId}/member/account/${reporter}`;
    // Suppressing existing violation. Please fix this.
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    return (0, $llRGw.get)(uri)// Suppressing existing violation. Please fix this.
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    .map(({ response: response })=>response).catch((e)=>{
        (0, $jBiia.trackError)('organisation.fetch.failed', {}, e);
        // Rethrow error
        return (0, $8jOUp.Observable).throw(e);
    });
};

});

parcelRegister("8yq8C", function(module, exports) {
$parcel$export(module.exports, "OrganisationPickerDumb", () => (parcelRequire("fLhXC")).default);

var $fLhXC = parcelRequire("fLhXC");

});
parcelRegister("fLhXC", function(module, exports) {
$parcel$export(module.exports, "default", () => $8ea2410d6e5a5358$export$2e2bcd8739ae039);

var $bSJIT = parcelRequire("bSJIT");

var $4v2A7 = parcelRequire("4v2A7");

var $1zYnp = parcelRequire("1zYnp");

var $9K7mZ = parcelRequire("9K7mZ");

var $5cKiX = parcelRequire("5cKiX");
var $fK3tS = parcelRequire("fK3tS");

var $5FomD = parcelRequire("5FomD");

var $aanpT = parcelRequire("aanpT");

var $3yYVZ = parcelRequire("3yYVZ");
const $8ea2410d6e5a5358$var$privateOption = ()=>/*#__PURE__*/ $bSJIT.createElement($bSJIT.Fragment, null, /*#__PURE__*/ $bSJIT.createElement($8ea2410d6e5a5358$var$IconWrap, null, /*#__PURE__*/ $bSJIT.createElement((0, (/*@__PURE__*/$parcel$interopDefault($5FomD))), {
        label: "lock-icon"
    })), /*#__PURE__*/ $bSJIT.createElement((0, $5cKiX.default), (0, $3yYVZ.default).privateRequest));
const $8ea2410d6e5a5358$var$organisationOption = (orgName)=>/*#__PURE__*/ $bSJIT.createElement($bSJIT.Fragment, null, /*#__PURE__*/ $bSJIT.createElement($8ea2410d6e5a5358$var$IconWrap, null, /*#__PURE__*/ $bSJIT.createElement((0, (/*@__PURE__*/$parcel$interopDefault($aanpT))), {
        label: "unlocked-icon"
    })), /*#__PURE__*/ $bSJIT.createElement((0, $5cKiX.default), {
        ...(0, $3yYVZ.default).shareWith,
        values: {
            orgName: orgName
        }
    }));
const $8ea2410d6e5a5358$var$renderOption = (option)=>{
    if (!option.value) return $8ea2410d6e5a5358$var$privateOption();
    return $8ea2410d6e5a5358$var$organisationOption(option.label);
};
const $8ea2410d6e5a5358$var$createOption = (org)=>({
        label: org.name,
        value: String(org.id)
    });
const $8ea2410d6e5a5358$export$5f131c02b6b3718d = (props)=>{
    const { organisations: organisations, description: description, selected: selected, isLoading: isLoading, isDisabled: isDisabled, onSelectOrg: onSelectOrg, id: id, intl: intl } = props;
    const label = intl.formatMessage((0, $3yYVZ.default).shareWithLabel);
    const options = [
        ...organisations.map($8ea2410d6e5a5358$var$createOption),
        {
            label: intl.formatMessage((0, $3yYVZ.default).privateRequest),
            value: ''
        }
    ];
    return /*#__PURE__*/ $bSJIT.createElement($8ea2410d6e5a5358$export$ab2356e6e0b865c4, {
        id: id,
        required: true,
        label: label,
        description: description,
        options: options,
        value: selected,
        formatOptionLabel: $8ea2410d6e5a5358$var$renderOption,
        onChange: onSelectOrg,
        isLoading: isLoading,
        isDisabled: isLoading || isDisabled,
        backspaceRemovesValue: false
    });
};
var $8ea2410d6e5a5358$export$2e2bcd8739ae039 = (0, $fK3tS.default)($8ea2410d6e5a5358$export$5f131c02b6b3718d);
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $8ea2410d6e5a5358$var$IconWrap = /*#__PURE__*/ (0, $4v2A7.default).span.withConfig({
    componentId: "sc-1wc1gcr-0"
})`margin-right:${"var(--ds-space-050, 4px)"};`;
const $8ea2410d6e5a5358$export$ab2356e6e0b865c4 = /*#__PURE__*/ (0, $4v2A7.default)((0, $1zYnp.FieldSingleSelect)).withConfig({
    componentId: "sc-1wc1gcr-1"
})`display:inline-block;min-width:${$9K7mZ.multiple(30).px};`;

});
parcelRegister("3yYVZ", function(module, exports) {
$parcel$export(module.exports, "default", () => $f37ec342381fcc4d$export$2e2bcd8739ae039);

var $f0Pt4 = parcelRequire("f0Pt4");
var $f37ec342381fcc4d$export$2e2bcd8739ae039 = (0, $f0Pt4.defineMessages)({
    shareWith: {
        defaultMessage: 'Share with {orgName}',
        description: 'Label descibing the organisation the user is sharing their request with',
        id: 'cv.request.create.form.organisation.picker'
    },
    privateRequest: {
        defaultMessage: 'No one',
        description: 'Label indicating the user is making a private request',
        id: 'cv.request.create.form.organisation.picker.private'
    },
    shareWithLabel: {
        defaultMessage: 'Share with',
        description: 'Organisation picker field label',
        id: 'cv.request-create-form.organisation.picker.shareWithLabel'
    }
});

});





parcelRegister("l4hB6", function(module, exports) {
$parcel$export(module.exports, "RadioGroup", () => (parcelRequire("86Hmw")).default);
$parcel$export(module.exports, "ControlledRadioGroup", () => (parcelRequire("86Hmw")).ControlledRadioGroup);

var $86Hmw = parcelRequire("86Hmw");

});
parcelRegister("86Hmw", function(module, exports) {
$parcel$export(module.exports, "ControlledRadioGroup", () => $6163d284d4caf269$export$8053f6ba79274831);
$parcel$export(module.exports, "default", () => $6163d284d4caf269$export$2e2bcd8739ae039);

var $bSJIT = parcelRequire("bSJIT");

var $4v2A7 = parcelRequire("4v2A7");

var $fK3tS = parcelRequire("fK3tS");

var $j2RlN = parcelRequire("j2RlN");

var $iS8wm = parcelRequire("iS8wm");

var $7x378 = parcelRequire("7x378");

var $8nDF2 = parcelRequire("8nDF2");

var $hH3hi = parcelRequire("hH3hi");

var $96iPn = parcelRequire("96iPn");

var $3cPfj = parcelRequire("3cPfj");
const $6163d284d4caf269$var$NONE_OPTION_VALUE = '-1';
class $6163d284d4caf269$var$RadioGroup extends $bSJIT.PureComponent {
    render() {
        const { required: required, label: label, id: id, description: description, defaultValue: defaultValue, value: value, errorMessage: errorMessage, disabled: disabled, intl: intl, items: items = [] } = this.props;
        const radioItems = items.map((item)=>{
            return {
                label: item.label,
                name: item.name,
                value: item.value,
                isDisabled: disabled
            };
        });
        if (!required) radioItems.push({
            label: intl.formatMessage((0, $hH3hi.default).noneOptionLabel),
            name: id,
            value: $6163d284d4caf269$var$NONE_OPTION_VALUE,
            isDisabled: disabled
        });
        return /*#__PURE__*/ $bSJIT.createElement((0, $j2RlN.FieldBase), {
            htmlFor: id,
            noLabel: true,
            required: required,
            description: description,
            label: label,
            labelId: `label-${id}`,
            errorMessage: errorMessage
        }, /*#__PURE__*/ $bSJIT.createElement((0, $iS8wm.Fieldset), {
            legend: /*#__PURE__*/ $bSJIT.createElement($bSJIT.Fragment, null, label, required && /*#__PURE__*/ $bSJIT.createElement((0, $7x378.RequiredAsterisk), null))
        }, /*#__PURE__*/ $bSJIT.createElement($6163d284d4caf269$var$RadioGroupWrapper, null, /*#__PURE__*/ $bSJIT.createElement((0, $8nDF2.default), {
            isRequired: required,
            options: radioItems,
            onChange: this.onChange,
            ...value === undefined ? {
                defaultValue: defaultValue
            } : {
                value: value
            },
            "aria-describedby": `${id}-field-description`
        }))));
    }
    constructor(...args){
        super(...args), this.onChange = (e)=>{
            if (!this.props.onChange) return;
            if (this.props.value !== undefined) {
                var _this$props$items;
                const selectedItem = (_this$props$items = this.props.items) === null || _this$props$items === void 0 ? void 0 : _this$props$items.find((item)=>item.value === e.target.value);
                this.props.onChange(this.props.id, e.target.value, false, {
                    rawObject: selectedItem ?? {},
                    rawValue: selectedItem ?? null
                });
                return;
            }
            this.props.onChange(this.props.id, e.target.value);
        };
    }
}
const $6163d284d4caf269$var$IntlRadioGroup = (0, $fK3tS.default)($6163d284d4caf269$var$RadioGroup);
const $6163d284d4caf269$export$8053f6ba79274831 = (0, $96iPn.withControlledFormComponentValue)((_field, value)=>value, (0, $3cPfj.normalizeRadioButtonsValue))($6163d284d4caf269$var$IntlRadioGroup);
var $6163d284d4caf269$export$2e2bcd8739ae039 = $6163d284d4caf269$var$IntlRadioGroup;
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $6163d284d4caf269$var$RadioGroupWrapper = /*#__PURE__*/ (0, $4v2A7.default).div.withConfig({
    componentId: "sc-1smtcdf-0"
})`padding:${"var(--ds-space-075, 6px)"};`;

});
parcelRegister("iS8wm", function(module, exports) {
$parcel$export(module.exports, "Fieldset", () => $be42dc6f630a8f17$export$e154be390aa0e14);
/* fieldset.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $dc70d = parcelRequire("dc70d");
parcelRequire("bSJIT");

var $9fU1q = parcelRequire("9fU1q");

var $91vAL = parcelRequire("91vAL");
const $be42dc6f630a8f17$var$fieldSetStyles = null;
const $be42dc6f630a8f17$export$e154be390aa0e14 = ({ children: children, legend: legend })=>{
    return /*#__PURE__*/ (0, $dc70d.jsxs)("fieldset", {
        className: (0, $9fU1q.default)([
            "_1pfhu2gc"
        ]),
        children: [
            legend && /*#__PURE__*/ (0, $dc70d.jsx)((0, $91vAL.Legend), {
                children: legend
            }),
            children
        ]
    });
};

});
parcelRegister("91vAL", function(module, exports) {
$parcel$export(module.exports, "Legend", () => $246f719b71dedcfd$export$ed247974535929c7);
/* legend.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $dc70d = parcelRequire("dc70d");
parcelRequire("bSJIT");

var $9fU1q = parcelRequire("9fU1q");
const $246f719b71dedcfd$var$fieldsetLabelStyles = null;
const $246f719b71dedcfd$export$ed247974535929c7 = ({ children: children })=>{
    return /*#__PURE__*/ (0, $dc70d.jsx)("legend", {
        className: (0, $9fU1q.default)([
            "_11c8wadc _1e0c1o8l _syazazsu _k48pwu06 _6rth1b66 _1pfhze3t"
        ]),
        children: children
    });
};

});


parcelRegister("8nDF2", function(module, exports) {
$parcel$export(module.exports, "default", () => $8d3d7d30cb1ab0c7$export$2e2bcd8739ae039);

var $dc70d = parcelRequire("dc70d");

var $bSJIT = parcelRequire("bSJIT");

var $1OdZP = parcelRequire("1OdZP");

var $d6mTg = parcelRequire("d6mTg");

var $6B621 = parcelRequire("6B621");
const $8d3d7d30cb1ab0c7$var$noOptions = [];
function $8d3d7d30cb1ab0c7$export$2e2bcd8739ae039(props) {
    const { onChange: onChange, options: options = $8d3d7d30cb1ab0c7$var$noOptions, value: propValue, defaultValue: defaultValue, id: id, isDisabled: isDisabled, isRequired: isRequired, isInvalid: isInvalid, labelId: labelId, onInvalid: onInvalid = (0, $1OdZP.default), name: name, analyticsContext: analyticsContext, ['aria-labelledby']: ariaLabelledBy, testId: testId } = props;
    const uid = (0, $d6mTg.useId)();
    const [selectedValue, setSelectedValue] = (0, $bSJIT.useState)(propValue !== undefined ? propValue : defaultValue);
    const onRadioChange = (0, $bSJIT.useCallback)((e, analyticsEvent)=>{
        setSelectedValue(e.currentTarget.value);
        if (onChange) onChange(e, analyticsEvent);
    }, [
        onChange
    ]);
    // If propValue is provided than act as a controlled component
    // If not then act as an uncontrolled component using the value from state
    const value = typeof propValue !== 'undefined' ? propValue : selectedValue;
    return /*#__PURE__*/ (0, $dc70d.jsx)("div", {
        role: "radiogroup",
        // TODO: Make `aria-labelledby` a `never` in TS. See https://product-fabric.atlassian.net/browse/DSP-23009
        "aria-labelledby": labelId || ariaLabelledBy,
        "data-testid": testId,
        "aria-describedby": isInvalid ? `${id || uid}-error` : undefined,
        id: id || uid,
        children: options.map(({ ...optionProps }, index)=>{
            if (typeof isDisabled !== 'undefined') optionProps.isDisabled = isDisabled;
            const isChecked = value !== null && optionProps.value === value;
            return /*#__PURE__*/ (0, $bSJIT.createElement)((0, $6B621.default), {
                ...optionProps,
                name: name || optionProps.name,
                key: index,
                onChange: onRadioChange,
                onInvalid: onInvalid,
                isInvalid: isChecked && isInvalid,
                isChecked: isChecked,
                testId: optionProps.testId || testId,
                isRequired: isRequired,
                analyticsContext: analyticsContext
            });
        })
    });
}

});
parcelRegister("6B621", function(module, exports) {
$parcel$export(module.exports, "default", () => $ca4e1562b9186970$export$2e2bcd8739ae039);
/* radio.tsx generated by @compiled/babel-plugin v3.0.2 */ /// <reference types="node" />
// for typing `process`

var $dc70d = parcelRequire("dc70d");

var $bSJIT = parcelRequire("bSJIT");

var $9fU1q = parcelRequire("9fU1q");

var $kIUP1 = parcelRequire("kIUP1");

var $1OdZP = parcelRequire("1OdZP");

var $gdUUy = parcelRequire("gdUUy");
const $ca4e1562b9186970$var$packageName = undefined;
const $ca4e1562b9186970$var$packageVersion = undefined;
const $ca4e1562b9186970$var$noop = (0, $1OdZP.default);
const $ca4e1562b9186970$var$labelPaddingStyles = null;
const $ca4e1562b9186970$var$labelStyles = null;
const $ca4e1562b9186970$var$labelDisabledStyles = null;
const $ca4e1562b9186970$var$radioBaseStyles = null;
const $ca4e1562b9186970$var$radioInteractiveStyles = null;
const $ca4e1562b9186970$var$radioDisabledStyles = null;
const $ca4e1562b9186970$var$radioDisabledCheckedStyles = null;
const $ca4e1562b9186970$var$radioInvalidStyles = null;
// Preserve the input's zoom correction and focus outline while cross-fading states.
// Preserve non-spatial transitions for reduced motion, per the LDR:
// https://hello.atlassian.net/wiki/spaces/DST/pages/7402790985
const $ca4e1562b9186970$var$crossFadeStyles = null;
const $ca4e1562b9186970$var$InnerRadio = /*#__PURE__*/ (0, $bSJIT.forwardRef)(function Radio(props, ref) {
    const { ariaLabel: ariaLabel, 'aria-labelledby': ariaLabelledBy, isDisabled: isDisabled = false, isRequired: isRequired, isInvalid: isInvalid = false, isChecked: isChecked = false, label: label, labelId: labelId, name: name, onChange: onChange = $ca4e1562b9186970$var$noop, value: value, testId: testId, analyticsContext: analyticsContext, // events and all other input props
    ...rest } = props;
    const onChangeAnalytics = (0, $kIUP1.usePlatformLeafEventHandler)({
        fn: onChange,
        action: 'changed',
        analyticsData: analyticsContext,
        componentName: 'radio',
        packageName: $ca4e1562b9186970$var$packageName,
        packageVersion: $ca4e1562b9186970$var$packageVersion
    });
    return /*#__PURE__*/ (0, $dc70d.jsxs)("label", {
        "data-testid": testId && `${testId}--radio-label`,
        "data-disabled": isDisabled ? 'true' : undefined,
        className: (0, $9fU1q.default)([
            "_11c8fhey _1e0c1txw _vchhusvi _kqswh2mm _4cvr1y6m _syazi7uo",
            isDisabled && "_syaz1gmx _80om13gf"
        ]),
        children: [
            /*#__PURE__*/ (0, $dc70d.jsx)("input", {
                ...rest,
                // It is necessary only for Safari. It allows to render focus styles.
                tabIndex: 0,
                "aria-label": ariaLabel,
                // TODO: Make `aria-labelledby` a `never` in TS. See https://product-fabric.atlassian.net/browse/DSP-23009
                "aria-labelledby": labelId || ariaLabelledBy,
                checked: isChecked,
                disabled: isDisabled,
                name: name,
                onChange: onChangeAnalytics,
                required: isRequired,
                type: "radio",
                value: value,
                "data-testid": testId && `${testId}--radio-input`,
                // isInvalid is used in a nonstandard way so cannot
                // use :invalid selector
                "data-invalid": isInvalid ? 'true' : undefined,
                ref: ref,
                className: (0, $9fU1q.default)([
                    "_18s8ze3t _19it3vzd _2rko1qll _12ji1r31 _1qu2glyw _12y31o36 _v56415j1 _1e0c1txw _1bsb1tcg _4t3i1tcg _kqswh2mm _4cvr1h6o _1bah1h6o _1o9zidpf _bfhk4t47 _13diglyw _1q6q1j9a _1151rsbi _1s6w5w2r _tqbwidpf _t9ec1soj _s7n4jp4b _wstuglyw _16r2ucr4 _14mj1qll _qc5orqeg _z0ai120g _1qdg120g _18postnw _aetrb3bt _1peq1xmd",
                    (0, $gdUUy.fg)('platform_design_system_selection_radial_fade') && "_v564109b _qc5o109b _s0npglyw _11fnglyw _1hdqglyw",
                    !isDisabled && "_iosijmqp _11jyjmqp _f3ett94y _y2mvdfik _1bg41l7b _6tjkdfik _awqn1l7b _1rvql4ek _1p9jrsbi _x2tz1q28 _1iwz1q28 _sj8yr01l _jcko12kk _1dvdrsbi _60ak5w2r",
                    isDisabled && "_80om13gf _1q6q187o _1151bk0g _1s6w2sac",
                    isDisabled && isChecked && "_tqbwt94y",
                    isInvalid && !isDisabled && "_1151s4qr _11jys4qr"
                ])
            }),
            label ? /*#__PURE__*/ (0, $dc70d.jsx)("span", {
                className: (0, $9fU1q.default)([
                    "_85i5v77o _1q51v77o _y4ti1b66 _bozg1b66"
                ]),
                children: label
            }) : null
        ]
    });
});
/**
 * __Radio__
 *
 * A radio input allows users to select only one option from a number of choices. Radio is generally displayed in a radio group.
 *
 * - [Examples](https://atlassian.design/components/radio/examples)
 * - [Code](https://atlassian.design/components/radio/code)
 * - [Usage](https://atlassian.design/components/radio/usage)
 */ const $ca4e1562b9186970$var$Radio = /*#__PURE__*/ (0, $bSJIT.memo)(/*#__PURE__*/ (0, $bSJIT.forwardRef)(function Radio(props, ref) {
    return /*#__PURE__*/ (0, $dc70d.jsx)($ca4e1562b9186970$var$InnerRadio, {
        ...props,
        ref: ref
    });
}));
var $ca4e1562b9186970$export$2e2bcd8739ae039 = $ca4e1562b9186970$var$Radio;

});


parcelRegister("hH3hi", function(module, exports) {
$parcel$export(module.exports, "default", () => $1792d0e06ec23f57$export$2e2bcd8739ae039);

var $f0Pt4 = parcelRequire("f0Pt4");
var $1792d0e06ec23f57$export$2e2bcd8739ae039 = (0, $f0Pt4.defineMessages)({
    noneOptionLabel: {
        defaultMessage: 'None',
        description: 'Label for the radio group option to select no options.',
        id: 'sd.customerview.field.radio.group.none.option'
    }
});

});



parcelRegister("esIdH", function(module, exports) {
$parcel$export(module.exports, "Reporter", () => (parcelRequire("gxtE7")).default);

var $gxtE7 = parcelRequire("gxtE7");

});
parcelRegister("gxtE7", function(module, exports) {
$parcel$export(module.exports, "default", () => $3ea3f840b88dc036$export$2e2bcd8739ae039);

var $bSJIT = parcelRequire("bSJIT");
parcelRequire("dgSpO");
var $iDsx5 = parcelRequire("iDsx5");
class $3ea3f840b88dc036$var$Reporter extends $bSJIT.PureComponent {
    render() {
        return /*#__PURE__*/ $bSJIT.createElement((0, $iDsx5.default), {
            ...this.props,
            defaultUser: this.props.defaultReporter,
            id: "reporter",
            required: true
        });
    }
}
var $3ea3f840b88dc036$export$2e2bcd8739ae039 = $3ea3f840b88dc036$var$Reporter;

});
parcelRegister("dgSpO", function(module, exports) {
$parcel$export(module.exports, "UserPicker", () => (parcelRequire("iDsx5")).default);

var $iDsx5 = parcelRequire("iDsx5");

});
parcelRegister("iDsx5", function(module, exports) {
$parcel$export(module.exports, "default", () => $5962ea25f5b5f00e$export$2e2bcd8739ae039);

var $bSJIT = parcelRequire("bSJIT");

var $lFpPv = parcelRequire("lFpPv");

var $4ZMmh = parcelRequire("4ZMmh");

var $dp27t = parcelRequire("dp27t");
parcelRequire("7f2CH");
var $50Jh1 = parcelRequire("50Jh1");
class $5962ea25f5b5f00e$export$2e2bcd8739ae039 extends $bSJIT.PureComponent {
    render() {
        return /*#__PURE__*/ $bSJIT.createElement((0, $50Jh1.default), {
            ...this.props,
            loadOptions: this.loadOptions,
            ...this.isRequestCreateSkipDropdownInitialOptionsCallEnabled ? {
                onMenuOpen: this.handleMenuOpen,
                isLoading: this.state.isLoadingInitialOptions,
                defaultOptions: this.state.initialOptions
            } : {
                doInitialSearch: true
            }
        });
    }
    constructor(...args){
        super(...args), this.isRequestCreateSkipDropdownInitialOptionsCallEnabled = (0, $lFpPv.isRequestCreateSkipDropdownInitialOptionsCallEnabled)(), this.state = {
            initialOptions: [],
            isLoadingInitialOptions: false,
            hasFetchedInitialOptions: false
        }, this.loadOptions = (inputValue, callback)=>{
            // Disabling existing violations, should be fixed when revisited.
            // eslint-disable-next-line @typescript-eslint/no-floating-promises
            this.fetchUserDebounced(inputValue, callback);
        }, this.fetchUsers = (inputValue, callback)=>{
            return (0, $dp27t.searchUser)({
                fieldName: this.props.id,
                query: inputValue,
                portalId: this.props.portalId,
                fieldConfigId: this.props.fieldConfigId
            }).map((response)=>response.map((user)=>({
                        value: user.id,
                        label: user.displayName,
                        iconUrl: user.avatar,
                        email: user.emailAddress,
                        accountId: user.accountId
                    }))).toPromise().then(callback);
        }, this.fetchUserDebounced = (0, $4ZMmh.debounce)(this.fetchUsers, 400), this.handleMenuOpen = ()=>{
            if (!this.state.hasFetchedInitialOptions) {
                this.setState({
                    hasFetchedInitialOptions: true,
                    isLoadingInitialOptions: true
                });
                // Disabling existing violations, should be fixed when revisited.
                // eslint-disable-next-line @typescript-eslint/no-floating-promises
                this.fetchUsers('', (options)=>this.setState({
                        isLoadingInitialOptions: false,
                        initialOptions: options
                    }));
            }
        };
    }
}

});
parcelRegister("7f2CH", function(module, exports) {
$parcel$export(module.exports, "UserPickerDumb", () => (parcelRequire("50Jh1")).default);

var $50Jh1 = parcelRequire("50Jh1");

});
parcelRegister("50Jh1", function(module, exports) {
$parcel$export(module.exports, "default", () => $1667cd69bb96bc93$export$2e2bcd8739ae039);

var $bSJIT = parcelRequire("bSJIT");

var $lFpPv = parcelRequire("lFpPv");

var $1zYnp = parcelRequire("1zYnp");

var $fK3tS = parcelRequire("fK3tS");
parcelRequire("4zp9W");
var $lvEVI = parcelRequire("lvEVI");

var $kbBdI = parcelRequire("kbBdI");

var $30F9J = parcelRequire("30F9J");

var $kjCfa = parcelRequire("kjCfa");
parcelRequire("fOqQw");
var $3ptbP = parcelRequire("3ptbP");
class $1667cd69bb96bc93$export$72002aa2fe0510f1 extends $bSJIT.PureComponent {
    render() {
        const { disabled: disabled, defaultUser: defaultUser, doInitialSearch: doInitialSearch, canCreateUser: canCreateUser, defaultOptions: defaultOptions, createLabelType: createLabelType, onMenuOpen: onMenuOpen, isLoading: isLoading, intl: intl, onChange: onChange, ...otherProps } = this.props;
        const customComponents = {
            SingleValue: this.userPickerItem,
            Option: this.userPickerOption
        };
        if (this.shouldShowCreatabelSelect()) {
            const useShowNewLabelForCreatedValues = createLabelType === 'create';
            return /*#__PURE__*/ $bSJIT.createElement((0, $1zYnp.FormAsyncCreatableSingleSelect), {
                ...otherProps,
                formatCreateLabel: this.formatCreateLabel,
                isDisabled: disabled,
                isValidNewOption: this.isValidNewOption,
                components: customComponents,
                onChange: this.onChangeForSelectField,
                onMenuOpen: onMenuOpen,
                isLoading: isLoading,
                defaultValue: defaultUser,
                defaultOptions: doInitialSearch || defaultOptions,
                placeholder: intl.formatMessage((0, $kjCfa.default).placeholder),
                noOptionsMessage: this.getNoOptionsCreatable,
                showNewLabelForCreatedValues: useShowNewLabelForCreatedValues
            });
        }
        return /*#__PURE__*/ $bSJIT.createElement((0, $1zYnp.FormAsyncSingleSelect), {
            ...otherProps,
            loadOptions: this.props.loadOptions,
            isDisabled: disabled,
            components: customComponents,
            onMenuOpen: onMenuOpen,
            isLoading: isLoading,
            onChange: this.onChangeForSelectField,
            defaultValue: defaultUser,
            placeholder: intl.formatMessage((0, $kjCfa.default).placeholder),
            defaultOptions: doInitialSearch || defaultOptions,
            noOptionsMessage: this.getNoOptions
        });
    }
    constructor(...args){
        super(...args), this.onChangeForSelectField = (value)=>{
            var _this$props$onChange3, _this$props3, _this$props$onChange4, _this$props4;
            const selectedValue = (0, $30F9J.toSingleSelectValue)(value);
            if (selectedValue == null) {
                var _this$props$onChange, _this$props, _this$props$onChange2, _this$props2;
                (0, $lFpPv.isUserPickerSupportEnabled)() ? (_this$props$onChange = (_this$props = this.props).onChange) === null || _this$props$onChange === void 0 || _this$props$onChange.call(_this$props, this.props.id, '', false, {
                    rawObject: value ?? {},
                    rawValue: {
                        accountId: ''
                    }
                }) : (_this$props$onChange2 = (_this$props2 = this.props).onChange) === null || _this$props$onChange2 === void 0 || _this$props$onChange2.call(_this$props2, this.props.id, '', false, {
                    rawObject: value ?? {}
                });
                return;
            }
            (0, $lFpPv.isUserPickerSupportEnabled)() ? (_this$props$onChange3 = (_this$props3 = this.props).onChange) === null || _this$props$onChange3 === void 0 || _this$props$onChange3.call(_this$props3, this.props.id, selectedValue.value, false, {
                rawObject: value ?? {},
                rawValue: selectedValue ? {
                    accountId: selectedValue.value
                } : null
            }) : (_this$props$onChange4 = (_this$props4 = this.props).onChange) === null || _this$props$onChange4 === void 0 || _this$props$onChange4.call(_this$props4, this.props.id, selectedValue.value, false, {
                rawObject: value ?? {}
            });
        }, this.userPickerItem = ({ data: data })=>{
            const { iconUrl: iconUrl, label: label, email: email, isNew: isNew } = data;
            // Suppressing existing violation. Please fix this.
            // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
            return /*#__PURE__*/ $bSJIT.createElement((0, $lvEVI.default), {
                name: label,
                icon: iconUrl,
                email: email,
                isNew: isNew
            });
        }, this.userPickerOption = ({ data: data, ...props })=>{
            const { iconUrl: iconUrl, label: label, email: email, isNew: isNew } = data;
            return /*#__PURE__*/ $bSJIT.createElement((0, $kbBdI.components).Option, {
                ...props,
                data: data
            }, /*#__PURE__*/ $bSJIT.createElement((0, $lvEVI.default), {
                name: label,
                icon: iconUrl,
                email: email,
                isNew: isNew
            }));
        }, this.formatCreateLabel = (input)=>{
            const { intl: intl, createLabelType: createLabelType } = this.props;
            if (createLabelType === 'create') return intl.formatMessage((0, $kjCfa.default).createAction, {
                value: input
            });
            if (createLabelType === 'add') return intl.formatMessage((0, $kjCfa.default).addAction, {
                value: input
            });
            return input;
        }, this.isValidNewOption = (inputValue, _, selectOptions)=>{
            // Check whether the input value already corresponds to one of the available option.
            // We check whether the email matches the input exactly otherwise we show the option to create
            const isInputValueAnOption = selectOptions && Array.isArray(selectOptions) && selectOptions.filter((option)=>option.email === inputValue).length > 0;
            return !isInputValueAnOption && (0, $3ptbP.isEmail)(inputValue);
        }, this.shouldShowCreatabelSelect = ()=>{
            const { canCreateUser: canCreateUser } = this.props;
            if (canCreateUser) return true;
            return false;
        }, this.getNoOptionsCreatable = ()=>{
            const { intl: intl } = this.props;
            return intl.formatMessage((0, $kjCfa.default).noOptionsCreatable);
        }, this.getNoOptions = ()=>{
            const { intl: intl } = this.props;
            return intl.formatMessage((0, $kjCfa.default).noOptions);
        };
    }
}
var $1667cd69bb96bc93$export$2e2bcd8739ae039 = (0, $fK3tS.default)($1667cd69bb96bc93$export$72002aa2fe0510f1);

});






parcelRegister("8UJBN", function(module, exports) {
$parcel$export(module.exports, "RequestCreateAttachmentField", () => (parcelRequire("4tm1w")).default);

var $4tm1w = parcelRequire("4tm1w");

});
parcelRegister("4tm1w", function(module, exports) {
$parcel$export(module.exports, "default", () => $0b3de0f9894a4f4b$export$2e2bcd8739ae039);

var $bSJIT = parcelRequire("bSJIT");

var $egQxE = parcelRequire("egQxE");

var $gnjRF = parcelRequire("gnjRF");

var $eNRmj = parcelRequire("eNRmj");

var $gUbcQ = parcelRequire("gUbcQ");

var $ik9zp = parcelRequire("ik9zp");
parcelRequire("gWtPh");
var $7AClH = parcelRequire("7AClH");
parcelRequire("57cqK");
var $2B4FM = parcelRequire("2B4FM");
parcelRequire("kl1Qg");
var $aWhly = parcelRequire("aWhly");
const $0b3de0f9894a4f4b$export$6df17d9d790736ce = 600000; // 10 minutes
class $0b3de0f9894a4f4b$var$RequestCreateAttachmentField extends $bSJIT.PureComponent {
    componentDidMount() {
        if (!this.props.mediaApiUploadToken) this.props.fetchPortalUploadMediaToken(this.props.portalId);
    }
    componentWillUnmount() {
        if (this.timeout) clearTimeout(this.timeout);
    }
    render() {
        const { id: id, label: label, description: description, errorMessage: errorMessage, mediaApiError: mediaApiError, required: required, mediaApiUploadToken: mediaApiUploadToken, blockFormSubmission: blockFormSubmission } = this.props;
        if (mediaApiUploadToken) return /*#__PURE__*/ $bSJIT.createElement((0, $7AClH.default), {
            renderError: this.renderError
        }, /*#__PURE__*/ $bSJIT.createElement((0, $2B4FM.default), {
            ...this.props,
            mediaApiUploadToken: mediaApiUploadToken,
            saveAttachment: this.saveAttachment,
            authProvider: this.authProvider,
            blockFormSubmission: blockFormSubmission
        }));
        return /*#__PURE__*/ $bSJIT.createElement((0, $aWhly.default), {
            id: id,
            label: label,
            description: description,
            required: required,
            errorMessage: errorMessage,
            mediaApiError: mediaApiError
        });
    }
    constructor(...args){
        super(...args), this.timeout = undefined, this.mediaUploadAuth = undefined, this.authProvider = async ()=>{
            if (this.mediaUploadAuth) return this.mediaUploadAuth;
            const { portalId: portalId } = this.props;
            const { clientId: clientId, token: token, endpointUrl: baseUrl } = await (0, $eNRmj.getUploadCredentials)(portalId);
            this.mediaUploadAuth = {
                clientId: clientId,
                token: token,
                baseUrl: baseUrl
            };
            // Ideally token should be expired based on expiryEpoch on the response from getUploadCredentials
            // The token expires in 20 minutes
            this.timeout = setTimeout(()=>{
                this.mediaUploadAuth = undefined;
            }, $0b3de0f9894a4f4b$export$6df17d9d790736ce); // Cache token for 10 minutes
            return {
                clientId: clientId,
                token: token,
                baseUrl: baseUrl
            };
        }, this.saveAttachment = (fileId)=>{
            return (0, $gnjRF.default)(this.props.portalId, fileId);
        }, this.renderError = ()=>{
            const { id: id, label: label } = this.props;
            return /*#__PURE__*/ $bSJIT.createElement((0, $aWhly.default), {
                id: id,
                label: label
            });
        };
    }
}
const $0b3de0f9894a4f4b$var$selector = (state, props)=>{
    const { portalId: portalId } = props;
    const mediaApiUploadToken = (0, $ik9zp.getMediaApiUploadToken)(state, portalId);
    const mediaApiError = (0, $ik9zp.getMediaApiError)(state, portalId);
    return {
        ...props,
        mediaApiUploadToken: mediaApiUploadToken,
        mediaApiError: mediaApiError
    };
};
var $0b3de0f9894a4f4b$export$2e2bcd8739ae039 = (0, $egQxE.connect)($0b3de0f9894a4f4b$var$selector, {
    fetchPortalUploadMediaToken: (0, $gUbcQ.fetchPortalUploadMediaTokenAction)
})($0b3de0f9894a4f4b$var$RequestCreateAttachmentField);

});
parcelRegister("gnjRF", function(module, exports) {
$parcel$export(module.exports, "default", () => $8f7f09b917bfe28c$export$2e2bcd8739ae039);

var $llRGw = parcelRequire("llRGw");

var $8jOUp = parcelRequire("8jOUp");

var $jBiia = parcelRequire("jBiia");

var $eDcdn = parcelRequire("eDcdn");
const $8f7f09b917bfe28c$var$saveAttachment = (portalId, fileId)=>{
    // Suppressing existing violation. Please fix this.
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    return (0, $llRGw.post)(`${(0, $eDcdn.contextPath)}/rest/servicedesk/1/customer/portal/${portalId}/media/upload`, {
        fileId: fileId
    }, {
        'Content-Type': 'application/json'
    }).map((res)=>({
            // Suppressing existing violation. Please fix this.
            // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access
            attachmentId: res.response.attachmentId
        })).catch((res)=>{
        (0, $jBiia.trackError)('attachment.save.failed', {}, res);
        // Suppressing existing violation. Please fix this.
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access
        const errors = res.response.errors;
        // Suppressing existing violation. Please fix this.
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access
        const error = errors && errors.length && errors[0].errorMessage;
        return (0, $8jOUp.Observable).throw(error);
    });
};
var $8f7f09b917bfe28c$export$2e2bcd8739ae039 = $8f7f09b917bfe28c$var$saveAttachment;

});

parcelRegister("gWtPh", function(module, exports) {
$parcel$export(module.exports, "UnSupportedBrowserErrorBoundary", () => (parcelRequire("7AClH")).default);
parcelRequire("kNF1d");
var $7AClH = parcelRequire("7AClH");

});
parcelRegister("kNF1d", function(module, exports) {
$parcel$export(module.exports, "UnSupportedBrowserErrorBoundary", () => (parcelRequire("7AClH")).default);

var $7AClH = parcelRequire("7AClH");

});
parcelRegister("7AClH", function(module, exports) {
$parcel$export(module.exports, "default", () => $b685504f68414fb4$export$2e2bcd8739ae039);

var $bSJIT = parcelRequire("bSJIT");

var $a6ENB = parcelRequire("a6ENB");

var $cvZci = parcelRequire("cvZci");
const $b685504f68414fb4$var$isUnSupportedBrowser = ()=>{
    return (0, $cvZci.isOldSafari)();
};
class $b685504f68414fb4$export$99acd2c5aad927c extends $bSJIT.Component {
    componentDidCatch(error) {
        const { onError: onError } = this.props;
        if ($b685504f68414fb4$var$isUnSupportedBrowser()) {
            /**
       * Report error to sentry and don't re-throw the error
       */ (0, $a6ENB.reportError)(error);
            if (onError) onError(error);
        } else throw error;
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    render() {
        const { children: children, renderError: renderError } = this.props;
        const { error: error } = this.state;
        if (error) return renderError ? renderError() : null;
        return children;
    }
    constructor(...args){
        super(...args), this.state = {
            error: undefined
        };
    }
}
var $b685504f68414fb4$export$2e2bcd8739ae039 = $b685504f68414fb4$export$99acd2c5aad927c;

});



parcelRegister("57cqK", function(module, exports) {
$parcel$export(module.exports, "RequestCreateAttachmentFieldDumb", () => (parcelRequire("2B4FM")).default);

var $2B4FM = parcelRequire("2B4FM");

});
parcelRegister("2B4FM", function(module, exports) {
$parcel$export(module.exports, "default", () => $8a01d913566a748c$export$2e2bcd8739ae039);

var $bSJIT = parcelRequire("bSJIT");

var $4ZMmh = parcelRequire("4ZMmh");

var $ejaUb = parcelRequire("ejaUb");

var $j2RlN = parcelRequire("j2RlN");
class $8a01d913566a748c$var$RequestCreateAttachmentFieldDumb extends $bSJIT.PureComponent {
    render() {
        const { label: label, description: description, errorMessage: errorMessage, mediaApiUploadToken: mediaApiUploadToken, blockFormSubmission: blockFormSubmission, required: required, disabled: disabled, authProvider: authProvider, saveAttachment: saveAttachment, id: id } = this.props;
        return /*#__PURE__*/ $bSJIT.createElement((0, $j2RlN.FieldBase), {
            htmlFor: id,
            label: label,
            description: description,
            required: required,
            errorMessage: errorMessage
        }, /*#__PURE__*/ $bSJIT.createElement((0, $ejaUb.Attachments), {
            onChange: this.onChange,
            authProvider: authProvider,
            collection: mediaApiUploadToken.targetCollection,
            saveAttachment: saveAttachment,
            blockFormSubmission: blockFormSubmission,
            onError: this.onError,
            disabled: disabled,
            hasError: !(0, $4ZMmh.isEmpty)(errorMessage),
            "aria-describedby": `${id}-field-description`
        }));
    }
    constructor(...args){
        super(...args), this.onChange = (value)=>{
            this.props.onChange && this.props.onChange(this.props.id, value);
        }, this.onError = (messages)=>{
            this.props.onError && this.props.onError({
                messages: messages,
                name: this.props.id
            });
        };
    }
}
var $8a01d913566a748c$export$2e2bcd8739ae039 = $8a01d913566a748c$var$RequestCreateAttachmentFieldDumb;

});
parcelRegister("ejaUb", function(module, exports) {
$parcel$export(module.exports, "Attachments", () => $bc66eab919d7ed77$export$c129802f229d9594);

var $cVM5r = parcelRequire("cVM5r");

var $cJJTb = parcelRequire("cJJTb");

const $bc66eab919d7ed77$export$c129802f229d9594 = (0, $cVM5r.default)({
    loader: (0, $cJJTb.lazyForPaint)(()=>(parcelRequire("lpR9D")), {
        moduleId: "./src/view/common/attachments/attachments.tsx"
    })
});

});
parcelRegister("lpR9D", function(module, exports) {

var $kOunM = parcelRequire("kOunM");
module.exports = Promise.all([
    $kOunM("272yQ"),
    $kOunM("i7OVH")
]).then(()=>parcelRequire('5XdNJ'));

});




parcelRegister("kl1Qg", function(module, exports) {
$parcel$export(module.exports, "RequestCreateAttachmentFieldError", () => (parcelRequire("aWhly")).default);

var $aWhly = parcelRequire("aWhly");

});
parcelRegister("aWhly", function(module, exports) {
$parcel$export(module.exports, "default", () => $20f8a6c710fb10e1$export$2e2bcd8739ae039);

var $bSJIT = parcelRequire("bSJIT");

var $4v2A7 = parcelRequire("4v2A7");

var $fU62V = parcelRequire("fU62V");

var $5cKiX = parcelRequire("5cKiX");

var $j2RlN = parcelRequire("j2RlN");

var $gX1qf = parcelRequire("gX1qf");
const $20f8a6c710fb10e1$var$RequestCreateAttachmentFieldError = ({ label: label, description: description, required: required, errorMessage: errorMessage, mediaApiError: mediaApiError, id: id })=>{
    return /*#__PURE__*/ $bSJIT.createElement((0, $j2RlN.FieldBase), {
        htmlFor: id,
        label: label,
        description: description,
        required: required,
        errorMessage: errorMessage
    }, /*#__PURE__*/ $bSJIT.createElement($20f8a6c710fb10e1$var$Error, null, mediaApiError || /*#__PURE__*/ $bSJIT.createElement((0, $5cKiX.default), (0, $gX1qf.default).genericError)));
};
var $20f8a6c710fb10e1$export$2e2bcd8739ae039 = $20f8a6c710fb10e1$var$RequestCreateAttachmentFieldError;
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $20f8a6c710fb10e1$var$Error = /*#__PURE__*/ (0, $4v2A7.default).div.withConfig({
    componentId: "sc-jcr6mx-0"
})`${$fU62V.borderRadius};border:${"var(--ds-border-width, 1px)"} solid ${"var(--ds-border-danger, #BF2600)"};width:100%;padding:${"var(--ds-space-100, 8px)"};text-align:center;`;

});
parcelRegister("gX1qf", function(module, exports) {
$parcel$export(module.exports, "default", () => $8c8ff9c665c5193b$export$2e2bcd8739ae039);

var $f0Pt4 = parcelRequire("f0Pt4");
var $8c8ff9c665c5193b$export$2e2bcd8739ae039 = (0, $f0Pt4.defineMessages)({
    genericError: {
        defaultMessage: 'An error occurred when loading the attachments field',
        description: 'Default message when an error occurs loading the media picker',
        id: 'sd.request.create.attachment.field.error'
    }
});

});





parcelRegister("bny4J", function(module, exports) {
$parcel$export(module.exports, "FormRichTextArea", () => (parcelRequire("26Nuz")).FormRichTextArea);

var $26Nuz = parcelRequire("26Nuz");

});
parcelRegister("26Nuz", function(module, exports) {
$parcel$export(module.exports, "FormRichTextArea", () => $706e74c2a2c96531$export$5493e8865eb5ab09);
/* rich-text-area.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $9fU1q = parcelRequire("9fU1q");

var $bSJIT = parcelRequire("bSJIT");

var $inh7J = parcelRequire("inh7J");

var $jcRK7 = parcelRequire("jcRK7");

var $hF8Ik = parcelRequire("hF8Ik");

var $oR6fe = parcelRequire("oR6fe");

var $j2RlN = parcelRequire("j2RlN");

var $96iPn = parcelRequire("96iPn");

var $87QgR = parcelRequire("87QgR");

var $2Zepk = parcelRequire("2Zepk");

var $jBiia = parcelRequire("jBiia");
class $706e74c2a2c96531$var$RichTextArea extends $bSJIT.Component {
    componentDidUpdate(prevProps) {
        // Update editor content when value changes and UI modifications are enabled
        if (this.props.shouldReplaceValue && prevProps.value !== this.props.value && this.editorActions && this.props.value !== undefined) this.editorActions.replaceDocument(this.props.value);
    }
    render() {
        const { id: id, label: label, required: required, errorMessage: errorMessage, description: description, disabled: disabled, defaultValue: defaultValue, fieldConfigs: fieldConfigs, value: value } = this.props;
        const editorProps = (0, $87QgR.default).checkGate('request_create_inline_attachment') ? {
            mediaContext: this.props.mediaContext
        } : {};
        const updatedDefaultValue = defaultValue ?? value;
        return /*#__PURE__*/ $bSJIT.createElement((0, $j2RlN.FieldBase), {
            label: label,
            description: description,
            htmlFor: id,
            required: required,
            errorMessage: errorMessage
        }, /*#__PURE__*/ $bSJIT.createElement("div", {
            id: id,
            "data-test-id": "rich-text-area-field",
            "aria-label": label,
            onBlur: this.onFieldBlur,
            className: (0, $9fU1q.default)([
                "_16jlkb7n _1o9zkb7n _i0dl1osq _1it91qi0 _165v1w7i _arztr5cv _1n18rsbi _wdezmag2 _h9ctidpf _168zidpf _1tnhidpf _1kalidpf _1rxnr5cv _1pom1qi0 _1m86mag2 _bbdp8bwy _11rh1l4g _1k1o1j9a _1skf8bwy _j1fv1l4g _1xz81j9a _1og910ko _5uu810ko _tvk11j9a _5chu1j9a",
                errorMessage ? "_1iun1jh0 _1n1816c1" : "_172m1r31 _1xdeglyw _1w6j1o36 _1n1817va"
            ])
        }, /*#__PURE__*/ $bSJIT.createElement((0, $oR6fe.default), {
            isExpanded: true,
            editorType: "field",
            isEmojiEnabled: true,
            disabled: !!disabled,
            onChange: this.onFieldChangeDebounced,
            defaultValue: updatedDefaultValue,
            fieldConfigs: fieldConfigs,
            onInternalRender: this.handleInternalRender,
            // TODO: editor currently does not support aria-labelledby, so we are using ariaLabel for now
            ariaLabel: label,
            ariaDescribedby: `${id}-field-description`,
            LoadingComponent: (0, $hF8Ik.FieldLoadingSkeleton),
            ...editorProps
        })));
    }
    constructor(...args){
        super(...args), this.handleInternalRender = (editorActions)=>{
            this.editorActions = editorActions;
        }, this.onFieldChange = (transformedDoc)=>{
            const { id: id, onChange: onChange } = this.props;
            if (onChange) {
                // When the fields content is cleared we reset it's value to an empty string in order to correctly display the dirty form warning
                const correctValue = (0, $2Zepk.isOnlyWhitespaceAdf)(transformedDoc) ? '' : JSON.stringify(transformedDoc);
                onChange(id, correctValue, false, {
                    rawObject: {},
                    rawValue: correctValue
                });
            }
        }, this.onFieldBlur = (event)=>{
            // Check if the focus is moving to an element within this component
            const currentTarget = event.currentTarget;
            const relatedTarget = event.relatedTarget;
            // If relatedTarget is within the currentTarget, don't trigger blur
            if (relatedTarget && currentTarget.contains(relatedTarget)) return;
            if (this.props.onFieldBlurredByUser) {
                var _this$editorActions;
                const { onFieldBlurredByUser: onFieldBlurredByUser } = this.props;
                // Handle the promise properly to avoid floating promise error
                (_this$editorActions = this.editorActions) === null || _this$editorActions === void 0 || _this$editorActions.getValue().then((transformedDoc)=>{
                    const correctValue = (0, $2Zepk.isOnlyWhitespaceAdf)(transformedDoc) ? '' : JSON.stringify(transformedDoc);
                    onFieldBlurredByUser({
                        field: this.props.id,
                        value: correctValue,
                        additionalFieldData: {
                            rawObject: {},
                            rawValue: correctValue
                        }
                    });
                }).catch((error)=>{
                    (0, $jBiia.trackError)('rich.text.area.failed.to.get.value', {
                        message: JSON.stringify(error)
                    }, `Rich text area: Failed to get value from editor`);
                });
            }
        }, this.onFieldChangeDebounced = (0, (/*@__PURE__*/$parcel$interopDefault($inh7J)))(this.onFieldChange, (0, $jcRK7.USER_TYPING_DEBOUNCE_TIME));
    }
}
var $706e74c2a2c96531$export$2e2bcd8739ae039 = $706e74c2a2c96531$var$RichTextArea;
const $706e74c2a2c96531$var$ControlledRichTextArea = (0, $96iPn.withControlledFormComponentValue)((_field, value)=>value)($706e74c2a2c96531$var$RichTextArea);
const $706e74c2a2c96531$export$5493e8865eb5ab09 = $706e74c2a2c96531$var$ControlledRichTextArea;
// Manual overrides required to theme the editor to look like a request create form field
const $706e74c2a2c96531$var$wrapperStyles = null;
const $706e74c2a2c96531$var$errorStyles = null;
const $706e74c2a2c96531$var$noErrorStyles = null;

});
parcelRegister("oR6fe", function(module, exports) {
$parcel$export(module.exports, "default", () => $0b9e36e1ab3fab29$export$2e2bcd8739ae039);

var $bSJIT = parcelRequire("bSJIT");

var $egQxE = parcelRequire("egQxE");

var $BOq7h = parcelRequire("BOq7h");

var $cVM5r = parcelRequire("cVM5r");

var $7RZPz = parcelRequire("7RZPz");

var $dTM5i = parcelRequire("dTM5i");

var $cJJTb = parcelRequire("cJJTb");

var $aI0YR = parcelRequire("aI0YR");

var $iPFsM = parcelRequire("iPFsM");

var $81Vbr = parcelRequire("81Vbr");

var $30REn = parcelRequire("30REn");

var $90RSm = parcelRequire("90RSm");

/**
 *  (Currently) the editor supports 2 rendering modes in the Portal, it can render either as a comment box or as a field in the request create form.
 *  Both cases can be see as being "semi-uncontrolled" components.
 *
 *  In the case of the comment box, we copy the ADF document to redux UI state on submit
 *  so we can re-populate the editor if the request fails.
 *
 *  In the case of the field, we update Formik's internal state as the user types, and use that value when submitting the form.
 *
 */ const $0b9e36e1ab3fab29$var$AsyncRichTextEditor = (props)=>{
    const prevProps = $bSJIT.useRef(props);
    $bSJIT.useEffect(()=>{
        prevProps.current = props;
    });
    const AsyncEditor = $bSJIT.useMemo(()=>(0, $cVM5r.default)({
            loader: (0, $cJJTb.lazyForPaint)(()=>(parcelRequire("7OWzr")), {
                ssr: false,
                moduleId: "./packages/common-utils/rich-text-editor-v2/src/hocs.tsx"
            }),
            LoadingSkeleton: props.LoadingComponent
        }), // oxlint-disable-next-line react-hooks/exhaustive-deps
    [
        props.editorType
    ]);
    return /*#__PURE__*/ $bSJIT.createElement(AsyncEditor, props);
};
const $0b9e36e1ab3fab29$var$EditorWithTranslations = /*#__PURE__*/ $bSJIT.memo(function EditorWithTranslationsV2(ownProps) {
    const { locale: locale, LoadingComponent: LoadingComponent = ()=>null } = ownProps;
    const [intlMessages, setIntlMessages] = $bSJIT.useState();
    const [error, setError] = $bSJIT.useState();
    $bSJIT.useEffect(()=>{
        (0, $90RSm.promiseWithRetries)(()=>(0, $iPFsM.importLocaleMessages)(locale)).then((loaded)=>{
            setIntlMessages(loaded);
        }).catch((err)=>{
            setError(err);
        });
    }, [
        locale
    ]);
    if (!intlMessages) return /*#__PURE__*/ $bSJIT.createElement(LoadingComponent, {
        error: error,
        isLoading: !error
    });
    return /*#__PURE__*/ $bSJIT.createElement((0, $dTM5i.default), {
        messages: intlMessages,
        locale: (0, $81Vbr.getLanguageFromLocale)(locale),
        onError: (0, $7RZPz.onIntlNextError)
    }, /*#__PURE__*/ $bSJIT.createElement($0b9e36e1ab3fab29$var$AsyncRichTextEditor, ownProps));
});
const $0b9e36e1ab3fab29$export$3301e0145bb4a9b5 = (props)=>{
    const { LoadingComponent: LoadingComponent = ()=>null } = props;
    const portalLocale = (0, $30REn.usePortalLocale)();
    // Inside a portal page the editor follows the portal's locale; everywhere else
    // (CSM request details, embedded pages) it stays on the account locale the
    // Redux selector supplied.
    const locale = portalLocale ? (0, $iPFsM.getNormalizedLocale)(portalLocale) : props.locale;
    // If the users locale is english, which is the editors default locale, we can avoid requiring the locale unnecessarily
    if (locale === 'en') return /*#__PURE__*/ $bSJIT.createElement($0b9e36e1ab3fab29$var$AsyncRichTextEditor, {
        ...props,
        LoadingComponent: LoadingComponent
    });
    return /*#__PURE__*/ $bSJIT.createElement($0b9e36e1ab3fab29$var$EditorWithTranslations, {
        ...props,
        locale: locale,
        LoadingComponent: LoadingComponent
    });
};
const $0b9e36e1ab3fab29$var$selector = (0, $BOq7h.createSelector)((state)=>(0, $aI0YR.getLocale)(state), (locale)=>({
        locale: (0, $iPFsM.getNormalizedLocale)(locale)
    }));
var $0b9e36e1ab3fab29$export$2e2bcd8739ae039 = (0, $egQxE.connect)($0b9e36e1ab3fab29$var$selector)($0b9e36e1ab3fab29$export$3301e0145bb4a9b5);

});
parcelRegister("7OWzr", function(module, exports) {

var $kOunM = parcelRequire("kOunM");
module.exports = Promise.all([
    $kOunM("cW2Rw"),
    $kOunM("br2rQ"),
    $kOunM("aA07X"),
    $kOunM("7k2Dk"),
    $kOunM("9Vb2H"),
    $kOunM("6qSv5"),
    $kOunM("3BiwA"),
    $kOunM("3cwQ2"),
    $kOunM("ihkwh"),
    $kOunM("36aBu"),
    $kOunM("1fqfR"),
    $kOunM("9pCDc"),
    $kOunM("hyEGg"),
    $kOunM("iZJsN"),
    $kOunM("eTibs"),
    $kOunM("coIBk"),
    $kOunM("hxYvx"),
    $kOunM("3M7DB"),
    $kOunM("lzQaK"),
    $kOunM("bZkRg"),
    $kOunM("8vIDD"),
    $kOunM("euwch"),
    $kOunM("kwMqK"),
    $kOunM("fe9LF"),
    $kOunM("nZyiB")
]).then(()=>parcelRequire('6nmjq'));

});




parcelRegister("4uFRA", function(module, exports) {
$parcel$export(module.exports, "SummaryField", () => (parcelRequire("c4tGx")).default);

var $c4tGx = parcelRequire("c4tGx");

});
parcelRegister("c4tGx", function(module, exports) {
$parcel$export(module.exports, "default", () => $63a46784450149e5$export$2e2bcd8739ae039);

var $bSJIT = parcelRequire("bSJIT");

var $egQxE = parcelRequire("egQxE");

var $jcRK7 = parcelRequire("jcRK7");

var $8jOUp = parcelRequire("8jOUp");
var $aAAtt = parcelRequire("aAAtt");

var $5RxZm = parcelRequire("5RxZm");

var $4ZMmh = parcelRequire("4ZMmh");

var $kbQUS = parcelRequire("kbQUS");

var $1xrTy = parcelRequire("1xrTy");

var $ik9zp = parcelRequire("ik9zp");

var $kIbto = parcelRequire("kIbto");

var $2usNr = parcelRequire("2usNr");

var $haAAx = parcelRequire("haAAx");

var $jBiia = parcelRequire("jBiia");

var $h92tT = parcelRequire("h92tT");
parcelRequire("5cEov");
var $iAOpR = parcelRequire("iAOpR");
const $63a46784450149e5$var$KB_SUGGESTIONS_MIN_QUERY_LENGTH = 3;
class $63a46784450149e5$export$b75b6a6cc3a70ff8 extends $bSJIT.PureComponent {
    componentDidMount() {
        this.subscription = new (0, $aAAtt.Subscription)();
    }
    componentWillUnmount() {
        this.subscription.unsubscribe();
        const { fetchKBSuggestionsSuccess: fetchKBSuggestionsSuccess, portalId: portalId } = this.props;
        fetchKBSuggestionsSuccess({
            portalId: portalId,
            kbArticleSuggestions: []
        });
    }
    render() {
        const { knowledgeBase: knowledgeBase, onFieldBlurredByUser: onFieldBlurredByUser, kbSuggestions: kbSuggestions, ...props } = this.props;
        return /*#__PURE__*/ $bSJIT.createElement((0, $iAOpR.default), {
            ...props,
            onChange: this.onChange,
            onFieldBlurredByUser: onFieldBlurredByUser,
            kbArticles: kbSuggestions
        });
    }
    constructor(...args){
        super(...args), this.fetchKbSuggestions = (inputValue)=>{
            const { knowledgeBase: knowledgeBase, fetchKBSuggestionsSuccess: fetchKBSuggestionsSuccess, portalId: portalId, projectId: projectId, requestTypeId: requestTypeId } = this.props;
            const trimmedInputValue = inputValue.trim();
            if ((0, $4ZMmh.isEmpty)(trimmedInputValue)) return;
            if (trimmedInputValue.length < $63a46784450149e5$var$KB_SUGGESTIONS_MIN_QUERY_LENGTH) {
                fetchKBSuggestionsSuccess({
                    portalId: portalId,
                    kbArticleSuggestions: []
                });
                return;
            }
            // projectId must be defined for the search endpoint to work
            if (projectId) {
                const subs = (0, $kbQUS.searchKbs)({
                    projectId: projectId,
                    requestTypeId: requestTypeId,
                    labels: knowledgeBase ? knowledgeBase.labels : [],
                    query: trimmedInputValue,
                    resultLimit: 3
                }).subscribe((kbSearchResponse)=>{
                    const meta = this.getAnalyticsEvent(kbSearchResponse.articles.length);
                    if (meta !== null && meta !== void 0 && meta.analyticsSuccessEvent) (0, $jBiia.legacySendEvent)(meta.analyticsSuccessEvent);
                    fetchKBSuggestionsSuccess({
                        portalId: portalId,
                        kbArticleSuggestions: kbSearchResponse.articles
                    });
                }, (e)=>{
                    // TypeScript upgrade (v4.4.3). Please correct when you revisit this code.
                    const meta = this.getAnalyticsEvent();
                    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
                    if (meta !== null && meta !== void 0 && meta.analyticsFailureEvent && !(0, $h92tT.isNetworkOrClientErrorCode)(e.status)) (0, $jBiia.legacySendEvent)(meta.analyticsFailureEvent);
                    (0, $jBiia.trackError)('kbsuggestions.fetch.failed', {}, e);
                    return (0, $8jOUp.Observable).empty();
                });
                this.subscription.add(subs);
            }
        }, this.getAnalyticsEvent = (length)=>{
            const { createAnalyticsEvent: createAnalyticsEvent } = this.props;
            return {
                analyticsSuccessEvent: createAnalyticsEvent === null || createAnalyticsEvent === void 0 ? void 0 : createAnalyticsEvent({
                    action: 'Fetch success',
                    analyticsType: (0, $haAAx.TRACK_EVENT_TYPE),
                    actionSubjectId: 'kbSuggestion',
                    actionSubject: 'kbSuggestionField',
                    totalArticles: length
                }),
                analyticsFailureEvent: createAnalyticsEvent === null || createAnalyticsEvent === void 0 ? void 0 : createAnalyticsEvent({
                    action: 'Fetch failed',
                    analyticsType: (0, $haAAx.OPERATIONAL_EVENT_TYPE)
                })
            };
        }, this.loadKbSuggestions = (0, $4ZMmh.debounce)(this.fetchKbSuggestions, (0, $jcRK7.USER_TYPING_DEBOUNCE_TIME)), this.onChange = (name, value, notFromUserInteraction, additionalFieldData)=>{
            const { onChange: onChange } = this.props;
            onChange && onChange(name, value, notFromUserInteraction, additionalFieldData);
            this.loadKbSuggestions(value);
        };
    }
}
const $63a46784450149e5$export$9adbba5a02101fe3 = (0, $egQxE.connect)((state)=>{
    const portalId = (0, $1xrTy.getPortalId)(state);
    const projectId = (0, $ik9zp.getProjectId)(state, portalId);
    return {
        portalId: portalId,
        projectId: projectId,
        kbSuggestions: (0, $ik9zp.getKbSuggestions)(state, portalId)
    };
}, {
    fetchKBSuggestionsSuccess: (0, $5RxZm.fetchKBSuggestionsSuccessAction)
})($63a46784450149e5$export$b75b6a6cc3a70ff8);
var $63a46784450149e5$export$2e2bcd8739ae039 = (0, $2usNr.default)({
    componentName: 'KbSuggestions'
})((0, $kIbto.default)()($63a46784450149e5$export$9adbba5a02101fe3));

});
parcelRegister("5cEov", function(module, exports) {
$parcel$export(module.exports, "SummaryDumbField", () => (parcelRequire("iAOpR")).default);

var $iAOpR = parcelRequire("iAOpR");

});
parcelRegister("iAOpR", function(module, exports) {
$parcel$export(module.exports, "default", () => $cd4f102c6437f780$export$2e2bcd8739ae039);

var $bSJIT = parcelRequire("bSJIT");

var $jcRK7 = parcelRequire("jcRK7");

var $4ZMmh = parcelRequire("4ZMmh");
parcelRequire("k9e9R");
var $inK6C = parcelRequire("inK6C");

var $3gTkE = parcelRequire("3gTkE");

var $96iPn = parcelRequire("96iPn");
const $cd4f102c6437f780$var$ControlledTextField = (0, $96iPn.withControlledFormComponentValue)((_field, value)=>value)((0, $3gTkE.TextField));
const $cd4f102c6437f780$var$SummaryDumbField = ({ kbArticles: kbArticles, ...props })=>{
    const debouncedOnChange = $bSJIT.useMemo(()=>{
        if (props.onChange) return (0, $4ZMmh.debounce)(props.onChange, (0, $jcRK7.USER_TYPING_DEBOUNCE_TIME));
        return props.onChange;
    }, [
        props.onChange
    ]);
    return /*#__PURE__*/ $bSJIT.createElement($bSJIT.Fragment, null, /*#__PURE__*/ $bSJIT.createElement($cd4f102c6437f780$var$ControlledTextField, {
        id: props.id,
        label: props.label,
        required: props.required,
        defaultValue: props.defaultValue,
        valueOverride: props.valueOverride,
        description: props.description,
        onChange: debouncedOnChange,
        onFieldBlurredByUser: props.onFieldBlurredByUser,
        key: "summary-text-field",
        errorMessage: props.errorMessage,
        disabled: props.disabled,
        testId: "request-field-summary-input"
    }), !!kbArticles && !(0, $4ZMmh.isEmpty)(kbArticles) && /*#__PURE__*/ $bSJIT.createElement((0, $inK6C.default), {
        articles: kbArticles,
        portalId: props.portalId
    }));
};
var $cd4f102c6437f780$export$2e2bcd8739ae039 = $cd4f102c6437f780$var$SummaryDumbField;

});
parcelRegister("k9e9R", function(module, exports) {
$parcel$export(module.exports, "KbSuggestedArticles", () => (parcelRequire("inK6C")).default);

var $inK6C = parcelRequire("inK6C");

});
parcelRegister("inK6C", function(module, exports) {
$parcel$export(module.exports, "default", () => $6459487900350d09$export$2e2bcd8739ae039);
/* kb-suggestions.tsx generated by @compiled/babel-plugin v3.0.2 */ // eslint-disable-next-line @compiled/jsx-pragma

var $9fU1q = parcelRequire("9fU1q");

var $bSJIT = parcelRequire("bSJIT");

var $4v2A7 = parcelRequire("4v2A7");

var $4ZMmh = parcelRequire("4ZMmh");

var $fK3tS = parcelRequire("fK3tS");
parcelRequire("awDZV");
var $h1e27 = parcelRequire("h1e27");

var $kIbto = parcelRequire("kIbto");

var $7WQx2 = parcelRequire("7WQx2");

var $haAAx = parcelRequire("haAAx");

var $2cpV8 = parcelRequire("2cpV8");
const $6459487900350d09$export$329234c6d2caa76b = ({ createAnalyticsEvent: createAnalyticsEvent, articles: articles, intl: intl, connectedToForm: connectedToForm, portalId: portalId })=>{
    $bSJIT.useEffect(()=>{
        createAnalyticsEvent && createAnalyticsEvent({
            action: 'viewed',
            analyticsType: (0, $haAAx.TRACK_EVENT_TYPE),
            actionSubjectId: `kbSuggestion${connectedToForm ? '-proforma' : ''}`,
            actionSubject: `kbSuggestionField${connectedToForm ? '-proforma' : ''}`,
            totalArticles: articles.length
        }).fire();
    // oxlint-disable-next-line react-hooks/exhaustive-deps
    }, [
        createAnalyticsEvent,
        articles.length
    ]);
    const articleList = !(0, $4ZMmh.isEmpty)(articles) && /*#__PURE__*/ $bSJIT.createElement($6459487900350d09$var$Container, null, articles.map((article)=>/*#__PURE__*/ $bSJIT.createElement($6459487900350d09$export$4c96a30fe18d5130, {
            articleUrl: article.articleUrl,
            sourceType: article.sourceType,
            key: article.id,
            elevated: false,
            title: article.name,
            openNewTab: true,
            focusable: true,
            isSuggestion: true,
            portalId: typeof portalId === 'number' ? portalId.toString() : portalId,
            ...article
        })));
    return /*#__PURE__*/ $bSJIT.createElement($6459487900350d09$var$Root, null, /*#__PURE__*/ $bSJIT.createElement("div", {
        "data-test-id": "request-field-kb-suggest-article"
    }, /*#__PURE__*/ $bSJIT.createElement("div", {
        className: (0, $9fU1q.default)([
            "_1pfhpxbi _1q51v77o _85i51b66 _syazazsu _129u1kw7"
        ])
    }, /*#__PURE__*/ $bSJIT.createElement((0, $7WQx2.default), {
        size: "xxsmall",
        as: "h2"
    }, intl.formatMessage((0, $2cpV8.default).label))), articleList));
};
var $6459487900350d09$export$2e2bcd8739ae039 = (0, $kIbto.default)()((0, $fK3tS.default)($6459487900350d09$export$329234c6d2caa76b));
const $6459487900350d09$var$sectionHeadingWrapperStyles = null;
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $6459487900350d09$var$Root = /*#__PURE__*/ (0, $4v2A7.default).div.withConfig({
    componentId: "sc-1m0nkh8-0"
})`width:100%;`;
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $6459487900350d09$var$Container = /*#__PURE__*/ (0, $4v2A7.default).div.withConfig({
    componentId: "sc-1m0nkh8-1"
})`padding:${"var(--ds-space-200, 16px)"};background-color:${"var(--ds-background-neutral, #FAFBFC)"};`;
const $6459487900350d09$export$4c96a30fe18d5130 = /*#__PURE__*/ (0, $4v2A7.default)((0, $h1e27.default)).withConfig({
    componentId: "sc-1m0nkh8-2"
})`transition:box-shadow 0.2s ease-in-out;`;

});
parcelRegister("awDZV", function(module, exports) {
$parcel$export(module.exports, "SearchResultKb", () => (parcelRequire("h1e27")).default);

var $h1e27 = parcelRequire("h1e27");

});
parcelRegister("h1e27", function(module, exports) {
$parcel$export(module.exports, "default", () => $73a906d1d1bbabb5$export$2e2bcd8739ae039);

var $bSJIT = parcelRequire("bSJIT");
parcelRequire("6gVz3");
var $4R1Vb = parcelRequire("4R1Vb");

var $dwOcU = parcelRequire("dwOcU");

var $zZCyy = parcelRequire("zZCyy");
const $73a906d1d1bbabb5$export$a3d66732745adbf1 = (text)=>// eslint-disable-next-line no-useless-escape
    text.replace(/\@\@\@hl\@\@\@/g, '<strong>').replace(/\@\@\@endhl\@\@\@/g, '</strong>');
const $73a906d1d1bbabb5$var$SearchResultKb = ({ title: title, portalName: portalName, portalId: portalId, id: id, articleUrl: articleUrl, articleSnippet: articleSnippet, isSmartSnippet: isSmartSnippet, pageVersion: pageVersion, score: score, linkedPortals: linkedPortals, openNewTab: openNewTab, sourceType: sourceType, ...props })=>{
    const articleId = id;
    const snippet = articleSnippet ? $73a906d1d1bbabb5$export$a3d66732745adbf1(articleSnippet) : '';
    const getArticleUrl = ()=>{
        if ((0, $zZCyy.isThirdPartyArticle)(sourceType)) return articleUrl || '';
        if (portalId) return `/portal/${portalId}/article/${articleId}`;
        // If portalId doesnt exist in store, ie for global search, use the portalId for first linked portal
        if (Array.isArray(linkedPortals) && linkedPortals.length > 0) return `/portal/${linkedPortals[0].portalId}/article/${articleId}`;
        return `/article/${articleId}`;
    };
    return /*#__PURE__*/ $bSJIT.createElement((0, $dwOcU.default), {
        data: {
            attributes: {
                pageVersion: pageVersion,
                score: score,
                isSmartSnippet: isSmartSnippet,
                articleId: articleId,
                portalId: portalId,
                sourceType: sourceType,
                snippetsLength: snippet.length
            }
        }
    }, /*#__PURE__*/ $bSJIT.createElement((0, $4R1Vb.default), {
        actionSubjectId: "smartSuggestion",
        titleHtml: $73a906d1d1bbabb5$export$a3d66732745adbf1(title),
        to: getArticleUrl(),
        openNewTab: openNewTab,
        snippet: snippet,
        portalName: portalName,
        sourceType: sourceType,
        ...props
    }));
};
var $73a906d1d1bbabb5$export$2e2bcd8739ae039 = $73a906d1d1bbabb5$var$SearchResultKb;

});
parcelRegister("6gVz3", function(module, exports) {
$parcel$export(module.exports, "KbSnippet", () => (parcelRequire("4R1Vb")).default);

var $4R1Vb = parcelRequire("4R1Vb");

});
parcelRegister("4R1Vb", function(module, exports) {
$parcel$export(module.exports, "default", () => $b9dd17aee97497a3$export$2e2bcd8739ae039);

var $bSJIT = parcelRequire("bSJIT");

var $4v2A7 = parcelRequire("4v2A7");

var $2OuWT = parcelRequire("2OuWT");

var $98sDU = parcelRequire("98sDU");

var $9K7mZ = parcelRequire("9K7mZ");

var $fU62V = parcelRequire("fU62V");

var $9Yqiu = parcelRequire("9Yqiu");

var $fKGH0 = parcelRequire("fKGH0");

var $6WltM = parcelRequire("6WltM");

var $2usNr = parcelRequire("2usNr");

var $67YKA = parcelRequire("67YKA");

var $emsU2 = parcelRequire("emsU2");

var $gUpf2 = parcelRequire("gUpf2");

var $haAAx = parcelRequire("haAAx");

var $3Asfj = parcelRequire("3Asfj");

var $zZCyy = parcelRequire("zZCyy");

var $4CtTG = parcelRequire("4CtTG");

var $2grDj = parcelRequire("2grDj");
const $b9dd17aee97497a3$var$KbSnippet = ({ titleHtml: titleHtml, to: to, actionSubjectId: actionSubjectId, openNewTab: openNewTab, onClick: onClick, snippet: snippet, portalName: portalName, sourceType: sourceType, showPortalName: showPortalName = false, ...props })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $6WltM.useAnalyticsEvents)();
    const isAnExternalResource = (0, $zZCyy.isThirdPartyArticle)(sourceType);
    const highlightHtmlSanitizeConfig = {
        FORBID_TAGS: [
            'style'
        ],
        FORBID_ATTR: [
            'style'
        ]
    };
    const sanitizeHighlightHtml = (html)=>{
        return (0, $fKGH0.sanitize)(html, highlightHtmlSanitizeConfig);
    };
    const linkProps = (0, $zZCyy.urlRefsAndTarget)({
        isAnExternalResource: isAnExternalResource,
        displayLink: (0, $3Asfj.addSourceToUrl)(to, 'request-form', isAnExternalResource)
    });
    const getIcon = ()=>{
        const IconInTile = ({ label: label })=>{
            if (sourceType === 'GOOGLE_DRIVE') return /*#__PURE__*/ $bSJIT.createElement((0, $4CtTG.default), {
                label: label,
                size: "medium"
            });
            if (sourceType === 'SHAREPOINT') return /*#__PURE__*/ $bSJIT.createElement((0, $2grDj.default), {
                label: label,
                size: "medium"
            });
            return /*#__PURE__*/ $bSJIT.createElement((0, (/*@__PURE__*/$parcel$interopDefault($emsU2))), {
                label: label
            });
        };
        return /*#__PURE__*/ $bSJIT.createElement((0, $67YKA.default), {
            appearance: "blue",
            icon: IconInTile,
            label: "Article icon",
            size: "medium"
        });
    };
    $bSJIT.useEffect(()=>{
        createAnalyticsEvent({
            analyticsType: (0, $haAAx.UI_EVENT_TYPE),
            action: 'viewed'
        }).fire();
    }, [
        createAnalyticsEvent
    ]);
    return(// eslint-disable-next-line @atlassian/a11y/click-events-have-key-events, @atlassian/a11y/no-static-element-interactions, styled-components-a11y/click-events-have-key-events, styled-components-a11y/no-static-element-interactions -- Disabling existing violation, should be fixed when revisited.
    /*#__PURE__*/ $bSJIT.createElement($b9dd17aee97497a3$var$LinkContainer, {
        key: to,
        onClick: onClick,
        actionSubjectId: actionSubjectId,
        "data-test-id": "article-link-container",
        ...props,
        ...linkProps
    }, /*#__PURE__*/ $bSJIT.createElement((0, $gUpf2.Box), null, getIcon()), /*#__PURE__*/ $bSJIT.createElement($b9dd17aee97497a3$var$ArticleContainer, {
        snippets: snippet
    }, /*#__PURE__*/ $bSJIT.createElement($b9dd17aee97497a3$var$Title, {
        dangerouslySetInnerHTML: {
            __html: sanitizeHighlightHtml(titleHtml)
        }
    }), showPortalName && portalName && /*#__PURE__*/ $bSJIT.createElement($b9dd17aee97497a3$var$ServiceDeskTitle, null, "from ", portalName), snippet && /*#__PURE__*/ $bSJIT.createElement($b9dd17aee97497a3$var$Snippet, {
        dangerouslySetInnerHTML: {
            __html: sanitizeHighlightHtml(snippet)
        }
    }))));
};
var $b9dd17aee97497a3$export$2e2bcd8739ae039 = (0, $2usNr.default)({
    componentName: 'KbSnippet'
})($b9dd17aee97497a3$var$KbSnippet);
// eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $b9dd17aee97497a3$var$TitleH3Css = /*#__PURE__*/ (0, $4v2A7.css)`${$98sDU.regular};overflow:hidden;text-overflow:ellipsis;display:-webkit-box;-webkit-line-clamp:1;word-break:break-word;-webkit-box-orient:vertical;text-transform:uppercase;margin:${"var(--ds-space-0, 0px)"};font-weight:normal;transition:color ${$9Yqiu.speedMs.medium}ms ${$9Yqiu.timingFunctions.easeInOut};color:${"var(--ds-text, #172B4D)"};`;
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $b9dd17aee97497a3$var$Title = /*#__PURE__*/ (0, $4v2A7.default).h3.withConfig({
    componentId: "sc-ioq6m2-0"
})`${$b9dd17aee97497a3$var$TitleH3Css}`;
// eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $b9dd17aee97497a3$var$SnippetParagraphCss = /*#__PURE__*/ (0, $4v2A7.css)`${$98sDU.small};color:${"var(--ds-text, #172B4D)"};margin-top:${"var(--ds-space-100, 8px)"};padding-right:${"var(--ds-space-200, 16px)"};overflow:hidden;text-overflow:ellipsis;display:-webkit-box;-webkit-line-clamp:3;-webkit-box-orient:vertical;line-height:${"var(--ds-space-250, 20px)"};word-break:break-word;white-space:normal;`;
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $b9dd17aee97497a3$var$Snippet = /*#__PURE__*/ (0, $4v2A7.default).p.withConfig({
    componentId: "sc-ioq6m2-1"
})`${$b9dd17aee97497a3$var$SnippetParagraphCss}`;
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $b9dd17aee97497a3$var$LinkContainer = /*#__PURE__*/ (0, $4v2A7.default)((0, $2OuWT.Link)).withConfig({
    componentId: "sc-ioq6m2-2"
})`${$fU62V.borderRadius};${(props)=>$fU62V.applyIf(!props.isSuggestion, $fU62V.raiseUpOnHoverOrFocus())};display:flex;background-color:${(props)=>props.isSuggestion ? 'none' : "var(--ds-surface-raised, #FFFFFF)"};padding:${"var(--ds-space-200, 16px)"} ${"var(--ds-space-050, 4px)"} ${"var(--ds-space-200, 16px)"} ${"var(--ds-space-150, 12px)"};margin:${(props)=>props.isSuggestion ? '0' : `${"var(--ds-space-100, 8px)"} 0 ${"var(--ds-space-200, 16px)"}`};&:hover,&:focus{background:${(props)=>props.isSuggestion ? "var(--ds-background-neutral-subtle-hovered, #EBECF0)" : "var(--ds-surface-raised, #FFFFFF)"};text-decoration:none;}&:hover h3,&:focus h3{color:${(props)=>`var(--ds-link, ${props.theme.color})`};}`;
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $b9dd17aee97497a3$var$ArticleContainer = /*#__PURE__*/ (0, $4v2A7.default).div.withConfig({
    componentId: "sc-ioq6m2-3"
})`margin-left:${"var(--ds-space-250, 20px)"};${(props)=>!props.snippets ? `
            display: flex;
            align-items: center
            ` : ''}`;
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $b9dd17aee97497a3$var$ServiceDeskTitle = /*#__PURE__*/ (0, $4v2A7.default).div.withConfig({
    componentId: "sc-ioq6m2-4"
})`color:${"var(--ds-text-subtlest, #7A869A)"};font-size:${$9K7mZ.multiple(1.375).px};`;

});




parcelRegister("2cpV8", function(module, exports) {
$parcel$export(module.exports, "default", () => $72c40793ff046c4f$export$2e2bcd8739ae039);

var $f0Pt4 = parcelRequire("f0Pt4");
var $72c40793ff046c4f$export$2e2bcd8739ae039 = (0, $f0Pt4.defineMessages)({
    label: {
        defaultMessage: 'Suggested articles',
        description: 'label for related articles in request create form based on text in summary field',
        id: 'cv.request.create.form.kb.suggestions.label'
    }
});

});







parcelRegister("j2g7T", function(module, exports) {
$parcel$export(module.exports, "TextArea", () => (parcelRequire("7pA9H")).default);
$parcel$export(module.exports, "FormTextArea", () => (parcelRequire("7pA9H")).FormTextArea);

var $7pA9H = parcelRequire("7pA9H");

});
parcelRegister("7pA9H", function(module, exports) {
$parcel$export(module.exports, "default", () => $b5e7beccb1d50fdd$export$2e2bcd8739ae039);
$parcel$export(module.exports, "FormTextArea", () => $b5e7beccb1d50fdd$export$a83de22056f04f06);

var $bSJIT = parcelRequire("bSJIT");

var $4ZMmh = parcelRequire("4ZMmh");

var $j2RlN = parcelRequire("j2RlN");

var $96iPn = parcelRequire("96iPn");

var $5R01U = parcelRequire("5R01U");
class $b5e7beccb1d50fdd$export$2e2bcd8739ae039 extends $bSJIT.PureComponent {
    render() {
        const { id: id, required: required, label: label, defaultValue: defaultValue, description: description, maxLength: maxLength, minimumRows: minimumRows, errorMessage: errorMessage, disabled: disabled, placeholder: placeholder, isLabelHidden: isLabelHidden, enableResize: enableResize, value: value } = this.props;
        const isInvalid = !(0, $4ZMmh.isEmpty)(errorMessage);
        return /*#__PURE__*/ $bSJIT.createElement((0, $j2RlN.FieldBase), {
            htmlFor: id,
            required: required,
            description: description,
            label: label,
            errorMessage: errorMessage,
            noLabel: isLabelHidden
        }, /*#__PURE__*/ $bSJIT.createElement((0, $5R01U.default), {
            id: id,
            name: id,
            defaultValue: defaultValue,
            maxLength: maxLength,
            minimumRows: minimumRows,
            resize: enableResize === undefined || enableResize ? 'vertical' : 'none',
            isInvalid: isInvalid,
            onChange: this.onChange,
            isDisabled: disabled,
            placeholder: placeholder,
            value: value,
            "aria-describedby": `${id}-field-description`,
            onBlur: this.onBlur
        }));
    }
    constructor(...args){
        super(...args), this.onChange = (e)=>{
            if (this.props.onChange) this.props.onChange(this.props.id, e.target.value, false, {
                rawObject: e,
                rawValue: e.target.value
            });
        }, this.onBlur = (e)=>{
            if (this.props.onFieldBlurredByUser) this.props.onFieldBlurredByUser({
                field: this.props.id,
                value: e.target.value,
                additionalFieldData: {
                    rawObject: e,
                    rawValue: e.target.value
                }
            });
        };
    }
}
const $b5e7beccb1d50fdd$var$ControlledTextArea = (0, $96iPn.withControlledFormComponentValue)((_field, value)=>value)($b5e7beccb1d50fdd$export$2e2bcd8739ae039);
const $b5e7beccb1d50fdd$export$a83de22056f04f06 = $b5e7beccb1d50fdd$var$ControlledTextArea;

});


parcelRegister("lHUBw", function(module, exports) {
$parcel$export(module.exports, "UnknownField", () => (parcelRequire("8IOO6")).default);

var $8IOO6 = parcelRequire("8IOO6");

});
parcelRegister("8IOO6", function(module, exports) {
$parcel$export(module.exports, "default", () => $8f8e8cc1e1ef5229$export$2e2bcd8739ae039);

var $bSJIT = parcelRequire("bSJIT");

var $egQxE = parcelRequire("egQxE");

var $BOq7h = parcelRequire("BOq7h");

var $fK3tS = parcelRequire("fK3tS");

var $aI0YR = parcelRequire("aI0YR");

var $j2RlN = parcelRequire("j2RlN");

var $3vZvu = parcelRequire("3vZvu");
class $8f8e8cc1e1ef5229$export$64cd47482e3a83fe extends $bSJIT.Component {
    render() {
        const { id: id, intl: intl, canAdministerJIRA: canAdministerJIRA, agentForPortal: agentForPortal } = this.props;
        if (canAdministerJIRA || agentForPortal) return /*#__PURE__*/ $bSJIT.createElement((0, $j2RlN.FieldBase), {
            htmlFor: id,
            label: intl.formatMessage((0, $3vZvu.default).unknownField, {
                id: id
            })
        });
        return null;
    }
}
const $8f8e8cc1e1ef5229$var$selector = (0, $BOq7h.createSelector)((0, $aI0YR.getCanAdministerJIRA), (0, $aI0YR.getAgentForPortal), (canAdministerJIRA, agentForPortal)=>({
        canAdministerJIRA: canAdministerJIRA,
        agentForPortal: agentForPortal
    }));
var $8f8e8cc1e1ef5229$export$2e2bcd8739ae039 = (0, $egQxE.connect)($8f8e8cc1e1ef5229$var$selector, {})((0, $fK3tS.default)($8f8e8cc1e1ef5229$export$64cd47482e3a83fe));

});
parcelRegister("3vZvu", function(module, exports) {
$parcel$export(module.exports, "default", () => $6e321cde7761769d$export$2e2bcd8739ae039);

var $f0Pt4 = parcelRequire("f0Pt4");
var $6e321cde7761769d$export$2e2bcd8739ae039 = (0, $f0Pt4.defineMessages)({
    unknownField: {
        defaultMessage: 'Unknown field: {id}',
        description: 'Fallback message to display field when its type is unknown',
        id: 'cv.request.create.form.field.unknown'
    }
});

});



parcelRegister("l0uAN", function(module, exports) {
$parcel$export(module.exports, "RecaptchaForm", () => (parcelRequire("fcFs7")).default);

var $fcFs7 = parcelRequire("fcFs7");

});
parcelRegister("fcFs7", function(module, exports) {
$parcel$export(module.exports, "default", () => $6451dfef6c3618d6$export$2e2bcd8739ae039);

var $bSJIT = parcelRequire("bSJIT");

var $haAAx = parcelRequire("haAAx");

var $7JgEy = parcelRequire("7JgEy");

var $1rId1 = parcelRequire("1rId1");
class $6451dfef6c3618d6$export$2e2bcd8739ae039 extends $bSJIT.PureComponent {
    constructor(props){
        super(props), this.state = {
            isExecuting: false,
            isError: false
        }, this.lastFormSubmissionEvent = undefined, this.recaptchaInstance = undefined, this.onSubmit = (e)=>{
            if (this.props.recaptchaEnabled) this.handleRecaptchaOnSubmit(e);
            else this.props.onSubmit && this.props.onSubmit(e);
        }, this.handleRecaptchaOnSubmit = (e)=>{
            e.persist();
            e.preventDefault();
            this.lastFormSubmissionEvent = e;
            // If the recaptcha instance has not loaded properly then show an error
            // Suppressing existing violation. Please fix this.
            // eslint-disable-next-line @typescript-eslint/no-unsafe-call, @typescript-eslint/no-unsafe-member-access
            if (this.recaptchaInstance == null || this.recaptchaInstance.getWidgetId() == null) this.setState({
                isError: true
            });
            else {
                this.setState({
                    isExecuting: true
                });
                // Suppressing existing violation. Please fix this.
                // eslint-disable-next-line @typescript-eslint/no-unsafe-call, @typescript-eslint/no-unsafe-member-access
                this.recaptchaInstance && this.recaptchaInstance.reset();
                // Suppressing existing violation. Please fix this.
                // eslint-disable-next-line @typescript-eslint/no-unsafe-call, @typescript-eslint/no-unsafe-member-access
                this.recaptchaInstance && this.recaptchaInstance.execute();
            }
        }, this.handeRecaptchaOnChange = (token)=>{
            if (this.props.onSubmit && this.lastFormSubmissionEvent) {
                this.props.onTokenChange(token);
                this.props.onSubmit(this.lastFormSubmissionEvent);
            }
            this.setState({
                isExecuting: false
            });
        }, this.onError = ()=>{
            // This is to ensure the user can retry after an recaptcha error.
            this.setState({
                isExecuting: false
            });
        }, this.onDismissError = ()=>{
            this.setState({
                isError: false
            });
        };
        // TypeScript upgrade (v4.4.3). Please correct when you revisit this code.
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-explicit-any, @atlassian/ssr-linting/no-dom-globals-in-constructor
        window.recaptchaOptions = {
            useRecaptchaNet: true
        };
    }
    render() {
        const { children: children, sitekey: sitekey, recaptchaEnabled: recaptchaEnabled, formRef: formRef, onSubmit: onSubmit, onTokenChange: _, ...formProps } = this.props;
        return /*#__PURE__*/ $bSJIT.createElement((0, $haAAx.AnalyticsContext), {
            attributes: {
                sitekey: sitekey,
                recaptchaEnabled: recaptchaEnabled
            }
        }, /*#__PURE__*/ $bSJIT.createElement("form", {
            ...formProps,
            ref: formRef,
            onSubmit: this.onSubmit
        }, children({
            isExecuting: this.state.isExecuting
        }), recaptchaEnabled && sitekey && /*#__PURE__*/ $bSJIT.createElement((0, $7JgEy.default), {
            ref: (e)=>{
                /* eslint-disable-next-line @typescript-eslint/no-unsafe-return, @typescript-eslint/no-unsafe-assignment */ /* oxlint-disable-next-line no-return-assign */ return this.recaptchaInstance = e;
            },
            sitekey: sitekey,
            onChange: this.handeRecaptchaOnChange,
            size: "invisible",
            onErrored: this.onError
        }), recaptchaEnabled && sitekey && this.state.isError && /*#__PURE__*/ $bSJIT.createElement((0, $1rId1.RecaptchaFormError), {
            onDismiss: this.onDismissError
        })));
    }
}

});
parcelRegister("7JgEy", function(module, exports) {
$parcel$export(module.exports, "default", () => $994154fbdef6e453$export$2e2bcd8739ae039);

var $jhjV0 = parcelRequire("jhjV0");
var $994154fbdef6e453$export$2e2bcd8739ae039 = (0, $jhjV0.default);

});
parcelRegister("jhjV0", function(module, exports) {
$parcel$export(module.exports, "default", () => $6a519959541c5ddc$export$2e2bcd8739ae039);

var $bSJIT = parcelRequire("bSJIT");

var $lAHoS = parcelRequire("lAHoS");
class $6a519959541c5ddc$export$d720047286fe21e9 extends $bSJIT.Component {
    static #_ = this.defaultProps = {
        onChange: ()=>0,
        theme: 'light',
        type: 'image',
        tabindex: 0,
        size: 'normal',
        badge: 'bottomright'
    };
    constructor(props){
        super(props), this._executeRequested = false;
        // Suppressing existing violation. Please fix this.
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
        this.handleExpired = this.handleExpired.bind(this);
        // Suppressing existing violation. Please fix this.
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
        this.handleErrored = this.handleErrored.bind(this);
        // Suppressing existing violation. Please fix this.
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
        this.handleRecaptchaRef = this.handleRecaptchaRef.bind(this);
    }
    getValue() {
        if (this.props.grecaptcha && this.props.grecaptcha.enterprise && this._widgetId !== undefined) return this.props.grecaptcha.enterprise.getResponse(this._widgetId);
        return null;
    }
    getWidgetId() {
        if (this.props.grecaptcha && this._widgetId !== undefined) return this._widgetId;
        return null;
    }
    execute() {
        const { grecaptcha: grecaptcha } = this.props;
        if (grecaptcha && grecaptcha.enterprise && this._widgetId !== undefined) return grecaptcha.enterprise.execute(this._widgetId);
        this._executeRequested = true;
        return null;
    }
    reset() {
        if (this.props.grecaptcha && this.props.grecaptcha.enterprise && this._widgetId !== undefined) this.props.grecaptcha.enterprise.reset(this._widgetId);
    }
    handleExpired() {
        if (this.props.onExpired) this.props.onExpired();
        else if (this.props.onChange) /*
                   we will be resetting the recaptcha after the faulty token expires.
                   The expiry will happen once the current token has returned a 400 from the JIRA backend,
                   which will keep the page on the same route and not navigate further and thus lead to token
                   expiry from google which is around 2mins.
                   In case of a success, the route changes so this condition is out of question.
               */ this.reset();
    }
    handleErrored() {
        if (this.props.onErrored) this.props.onErrored();
    }
    explicitRender() {
        if (this.props.grecaptcha && this.props.grecaptcha.enterprise && this.props.grecaptcha.enterprise.render && this._widgetId === undefined) {
            // Upgrading @atlaskit/platform; fix these violations.
            // eslint-disable-next-line @atlaskit/platform/no-direct-document-usage
            const wrapper = document.createElement('div');
            this._widgetId = this.props.grecaptcha.enterprise.render(wrapper, {
                sitekey: this.props.sitekey,
                callback: this.props.onChange,
                theme: this.props.theme,
                type: this.props.type,
                tabindex: this.props.tabindex,
                'expired-callback': this.handleExpired,
                'error-callback': this.handleErrored,
                size: this.props.size,
                stoken: this.props.stoken,
                hl: this.props.hl,
                badge: this.props.badge
            });
            this.captcha.appendChild(wrapper);
        }
        if (this._executeRequested && this.props.grecaptcha && this._widgetId !== undefined) {
            this._executeRequested = false;
            this.execute();
        }
    }
    componentDidMount() {
        this.explicitRender();
    }
    componentDidUpdate() {
        this.explicitRender();
    }
    componentWillUnmount() {
        if (this._widgetId !== undefined) {
            this.delayOfCaptchaIframeRemoving();
            this.reset();
        }
    }
    delayOfCaptchaIframeRemoving() {
        // Upgrading @atlaskit/platform; fix these violations.
        // eslint-disable-next-line @atlaskit/platform/no-direct-document-usage
        const temporaryNode = document.createElement('div');
        // Upgrading @atlaskit/platform; fix these violations.
        // eslint-disable-next-line @atlaskit/platform/no-direct-document-usage
        document.body.appendChild(temporaryNode);
        temporaryNode.style.display = 'none';
        // move of the recaptcha to a temporary node
        while(this.captcha.firstChild)temporaryNode.appendChild(this.captcha.firstChild);
        // delete the temporary node after reset will be done
        setTimeout(()=>{
            // Upgrading @atlaskit/platform; fix these violations.
            // eslint-disable-next-line @atlaskit/platform/no-direct-document-usage
            document.body.removeChild(temporaryNode);
        }, 5000);
    }
    handleRecaptchaRef(elem) {
        this.captcha = elem;
    }
    render() {
        // consume properties owned by the reCATPCHA, pass the rest to the div so the user can style it.
        const { sitekey: sitekey, onChange: onChange, theme: theme, type: type, tabindex: tabindex, onExpired: onExpired, onErrored: onErrored, size: size, stoken: stoken, grecaptcha: grecaptcha, badge: badge, hl: hl, ...childProps } = this.props;
        return /*#__PURE__*/ $bSJIT.createElement("div", {
            ...childProps,
            ref: this.handleRecaptchaRef
        });
    }
}
const $6a519959541c5ddc$var$callbackName = 'onloadcallback';
const $6a519959541c5ddc$var$globalName = 'grecaptcha';
const $6a519959541c5ddc$var$recaptchaOptions = 'recaptchaOptions';
// @ts-ignore TS(7015) TypeScript upgrade 5.1.6, please fix this violation when you revisit this code.: Element implicitly has an 'any' type because index... Remove this comment to see the full error message
// Suppressing existing violation. Please fix this.
// eslint-disable-next-line @typescript-eslint/no-unsafe-return
const $6a519959541c5ddc$var$getOptions = ()=>typeof window !== 'undefined' && window[$6a519959541c5ddc$var$recaptchaOptions] || {};
function $6a519959541c5ddc$export$152462a4e1ffe278() {
    // Suppressing existing violation. Please fix this.
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
    const dynamicOptions = $6a519959541c5ddc$var$getOptions();
    // TypeScript upgrade (v4.4.3). Please correct when you revisit this code. Please correct when this code is revisited.
    // eslint-disable-next-line @typescript-eslint/restrict-template-expressions, @typescript-eslint/no-unsafe-member-access
    const lang = dynamicOptions.lang ? `&hl=${dynamicOptions.lang}` : '';
    const hostname = 'www.google.com';
    return `https://${hostname}/recaptcha/enterprise.js?onload=${$6a519959541c5ddc$var$callbackName}&render=explicit${lang}`;
}
var // Suppressing existing violation. Please fix this.
// eslint-disable-next-line @typescript-eslint/no-unsafe-call
$6a519959541c5ddc$export$2e2bcd8739ae039 = (0, $lAHoS.default)($6a519959541c5ddc$export$152462a4e1ffe278, {
    callbackName: $6a519959541c5ddc$var$callbackName,
    globalName: $6a519959541c5ddc$var$globalName,
    // Suppressing existing violation. Please fix this.
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access
    removeOnUnmount: $6a519959541c5ddc$var$getOptions().removeOnUnmount || false
})($6a519959541c5ddc$export$d720047286fe21e9);

});


parcelRegister("1rId1", function(module, exports) {
$parcel$export(module.exports, "RecaptchaFormError", () => $d170094728393e4c$export$c70e25c9a04c26c4);

var $daloG = parcelRequire("daloG");

var $jgWti = parcelRequire("jgWti");
const $d170094728393e4c$export$c70e25c9a04c26c4 = (0, $daloG.PortalAnalyticsInlineDialog)('RecaptchaError')((0, $jgWti.default));

});
parcelRegister("jgWti", function(module, exports) {
$parcel$export(module.exports, "default", () => $7fdd56188046acdb$export$2e2bcd8739ae039);

var $bSJIT = parcelRequire("bSJIT");

var $fK3tS = parcelRequire("fK3tS");

var $lJzMO = parcelRequire("lJzMO");

var $eJ0Uu = parcelRequire("eJ0Uu");

var $cBVmT = parcelRequire("cBVmT");

var $haAAx = parcelRequire("haAAx");

var $iydAA = parcelRequire("iydAA");

var $ajaab = parcelRequire("ajaab");
class $7fdd56188046acdb$export$c70e25c9a04c26c4 extends $bSJIT.PureComponent {
    render() {
        const { intl: intl, onDismiss: onDismiss } = this.props;
        const errorMessageTitle = intl.formatMessage((0, $ajaab.default).loadErrorTitle);
        const errorMessageDescription = intl.formatMessage((0, $ajaab.default).loadErrorDesc);
        return /*#__PURE__*/ $bSJIT.createElement((0, $haAAx.AnalyticsContext), {
            attributes: {
                recaptchaError: 'load'
            }
        }, /*#__PURE__*/ $bSJIT.createElement($bSJIT.Fragment, null, /*#__PURE__*/ $bSJIT.createElement((0, $lJzMO.default), {
            onDismissed: onDismiss
        }, /*#__PURE__*/ $bSJIT.createElement((0, $eJ0Uu.default), {
            id: "recaptcha-fail-flag",
            icon: /*#__PURE__*/ $bSJIT.createElement((0, (/*@__PURE__*/$parcel$interopDefault($cBVmT))), {
                spacing: "spacious",
                color: "var(--ds-icon-danger, #BF2600)",
                label: "error-with-recaptcha"
            }),
            title: errorMessageTitle,
            description: errorMessageDescription
        })), /*#__PURE__*/ $bSJIT.createElement((0, $iydAA.FireScreenEventOnMount), null)));
    }
}
var $7fdd56188046acdb$export$2e2bcd8739ae039 = (0, $fK3tS.default)($7fdd56188046acdb$export$c70e25c9a04c26c4);

});
parcelRegister("ajaab", function(module, exports) {
$parcel$export(module.exports, "default", () => $f0396843aa06b5d8$export$2e2bcd8739ae039);

var $f0Pt4 = parcelRequire("f0Pt4");
var $f0396843aa06b5d8$export$2e2bcd8739ae039 = (0, $f0Pt4.defineMessages)({
    loadErrorTitle: {
        defaultMessage: 'Error submitting form',
        description: 'Error title shown when the recaptcha is blocked or fails to load on the page',
        id: 'sd.recaptcha.load.error.title'
    },
    loadErrorDesc: {
        defaultMessage: 'We were unable verify that you are not a bot. Reload your form and give it another try. If the problem persists please contact your Administrator.',
        description: 'Error description shown when the recaptcha is blocked or fails to load on the page',
        id: 'sd.recaptcha.load.error.desc'
    }
});

});





parcelRegister("eZ9Sa", function(module, exports) {
$parcel$export(module.exports, "RequestCreatePropertyPanelModule", () => $8cf1f2892a604e4d$export$39102d36f906b040);

var $cVM5r = parcelRequire("cVM5r");

var $cJJTb = parcelRequire("cJJTb");

const $8cf1f2892a604e4d$export$39102d36f906b040 = (0, $cVM5r.default)({
    loader: (0, $cJJTb.lazyForPaint)(()=>(parcelRequire("lFwiR")), {
        moduleId: "./src/view/forge-ui/request-create-property-panel/request-create-property-panel.tsx"
    }),
    LoadingSkeleton: ()=>null
});

});
parcelRegister("lFwiR", function(module, exports) {

var $kOunM = parcelRequire("kOunM");
module.exports = $kOunM("2YJyP").then(()=>parcelRequire('kbezA'));

});


parcelRegister("8BxxY", function(module, exports) {
$parcel$export(module.exports, "ButtonGroup", () => $593f5e90628d2ab6$export$69b1032f2ecdf404);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Disabled to rollout go/ui-styling-standard tooling, please resolve

var $4v2A7 = parcelRequire("4v2A7");

var $fU62V = parcelRequire("fU62V");
const $593f5e90628d2ab6$export$69b1032f2ecdf404 = /*#__PURE__*/ (0, $4v2A7.default).div.withConfig({
    componentId: "sc-17h17d1-0"
})`${$fU62V.flexCenter};margin-top:${"var(--ds-space-200, 16px)"};justify-content:flex-start;> *{margin-right:${"var(--ds-space-100, 8px)"};}`;

});

parcelRegister("8PrUg", function(module, exports) {
$parcel$export(module.exports, "CmdbObjectPicker", () => (parcelRequire("iPY20")).default);

var $iPY20 = parcelRequire("iPY20");

});
parcelRegister("iPY20", function(module, exports) {
$parcel$export(module.exports, "default", () => $f6df7a69c0e46d98$export$2e2bcd8739ae039);

var $bSJIT = parcelRequire("bSJIT");

var $inh7J = parcelRequire("inh7J");

var $dMMwa = parcelRequire("dMMwa");

var $fT4XN = parcelRequire("fT4XN");

var $lFpPv = parcelRequire("lFpPv");

var $fK3tS = parcelRequire("fK3tS");

var $eL3zl = parcelRequire("eL3zl");

var $87QgR = parcelRequire("87QgR");

var $eJ0Uu = parcelRequire("eJ0Uu");

var $lJzMO = parcelRequire("lJzMO");

var $hkLEY = parcelRequire("hkLEY");

var $jBiia = parcelRequire("jBiia");

var $8UaEm = parcelRequire("8UaEm");
parcelRequire("4LA20");
var $jKevm = parcelRequire("jKevm");
parcelRequire("hKK6q");
var $iGMgJ = parcelRequire("iGMgJ");

var $kAQLh = parcelRequire("kAQLh");
const $f6df7a69c0e46d98$var$NEW_EXPERIENCE_GATE = 'assets_custom_fields_limit_increase_ga';
const $f6df7a69c0e46d98$var$isNewExperienceEnabled = ()=>(0, $87QgR.default).checkGate($f6df7a69c0e46d98$var$NEW_EXPERIENCE_GATE);
const $f6df7a69c0e46d98$var$MAX_OBJECT_COUNT_CUTOFF = 1000;
class $f6df7a69c0e46d98$export$1c8a8ad79184b709 extends $bSJIT.Component {
    componentDidMount() {
        if (this.props.populateDefaultValue) // Disabling existing violations, should be fixed when revisited.
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this.getObjectOptions(()=>this.fetchFunction(''), true);
        if ((0, $lFpPv.isJsmPortalRovoIntegrationEnabled)()) {
            if (this.props.initialValues) this.setState({
                values: this.props.initialValues
            });
        }
    }
    componentDidUpdate(prevProps) {
        if (this.props.populateDefaultValue && !(0, (/*@__PURE__*/$parcel$interopDefault($dMMwa)))(prevProps.placeholderValues, this.props.placeholderValues)) // Disabling existing violations, should be fixed when revisited.
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this.getObjectOptions(()=>this.fetchFunction(''), true);
    }
    renderNewExperience() {
        const { options: options, loading: loading, values: values, hasNextPage: hasNextPage } = this.state;
        const { isMulti: isMulti, limit: limit, label: label, required: required, errorMessage: errorMessage, filterAttributes: filterAttributes } = this.props;
        const selectedObjects = values.map((v)=>v.cmdbObject).filter((o)=>Boolean(o));
        const searchResults = options.map((o)=>o.cmdbObject).filter((o)=>Boolean(o));
        return /*#__PURE__*/ $bSJIT.createElement((0, $fT4XN.default), {
            id: 'cmdb-object-picker',
            packageName: 'portal_fields'
        }, /*#__PURE__*/ $bSJIT.createElement((0, $jKevm.PaginatedObjectsView), {
            selectedObjects: selectedObjects,
            searchResults: searchResults,
            isMulti: isMulti,
            limit: limit,
            attributesToDisplayInSearch: filterAttributes,
            fieldLabel: label,
            searchQuery: this.state.lastSearchedInputValue,
            onSearchChange: this.handleNewSearch,
            isLoading: loading,
            hasMore: hasNextPage,
            onLoadMore: this.handleNewLoadMore,
            onSelectionCommit: this.handleSelectionCommit,
            required: required,
            errorMessage: errorMessage
        }));
    }
    render() {
        // The new create-issue-style experience only applies to multi-select fields.
        // Single-select CMDB fields always use the original picker.
        if (this.props.isMulti && $f6df7a69c0e46d98$var$isNewExperienceEnabled()) return this.renderNewExperience();
        const { options: options, loading: loading, responseTotal: responseTotal, selectedOptions: selectedOptions, values: values, flags: flags } = this.state;
        const { onChange: onChange, populateDefaultValue: populateDefaultValue, intl: intl, ...otherProps } = this.props;
        // This feature gate turns the component into a completely controlled component.
        // Previously it was uncontrolled except for when `populateDefaultValue` was true, making the logic
        // difficult to follow.
        const controlledComponentState = (0, $87QgR.default).checkGate('jsm_assets_field_only_display_label_in_portal');
        let numberOfAlreadySelectedSearchResults;
        if (controlledComponentState) // If always a controlled component, then we can just rely on `values` and don't need `selectedOptions`.
        // Please clean up `selectedOptions` when removing jsm_assets_field_only_display_label_in_portal feature gate.
        numberOfAlreadySelectedSearchResults = options.filter((object)=>values.some((value)=>value.value === object.value)).length;
        else numberOfAlreadySelectedSearchResults = options.filter((object)=>selectedOptions.some((option)=>option === object.value)).length;
        return /*#__PURE__*/ $bSJIT.createElement((0, $fT4XN.default), {
            id: 'cmdb-object-picker',
            packageName: 'portal_fields'
        }, /*#__PURE__*/ $bSJIT.createElement((0, $iGMgJ.default), {
            ...otherProps,
            doInitialSearch: true,
            onInputChange: this.onInputChangeDebounced,
            options: this.getOptionsWithLabel(options, responseTotal, numberOfAlreadySelectedSearchResults),
            onFocus: this.onFocus,
            isLoading: loading,
            defaultValue: values,
            onChange: populateDefaultValue || controlledComponentState ? this.onChange : onChange,
            populateDefaultValue: populateDefaultValue,
            classNamePrefix: "cmdbObjectPickerField",
            onMenuScrollToBottom: this.onMenuScrollToBottom
        }), /*#__PURE__*/ $bSJIT.createElement((0, $lJzMO.default), {
            onDismissed: this.dismissErrorFlag
        }, flags.map((flagId)=>{
            return /*#__PURE__*/ $bSJIT.createElement((0, $eJ0Uu.default), {
                id: flagId,
                icon: /*#__PURE__*/ $bSJIT.createElement((0, (/*@__PURE__*/$parcel$interopDefault($hkLEY))), {
                    color: "var(--ds-icon-danger, #BF2600)",
                    label: "Error",
                    spacing: "spacious"
                }),
                key: flagId,
                title: intl.formatMessage((0, $kAQLh.default).errorFlagTitle),
                description: intl.formatMessage((0, $kAQLh.default).errorFlagDescription)
            });
        })));
    }
    constructor(...args){
        super(...args), this.state = {
            options: [],
            values: [],
            loading: false,
            responseTotal: 0,
            selectedOptions: [],
            flags: [],
            hasNextPage: false,
            lastSearchedInputValue: ''
        }, this.abortController = null, this.getLabel = (total)=>{
            const { intl: intl } = this.props;
            return (total ?? 0) >= $f6df7a69c0e46d98$var$MAX_OBJECT_COUNT_CUTOFF ? intl.formatMessage((0, $kAQLh.default).dropdownMaxNumberOfSearchResultsLabel, {
                maxObjectCountCutoff: $f6df7a69c0e46d98$var$MAX_OBJECT_COUNT_CUTOFF
            }) : intl.formatMessage((0, $kAQLh.default).dropdownNumberOfSearchResultsLabel, {
                numberOfSearchResults: total
            });
        }, this.getOptionsWithLabel = (options, numberOfResults, numberOfAlreadySelectedResults)=>{
            if ((0, $87QgR.default).checkGate('jsm_assets_field_only_display_label_in_portal')) {
                // When isMulti is true, selected values are stripped out from the results dropdown.
                if (this.props.isMulti) return [
                    {
                        options: options,
                        label: this.getLabel(numberOfResults - numberOfAlreadySelectedResults)
                    }
                ];
                return [
                    {
                        options: options,
                        label: this.getLabel(numberOfResults)
                    }
                ];
            }
            return [
                {
                    options: options,
                    label: this.getLabel(numberOfResults - numberOfAlreadySelectedResults)
                }
            ];
        }, // getObjectOptions, fetchFunction retrieveObjects used by FIS FF
        this.getSearchableObject = (cmdbObject, attributesToDisplayInSearch)=>{
            const getDisplayValuesFromAttribute = (attribute)=>attribute.objectAttributeValues.map((val)=>val.displayValue).join(' ');
            // This label is the string value that @atlaskit/select uses under the hood
            // to determine a 'match' when typing in the select field. Therefore, we need to
            // build a string that includes values for all the attributes marked as
            // 'searchable' within the Insight field configuration.
            const searchableLabel = cmdbObject.attributes.map((attribute)=>{
                if (attributesToDisplayInSearch.includes(attribute.objectTypeAttribute.name) || attributesToDisplayInSearch.includes('Label') && attribute.objectTypeAttribute.label) return getDisplayValuesFromAttribute(attribute);
                return undefined;
            }).filter(Boolean).join(' ');
            // Label should fall back to the label attribute of the object if it doesn't contain any of the search attributes
            return {
                cmdbObject: cmdbObject,
                value: cmdbObject.id,
                label: searchableLabel || cmdbObject.label
            };
        }, this.getObjectOptions = async (fetchFunction, setValues = false)=>{
            const { populateDefaultValue: populateDefaultValue, isMulti: isMulti, limit: limit, id: id } = this.props;
            try {
                const response = await fetchFunction();
                const options = response.cmdbObjects.map((object)=>this.getSearchableObject(object, this.props.filterAttributes));
                this.setState({
                    responseTotal: response.total
                });
                if (populateDefaultValue && setValues) {
                    var _this$props$onChange, _this$props;
                    const newValues = this.getDefaultInitialValues(options, isMulti, limit);
                    this.setState({
                        values: newValues
                    });
                    (_this$props$onChange = (_this$props = this.props).onChange) === null || _this$props$onChange === void 0 || _this$props$onChange.call(_this$props, id, newValues.map((val)=>val ? val.value : ''));
                }
                this.setState((prevState)=>({
                        options: [
                            ...prevState.options,
                            ...options
                        ]
                    }));
            } catch (error) {
                // Ensure the dropdown never gets stuck on the loading spinner if the fetch (or
                // subsequent processing) throws. fetchFunction already handles its own errors, but
                // this guards against any other failure in this method.
                this.setState({
                    loading: false
                });
                (0, $jBiia.trackError)('cmdb-fetch-error', {}, error);
            }
        }, this.addErrorFlag = ()=>{
            const { flags: flags } = this.state;
            const newFlags = [
                ...flags
            ];
            newFlags.splice(0, 0, (0, $eL3zl.v4)());
            this.setState({
                flags: newFlags
            });
        }, this.dismissErrorFlag = ()=>{
            const flags = this.state.flags;
            this.setState({
                flags: flags.splice(1)
            });
        }, this.handleError = (error)=>{
            if (error.status === 400) this.addErrorFlag();
        }, this.fetchFunction = (inputValue, isNextPageQuery = false)=>{
            // Abort any in-flight requests, and create a new AbortController for the new request.
            if (this.abortController) this.abortController.abort('Cancelling in-flight request');
            const abortController = new AbortController();
            this.abortController = abortController;
            const { signal: signal } = abortController;
            // If fetching a fresh set of values rather than a subsequent page, clear out the options shown in the dropdown.
            if (!isNextPageQuery) this.setState({
                options: []
            });
            this.setState({
                loading: true
            });
            return (0, $8UaEm.fetchCmdbObjectsWithSignal)(this.props.portalId, this.props.requestTypeId, this.props.id, inputValue, this.props.fieldValueMap, signal, isNextPageQuery ? this.state.options.length : 0).then((response)=>{
                this.setState({
                    hasNextPage: response.hasNextPage,
                    lastSearchedInputValue: inputValue,
                    loading: false
                });
                return response;
            }).catch((err)=>{
                if (!abortController.signal.aborted) {
                    (0, $jBiia.trackError)('cmdb-fetch-error', {}, err);
                    this.handleError(err);
                    this.setState({
                        loading: false
                    });
                }
                return {
                    cmdbObjects: [],
                    total: 0,
                    hasNextPage: false
                };
            });
        }, this.retrieveObjects = (inputValue, type)=>{
            if (type.action === 'input-change') // Disabling existing violations, should be fixed when revisited.
            // eslint-disable-next-line @typescript-eslint/no-floating-promises
            this.getObjectOptions(()=>this.fetchFunction(inputValue));
        }, this.onInputChangeDebounced = (0, (/*@__PURE__*/$parcel$interopDefault($inh7J)))(this.retrieveObjects, 400), this.onMenuScrollToBottom = async ()=>{
            if (this.state.hasNextPage) await this.getObjectOptions(()=>this.fetchFunction(this.state.lastSearchedInputValue, true));
        }, this.onFocus = ()=>{
            // Disabling existing violations, should be fixed when revisited.
            // eslint-disable-next-line @typescript-eslint/no-floating-promises
            this.getObjectOptions(()=>this.fetchFunction(''));
        }, this.onChange = (name, value)=>{
            var _this$props$onChange2, _this$props2;
            this.setState({
                selectedOptions: value
            });
            // The existing code breaks if a search is currently in progress because prevState.options is empty.
            if ((0, $87QgR.default).checkGate('jsm_assets_field_only_display_label_in_portal')) this.setState((prevState)=>{
                // prevState.values will have existing values, and `prevState.options` will have potential new values.
                // We cannot only rely on prevState.options because they will be empty if search is occurring right now.
                // Get all existing values from prevValues
                const valuesFromExisting = prevState.values.filter((val)=>value === null || value === void 0 ? void 0 : value.includes(val === null || val === void 0 ? void 0 : val.value));
                // Get any new values from options
                const valuesFromSearch = prevState.options.filter((opt)=>value === null || value === void 0 ? void 0 : value.includes(opt === null || opt === void 0 ? void 0 : opt.value));
                // Combine and dedupe
                const newValues = [
                    ...valuesFromExisting,
                    ...valuesFromSearch
                ].filter((obj1, i, arr)=>arr.findIndex((obj2)=>obj2.value === obj1.value) === i);
                return {
                    values: newValues
                };
            });
            else this.setState((prevState)=>({
                    values: prevState.options.filter((opt)=>value === null || value === void 0 ? void 0 : value.includes(opt === null || opt === void 0 ? void 0 : opt.value))
                }));
            (_this$props$onChange2 = (_this$props2 = this.props).onChange) === null || _this$props$onChange2 === void 0 || _this$props$onChange2.call(_this$props2, name, value);
        }, this.getDefaultInitialValues = (options, isMulti, limit)=>{
            if (options.length === 0 && (0, $87QgR.default).checkGate('jsm_assets_field_only_display_label_in_portal')) return options;
            if (isMulti) return options.length > limit ? options.slice(0, limit - 1) : options;
            return [
                options[0]
            ];
        }, // --- New (create-issue style) experience handlers, gated behind NEW_EXPERIENCE_GATE ---
        this.handleNewSearch = (query)=>{
            this.setState({
                lastSearchedInputValue: query
            });
            // Disabling existing violations, should be fixed when revisited.
            // eslint-disable-next-line @typescript-eslint/no-floating-promises
            this.getObjectOptions(()=>this.fetchFunction(query));
        }, this.handleNewLoadMore = ()=>{
            // Disabling existing violations, should be fixed when revisited.
            // eslint-disable-next-line @typescript-eslint/no-floating-promises
            this.onMenuScrollToBottom();
        }, this.handleSelectionCommit = (objects)=>{
            var _this$props$onChange3, _this$props3;
            const newValues = objects.map((object)=>this.getSearchableObject(object, this.props.filterAttributes));
            this.setState({
                values: newValues
            });
            (_this$props$onChange3 = (_this$props3 = this.props).onChange) === null || _this$props$onChange3 === void 0 || _this$props$onChange3.call(_this$props3, this.props.id, newValues.map((val)=>val.value));
        };
    }
}
var $f6df7a69c0e46d98$export$2e2bcd8739ae039 = (0, $fK3tS.default)($f6df7a69c0e46d98$export$1c8a8ad79184b709);

});
parcelRegister("4LA20", function(module, exports) {
$parcel$export(module.exports, "PaginatedObjectsView", () => (parcelRequire("jKevm")).PaginatedObjectsView);

var $jKevm = parcelRequire("jKevm");

var $aBcsb = parcelRequire("aBcsb");

});
parcelRegister("jKevm", function(module, exports) {
$parcel$export(module.exports, "PaginatedObjectsView", () => $988de9be8387bf9d$export$6c89780265eb1a35);

var $bSJIT = parcelRequire("bSJIT");

var $4vLTk = parcelRequire("4vLTk");

var $6WltM = parcelRequire("6WltM");

var $haAAx = parcelRequire("haAAx");

var $gUpf2 = parcelRequire("gUpf2");

var $2IITT = parcelRequire("2IITT");

var $hYh8H = parcelRequire("hYh8H");

var $aRsbV = parcelRequire("aRsbV");

var $9BVpB = parcelRequire("9BVpB");

var $hzFIQ = parcelRequire("hzFIQ");

var $4TRbS = parcelRequire("4TRbS");

var $kFWau = parcelRequire("kFWau");

var $cBVmT = parcelRequire("cBVmT");

var $9dYEz = parcelRequire("9dYEz");

var $4GWyU = parcelRequire("4GWyU");

var $gfXmS = parcelRequire("gfXmS");

var $jgsO4 = parcelRequire("jgsO4");

var $26Jy2 = parcelRequire("26Jy2");

var $8xmRs = parcelRequire("8xmRs");

var $65Fe1 = parcelRequire("65Fe1");

var $7LtMZ = parcelRequire("7LtMZ");

var $kpgiw = parcelRequire("kpgiw");

var $g7Wu4 = parcelRequire("g7Wu4");

var $aBcsb = parcelRequire("aBcsb");

var $gOswG = parcelRequire("gOswG");

var $k1CGD = parcelRequire("k1CGD");

var $7x378 = parcelRequire("7x378");
/** Number of selected-object cards shown per page in the field. */ const $988de9be8387bf9d$var$CARDS_PER_PAGE = 10;
const $988de9be8387bf9d$var$EMPTY_ATTRIBUTE_NAMES = [];
const $988de9be8387bf9d$export$6c89780265eb1a35 = ({ selectedObjects: selectedObjects, searchResults: searchResults, isMulti: isMulti, limit: limit, fieldLabel: fieldLabel, searchQuery: searchQuery, onSearchChange: onSearchChange, isLoading: isLoading, hasMore: hasMore, onLoadMore: onLoadMore, onSelectionCommit: onSelectionCommit, errorMessage: errorMessage, attributesToDisplayInSearch: attributesToDisplayInSearch = $988de9be8387bf9d$var$EMPTY_ATTRIBUTE_NAMES, required: required = false })=>{
    const { formatMessage: formatMessage } = (0, $4vLTk.default)();
    const addTriggerLabel = (0, $gOswG.default).addObjectsLabel;
    const hasError = errorMessage != null && errorMessage !== '';
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $6WltM.useAnalyticsEvents)();
    const [isOpen, setIsOpen] = (0, $bSJIT.useState)(false);
    // Mirror of `isOpen` so event handlers can read the latest value without putting
    // side effects inside a setState updater (which React 18 may invoke more than once).
    const isOpenRef = (0, $bSJIT.useRef)(isOpen);
    (0, $bSJIT.useEffect)(()=>{
        isOpenRef.current = isOpen;
    }, [
        isOpen
    ]);
    // In-dropdown checkbox selections (object ids) staged before the user confirms with "Add".
    const [pendingIds, setPendingIds] = (0, $bSJIT.useState)([]);
    // Which page of selected-object cards is shown in the field.
    const [cardsPage, setCardsPage] = (0, $bSJIT.useState)(0);
    // Search query over the already-added objects (filters the cards list).
    const [listSearchQuery, setListSearchQuery] = (0, $bSJIT.useState)('');
    // Caches the full CmdbObject for every id that gets checked, so a confirm can still resolve
    // objects that were evicted from the current search results by a later query change.
    const pendingObjectsRef = (0, $bSJIT.useRef)(new Map());
    // The dropdown shows all search results; already-added objects appear pre-checked
    // (their id is seeded into pendingIds on open).
    // Set for O(1) membership checks instead of O(n) Array.includes.
    const pendingIdSet = (0, $bSJIT.useMemo)(()=>new Set(pendingIds), [
        pendingIds
    ]);
    const attributesToDisplaySet = (0, $bSJIT.useMemo)(()=>new Set(attributesToDisplayInSearch), [
        attributesToDisplayInSearch
    ]);
    const dropdownItems = (0, $bSJIT.useMemo)(()=>searchResults.map((object)=>{
            const metadata = object.attributes.filter((attribute)=>attributesToDisplaySet.has(attribute.objectTypeAttribute.name) || attributesToDisplaySet.has('Label') && attribute.objectTypeAttribute.label).flatMap((attribute)=>attribute.objectAttributeValues.map((value)=>value.displayValue).filter((value)=>Boolean(value)));
            return {
                object: object,
                isSelected: pendingIdSet.has(object.id),
                metadata: metadata.length > 0 ? metadata : undefined
            };
        }), [
        searchResults,
        pendingIdSet,
        attributesToDisplaySet
    ]);
    // Resolve an id to its object from search results or the already-committed set
    // (a pre-checked object may not be on the current search page).
    const objectById = (0, $bSJIT.useMemo)(()=>{
        const map = new Map();
        selectedObjects.forEach((o)=>map.set(o.id, o));
        searchResults.forEach((o)=>map.set(o.id, o));
        return map;
    }, [
        selectedObjects,
        searchResults
    ]);
    // Ids already committed to the field (the main list).
    const committedIds = (0, $bSJIT.useMemo)(()=>new Set(selectedObjects.map((o)=>o.id)), [
        selectedObjects
    ]);
    // "N selected" = the number of currently-checked rows in the dropdown. On open this is seeded
    // with the main-list objects (so reopen shows them checked), and it drops by one when a row is
    // unchecked.
    const selectedCount = pendingIds.length;
    // The whole field must not exceed the limit. The checked set (pendingIds) already includes the
    // pre-checked committed objects, so the checked count is the eventual field size.
    const isLimitReached = selectedCount >= limit;
    // "Select first N results" / "Showing N" reflect what can still be selected, capped at the limit.
    const allowedLimit = limit;
    // Confirm is enabled when the checked set differs from the current main list (additions/removals).
    const hasChanges = (0, $bSJIT.useMemo)(()=>{
        const pendingSet = new Set(pendingIds);
        const hasAdditions = pendingIds.some((id)=>!committedIds.has(id));
        const hasRemovals = selectedObjects.some((o)=>!pendingSet.has(o.id));
        return hasAdditions || hasRemovals;
    }, [
        pendingIds,
        committedIds,
        selectedObjects
    ]);
    const closeAndReset = (0, $bSJIT.useCallback)(()=>{
        setIsOpen(false);
        setPendingIds([]);
        pendingObjectsRef.current.clear();
        onSearchChange('');
    }, [
        onSearchChange
    ]);
    // Fired when the dropdown is dismissed via Cancel (or clicking away).
    const handleCancel = (0, $bSJIT.useCallback)(()=>{
        createAnalyticsEvent({
            analyticsType: (0, $haAAx.UI_EVENT_TYPE),
            action: 'cancelled',
            actionSubject: 'cmdbObjectPicker',
            source: 'cmdbObjectPicker',
            selectedCount: pendingIds.length
        }).fire();
        closeAndReset();
    }, [
        createAnalyticsEvent,
        closeAndReset,
        pendingIds.length
    ]);
    // Wrap the dropdown search so each query change is tracked (search over the searchable results).
    const handleDropdownSearchChange = (0, $bSJIT.useCallback)((query)=>{
        createAnalyticsEvent({
            analyticsType: (0, $haAAx.UI_EVENT_TYPE),
            action: 'searched',
            actionSubject: 'cmdbObjectPicker',
            source: 'cmdbObjectPicker',
            resultCount: searchResults.length
        }).fire();
        onSearchChange(query);
    }, [
        createAnalyticsEvent,
        onSearchChange,
        searchResults.length
    ]);
    // Wrap load-more (infinite scroll / "Load more") so paginated fetches are tracked.
    const handleLoadMore = (0, $bSJIT.useCallback)(()=>{
        createAnalyticsEvent({
            analyticsType: (0, $haAAx.UI_EVENT_TYPE),
            action: 'loadedMore',
            actionSubject: 'cmdbObjectPicker',
            source: 'cmdbObjectPicker',
            resultCount: searchResults.length
        }).fire();
        onLoadMore();
    }, [
        createAnalyticsEvent,
        onLoadMore,
        searchResults.length
    ]);
    const handleObjectSelectionChange = (0, $bSJIT.useCallback)((objectId, isSelected)=>{
        if (isSelected) {
            // Cache the full object so confirm can resolve it even if a later search evicts it.
            const object = objectById.get(objectId);
            if (object) pendingObjectsRef.current.set(objectId, object);
        }
        setPendingIds((prev)=>{
            if (isSelected) return prev.includes(objectId) ? prev : [
                ...prev,
                objectId
            ];
            return prev.filter((id)=>id !== objectId);
        });
    }, [
        objectById
    ]);
    const handleSelectAllChange = (0, $bSJIT.useCallback)((isChecked)=>{
        createAnalyticsEvent({
            limit: limit,
            analyticsType: (0, $haAAx.UI_EVENT_TYPE),
            action: isChecked ? 'selectedAll' : 'deselectedAll',
            actionSubject: 'cmdbObjectSelection',
            source: 'cmdbObjectPicker',
            resultCount: searchResults.length
        }).fire();
        if (!isChecked) {
            // Only deselect the currently-visible results; preserve pre-checked committed
            // objects that aren't on this search page.
            const visibleIds = new Set(searchResults.map((o)=>o.id));
            setPendingIds((prev)=>prev.filter((id)=>!visibleIds.has(id)));
            return;
        }
        // Fill up to the field limit with the visible results (preserving any already-checked).
        setPendingIds((prev)=>{
            const next = [
                ...prev
            ];
            for (const o of searchResults){
                if (next.length >= limit) break;
                if (!next.includes(o.id)) {
                    next.push(o.id);
                    pendingObjectsRef.current.set(o.id, o);
                }
            }
            return next.slice(0, limit);
        });
    }, [
        searchResults,
        limit,
        createAnalyticsEvent
    ]);
    const handleConfirm = (0, $bSJIT.useCallback)(()=>{
        // The field becomes exactly the checked set. Unchecked items are dropped. Resolve each id
        // from the current results/committed map, falling back to the pending cache so a checked
        // object isn't lost if a later search evicted it from the results.
        const committed = pendingIds.map((id)=>objectById.get(id) ?? pendingObjectsRef.current.get(id)).filter((o)=>Boolean(o));
        onSelectionCommit(committed);
        createAnalyticsEvent({
            analyticsType: (0, $haAAx.TRACK_EVENT_TYPE),
            action: 'confirmed',
            actionSubject: 'cmdbObjectSelection',
            selectedCount: committed.length
        }).fire();
        closeAndReset();
    }, [
        pendingIds,
        objectById,
        onSelectionCommit,
        closeAndReset,
        createAnalyticsEvent
    ]);
    const handleRemove = (0, $bSJIT.useCallback)((objectId)=>{
        onSelectionCommit(selectedObjects.filter((o)=>o.id !== objectId));
        createAnalyticsEvent({
            analyticsType: (0, $haAAx.TRACK_EVENT_TYPE),
            action: 'removed',
            actionSubject: 'cmdbObject'
        }).fire();
    }, [
        selectedObjects,
        onSelectionCommit,
        createAnalyticsEvent
    ]);
    // All visible results are checked (capped by the field limit).
    const isAllSelected = searchResults.length > 0 && searchResults.slice(0, allowedLimit).every((o)=>pendingIdSet.has(o.id));
    const isIndeterminate = selectedCount > 0 && !isAllSelected;
    // Search over the already-added objects (the cards list), mirroring Create Issue.
    const listFilteredObjects = (0, $bSJIT.useMemo)(()=>{
        const query = listSearchQuery.trim().toLowerCase();
        if (!query) return selectedObjects;
        return selectedObjects.filter((object)=>{
            const label = String(object.label ?? '').toLowerCase();
            return label.includes(query);
        });
    }, [
        selectedObjects,
        listSearchQuery
    ]);
    // Paginate the filtered selected-object cards shown in the field.
    const totalCardPages = Math.max(Math.ceil(listFilteredObjects.length / $988de9be8387bf9d$var$CARDS_PER_PAGE), 1);
    // Keep the current page in range when objects are removed/filtered.
    (0, $bSJIT.useEffect)(()=>{
        if (cardsPage > totalCardPages - 1) setCardsPage(totalCardPages - 1);
    }, [
        cardsPage,
        totalCardPages
    ]);
    const pagedObjects = (0, $bSJIT.useMemo)(()=>listFilteredObjects.slice(cardsPage * $988de9be8387bf9d$var$CARDS_PER_PAGE, cardsPage * $988de9be8387bf9d$var$CARDS_PER_PAGE + $988de9be8387bf9d$var$CARDS_PER_PAGE), [
        listFilteredObjects,
        cardsPage
    ]);
    const isListSearching = listSearchQuery.trim().length > 0;
    const showListSearch = selectedObjects.length > 1;
    const handleListSearchChange = (0, $bSJIT.useCallback)((event)=>{
        createAnalyticsEvent({
            analyticsType: (0, $haAAx.UI_EVENT_TYPE),
            action: 'searched',
            actionSubject: 'cmdbObjectField',
            source: 'cmdbObjectPicker'
        }).fire();
        setListSearchQuery(event.target.value);
        setCardsPage(0);
    }, [
        createAnalyticsEvent
    ]);
    const handleClearListSearch = (0, $bSJIT.useCallback)(()=>{
        createAnalyticsEvent({
            analyticsType: (0, $haAAx.UI_EVENT_TYPE),
            action: 'searchCleared',
            actionSubject: 'cmdbObjectField',
            source: 'cmdbObjectPicker'
        }).fire();
        setListSearchQuery('');
        setCardsPage(0);
    }, [
        createAnalyticsEvent
    ]);
    const fireRemoveEvent = (0, $bSJIT.useCallback)((mode, removedCount)=>{
        createAnalyticsEvent({
            mode: mode,
            removedCount: removedCount,
            analyticsType: (0, $haAAx.TRACK_EVENT_TYPE),
            action: 'removed',
            actionSubject: 'cmdbObjectSelection'
        }).fire();
    }, [
        createAnalyticsEvent
    ]);
    const handleRemoveAll = (0, $bSJIT.useCallback)(()=>{
        fireRemoveEvent('all', selectedObjects.length);
        onSelectionCommit([]);
    }, [
        onSelectionCommit,
        selectedObjects.length,
        fireRemoveEvent
    ]);
    // Remove only the objects shown on the current cards page.
    const handleRemoveThisPage = (0, $bSJIT.useCallback)(()=>{
        const pageIds = new Set(pagedObjects.map((o)=>o.id));
        fireRemoveEvent('page', pageIds.size);
        onSelectionCommit(selectedObjects.filter((o)=>!pageIds.has(o.id)));
    }, [
        pagedObjects,
        selectedObjects,
        onSelectionCommit,
        fireRemoveEvent
    ]);
    // Remove all objects matching the current list-search query.
    const handleRemoveSearchResults = (0, $bSJIT.useCallback)(()=>{
        const matchedIds = new Set(listFilteredObjects.map((o)=>o.id));
        fireRemoveEvent('searchResults', matchedIds.size);
        onSelectionCommit(selectedObjects.filter((o)=>!matchedIds.has(o.id)));
    }, [
        listFilteredObjects,
        selectedObjects,
        onSelectionCommit,
        fireRemoveEvent
    ]);
    // Open/close state for the create-issue-style "Remove all" options menu.
    const [isRemoveAllOpen, setIsRemoveAllOpen] = (0, $bSJIT.useState)(false);
    const toggleRemoveAll = (0, $bSJIT.useCallback)(()=>{
        // Compute the next value and fire analytics outside the setState updater
        // (React 18 may invoke updaters more than once, causing duplicate events).
        const willOpen = !isRemoveAllOpen;
        // Only track the open action, not the close.
        if (willOpen) createAnalyticsEvent({
            analyticsType: (0, $haAAx.UI_EVENT_TYPE),
            action: 'opened',
            actionSubject: 'cmdbObjectRemoveAllMenu',
            source: 'cmdbObjectPicker',
            selectedCount: selectedObjects.length
        }).fire();
        setIsRemoveAllOpen(willOpen);
    }, [
        createAnalyticsEvent,
        isRemoveAllOpen,
        selectedObjects.length
    ]);
    const closeRemoveAll = (0, $bSJIT.useCallback)(()=>setIsRemoveAllOpen(false), []);
    // Track pagination through the selected-object cards, then move to the requested page.
    const handleCardsPageChange = (0, $bSJIT.useCallback)((_event, page)=>{
        createAnalyticsEvent({
            analyticsType: (0, $haAAx.UI_EVENT_TYPE),
            action: 'paginated',
            actionSubject: 'cmdbObjectField',
            source: 'cmdbObjectPicker',
            pageCount: totalCardPages
        }).fire();
        setCardsPage(page - 1);
    }, [
        createAnalyticsEvent,
        totalCardPages
    ]);
    const handleOpen = (0, $bSJIT.useCallback)(()=>{
        // Keep side effects out of the setState updater (React 18 may invoke updaters
        // more than once). Read the latest open state via the functional ref pattern
        // by toggling based on the current value captured in a ref.
        const willOpen = !isOpenRef.current;
        setIsOpen(willOpen);
        if (willOpen) {
            // Pre-check the already-added objects so the dropdown reflects the current field.
            setPendingIds(selectedObjects.map((o)=>o.id));
            // Seed the cache with committed objects so they survive a confirm after searching.
            pendingObjectsRef.current = new Map(selectedObjects.map((o)=>[
                    o.id,
                    o
                ]));
            // Fetch the initial (unfiltered) page when the dropdown opens.
            onSearchChange('');
            createAnalyticsEvent({
                analyticsType: (0, $haAAx.UI_EVENT_TYPE),
                action: 'opened',
                actionSubject: 'cmdbObjectPicker',
                selectedCount: selectedObjects.length
            }).fire();
        }
    }, [
        onSearchChange,
        selectedObjects,
        createAnalyticsEvent
    ]);
    const hasObjects = selectedObjects.length > 0;
    // Show the field trigger when multi-select, or single-select with nothing chosen yet.
    const showTrigger = isMulti || !hasObjects;
    // When objects already exist, the trigger is a compact "+" icon; otherwise the full button.
    const renderAddTrigger = (triggerProps)=>hasObjects ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $gUpf2.Box), {
            xcss: $988de9be8387bf9d$var$addTriggerStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $4TRbS.default), {
            ...triggerProps,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($kFWau))),
            appearance: "subtle",
            spacing: "compact",
            isDisabled: isLimitReached,
            label: formatMessage(addTriggerLabel),
            onClick: handleOpen
        })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $hzFIQ.default), {
            ...triggerProps,
            appearance: "link",
            spacing: "none",
            iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($kFWau))), {
                label: "",
                color: "var(--ds-link, #0C66E4)"
            }),
            onClick: handleOpen
        }, formatMessage(addTriggerLabel));
    const dropdownContent = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $aBcsb.ObjectsDropdown), {
            items: dropdownItems,
            displayedCount: searchResults.length,
            searchQuery: searchQuery,
            onSearchChange: handleDropdownSearchChange,
            isLoading: isLoading,
            hasMore: hasMore,
            onLoadMore: handleLoadMore,
            selectedCount: selectedCount,
            allowedLimit: allowedLimit,
            isAllSelected: isAllSelected,
            isIndeterminate: isIndeterminate,
            onSelectAllChange: handleSelectAllChange,
            onObjectSelectionChange: handleObjectSelectionChange,
            isConfirmDisabled: !hasChanges,
            onCancel: handleCancel,
            onConfirm: handleConfirm
        });
    const popupTrigger = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $26Jy2.Popup), {
        isOpen: isOpen,
        onClose: closeAndReset,
        placement: "top-start",
        content: dropdownContent,
        trigger: renderAddTrigger
    });
    // Empty state: title (with required asterisk) on its own line, the
    // "Add objects" trigger on the line below, and an optional error message.
    if (!hasObjects) {
        const fieldTitle = fieldLabel ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $aRsbV.Text), {
            size: "small",
            weight: "semibold",
            color: "color.text.subtle"
        }, fieldLabel, required && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $7x378.RequiredAsterisk), null)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $gUpf2.Box), null);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $gUpf2.Box), {
            xcss: $988de9be8387bf9d$var$rootStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $hYh8H.Stack), {
            space: "space.100",
            alignInline: "start"
        }, fieldTitle, showTrigger && popupTrigger), hasError && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $k1CGD.ErrorMessage), null, errorMessage));
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $hYh8H.Stack), {
        space: "space.100",
        xcss: $988de9be8387bf9d$var$rootStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $2IITT.Inline), {
        alignBlock: "center",
        spread: "space-between",
        space: "space.100"
    }, fieldLabel ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $aRsbV.Text), {
        size: "small",
        weight: "semibold",
        color: "color.text.subtle"
    }, fieldLabel, required && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $7x378.RequiredAsterisk), null)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $gUpf2.Box), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $2IITT.Inline), {
        alignBlock: "center",
        space: "space.050"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $26Jy2.Popup), {
        isOpen: isRemoveAllOpen,
        onClose: closeRemoveAll,
        placement: "bottom-start",
        content: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $65Fe1.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $7LtMZ.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $kpgiw.default), {
                iconAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $gUpf2.Box), {
                    xcss: $988de9be8387bf9d$var$menuItemIconStyles
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($9dYEz))), {
                    label: "",
                    color: "var(--ds-icon, #44546F)"
                })),
                isDisabled: pagedObjects.length === 0,
                onClick: ()=>{
                    handleRemoveThisPage();
                    closeRemoveAll();
                }
            }, formatMessage((0, $gOswG.default).removeOnThisPage, {
                count: pagedObjects.length
            })), isListSearching && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $kpgiw.default), {
                iconAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $gUpf2.Box), {
                    xcss: $988de9be8387bf9d$var$menuItemIconStyles
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($9dYEz))), {
                    label: "",
                    color: "var(--ds-icon, #44546F)"
                })),
                isDisabled: listFilteredObjects.length === 0,
                onClick: ()=>{
                    handleRemoveSearchResults();
                    closeRemoveAll();
                }
            }, formatMessage((0, $gOswG.default).removeSearchResults, {
                count: listFilteredObjects.length
            })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $kpgiw.default), {
                iconAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $gUpf2.Box), {
                    xcss: $988de9be8387bf9d$var$menuItemIconStyles
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($9dYEz))), {
                    label: "",
                    color: "var(--ds-icon, #44546F)"
                })),
                isDisabled: selectedObjects.length === 0,
                onClick: ()=>{
                    handleRemoveAll();
                    closeRemoveAll();
                }
            }, formatMessage((0, $gOswG.default).removeAddedObjects, {
                count: selectedObjects.length
            })))),
        trigger: (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $hzFIQ.default), {
                ...triggerProps,
                appearance: "subtle",
                spacing: "compact",
                iconAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4GWyU))), {
                    label: ""
                }),
                isDisabled: selectedObjects.length === 0,
                onClick: toggleRemoveAll
            }, formatMessage((0, $gOswG.default).removeAll))
    }), showTrigger && popupTrigger)), showListSearch && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $gUpf2.Box), {
        xcss: $988de9be8387bf9d$var$listSearchStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $jgsO4.default), {
        value: listSearchQuery,
        onChange: handleListSearchChange,
        placeholder: formatMessage((0, $gOswG.default).searchPlaceholder),
        "aria-label": formatMessage((0, $gOswG.default).search),
        elemBeforeInput: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $gUpf2.Box), {
            xcss: $988de9be8387bf9d$var$listSearchIconStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gfXmS))), {
            label: "",
            size: "small"
        }))
    })), isListSearching && listFilteredObjects.length === 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $gUpf2.Box), {
        xcss: $988de9be8387bf9d$var$listSearchEmptyStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $aRsbV.Text), {
        color: "color.text.subtle"
    }, formatMessage((0, $gOswG.default).noResults)), ' ', /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $hzFIQ.default), {
        appearance: "link",
        spacing: "none",
        onClick: handleClearListSearch
    }, formatMessage((0, $gOswG.default).clearSearch))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $hYh8H.Stack), {
        space: "space.050"
    }, pagedObjects.map((object)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $gUpf2.Box), {
            key: object.id,
            xcss: $988de9be8387bf9d$var$cardRowStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $g7Wu4.CmdbObjectCard), {
            cmdbObject: object,
            hideExpand: true
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $gUpf2.Box), {
            xcss: $988de9be8387bf9d$var$removeButtonStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $4TRbS.default), {
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($cBVmT))),
            appearance: "subtle",
            spacing: "compact",
            shape: "circle",
            label: formatMessage((0, $gOswG.default).removeObject, {
                objectLabel: object.label
            }),
            onClick: ()=>handleRemove(object.id)
        })))), listFilteredObjects.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $gUpf2.Box), {
        xcss: $988de9be8387bf9d$var$paginationStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $gUpf2.Box), {
        xcss: $988de9be8387bf9d$var$paginationRangeStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $aRsbV.Text), {
        size: "medium",
        color: "color.text.subtlest"
    }, formatMessage((0, $gOswG.default).paginationRangeInline, {
        start: cardsPage * $988de9be8387bf9d$var$CARDS_PER_PAGE + 1,
        end: Math.min((cardsPage + 1) * $988de9be8387bf9d$var$CARDS_PER_PAGE, listFilteredObjects.length),
        total: listFilteredObjects.length
    }))), totalCardPages > 1 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $gUpf2.Box), {
        xcss: $988de9be8387bf9d$var$paginationControlsStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $8xmRs.default), {
        label: formatMessage((0, $gOswG.default).pageLabel),
        pageLabel: formatMessage((0, $gOswG.default).pageLabel),
        nextLabel: formatMessage((0, $gOswG.default).nextPage),
        previousLabel: formatMessage((0, $gOswG.default).previousPage),
        pages: Array.from({
            length: totalCardPages
        }, (_, index)=>index + 1),
        selectedIndex: cardsPage,
        onChange: handleCardsPageChange,
        max: 7
    })))), hasError && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $k1CGD.ErrorMessage), null, errorMessage));
};
const $988de9be8387bf9d$var$rootStyles = (0, $9BVpB.xcss)({
    paddingBlockStart: 'space.200'
});
const $988de9be8387bf9d$var$paginationStyles = (0, $9BVpB.xcss)({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    columnGap: 'space.150',
    flexWrap: 'wrap',
    paddingBlockStart: 'space.050'
});
const $988de9be8387bf9d$var$paginationRangeStyles = (0, $9BVpB.xcss)({
    flexShrink: 0
});
const $988de9be8387bf9d$var$paginationControlsStyles = (0, $9BVpB.xcss)({
    display: 'flex',
    alignItems: 'center'
});
const $988de9be8387bf9d$var$cardRowStyles = (0, $9BVpB.xcss)({
    position: 'relative',
    width: '100%'
});
// Search bar above the added-objects cards list.
const $988de9be8387bf9d$var$listSearchStyles = (0, $9BVpB.xcss)({
    paddingBlockEnd: 'space.050'
});
const $988de9be8387bf9d$var$listSearchIconStyles = (0, $9BVpB.xcss)({
    display: 'flex',
    alignItems: 'center',
    paddingInlineStart: 'space.075',
    color: 'color.text.subtle'
});
// "No results matching your search." + Clear search empty state (centered).
const $988de9be8387bf9d$var$listSearchEmptyStyles = (0, $9BVpB.xcss)({
    paddingBlock: 'space.100',
    textAlign: 'center'
});
// Trailing cross icon inside each Remove-all menu option (matches Create Issue).
const $988de9be8387bf9d$var$menuItemIconStyles = (0, $9BVpB.xcss)({
    display: 'flex',
    alignItems: 'center'
});
// Overlay the remove control in the card's top-right corner without extra wrapper chrome.
const $988de9be8387bf9d$var$removeButtonStyles = (0, $9BVpB.xcss)({
    position: 'absolute',
    top: 'space.100',
    right: 'space.100',
    zIndex: 'card'
});
// "+" add trigger: bordered at rest, background change on hover (matches Create Issue).
const $988de9be8387bf9d$var$addTriggerStyles = (0, $9BVpB.xcss)({
    borderRadius: 'radius.small',
    borderWidth: 'border.width',
    borderStyle: 'solid',
    borderColor: 'color.border',
    ':hover': {
        backgroundColor: 'color.background.neutral.subtle.hovered'
    }
});

});
parcelRegister("aBcsb", function(module, exports) {
$parcel$export(module.exports, "ObjectsDropdown", () => $9f77a78cc9515344$export$af6ac03c30eda9b9);

var $bSJIT = parcelRequire("bSJIT");

var $4vLTk = parcelRequire("4vLTk");

var $gUpf2 = parcelRequire("gUpf2");

var $2IITT = parcelRequire("2IITT");

var $aHbh3 = parcelRequire("aHbh3");

var $hYh8H = parcelRequire("hYh8H");

var $aRsbV = parcelRequire("aRsbV");

var $9BVpB = parcelRequire("9BVpB");

var $jgsO4 = parcelRequire("jgsO4");

var $gfXmS = parcelRequire("gfXmS");

var $dsw4B = parcelRequire("dsw4B");

var $8HhhR = parcelRequire("8HhhR");

var $jNJGJ = parcelRequire("jNJGJ");

var $hDkm2 = parcelRequire("hDkm2");

var $arQGg = parcelRequire("arQGg");

var $gOswG = parcelRequire("gOswG");
const $9f77a78cc9515344$var$DropdownListItem = ({ item: item, onSelectionChange: onSelectionChange, isDisabled: isDisabled })=>{
    const { formatMessage: formatMessage } = (0, $4vLTk.default)();
    const handleCheckboxChange = (0, $bSJIT.useCallback)((event)=>{
        onSelectionChange(item.object.id, event.target.checked);
    }, [
        item.object.id,
        onSelectionChange
    ]);
    const label = item.object.label;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $gUpf2.Box), {
        xcss: $9f77a78cc9515344$var$listItemStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $2IITT.Inline), {
        space: "space.100",
        alignBlock: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $8HhhR.Checkbox), {
        isChecked: item.isSelected,
        onChange: handleCheckboxChange,
        "aria-label": formatMessage((0, $gOswG.default).selectObject, {
            objectLabel: label
        }),
        isDisabled: item.isSelected ? false : isDisabled
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $gUpf2.Box), {
        xcss: $9f77a78cc9515344$var$iconContainerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $arQGg.MemoizedInsightIcon), {
        ...item.object.avatar.mediaClientConfig,
        iconUrl: item.object.avatar.url48
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $hYh8H.Stack), {
        space: "space.0",
        grow: "fill",
        xcss: $9f77a78cc9515344$var$textColumnStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $gUpf2.Box), {
        xcss: $9f77a78cc9515344$var$objectLabelStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $aRsbV.Text), null, label)), item.metadata && item.metadata.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $gUpf2.Box), {
        xcss: $9f77a78cc9515344$var$metadataStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $aRsbV.Text), {
        size: "small",
        color: "color.text.subtlest"
    }, item.metadata.join(' | '))))));
};
const $9f77a78cc9515344$export$af6ac03c30eda9b9 = ({ items: items, displayedCount: displayedCount, searchQuery: searchQuery, onSearchChange: onSearchChange, isLoading: isLoading, hasMore: hasMore, onLoadMore: onLoadMore, selectedCount: selectedCount, allowedLimit: allowedLimit, isAllSelected: isAllSelected, isIndeterminate: isIndeterminate, onSelectAllChange: onSelectAllChange, onObjectSelectionChange: onObjectSelectionChange, isConfirmDisabled: isConfirmDisabled, onCancel: onCancel, onConfirm: onConfirm })=>{
    const { formatMessage: formatMessage } = (0, $4vLTk.default)();
    const listContainerRef = (0, $bSJIT.useRef)(null);
    const handleSearchChange = (0, $bSJIT.useCallback)((event)=>{
        onSearchChange(event.target.value);
    }, [
        onSearchChange
    ]);
    const handleScroll = (0, $bSJIT.useCallback)(()=>{
        const el = listContainerRef.current;
        if (!el || isLoading || !hasMore) return;
        if (el.scrollTop + el.clientHeight >= el.scrollHeight - 24) onLoadMore();
    }, [
        isLoading,
        hasMore,
        onLoadMore
    ]);
    (0, $bSJIT.useEffect)(()=>{
        const el = listContainerRef.current;
        if (!el) return undefined;
        el.addEventListener('scroll', handleScroll);
        return ()=>el.removeEventListener('scroll', handleScroll);
    }, [
        handleScroll
    ]);
    const selectAllCount = displayedCount > allowedLimit ? allowedLimit : displayedCount;
    const isLimitReached = selectedCount >= allowedLimit;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $gUpf2.Box), {
        xcss: $9f77a78cc9515344$var$containerStyles,
        testId: "cmdb-object-picker-new.objects-dropdown"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $gUpf2.Box), {
        xcss: $9f77a78cc9515344$var$headerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $jgsO4.default), {
        appearance: "standard",
        value: searchQuery,
        onChange: handleSearchChange,
        placeholder: formatMessage((0, $gOswG.default).searchPlaceholder),
        "aria-label": formatMessage((0, $gOswG.default).search),
        autoFocus: true,
        elemBeforeInput: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $gUpf2.Box), {
            xcss: $9f77a78cc9515344$var$searchIconStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gfXmS))), {
            label: "",
            size: "small"
        }))
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $gUpf2.Box), {
        xcss: $9f77a78cc9515344$var$resultsInfoStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $2IITT.Inline), {
        space: "space.050",
        alignBlock: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $aRsbV.Text), {
        size: "small"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $gUpf2.Box), {
        as: "span",
        role: "status",
        "aria-atomic": "true"
    }, formatMessage((0, $gOswG.default).showingResults, {
        displayed: displayedCount
    }))), hasMore && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $aHbh3.Pressable), {
        xcss: $9f77a78cc9515344$var$loadMoreButtonStyles,
        onClick: onLoadMore
    }, formatMessage((0, $gOswG.default).loadMore))))), displayedCount > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $gUpf2.Box), {
        xcss: $9f77a78cc9515344$var$selectAllContainerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $8HhhR.Checkbox), {
        isChecked: isAllSelected,
        isIndeterminate: isIndeterminate,
        onChange: (e)=>onSelectAllChange(e.target.checked),
        label: formatMessage((0, $gOswG.default).selectFirstResults, {
            count: selectAllCount
        }),
        isDisabled: allowedLimit === 0 || isLimitReached && !isIndeterminate && !isAllSelected
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $gUpf2.Box), {
        xcss: $9f77a78cc9515344$var$dividerStyles
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $gUpf2.Box), {
        xcss: $9f77a78cc9515344$var$listContainerStyles,
        ref: listContainerRef
    }, items.map((item)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement($9f77a78cc9515344$var$DropdownListItem, {
            key: item.object.id,
            item: item,
            onSelectionChange: onObjectSelectionChange,
            isDisabled: isLimitReached
        })), !isLoading && items.length === 0 && searchQuery && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $gUpf2.Box), {
        xcss: $9f77a78cc9515344$var$emptyStateStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $aRsbV.Text), {
        size: "small"
    }, formatMessage((0, $gOswG.default).noResults))), isLoading && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $gUpf2.Box), {
        xcss: $9f77a78cc9515344$var$loadingContainerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $hDkm2.default), {
        size: "small",
        label: formatMessage((0, $gOswG.default).loading)
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $gUpf2.Box), {
        xcss: $9f77a78cc9515344$var$dividerStyles
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $gUpf2.Box), {
        xcss: $9f77a78cc9515344$var$footerStyles
    }, isLimitReached ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $2IITT.Inline), {
        space: "space.050",
        alignBlock: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $gUpf2.Box), {
        xcss: $9f77a78cc9515344$var$warningIconStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dsw4B))), {
        label: "",
        color: "var(--ds-icon-warning, #E06C00)"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $aRsbV.Text), {
        size: "small"
    }, formatMessage((0, $gOswG.default).fieldLimitReached))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $aRsbV.Text), {
        size: "small"
    }, formatMessage((0, $gOswG.default).selectedCount, {
        count: selectedCount
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $2IITT.Inline), {
        space: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $jNJGJ.default), {
        appearance: "subtle",
        onClick: onCancel
    }, formatMessage((0, $gOswG.default).cancel)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $jNJGJ.default), {
        appearance: "primary",
        onClick: onConfirm,
        isDisabled: isConfirmDisabled
    }, formatMessage((0, $gOswG.default).addObjects, {
        count: selectedCount
    })))));
};
const $9f77a78cc9515344$var$containerStyles = (0, $9BVpB.xcss)({
    width: '400px',
    minWidth: '400px',
    maxWidth: '600px',
    borderWidth: 'border.width',
    borderStyle: 'solid',
    borderColor: 'color.border',
    borderRadius: 'radius.small',
    backgroundColor: 'elevation.surface.overlay',
    boxShadow: 'elevation.shadow.overlay'
});
const $9f77a78cc9515344$var$headerStyles = (0, $9BVpB.xcss)({
    padding: 'space.150'
});
const $9f77a78cc9515344$var$searchIconStyles = (0, $9BVpB.xcss)({
    display: 'flex',
    alignItems: 'center',
    paddingInlineStart: 'space.050',
    color: 'color.text.subtle'
});
const $9f77a78cc9515344$var$resultsInfoStyles = (0, $9BVpB.xcss)({
    marginTop: 'space.100',
    color: 'color.text.subtlest'
});
const $9f77a78cc9515344$var$selectAllContainerStyles = (0, $9BVpB.xcss)({
    paddingInline: 'space.150',
    paddingBlock: 'space.050'
});
const $9f77a78cc9515344$var$dividerStyles = (0, $9BVpB.xcss)({
    height: '1px',
    backgroundColor: 'color.background.neutral',
    flexShrink: 0
});
const $9f77a78cc9515344$var$listContainerStyles = (0, $9BVpB.xcss)({
    maxHeight: '240px',
    overflowY: 'auto',
    paddingBlock: 'space.050'
});
const $9f77a78cc9515344$var$listItemStyles = (0, $9BVpB.xcss)({
    paddingInline: 'space.150',
    paddingBlock: 'space.075',
    ':hover': {
        backgroundColor: 'color.background.neutral.subtle.hovered'
    }
});
const $9f77a78cc9515344$var$iconContainerStyles = (0, $9BVpB.xcss)({
    display: 'flex',
    alignItems: 'center',
    flexShrink: 0
});
const $9f77a78cc9515344$var$textColumnStyles = (0, $9BVpB.xcss)({
    minWidth: 'space.0'
});
const $9f77a78cc9515344$var$objectLabelStyles = (0, $9BVpB.xcss)({
    overflowWrap: 'anywhere',
    wordBreak: 'break-word'
});
const $9f77a78cc9515344$var$metadataStyles = (0, $9BVpB.xcss)({
    overflowWrap: 'anywhere',
    wordBreak: 'break-word'
});
const $9f77a78cc9515344$var$emptyStateStyles = (0, $9BVpB.xcss)({
    padding: 'space.150',
    color: 'color.text.subtlest',
    textAlign: 'center'
});
const $9f77a78cc9515344$var$loadingContainerStyles = (0, $9BVpB.xcss)({
    display: 'flex',
    justifyContent: 'center',
    padding: 'space.150'
});
const $9f77a78cc9515344$var$footerStyles = (0, $9BVpB.xcss)({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: 'space.150'
});
const $9f77a78cc9515344$var$warningIconStyles = (0, $9BVpB.xcss)({
    display: 'flex',
    alignItems: 'center'
});
// "Load more" rendered as an inline text link (mirrors Jira's ObjectsDropdown Pressable), avoiding button chrome.
const $9f77a78cc9515344$var$loadMoreButtonStyles = (0, $9BVpB.xcss)({
    display: 'inline-flex',
    color: 'color.link',
    cursor: 'pointer',
    textDecoration: 'none',
    backgroundColor: 'color.background.neutral.subtle',
    padding: 'space.0',
    ':hover': {
        textDecoration: 'underline'
    }
});

});
parcelRegister("gOswG", function(module, exports) {
$parcel$export(module.exports, "default", () => $6248efbcb07c0bb8$export$2e2bcd8739ae039);

var $f0Pt4 = parcelRequire("f0Pt4");
var $6248efbcb07c0bb8$export$2e2bcd8739ae039 = (0, $f0Pt4.defineMessages)({
    searchPlaceholder: {
        id: 'cmdb-components.cmdb-object-picker-new.search-placeholder',
        defaultMessage: 'Search',
        description: 'Placeholder text for the search input in the object dropdown'
    },
    showingResults: {
        id: 'cmdb-components.cmdb-object-picker-new.showing-results',
        defaultMessage: 'Showing {displayed} results.',
        description: 'Text showing the number of results currently displayed in the dropdown'
    },
    loadMore: {
        id: 'cmdb-components.cmdb-object-picker-new.load-more',
        defaultMessage: 'Load more',
        description: 'Link text to load more search results in the dropdown list'
    },
    selectFirstResults: {
        id: 'cmdb-components.cmdb-object-picker-new.select-first-results',
        defaultMessage: 'Select first {count} results',
        description: 'Label for the select-all checkbox that selects the first N results'
    },
    selectedCount: {
        id: 'cmdb-components.cmdb-object-picker-new.selected-count',
        defaultMessage: '{count} selected',
        description: 'Text showing the number of currently selected items'
    },
    fieldLimitReached: {
        id: 'cmdb-components.cmdb-object-picker-new.field-limit-reached',
        defaultMessage: 'Field limit reached',
        description: 'Message shown when the maximum number of objects for the field has been reached'
    },
    cancel: {
        id: 'cmdb-components.cmdb-object-picker-new.cancel',
        defaultMessage: 'Cancel',
        description: 'Text for the cancel button to dismiss the dropdown'
    },
    addObjects: {
        id: 'cmdb-components.cmdb-object-picker-new.add-objects',
        defaultMessage: '{count, plural, one {Add # object} other {Add # objects}}',
        description: 'Text for the button that confirms adding the selected objects'
    },
    addObject: {
        id: 'cmdb-components.cmdb-object-picker-new.add-object',
        defaultMessage: 'Add object',
        description: 'Label for the button that opens the object search dropdown'
    },
    addObjectsLabel: {
        id: 'cmdb-components.cmdb-object-picker-new.add-objects-label',
        defaultMessage: 'Add objects',
        description: 'Label for the button that opens the object search dropdown (portal enhancements)'
    },
    removeObject: {
        id: 'cmdb-components.cmdb-object-picker-new.remove-object',
        defaultMessage: 'Remove {objectLabel}',
        description: 'Accessible label for the button that removes a selected object from the field'
    },
    selectObject: {
        id: 'cmdb-components.cmdb-object-picker-new.select-object',
        defaultMessage: 'Select {objectLabel}',
        description: 'Accessible label for the checkbox that selects an object in the dropdown'
    },
    noObjectsAdded: {
        id: 'cmdb-components.cmdb-object-picker-new.no-objects-added',
        defaultMessage: 'No objects added',
        description: 'Empty-state message shown when no objects are selected for the field'
    },
    noResults: {
        id: 'cmdb-components.cmdb-object-picker-new.no-results',
        defaultMessage: 'No results matching your search.',
        description: 'Message shown when the search returns no matching objects'
    },
    loading: {
        id: 'cmdb-components.cmdb-object-picker-new.loading',
        defaultMessage: 'Loading',
        description: 'Accessible label for the loading spinner'
    },
    search: {
        id: 'cmdb-components.cmdb-object-picker-new.search-label',
        defaultMessage: 'Search assets',
        description: 'Accessible label for the search input'
    },
    removeAll: {
        id: 'cmdb-components.cmdb-object-picker-new.remove-all',
        defaultMessage: 'Remove all',
        description: 'Label for the button that removes all selected objects from the field'
    },
    removeOnThisPage: {
        id: 'cmdb-components.cmdb-object-picker-new.remove-on-this-page',
        defaultMessage: 'On this page ({count})',
        description: 'Remove-all menu option that removes the objects shown on the current page'
    },
    removeSearchResults: {
        id: 'cmdb-components.cmdb-object-picker-new.remove-search-results',
        defaultMessage: 'Search results ({count})',
        description: 'Remove-all menu option that removes all objects matching the current search'
    },
    removeAddedObjects: {
        id: 'cmdb-components.cmdb-object-picker-new.remove-added-objects',
        defaultMessage: 'Added objects ({count})',
        description: 'Remove-all menu option that removes all added objects from the field'
    },
    previousPage: {
        id: 'cmdb-components.cmdb-object-picker-new.previous-page',
        defaultMessage: 'Previous',
        description: 'Label for the button that shows the previous page of selected object cards'
    },
    nextPage: {
        id: 'cmdb-components.cmdb-object-picker-new.next-page',
        defaultMessage: 'Next',
        description: 'Label for the button that shows the next page of selected object cards'
    },
    pageIndicator: {
        id: 'cmdb-components.cmdb-object-picker-new.page-indicator',
        defaultMessage: 'Page {current} of {total}',
        description: 'Indicates the current page and total pages of selected object cards'
    },
    pageLabel: {
        id: 'cmdb-components.cmdb-object-picker-new.page-label',
        defaultMessage: 'Page',
        description: 'Accessible label for a page number in the selected objects pagination'
    },
    paginationRangeInline: {
        id: 'cmdb-components.cmdb-object-picker-new.pagination-range-inline',
        defaultMessage: 'Viewing {start}-{end} of {total}',
        description: 'Shows the range of selected object cards currently visible out of the total count'
    },
    clearSearch: {
        id: 'cmdb-components.cmdb-object-picker-new.clear-search',
        defaultMessage: 'Clear search',
        description: 'Link to clear the added-objects list search and show all objects again'
    }
});

});




parcelRegister("hKK6q", function(module, exports) {
$parcel$export(module.exports, "CmdbObjectPickerDumb", () => (parcelRequire("iGMgJ")).default);

var $iGMgJ = parcelRequire("iGMgJ");

});
parcelRegister("iGMgJ", function(module, exports) {
$parcel$export(module.exports, "default", () => $2ac5ef49abc37c91$export$2e2bcd8739ae039);

var $bSJIT = parcelRequire("bSJIT");

var $1zYnp = parcelRequire("1zYnp");
var $82wak = parcelRequire("82wak");

var $fK3tS = parcelRequire("fK3tS");

var $87QgR = parcelRequire("87QgR");

var $30F9J = parcelRequire("30F9J");
parcelRequire("74dWg");
var $2mSAd = parcelRequire("2mSAd");

var $aDNnF = parcelRequire("aDNnF");
class $2ac5ef49abc37c91$export$d12f6928a020725f extends $bSJIT.Component {
    render() {
        const { isMulti: isMulti, disabled: disabled, doInitialSearch: doInitialSearch, intl: intl, defaultValue: defaultValue, populateDefaultValue: populateDefaultValue, ...otherProps } = this.props;
        const placeholder = intl.formatMessage((0, $aDNnF.default).searchPlaceholder);
        const makeControlledAndOnlyDisplayLabel = (0, $87QgR.default).checkGate('jsm_assets_field_only_display_label_in_portal');
        let selectedValues = defaultValue;
        if (makeControlledAndOnlyDisplayLabel && Array.isArray(defaultValue)) // We change the shape of the selected values to display just the object label rather than the full searchable label
        selectedValues = defaultValue.filter((value)=>value !== undefined).map((value)=>({
                ...value,
                label: value.cmdbObject.label
            }));
        if (isMulti) return /*#__PURE__*/ $bSJIT.createElement((0, $82wak.FormMultiSelect), {
            ...otherProps,
            actionSubjectId: "cmdbObjectPickerField",
            placeholder: placeholder,
            noOptionsMessage: this.noOptionsMessage,
            onChange: this.onChangeForSelect,
            components: this.customComponents,
            value: populateDefaultValue || makeControlledAndOnlyDisplayLabel ? selectedValues : undefined
        });
        let singleSelectValue = selectedValues && selectedValues[0];
        if (makeControlledAndOnlyDisplayLabel) // Need to explicitly set to `null` rather than `undefined` to clear the value.
        singleSelectValue = selectedValues && selectedValues.length > 0 ? selectedValues[0] : null;
        return /*#__PURE__*/ $bSJIT.createElement((0, $1zYnp.FieldSingleSelect), {
            ...otherProps,
            actionSubjectId: "cmdbObjectPickerField",
            placeholder: placeholder,
            noOptionsMessage: this.noOptionsMessage,
            onChange: this.onChangeForSelect,
            components: this.customComponents,
            value: (populateDefaultValue || makeControlledAndOnlyDisplayLabel) && selectedValues ? singleSelectValue : undefined,
            isClearable: true
        });
    }
    constructor(...args){
        super(...args), this.onChangeForSelect = (selectedOption)=>{
            var _this$props$onChange, _this$props;
            (_this$props$onChange = (_this$props = this.props).onChange) === null || _this$props$onChange === void 0 || _this$props$onChange.call(_this$props, this.props.id, (0, $30F9J.toMultiSelectValue)(selectedOption).map((v)=>v.value));
        }, this.customComponents = {
            Option: (0, $2mSAd.CmdbSelectOption)
        }, this.noOptionsMessage = ()=>{
            const { intl: intl } = this.props;
            return intl.formatMessage((0, $aDNnF.default).noOptions);
        };
    }
}
var $2ac5ef49abc37c91$export$2e2bcd8739ae039 = (0, $fK3tS.default)($2ac5ef49abc37c91$export$d12f6928a020725f);

});
parcelRegister("74dWg", function(module, exports) {
$parcel$export(module.exports, "CmdbSelectOption", () => (parcelRequire("2mSAd")).CmdbSelectOption);

var $2mSAd = parcelRequire("2mSAd");

});
parcelRegister("2mSAd", function(module, exports) {
$parcel$export(module.exports, "CmdbSelectOption", () => $db00e00d247ee68d$export$a7be07965a3ed09b);
/* cmdb-object-picker-option.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $9fU1q = parcelRequire("9fU1q");

var $bSJIT = parcelRequire("bSJIT");

var $egQxE = parcelRequire("egQxE");

var $BOq7h = parcelRequire("BOq7h");

var $4ZMmh = parcelRequire("4ZMmh");

var $aRsbV = parcelRequire("aRsbV");

var $kbBdI = parcelRequire("kbBdI");

var $ke6wr = parcelRequire("ke6wr");

var $arQGg = parcelRequire("arQGg");
const $db00e00d247ee68d$export$5a780c1be95ea1c8 = (attributes, attributesToDisplay, timezone)=>{
    const notUndefined = (attr)=>{
        return Boolean(attr);
    };
    const deepClonedAttributes = (0, $4ZMmh.cloneDeep)(attributes);
    return attributesToDisplay.map((attrName)=>attrName === 'Label' ? deepClonedAttributes.find((attr)=>attr.objectTypeAttribute.label) : deepClonedAttributes.find((attr)=>attr.objectTypeAttribute.name === attrName))// get only attributes that have valid displayValue
    .filter(notUndefined).filter((attribute)=>attribute.objectAttributeValues.length > 0 && attribute.objectAttributeValues.every((value)=>value && value.displayValue)).map((attribute)=>{
        var _attribute$objectType;
        if (((_attribute$objectType = attribute.objectTypeAttribute.defaultType) === null || _attribute$objectType === void 0 ? void 0 : _attribute$objectType.name) === 'DateTime') attribute.objectAttributeValues.forEach((value)=>{
            value.displayValue = value.value ? (0, $ke6wr.convertToTimezone)(value.value, timezone.id) : value.displayValue;
        });
        return attribute;
    });
};
const $db00e00d247ee68d$export$fee117cd50d6234b = ({ match: match, children: children })=>{
    if (match === '') return /*#__PURE__*/ $bSJIT.createElement($bSJIT.Fragment, null, children);
    // we need to escape special characters to avoid getting them interpreted in the RegExp group
    const escapedSpecialCharsInMatchQuery = match.replace(/[\\.,*+?^${}()|[\]]/g, '\\$&');
    const parts = children.split(new RegExp(`(${escapedSpecialCharsInMatchQuery})`, 'gi'));
    return /*#__PURE__*/ $bSJIT.createElement($bSJIT.Fragment, null, parts.map((part, i)=>{
        if (part.toLowerCase() === match.toLowerCase()) // eslint-disable-next-line @atlaskit/design-system/use-primitives-text
        return /*#__PURE__*/ $bSJIT.createElement("strong", {
            key: i
        }, part);
        return /*#__PURE__*/ $bSJIT.createElement($bSJIT.Fragment, {
            key: i
        }, part);
    }));
};
const $db00e00d247ee68d$export$3c4337b649d4ffca = (attributes, attributesToDisplay)=>{
    const notUndefined = (attr)=>{
        return Boolean(attr);
    };
    return attributesToDisplay.map((attrName)=>attrName === 'Label' ? attributes.find((attr)=>attr.objectTypeAttribute.label) : attributes.find((attr)=>attr.objectTypeAttribute.name === attrName))// get only attributes that have valid displayValue
    .filter(notUndefined).filter((attribute)=>attribute.objectAttributeValues.length > 0 && attribute.objectAttributeValues.every((value)=>value && value.displayValue));
};
const $db00e00d247ee68d$export$cd0f2f750043f4bc = (attributes)=>{
    return attributes.map((attribute)=>attribute.objectAttributeValues.map((value)=>value.displayValue).join(', ')).join(' | ');
};
const $db00e00d247ee68d$export$9ce1cf00f76f3d0b = (attributes, defaultLabel)=>{
    var _attributes$;
    return ((_attributes$ = attributes[0]) === null || _attributes$ === void 0 ? void 0 : _attributes$.objectAttributeValues.map((v)=>v.displayValue).join(', ')) || defaultLabel;
};
const $db00e00d247ee68d$export$e4de0626a00cf8b4 = (optionProps)=>{
    const { data: data, innerProps: innerProps, selectProps: selectProps, timezone: timezone } = optionProps;
    const { inputValue: inputValue, filterAttributes: filterAttributes } = selectProps;
    const object = data.cmdbObject;
    const visibleAttributes = $db00e00d247ee68d$export$5a780c1be95ea1c8(object.attributes, filterAttributes ?? [], timezone);
    const [, ...secondaryAttributes] = visibleAttributes;
    const labelAttribute = $db00e00d247ee68d$export$9ce1cf00f76f3d0b(visibleAttributes, object.label);
    const secondaryAttributesDescription = $db00e00d247ee68d$export$cd0f2f750043f4bc(secondaryAttributes);
    const { Option: Option } = (0, $kbBdI.components);
    const { ref: ref, ...otherDivProps } = innerProps;
    return /*#__PURE__*/ $bSJIT.createElement(Option, optionProps, /*#__PURE__*/ $bSJIT.createElement("div", {
        ...otherDivProps,
        className: (0, $9fU1q.default)([
            "_1e0c1txw _ca0qcxkx _n3tdcxkx _19bv1e9d _u5f31e9d _irr3dvhl"
        ])
    }, /*#__PURE__*/ $bSJIT.createElement("div", {
        className: (0, $9fU1q.default)([
            "_2hwx1no3 _1o9zidpf"
        ])
    }, /*#__PURE__*/ $bSJIT.createElement((0, $arQGg.MemoizedInsightIcon), {
        ...object.avatar.mediaClientConfig,
        iconUrl: object.avatar.url48
    })), /*#__PURE__*/ $bSJIT.createElement("div", {
        className: (0, $9fU1q.default)([
            "_1e0c1txw _2lx21bp4 _ca0q1xvx"
        ])
    }, /*#__PURE__*/ $bSJIT.createElement((0, $aRsbV.Text), {
        size: "medium",
        weight: "medium"
    }, /*#__PURE__*/ $bSJIT.createElement($db00e00d247ee68d$export$fee117cd50d6234b, {
        match: inputValue ?? ''
    }, labelAttribute)), /*#__PURE__*/ $bSJIT.createElement((0, $aRsbV.Text), {
        size: "small"
    }, /*#__PURE__*/ $bSJIT.createElement($db00e00d247ee68d$export$fee117cd50d6234b, {
        match: inputValue ?? ''
    }, secondaryAttributesDescription)))));
};
const $db00e00d247ee68d$var$selector = (0, $BOq7h.createSelector)((state)=>{
    return state.persisted.user.timezone;
}, (timezone)=>({
        timezone: timezone
    }));
const $db00e00d247ee68d$export$a7be07965a3ed09b = (0, $egQxE.connect)($db00e00d247ee68d$var$selector)($db00e00d247ee68d$export$e4de0626a00cf8b4);
const $db00e00d247ee68d$var$outerStyles = null;
const $db00e00d247ee68d$var$iconStyles = null;
const $db00e00d247ee68d$var$contentStyles = null;

});


parcelRegister("aDNnF", function(module, exports) {
$parcel$export(module.exports, "default", () => $98f075c71978aa1a$export$2e2bcd8739ae039);

var $f0Pt4 = parcelRequire("f0Pt4");
var $98f075c71978aa1a$export$2e2bcd8739ae039 = (0, $f0Pt4.defineMessages)({
    searchPlaceholder: {
        defaultMessage: 'Search...',
        description: 'Placeholder for CMDB object picker field to advise the user to search for objects',
        id: 'cv.request.create.form.cmdbobjectpicker.search.new'
    },
    noOptions: {
        defaultMessage: 'No options',
        description: 'Text that appears in the dropdown for the CMDB object picker if there are no objects to select',
        id: 'cv.request.create.form.cmdbobjectpicker.no.options'
    }
});

});



parcelRegister("kAQLh", function(module, exports) {
$parcel$export(module.exports, "default", () => $463f38d05b3ce43d$export$2e2bcd8739ae039);

var $f0Pt4 = parcelRequire("f0Pt4");
var $463f38d05b3ce43d$export$2e2bcd8739ae039 = (0, $f0Pt4.defineMessages)({
    dropdownNumberOfSearchResultsLabel: {
        id: 'cv.request.create.form.cmdbobjectpicker.numberofsearchresultslabel',
        defaultMessage: `{numberOfSearchResults, plural, one {# search result} other {# search results}}`,
        description: 'Description above cmdb objects options describing how many objects were found'
    },
    dropdownMaxNumberOfSearchResultsLabel: {
        id: 'cv.request.create.form.cmdbobjectpicker.maxnumberofsearchresultslabel',
        defaultMessage: '{maxObjectCountCutoff}+ search results',
        description: 'Description above cmdb objects options describing how many objects were found'
    },
    errorFlagTitle: {
        id: 'cv.request.create.form.cmdbobjectpicker.errorFlagTitle',
        defaultMessage: `We couldn't fetch any results for this search`,
        description: 'Title for error flag that is triggered when searching for CMDB objects fails'
    },
    errorFlagDescription: {
        id: 'cv.request.create.form.cmdbobjectpicker.errorFlagDescription',
        defaultMessage: `Ask your team or admin for support.`,
        description: 'Description for error flag that is triggered when searching for CMDB objects fails'
    }
});

});



parcelRegister("fFdP5", function(module, exports) {
$parcel$export(module.exports, "createPlaceholderValueMap", () => $b08f6fadcc8ac15f$export$e48ef9588813000d);
const $b08f6fadcc8ac15f$export$e48ef9588813000d = (fieldValues, placeholderKeys)=>{
    // This reducer takes the field keys specified by the BE and grabs the relevant values from the form
    // to construct a map of values for the specified fields
    // This map is used by the CmdbObectPicker to determine when to display a default value based on an IQL query
    const placeholderValuesReducer = (accumulator, currentPlaceholder)=>{
        if (fieldValues[currentPlaceholder]) {
            var _fieldValues$currentP;
            // Suppressing existing violation. Please fix this.
            // eslint-disable-next-line @typescript-eslint/no-unsafe-call,  @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access
            accumulator[currentPlaceholder] = ((_fieldValues$currentP = fieldValues[currentPlaceholder]) === null || _fieldValues$currentP === void 0 ? void 0 : _fieldValues$currentP.toString()) || '';
        }
        return accumulator;
    };
    return placeholderKeys === null || placeholderKeys === void 0 ? void 0 : placeholderKeys.reduce(placeholderValuesReducer, {});
};

});

parcelRegister("kTwJo", function(module, exports) {
$parcel$export(module.exports, "createAsyncProformaRequestCreate", () => $be86c73f9229af46$export$e401e2e1cb149a1b);


var $cVM5r = parcelRequire("cVM5r");

var $cJJTb = parcelRequire("cJJTb");

var $6rN3y = parcelRequire("6rN3y");

const $be86c73f9229af46$export$e401e2e1cb149a1b = (options)=>(0, $cVM5r.default)({
        LoadingSkeleton: options === null || options === void 0 ? void 0 : options.LoadingSkeleton,
        loader: (0, $cJJTb.lazyForPaint)(()=>(parcelRequire("itHeU")).then((module)=>{
                var _options$onLoaded;
                options === null || options === void 0 || (_options$onLoaded = options.onLoaded) === null || _options$onLoaded === void 0 || _options$onLoaded.call(options);
                return (0, $6rN3y.withFadeIn)()(module.ConnectedProformaRequestCreate);
            }), {
            ssr: false,
            moduleId: "./packages/proforma/request-create/src/ui/index.tsx"
        })
    });
const $be86c73f9229af46$export$2e65e0be2de61019 = $be86c73f9229af46$export$e401e2e1cb149a1b();

});
parcelRegister("itHeU", function(module, exports) {

var $kOunM = parcelRequire("kOunM");
module.exports = Promise.all([
    $kOunM("9EMTX"),
    $kOunM("5Ikrx"),
    $kOunM("aA07X"),
    $kOunM("9pCDc"),
    $kOunM("if62Z"),
    $kOunM("272yQ"),
    $kOunM("2PEFH")
]).then(()=>parcelRequire('gqiCO'));

});


parcelRegister("cPxQb", function(module, exports) {
$parcel$export(module.exports, "FormErrorMessage", () => (parcelRequire("hVMHI")).default);

var $hVMHI = parcelRequire("hVMHI");

});
parcelRegister("hVMHI", function(module, exports) {
$parcel$export(module.exports, "default", () => $b3bb7206c462a1b9$export$2e2bcd8739ae039);

var $bSJIT = parcelRequire("bSJIT");

var $5ymrB = parcelRequire("5ymrB");
var $5cDQ8 = parcelRequire("5cDQ8");

var $5cKiX = parcelRequire("5cKiX");
var $fK3tS = parcelRequire("fK3tS");

var $4ENEb = parcelRequire("4ENEb");

var $5txC1 = parcelRequire("5txC1");
class $b3bb7206c462a1b9$export$185a8afe504e8fca extends $bSJIT.Component {
    render() {
        const { errors: errors, intl: intl } = this.props;
        const { errorReasonKey: errorReasonKey } = errors;
        const { errorMessageTitle: errorMessageTitle, errorMessageTitleForBot: errorMessageTitleForBot, errorMessageOfflineText: errorMessageOfflineText, errorMessageText: errorMessageText, errorMessageContactLink: errorMessageContactLink, errorMessageForInternalError: errorMessageForInternalError } = (0, $4ENEb.default);
        const submissionError = errors.submissionError;
        const errorTitleDescriptor = errorReasonKey === (0, $5txC1.ERROR_REASON_KEYS).RECAPTCHA_ERROR ? errorMessageTitleForBot : errorMessageTitle;
        const errorTitle = intl.formatMessage(errorTitleDescriptor);
        let errorMessage;
        const hasTraceId = !!errors.traceId;
        if (submissionError && 'isOfflineError' in submissionError && submissionError.isOfflineError) errorMessage = intl.formatMessage(errorMessageOfflineText);
        else if (hasTraceId && submissionError && 'isGeneric' in submissionError && submissionError.isGeneric) errorMessage = /*#__PURE__*/ $bSJIT.createElement((0, $5cKiX.default), {
            ...errorMessageText,
            values: {
                contactLink: // eslint-disable-next-line @atlassian/i18n/no-unsafe-message-composition -- Pre-existing; to be migrated
                /*#__PURE__*/ $bSJIT.createElement((0, $5cDQ8.Link), {
                    href: errors.contactLink,
                    target: "_blank",
                    actionSubjectId: "errorMessageContactLink"
                }, /*#__PURE__*/ $bSJIT.createElement((0, $5cKiX.default), errorMessageContactLink))
            }
        });
        else // pre-translated error message from the backend
        errorMessage = submissionError && 'errorMessage' in submissionError && submissionError.errorMessage;
        if (!errorMessage && !hasTraceId) errorMessage = intl.formatMessage(errorMessageForInternalError);
        return /*#__PURE__*/ $bSJIT.createElement((0, $5ymrB.default), {
            title: errorTitle,
            message: errorMessage
        });
    }
}
var $b3bb7206c462a1b9$export$2e2bcd8739ae039 = (0, $fK3tS.default)($b3bb7206c462a1b9$export$185a8afe504e8fca);

});
parcelRegister("5ymrB", function(module, exports) {
$parcel$export(module.exports, "default", () => $04895a80ae094b0d$export$2e2bcd8739ae039);

var $bSJIT = parcelRequire("bSJIT");

var $4v2A7 = parcelRequire("4v2A7");

var $9K7mZ = parcelRequire("9K7mZ");

var $fU62V = parcelRequire("fU62V");

var $hkLEY = parcelRequire("hkLEY");
const $04895a80ae094b0d$var$ErrorMessage = ({ title: title, message: message })=>{
    return(// Ensures users can always tab from the error message
    // eslint-disable-next-line @atlassian/a11y/no-noninteractive-tabindex, styled-components-a11y/no-noninteractive-tabindex
    /*#__PURE__*/ $bSJIT.createElement($04895a80ae094b0d$var$Container, {
        tabIndex: 0,
        "data-test-id": "error-message"
    }, /*#__PURE__*/ $bSJIT.createElement($04895a80ae094b0d$var$Header, null, /*#__PURE__*/ $bSJIT.createElement($04895a80ae094b0d$var$Title, null, /*#__PURE__*/ $bSJIT.createElement($04895a80ae094b0d$var$Icon, null, /*#__PURE__*/ $bSJIT.createElement((0, (/*@__PURE__*/$parcel$interopDefault($hkLEY))), {
        spacing: "spacious",
        label: "error"
    })), title)), /*#__PURE__*/ $bSJIT.createElement($04895a80ae094b0d$var$Content, null, message)));
};
var $04895a80ae094b0d$export$2e2bcd8739ae039 = $04895a80ae094b0d$var$ErrorMessage;
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $04895a80ae094b0d$var$Container = /*#__PURE__*/ (0, $4v2A7.default).div.withConfig({
    componentId: "sc-l2wj5c-0"
})`${$fU62V.borderBox};${$fU62V.borderRadius};padding:${"var(--ds-space-200, 16px)"} 0;color:${"var(--ds-text-danger, #BF2600)"};margin-top:${"var(--ds-space-100, 8px)"};&:focus{outline:none;}`;
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $04895a80ae094b0d$var$Header = /*#__PURE__*/ (0, $4v2A7.default).div.withConfig({
    componentId: "sc-l2wj5c-1"
})`display:flex;align-items:center;height:${$9K7mZ.multiple(4).px};`;
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $04895a80ae094b0d$var$Content = /*#__PURE__*/ (0, $4v2A7.default).div.withConfig({
    componentId: "sc-l2wj5c-2"
})`display:flex;flex:1 1 100%;flex-direction:column;justify-content:center;`;
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $04895a80ae094b0d$var$Icon = /*#__PURE__*/ (0, $4v2A7.default).div.withConfig({
    componentId: "sc-l2wj5c-3"
})`margin-right:${"var(--ds-space-050, 4px)"};`;
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $04895a80ae094b0d$var$Title = /*#__PURE__*/ (0, $4v2A7.default).span.withConfig({
    componentId: "sc-l2wj5c-4"
})`${$fU62V.clamp};color:${"var(--ds-text-danger, #BF2600)"};display:flex;align-items:center;flex:1;font-weight:600;`;

});

parcelRegister("5cDQ8", function(module, exports) {
$parcel$export(module.exports, "Link", () => $a0f81f6b67ee2229$export$a6c7ac8248d6e38a);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Disabled to rollout go/ui-styling-standard tooling, please resolve

var $4v2A7 = parcelRequire("4v2A7");

var $53Khx = parcelRequire("53Khx");
const $a0f81f6b67ee2229$export$a6c7ac8248d6e38a = /*#__PURE__*/ (0, $4v2A7.default)((0, $53Khx.HtmlAnchor)).withConfig({
    componentId: "sc-c173o3-0"
})`color:${"var(--ds-text-danger, #BF2600)"} !important;font-weight:600;text-decoration:underline;`;

});

parcelRegister("4ENEb", function(module, exports) {
$parcel$export(module.exports, "default", () => $0da6b37fb481a7b5$export$2e2bcd8739ae039);

var $f0Pt4 = parcelRequire("f0Pt4");
var $0da6b37fb481a7b5$export$2e2bcd8739ae039 = (0, $f0Pt4.defineMessages)({
    errorMessageTitle: {
        defaultMessage: "Couldn't send request",
        description: 'Error message title when form submission fails',
        id: 'cv.request.create.form.error.banner.title'
    },
    errorMessageTitleForBot: {
        defaultMessage: "We couldn\u2019t verify that you are not a bot",
        description: 'Error message title when form submission fails due to bot validation failure',
        id: 'cv.request.create.form.error.banner.title.bot'
    },
    errorMessageText: {
        defaultMessage: "Please copy your text, then refresh the page and try again. If you've already tried again, {contactLink}.",
        description: 'Error message title when form submission fails',
        id: 'cv.request.create.form.error.banner.message'
    },
    errorMessageContactLink: {
        defaultMessage: 'tell us about this issue',
        description: 'Text inside the refresh link inside the error banner.',
        id: 'cv.request.create.form.error.banner.contact.link'
    },
    errorMessageOfflineText: {
        defaultMessage: "You've been disconnected from the internet, wait until you have connectivity and then try again.",
        description: 'Error message title when form submission fails',
        id: 'cv.request.create.form.error.banner.message.offline'
    },
    errorMessageForInternalError: {
        defaultMessage: 'Contact your administrator to verify your internal network settings or disable any VPNs, and try again.',
        description: 'Error message description when form submission fails due to internal tenant proxy settings',
        id: 'cv.request.create.form.error.banner.message.internal'
    }
});

});




parcelRegister("iGm04", function(module, exports) {
$parcel$export(module.exports, "RequestTypeProformaError", () => (parcelRequire("eSxIC")).default);

var $eSxIC = parcelRequire("eSxIC");

});
parcelRegister("eSxIC", function(module, exports) {
$parcel$export(module.exports, "default", () => $372e1d5b1eaa75d3$export$2e2bcd8739ae039);
/* request-type-proforma-error.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $9fU1q = parcelRequire("9fU1q");

var $bSJIT = parcelRequire("bSJIT");

var $fK3tS = parcelRequire("fK3tS");

var $kIbto = parcelRequire("kIbto");

var $buKRr = parcelRequire("buKRr");

var $haAAx = parcelRequire("haAAx");

var $8SBQq = parcelRequire("8SBQq");

var $429NB = parcelRequire("429NB");

var $amI9T = parcelRequire("amI9T");
const $372e1d5b1eaa75d3$var$styles = null;
class $372e1d5b1eaa75d3$export$67634daa559dd1dc extends $bSJIT.Component {
    componentDidMount() {
        this.fireRequestTypeViewedTrackEvent();
    }
    render() {
        const { admin: admin, intl: intl, formValidationResult: formValidationResult } = this.props;
        let errorMessage;
        if (formValidationResult !== null && formValidationResult !== void 0 && formValidationResult.readOnlyMandatory.some(({ readOnlyReason: readOnlyReason })=>readOnlyReason === (0, $8SBQq.ReadOnlyReason).Anonymous)) errorMessage = intl.formatMessage((0, $amI9T.default).couldntLoadRequestAnonymousDescription);
        else if (formValidationResult !== null && formValidationResult !== void 0 && formValidationResult.readOnlyMandatory.some(({ readOnlyReason: readOnlyReason })=>readOnlyReason === (0, $8SBQq.ReadOnlyReason).Unlicensed)) errorMessage = intl.formatMessage((0, $amI9T.default).couldntLoadRequestUnlicensedDescription);
        else if (admin && formValidationResult !== null && formValidationResult !== void 0 && formValidationResult.isConditionallyShown.length) errorMessage = intl.formatMessage((0, $amI9T.default).couldntLoadRequestConditionalSectionDescription);
        else errorMessage = intl.formatMessage((0, $amI9T.default).couldntLoadRequestGenericDescription);
        return /*#__PURE__*/ $bSJIT.createElement("div", {
            className: (0, $9fU1q.default)([
                "_19pkpxbi"
            ])
        }, /*#__PURE__*/ $bSJIT.createElement((0, $buKRr.default), {
            appearance: "error",
            title: intl.formatMessage((0, $amI9T.default).couldntLoadRequestTitle)
        }, errorMessage));
    }
    constructor(...args){
        super(...args), this.fireRequestTypeViewedTrackEvent = ()=>{
            const { createAnalyticsEvent: createAnalyticsEvent, requestTypeId: requestTypeId, portalId: portalId, formValidationResult: formValidationResult } = this.props;
            if (!createAnalyticsEvent) return;
            let analyticsReason;
            if (formValidationResult !== null && formValidationResult !== void 0 && formValidationResult.readOnlyMandatory.length) analyticsReason = 'readOnlyMandatory';
            else if (formValidationResult !== null && formValidationResult !== void 0 && formValidationResult.isConditionallyShown.length) analyticsReason = 'isConditionallyShown';
            const analyticsEvent = createAnalyticsEvent({
                portalId: portalId,
                requestTypeId: requestTypeId,
                analyticsType: (0, $haAAx.TRACK_EVENT_TYPE),
                action: (0, $429NB.Action).STOPPED,
                actionSubject: (0, $429NB.ActionSubject).FORM_VALIDATION,
                stopReason: analyticsReason
            });
            analyticsEvent.fire();
        };
    }
}
var $372e1d5b1eaa75d3$export$2e2bcd8739ae039 = (0, $fK3tS.default)((0, $kIbto.default)()($372e1d5b1eaa75d3$export$67634daa559dd1dc));

});
parcelRegister("8SBQq", function(module, exports) {
$parcel$export(module.exports, "ReadOnlyReason", () => $43ad85b55db38edd$export$3981c7d6e6518dac);
var $43ad85b55db38edd$export$3981c7d6e6518dac = /*#__PURE__*/ function(ReadOnlyReason) {
    ReadOnlyReason["Anonymous"] = "anonymous";
    ReadOnlyReason["Unlicensed"] = "unlicensed";
    return ReadOnlyReason;
}({});

});

parcelRegister("429NB", function(module, exports) {
$parcel$export(module.exports, "ActionSubject", () => $d3017dcc6cde9185$export$7f97440769de1377);
$parcel$export(module.exports, "Action", () => $d3017dcc6cde9185$export$e19cd5f9376f8cee);
$parcel$export(module.exports, "FormUpdateType", () => $d3017dcc6cde9185$export$d7867a52899740a0);
/* Read https://hello.atlassian.net/wiki/spaces/DQ/pages/786078865 on how to instrument well. */ // These are entities in ProForma. Reuse as much as possible.
// Think carefully when making a new ActionSubject about whether you can reuse an existing one.
var $d3017dcc6cde9185$export$7f97440769de1377 = /*#__PURE__*/ function(ActionSubject) {
    // Objects
    ActionSubject["FORM"] = "form";
    // An actual form on an issue.
    ActionSubject["FORM_FIELD"] = "formField";
    // A field in a form.
    ActionSubject["FORM_FIELD_CHOICES_DATA_CONNECTION"] = "formFieldChoicesDataConnection";
    // A data connection's choices in a form.
    ActionSubject["FORM_FIELD_CHOICES_JIRA_FIELD"] = "formFieldChoicesJiraField";
    // A Jira field's choices in a form.
    ActionSubject["FORM_SETTINGS_LANGUAGE"] = "formSettingsLanguage";
    // Language dropdown of a form in form settings.
    ActionSubject["FORM_SETTINGS_SUBMIT"] = "formSettingsSubmit";
    // Lock and PDF of a form on submit toggle in form settings.
    ActionSubject["FORM_SETTINGS_ISSUE_CREATE"] = "formSettingsIssueCreate";
    // Submit and validate on create toggle in form settings.
    ActionSubject["FORM_SETTINGS_ISSUE_FORMS_TYPES"] = "formSettingsIssueFormsTypes";
    // Issue forms types dropdown in form settings, enabled through issue forms toggle.
    ActionSubject["FORM_SETTINGS_RECOMMENDED_FORMS_TYPES"] = "formSettingsRecommendedFormsTypes";
    // Recommended forms types dropdown in form settings, enabled through recommended forms toggle.
    ActionSubject["FORM_SETTINGS_REQUEST_CREATE_TYPES"] = "formSettingsRequestCreateTypes";
    // Request create types dropdown in form settings, enabled through request create toggle ("Attach to request types").
    ActionSubject["QUESTION_ANSWER"] = "questionAnswer";
    // Answer of a Question in a form.
    ActionSubject["TEMPLATE_FORM"] = "templateForm";
    // A form in a project created by form builder than can be then instantiated on an issue.
    ActionSubject["EXAMPLE_TEMPLATE"] = "exampleTemplate";
    // Predefined templates available in the form builder that can be inserted into a template form.
    ActionSubject["BUTTON"] = "button";
    ActionSubject["DROPDOWN_ITEM"] = "dropdownItem";
    ActionSubject["SELECT_ITEM"] = "selectItem";
    ActionSubject["FILTER"] = "filter";
    ActionSubject["LIST"] = "list";
    ActionSubject["PANEL"] = "panel";
    ActionSubject["SECTION"] = "section";
    ActionSubject["TABLE"] = "table";
    ActionSubject["MODAL"] = "modal";
    ActionSubject["PROFORMA_API"] = "proformaAPI";
    ActionSubject["PROFORMA_UI"] = "proformaUI";
    ActionSubject["SECTION_MESSAGE"] = "sectionMessage";
    ActionSubject["ATTACHMENT"] = "proformaAttachment";
    ActionSubject["ATTACHMENT_UPLOAD"] = "proformaAttachmentUpload";
    ActionSubject["ATTACHMENT_VIEWER"] = "proformaAttachmentViewer";
    ActionSubject["ATTACHMENT_VIEWER_CARD"] = "proformaAttachmentViewerCard";
    ActionSubject["REQUEST_TYPE"] = "requestType";
    ActionSubject["DUPLICATE_REQUEST_TYPE_LINKED_FIELDS_WARNING_MODAL"] = "duplicateRequestTypeLinkedFieldsWarningModal";
    ActionSubject["TRANSLATIONS_EDITOR"] = "translationsEditor";
    ActionSubject["FORM_PERMISSIONS"] = "proformaFormPermissions";
    // Processes
    ActionSubject["ADF_NODE_INSERT"] = "adfNodeInsert";
    ActionSubject["FORM_VALIDATION"] = "formValidation";
    ActionSubject["FORM_EDIT"] = "formEdit";
    ActionSubject["FORM_SAVE"] = "formSave";
    ActionSubject["SEARCH_ASYNC_CHOICES"] = "searchAsyncChoices";
    ActionSubject["FETCH_FORM_ATTACHMENTS"] = "fetchFormAttachments";
    ActionSubject["UPLOAD_ISSUE_FORM_ATTACHMENTS"] = "uploadFormAttachments";
    ActionSubject["TRANSLATIONS_LANGUAGES_LOAD"] = "translationsLoad";
    ActionSubject["TRANSLATIONS_LOAD"] = "translationsLoad";
    ActionSubject["TRANSLATIONS_SAVE"] = "translationsSave";
    ActionSubject["TRANSLATIONS_DELETE"] = "translationsDelete";
    return ActionSubject;
}({});
var $d3017dcc6cde9185$export$e19cd5f9376f8cee = /*#__PURE__*/ function(Action) {
    // Objects
    Action["ADDED"] = "added";
    // When an entity is added/inserted into another.
    Action["CLICKED"] = "clicked";
    Action["CREATED"] = "created";
    Action["DELETED"] = "deleted";
    Action["DOWNLOADED"] = "downloaded";
    Action["EXPORTED"] = "exported";
    Action["UPDATED"] = "updated";
    Action["VIEWED"] = "viewed";
    Action["SELECTED"] = "selected";
    Action["COPIED"] = "copied";
    // Processes
    Action["FAILED"] = "failed";
    Action["FINISHED"] = "finished";
    Action["STARTED"] = "started";
    Action["STOPPED"] = "stopped";
    return Action;
}({});
var $d3017dcc6cde9185$export$d7867a52899740a0 = /*#__PURE__*/ function(FormUpdateType) {
    FormUpdateType["REOPEN"] = "REOPEN";
    FormUpdateType["SAVE"] = "SAVE";
    FormUpdateType["SET_EXTERNAL"] = "SET_EXTERNAL";
    FormUpdateType["SET_INTERNAL"] = "SET_INTERNAL";
    FormUpdateType["SUBMIT"] = "SUBMIT";
    FormUpdateType["CLOSE"] = "CLOSE";
    return FormUpdateType;
}({});

});

parcelRegister("amI9T", function(module, exports) {
$parcel$export(module.exports, "default", () => $509f832c08bddac9$export$2e2bcd8739ae039);

var $f0Pt4 = parcelRequire("f0Pt4");
var $509f832c08bddac9$export$2e2bcd8739ae039 = (0, $f0Pt4.defineMessages)({
    couldntLoadRequestTitle: {
        defaultMessage: "We couldn\u2019t load this request",
        description: 'Title shown in section message when form could not be loaded',
        id: 'sd.jsm.customerview.portalrequesttype.couldnt.load.request.title'
    },
    couldntLoadRequestGenericDescription: {
        defaultMessage: 'Select a different request, or contact your admin.',
        description: 'Description shown in section message when form could not be loaded due to an unknown reason.',
        id: 'sd.jsm.customerview.portalrequesttype.couldnt.load.request.generic.description'
    },
    couldntLoadRequestAnonymousDescription: {
        defaultMessage: 'Log in with a valid account to access, or select a different request.',
        description: 'Description shown in section message when form could not be loaded due to user not being logged in.',
        id: 'sd.jsm.customerview.portalrequesttype.couldnt.load.request.anonymous.description'
    },
    couldntLoadRequestUnlicensedDescription: {
        defaultMessage: 'This request is only available to users with Jira access. Select a different request, or contact your admin.',
        description: 'Description shown in section message when form could not be loaded due to not having Jira access.',
        id: 'sd.jsm.customerview.portalrequesttype.couldnt.load.request.unlicensed.description'
    },
    couldntLoadRequestConditionalSectionDescription: {
        defaultMessage: 'Remove required fields from conditional sections, or change their linked Jira fields to optional.',
        description: 'Description shown in section message when form could not be loaded due to required Jira fields being inside conditional section.',
        id: 'sd.jsm.customerview.portalrequesttype.couldnt.load.request.conditional.section.description'
    }
});

});





parcelRegister("87EHs", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::f9c38bfa054ce139eb4eb1d828621cdf>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $5e9e8c548b7c6c82$var$_react = $5e9e8c548b7c6c82$var$_interopRequireDefault((parcelRequire("bSJIT")));

var $5e9e8c548b7c6c82$var$_iconNew = $5e9e8c548b7c6c82$var$_interopRequireDefault((parcelRequire("gHJ0W")));
function $5e9e8c548b7c6c82$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Clock".
 * Category: multi-purpose
 * Location: @atlaskit/icon/core/clock
 * Usage guidance:
 * Known uses: recent, time input, sprint time remaining, overdue task work type status.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $5e9e8c548b7c6c82$var$ClockIcon = (props)=>/*#__PURE__*/ $5e9e8c548b7c6c82$var$_react.default.createElement($5e9e8c548b7c6c82$var$_iconNew.default, Object.assign({
        name: "ClockIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M14.5 8a6.5 6.5 0 1 0-13 0 6.5 6.5 0 0 0 13 0M8.75 3.25v4.389l2.219 1.775-.938 1.172-2.5-2-.281-.226V3.25zM16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0"/>`
    }, props));
$5e9e8c548b7c6c82$var$ClockIcon.displayName = 'ClockIcon';
var $5e9e8c548b7c6c82$var$_default = module.exports.default = $5e9e8c548b7c6c82$var$ClockIcon;

});

parcelRegister("jdcqW", function(module, exports) {
$parcel$export(module.exports, "Grid", () => $cb65d39a0cb27043$export$ef2184bd89960b14);
/* grid.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $dc70d = parcelRequire("dc70d");

var $bSJIT = parcelRequire("bSJIT");

var $9fU1q = parcelRequire("9fU1q");
const $cb65d39a0cb27043$var$rowGapMap = {
    'space.0': "_1p57ze3t",
    'space.025': "_1p57v77o",
    'space.050': "_1p571b66",
    'space.075': "_1p5712x7",
    'space.100': "_1p57u2gc",
    'space.150': "_1p57utpp",
    'space.200': "_1p57pxbi",
    'space.250': "_1p57v47k",
    'space.300': "_1p571ejb",
    'space.400': "_1p57xy5q",
    'space.500': "_1p571jfw",
    'space.600': "_1p57oahv",
    'space.800': "_1p57xncg",
    'space.1000': "_1p571epz",
    'space.gap.xxsmall': "_1p571j29",
    'space.gap.xsmall': "_1p57t24t",
    'space.gap.small': "_1p57e2kt",
    'space.gap.medium': "_1p57slki",
    'space.gap.large': "_1p571l0c",
    'space.gap.xlarge': "_1p571a4g",
    'space.gap.xxlarge': "_1p57rdp2"
};
const $cb65d39a0cb27043$var$columnGapMap = {
    'space.0': "_gy1pze3t",
    'space.025': "_gy1pv77o",
    'space.050': "_gy1p1b66",
    'space.075': "_gy1p12x7",
    'space.100': "_gy1pu2gc",
    'space.150': "_gy1putpp",
    'space.200': "_gy1ppxbi",
    'space.250': "_gy1pv47k",
    'space.300': "_gy1p1ejb",
    'space.400': "_gy1pxy5q",
    'space.500': "_gy1p1jfw",
    'space.600': "_gy1poahv",
    'space.800': "_gy1pxncg",
    'space.1000': "_gy1p1epz",
    'space.gap.xxsmall': "_gy1p1j29",
    'space.gap.xsmall': "_gy1pt24t",
    'space.gap.small': "_gy1pe2kt",
    'space.gap.medium': "_gy1pslki",
    'space.gap.large': "_gy1p1l0c",
    'space.gap.xlarge': "_gy1p1a4g",
    'space.gap.xxlarge': "_gy1prdp2"
};
const $cb65d39a0cb27043$var$justifyContentMap = {
    start: "_1bahv2br",
    center: "_1bah1h6o",
    end: "_1bahh9n0",
    'space-between': "_1bah1yb4",
    'space-around': "_1bah1b1v",
    'space-evenly': "_1bahitcz",
    stretch: "_1bah1fhb"
};
const $cb65d39a0cb27043$var$alignContentMap = {
    start: "_ae4vv2br",
    center: "_ae4v1h6o",
    end: "_ae4vh9n0",
    'space-between': "_ae4v1yb4",
    'space-around': "_ae4v1b1v",
    'space-evenly': "_ae4vitcz",
    stretch: "_ae4v1fhb"
};
const $cb65d39a0cb27043$var$alignItemsMap = {
    start: "_4cvrv2br",
    center: "_4cvr1h6o",
    baseline: "_4cvr1q9y",
    end: "_4cvrh9n0",
    stretch: "_4cvr1fhb"
};
const $cb65d39a0cb27043$var$baseStyles = {
    root: "_1e0c11p5 _vchhusvi"
};
const $cb65d39a0cb27043$var$gridAutoFlowMap = {
    row: "_wij2vrvc",
    column: "_wij21bp4",
    dense: "_wij218l3",
    'row dense': "_wij2j5tq",
    'column dense': "_wij2adhi"
};
const $cb65d39a0cb27043$export$ef2184bd89960b14 = /*#__PURE__*/ (0, $bSJIT.memo)(/*#__PURE__*/ (0, $bSJIT.forwardRef)(({ as: as, alignItems: alignItems, alignContent: alignContent, justifyContent: justifyContent, gap: gap, columnGap: columnGap, rowGap: rowGap, children: children, id: id, role: role, testId: testId, autoFlow: autoFlow, xcss: xcss }, ref)=>{
    const Component = as || 'div';
    return /*#__PURE__*/ (0, $dc70d.jsx)(Component, {
        id: id,
        role: role,
        className: (0, $9fU1q.default)([
            $cb65d39a0cb27043$var$baseStyles.root,
            gap && $cb65d39a0cb27043$var$columnGapMap[gap],
            columnGap && $cb65d39a0cb27043$var$columnGapMap[columnGap],
            gap && $cb65d39a0cb27043$var$rowGapMap[gap],
            rowGap && $cb65d39a0cb27043$var$rowGapMap[rowGap],
            alignItems && $cb65d39a0cb27043$var$alignItemsMap[alignItems],
            alignContent && $cb65d39a0cb27043$var$alignContentMap[alignContent],
            justifyContent && $cb65d39a0cb27043$var$justifyContentMap[justifyContent],
            autoFlow && $cb65d39a0cb27043$var$gridAutoFlowMap[autoFlow],
            xcss
        ]),
        "data-testid": testId,
        ref: ref,
        children: children
    });
}));
$cb65d39a0cb27043$export$ef2184bd89960b14.displayName = 'Grid';

});

parcelRegister("lPSjO", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::bdcfaadd200b1558cd21a6be22e04743>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $fe587ef1109f0ffe$var$_react = $fe587ef1109f0ffe$var$_interopRequireDefault((parcelRequire("bSJIT")));

var $fe587ef1109f0ffe$var$_iconNew = $fe587ef1109f0ffe$var$_interopRequireDefault((parcelRequire("gHJ0W")));
function $fe587ef1109f0ffe$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Calendar".
 * Category: multi-purpose
 * Location: @atlaskit/icon/core/calendar
 * Usage guidance:
 * Multi purpose - Known uses: date metadata, date input field, calendar view, jira status.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $fe587ef1109f0ffe$var$CalendarIcon = (props)=>/*#__PURE__*/ $fe587ef1109f0ffe$var$_react.default.createElement($fe587ef1109f0ffe$var$_iconNew.default, Object.assign({
        name: "CalendarIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M4.5 2.5v2H6v-2h4v2h1.5v-2H13a.5.5 0 0 1 .5.5v3h-11V3a.5.5 0 0 1 .5-.5zm-2 5V13a.5.5 0 0 0 .5.5h10a.5.5 0 0 0 .5-.5V7.5zm9-6.5H13a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h1.5V0H6v1h4V0h1.5z" clip-rule="evenodd"/>`
    }, props));
$fe587ef1109f0ffe$var$CalendarIcon.displayName = 'CalendarIcon';
var $fe587ef1109f0ffe$var$_default = module.exports.default = $fe587ef1109f0ffe$var$CalendarIcon;

});

parcelRegister("7q8Sl", function(module, exports) {
$parcel$export(module.exports, "createLocalizationProvider", () => $f43436c87ad73102$export$ea56ca58f08ffa52);

var $l8vXm = parcelRequire("l8vXm");

var $h8Z36 = parcelRequire("h8Z36");

var $9AtYB = parcelRequire("9AtYB");

var $d99bn = parcelRequire("d99bn");
const $f43436c87ad73102$export$ea56ca58f08ffa52 = (locale, formatterOptions)=>{
    // Intl.DateFormat expects locales in the format of 'la-CO' however it is
    // common for locale to be provided in the format of 'la_CO', where 'la' is
    // language and 'CO' is country.
    const normalizedLocale = (0, $l8vXm.normalizeLocale)(locale);
    const formatDate = (date)=>Intl.DateTimeFormat(normalizedLocale).format(date);
    const formatTime = (date)=>Intl.DateTimeFormat(normalizedLocale, {
            hour: 'numeric',
            minute: 'numeric'
        }).format(date);
    const getDays = (weekStartDay = 0, length)=>{
        const dayFormatter = Intl.DateTimeFormat(normalizedLocale, {
            weekday: length
        });
        // Right now there is no way to find out first day of the week based on Intl (locale)
        // api. Check issue here: https://github.com/tc39/ecma402/issues/6
        // So we rotate the weekdays based on #weekStartDay parameter.
        const weekdays = [
            0,
            1,
            2,
            3,
            4,
            5,
            6
        ];
        const rotatedWeekdays = weekStartDay > 0 ? [
            ...weekdays.slice(weekStartDay),
            ...weekdays.slice(0, weekStartDay)
        ] : weekdays;
        return rotatedWeekdays.map((day)=>{
            // Some short days are longer than 3 characters but are unique if the first
            // three non-white characters are used.
            const result = dayFormatter// Date range chosen which has a Sun-Sat range so we can extract the names
            .format(new Date(2000, 9, day + 1, 12))// \u200E matches on the Left-to-Right Mark character in IE/Edge
            .replace(/[\s\u200E]/g, '');
            // If short days, only return first three characters. Else return whole thing
            if (length === 'short') return result.substring(0, 3);
            return result;
        });
    };
    const getDaysShort = (weekStartDay = 0)=>getDays(weekStartDay, 'short');
    const getDaysLong = (weekStartDay = 0)=>getDays(weekStartDay, 'long');
    const getMonthsLong = ()=>{
        const monthFormatter = Intl.DateTimeFormat(normalizedLocale, {
            month: 'long'
        });
        return [
            0,
            1,
            2,
            3,
            4,
            5,
            6,
            7,
            8,
            9,
            10,
            11
        ].map((month)=>// Date chosen for no real reason, the only important part is the month
            // Using 2020 'cos Safari has a faulty implementation when we use the year 2000
            // Intl.DateTimeFormat("en-US", { month: 'long'}).format(new Date(2000, 3, 1))
            // should give "April" but gives "March" in Safari
            monthFormatter.format(new Date(2020, month, 1)));
    };
    const parseDate = (date, options = {})=>(0, $h8Z36.createDateParser)(normalizedLocale)(date, options);
    const formatToParts = (date = new Date())=>{
        const formatter = new Intl.DateTimeFormat(normalizedLocale, formatterOptions);
        /**
     * Safari has a bug that returns the wrong month for years 2005 and before.
     * The error occurs when the passed date has been created with numbers, like new Date(2000, 3, 1)
     * Not all the months fail in each year. To ensure the correct output,
     * we select 2020 as the base year for the whole date,
     * then we replace in the result the original input year
     */ const fixedDate = new Date(date);
        fixedDate.setFullYear(2020);
        const fixedParts = (0, $d99bn.toFormattedParts)(formatter.formatToParts(fixedDate));
        const originalParts = (0, $d99bn.toFormattedParts)(formatter.formatToParts(date));
        if (fixedParts.year) fixedParts.year = originalParts.year;
        /**
     * Chrome has a bug that returns hour="00" when it's 12:00pm in certain languages
     * We fix it by detecting the real time with getHours method
     */ if (fixedParts.hour === '00' && fixedDate.getHours() === 12) fixedParts.hour = '12';
        return fixedParts;
    };
    let intlLocale;
    const getFirstDayOfWeek = ()=>{
        if (!intlLocale) intlLocale = new Intl.Locale(normalizedLocale);
        const weekInfo = (0, $9AtYB.getWeekInfo)(intlLocale);
        // Intl uses ISO weekdays (1 = Monday … 7 = Sunday).
        // Calendar / getDays* use JS weekdays (0 = Sunday … 6 = Saturday).
        return weekInfo.firstDay % 7;
    };
    return {
        getDaysShort: getDaysShort,
        getDaysLong: getDaysLong,
        getMonthsLong: getMonthsLong,
        formatDate: formatDate,
        formatTime: formatTime,
        parseDate: parseDate,
        formatToParts: formatToParts,
        getFirstDayOfWeek: getFirstDayOfWeek
    };
};

});
parcelRegister("l8vXm", function(module, exports) {
$parcel$export(module.exports, "normalizeLocale", () => $ed2c35611702ec77$export$dca0327c9b9c6498);
const $ed2c35611702ec77$export$dca0327c9b9c6498 = (locale)=>locale.replace(/_/g, '-');

});

parcelRegister("h8Z36", function(module, exports) {
$parcel$export(module.exports, "createDateParser", () => $0e2297f33a926e8b$export$cfa2ef2687faeda2);

var $l8vXm = parcelRequire("l8vXm");

var $dKI0s = parcelRequire("dKI0s");

var $d07Xd = parcelRequire("d07Xd");

var $kMsXO = parcelRequire("kMsXO");
const $0e2297f33a926e8b$var$INVALID_DATE = new Date(NaN);
const $0e2297f33a926e8b$var$INVARIANT = {
    year: 1993,
    month: 2,
    day: 18
};
const $0e2297f33a926e8b$var$INVARIANT_DATE = (0, $kMsXO.toDate)($0e2297f33a926e8b$var$INVARIANT);
const $0e2297f33a926e8b$var$FORMAT_EXTRACTOR_REGEX = /(\d+)[^\d]+(\d+)[^\d]+(\d+)\.?/;
const $0e2297f33a926e8b$var$DATE_PARSER_REGEX = /(\d+)[^\d]*(\d+)?[^\d]*(\d+)?\.?/;
// Internet Explorer returns non-printing characters when formatting a date
const $0e2297f33a926e8b$var$stripExtras = (str)=>str.replace(/\u200E/g, '');
const $0e2297f33a926e8b$var$extractDateParts = (matchResult)=>{
    return matchResult// Get the 3 capture groups
    .splice(1, 4)// Convert them to numbers
    .map((datePart)=>parseInt(datePart, 10));
};
const $0e2297f33a926e8b$export$cfa2ef2687faeda2 = (locale)=>{
    // Intl.DateFormat expects locales in the format of 'la-CO' however it is
    // common for locale to be provided in the format of 'la_CO', where 'la' is
    // language and 'CO' is country.
    const normalizedLocale = (0, $l8vXm.normalizeLocale)(locale);
    const dateFormatter = Intl.DateTimeFormat(normalizedLocale);
    // Generate a date string from a hard coded date, this allows us to determine
    // the year/month/day position for the provided locale.
    const rawDateString = dateFormatter.format($0e2297f33a926e8b$var$INVARIANT_DATE);
    const shortDate = $0e2297f33a926e8b$var$stripExtras(rawDateString);
    // Extract the date pieces from the locale formatted date string
    const formatMatch = shortDate.match($0e2297f33a926e8b$var$FORMAT_EXTRACTOR_REGEX);
    if (!formatMatch) throw new Error('Unable to create DateParser');
    const formatParts = $0e2297f33a926e8b$var$extractDateParts(formatMatch);
    // Find the year/month/day positions of the locale formatted invariant date
    const yearPosition = formatParts.indexOf($0e2297f33a926e8b$var$INVARIANT.year);
    const monthPosition = formatParts.indexOf($0e2297f33a926e8b$var$INVARIANT.month);
    const dayPosition = formatParts.indexOf($0e2297f33a926e8b$var$INVARIANT.day);
    return (date, options = {})=>{
        const dateMatch = $0e2297f33a926e8b$var$stripExtras(date).match($0e2297f33a926e8b$var$DATE_PARSER_REGEX);
        if (!dateMatch) return $0e2297f33a926e8b$var$INVALID_DATE;
        const dateParts = $0e2297f33a926e8b$var$extractDateParts(dateMatch);
        // Use the previously extracted year/month/day positions to extract each
        // date piece.
        const extractedDate = {
            year: dateParts[yearPosition],
            month: dateParts[monthPosition],
            day: dateParts[dayPosition]
        };
        const normalizedDate = (0, $d07Xd.normalizeDate)(extractedDate, options === null || options === void 0 ? void 0 : options.defaultFirstDay);
        if (!(0, $dKI0s.isValid)(normalizedDate)) return $0e2297f33a926e8b$var$INVALID_DATE;
        return (0, $kMsXO.toDate)(normalizedDate);
    };
};

});
parcelRegister("dKI0s", function(module, exports) {
$parcel$export(module.exports, "isValid", () => $216db60c3470d53d$export$1ea939691cdc45b8);

var $fwflj = parcelRequire("fwflj");
const $216db60c3470d53d$export$1ea939691cdc45b8 = (date)=>{
    const { year: year, month: month, day: day } = date;
    const daysInMonth = (0, $fwflj.getDaysInMonth)(year, month);
    return 1 <= month && month <= 12 && 1 <= day && day <= daysInMonth;
};

});
parcelRegister("fwflj", function(module, exports) {
$parcel$export(module.exports, "getDaysInMonth", () => $a6f1ab3c6b4589ac$export$f645ddd439eb259d);

var $dg3Dp = parcelRequire("dg3Dp");
const $a6f1ab3c6b4589ac$export$f645ddd439eb259d = (year, month)=>{
    // February depends on leap year
    if (month === 2 && (0, $dg3Dp.isLeapYear)(year)) return 29;
    return [
        31,
        28,
        31,
        30,
        31,
        30,
        31,
        31,
        30,
        31,
        30,
        31
    ][month - 1];
};

});
parcelRegister("dg3Dp", function(module, exports) {
$parcel$export(module.exports, "isLeapYear", () => $500c511414fc08a4$export$553d7fa8e3805fc0);
const $500c511414fc08a4$export$553d7fa8e3805fc0 = (year)=>{
    return year % 4 === 0 && year % 100 !== 0 || year % 400 === 0;
};

});



parcelRegister("d07Xd", function(module, exports) {
$parcel$export(module.exports, "normalizeDate", () => $e3f935399e6d6f38$export$fcc71269590ba0a8);

var $bvndw = parcelRequire("bvndw");
const $e3f935399e6d6f38$export$fcc71269590ba0a8 = (date, defaultFirstDay = false)=>{
    const now = (0, $bvndw.toDateObj)(new Date());
    const { year: year, month: month, day: day } = date;
    // 19 should evaluate to 2019
    const fullYear = year < 100 ? 2000 + year : year;
    // Missing date pieces are filled in with their current date values
    const normalizedYear = !isNaN(fullYear) ? fullYear : now.year;
    const normalizedMonth = !isNaN(month) && month !== 0 ? month : now.month;
    const normalizedDay = !isNaN(day) && day !== 0 ? day : month !== 0 && defaultFirstDay ? 1 : now.day;
    return {
        year: normalizedYear,
        month: normalizedMonth,
        day: normalizedDay
    };
};

});
parcelRegister("bvndw", function(module, exports) {
$parcel$export(module.exports, "toDateObj", () => $3f539fdc47230322$export$abe96da78d4f59dd);
const $3f539fdc47230322$export$abe96da78d4f59dd = (date)=>({
        year: date.getFullYear(),
        month: date.getMonth() + 1,
        day: date.getDate()
    });

});


parcelRegister("kMsXO", function(module, exports) {
$parcel$export(module.exports, "toDate", () => $5e75c2cbeeb25144$export$e67a095c620b86fe);
const $5e75c2cbeeb25144$export$e67a095c620b86fe = (date)=>// The 'proper' month is stored in a DateObj but Date expects month index
    new Date(date.year, date.month - 1, date.day);

});


parcelRegister("9AtYB", function(module, exports) {
$parcel$export(module.exports, "getWeekInfo", () => $ec535144da9dd70a$export$837830ce0c77272);
// Regional exceptions from Unicode CLDR 48; all other regions use Monday.
// https://github.com/unicode-org/cldr-json/blob/48.0.0/cldr-json/cldr-core/supplemental/weekData.json
const $ec535144da9dd70a$var$firstDays = {
    AF: 6,
    AG: 7,
    AS: 7,
    BD: 7,
    BH: 6,
    BR: 7,
    BS: 7,
    BT: 7,
    BW: 7,
    BZ: 7,
    CA: 7,
    CO: 7,
    DJ: 6,
    DM: 7,
    DO: 7,
    DZ: 6,
    EG: 6,
    ET: 7,
    GT: 7,
    GU: 7,
    HK: 7,
    HN: 7,
    ID: 7,
    IL: 7,
    IN: 7,
    IQ: 6,
    IR: 6,
    IS: 7,
    JM: 7,
    JO: 6,
    JP: 7,
    KE: 7,
    KH: 7,
    KR: 7,
    KW: 6,
    LA: 7,
    LY: 6,
    MH: 7,
    MM: 7,
    MO: 7,
    MT: 7,
    MV: 5,
    MX: 7,
    MZ: 7,
    NI: 7,
    NP: 7,
    OM: 6,
    PA: 7,
    PE: 7,
    PH: 7,
    PK: 7,
    PR: 7,
    PT: 7,
    PY: 7,
    QA: 6,
    SA: 7,
    SD: 6,
    SG: 7,
    SV: 7,
    SY: 6,
    TH: 7,
    TT: 7,
    TW: 7,
    UM: 7,
    US: 7,
    VE: 7,
    VI: 7,
    WS: 7,
    YE: 7,
    ZA: 7,
    ZW: 7
};
// Only regular territories may override a locale's region (CLDR 48 region validity data).
// https://github.com/unicode-org/cldr/blob/release-48/common/validity/region.xml
const $ec535144da9dd70a$var$regularRegions = new Set([
    'AC AD AE AF AG AI AL AM AO AQ AR AS AT AU AW AX AZ BA BB BD BE BF',
    'BG BH BI BJ BL BM BN BO BQ BR BS BT BV BW BY BZ CA CC CD CF CG CH',
    'CI CK CL CM CN CO CP CQ CR CU CV CW CX CY CZ DE DG DJ DK DM DO DZ',
    'EA EC EE EG EH ER ES ET FI FJ FK FM FO FR GA GB GD GE GF GG GH GI',
    'GL GM GN GP GQ GR GS GT GU GW GY HK HM HN HR HT HU IC ID IE IL IM',
    'IN IO IQ IR IS IT JE JM JO JP KE KG KH KI KM KN KP KR KW KY KZ LA',
    'LB LC LI LK LR LS LT LU LV LY MA MC MD ME MF MG MH MK ML MM MN MO',
    'MP MQ MR MS MT MU MV MW MX MY MZ NA NC NE NF NG NI NL NO NP NR NU',
    'NZ OM PA PE PF PG PH PK PL PM PN PR PS PT PW PY QA RE RO RS RU RW',
    'SA SB SC SD SE SG SH SI SJ SK SL SM SN SO SR SS ST SV SX SY SZ TA',
    'TC TD TF TG TH TJ TK TL TM TN TO TR TT TV TW TZ UA UG UM US UY UZ',
    'VA VC VE VG VI VN VU WF WS XK YE YT ZA ZM ZW'
].join(' ').split(' '));
// Read only Unicode keywords, excluding other extensions and private-use subtags.
const $ec535144da9dd70a$var$getUnicodeKeyword = (locale, key)=>{
    const extensions = locale.toString().split('-');
    const start = extensions.indexOf('u');
    const privateUse = extensions.indexOf('x');
    if (start === -1 || privateUse !== -1 && privateUse < start) return undefined;
    for(let index = start + 1; index < extensions.length; index++){
        if (extensions[index].length === 1) break;
        if (extensions[index] === key) {
            const value = [];
            while(((_extensions = extensions[index + 1]) === null || _extensions === void 0 ? void 0 : _extensions.length) > 2){
                var _extensions;
                value.push(extensions[++index]);
            }
            return value.join('-');
        }
    }
    return undefined;
};
// Canonicalize aliases before rejecting unknown, private-use, and macroregion overrides.
const $ec535144da9dd70a$var$getOverrideRegion = (value)=>{
    if (!value) return undefined;
    const region = new Intl.Locale(`und-${value}`).region;
    return region && $ec535144da9dd70a$var$regularRegions.has(region) ? region : undefined;
};
const $ec535144da9dd70a$export$837830ce0c77272 = (locale)=>{
    var _getUnicodeKeyword, _getUnicodeKeyword2;
    if (typeof locale.getWeekInfo === 'function') return locale.getWeekInfo();
    const legacyWeekInfo = locale.weekInfo;
    if (legacyWeekInfo) return legacyWeekInfo;
    const regionOverride = $ec535144da9dd70a$var$getOverrideRegion((_getUnicodeKeyword = $ec535144da9dd70a$var$getUnicodeKeyword(locale, 'rg')) === null || _getUnicodeKeyword === void 0 || (_getUnicodeKeyword = _getUnicodeKeyword.match(/^([a-z]{2}|[0-9]{3})zzzz$/)) === null || _getUnicodeKeyword === void 0 ? void 0 : _getUnicodeKeyword[1]);
    const subdivision = $ec535144da9dd70a$var$getOverrideRegion((_getUnicodeKeyword2 = $ec535144da9dd70a$var$getUnicodeKeyword(locale, 'sd')) === null || _getUnicodeKeyword2 === void 0 || (_getUnicodeKeyword2 = _getUnicodeKeyword2.match(/^([a-z]{2}|[0-9]{3})[a-z0-9]+$/)) === null || _getUnicodeKeyword2 === void 0 ? void 0 : _getUnicodeKeyword2[1]);
    const region = regionOverride || locale.region || subdivision || locale.maximize().region || '001';
    const preferredDay = [
        'mon',
        'tue',
        'wed',
        'thu',
        'fri',
        'sat',
        'sun'
    ].indexOf($ec535144da9dd70a$var$getUnicodeKeyword(locale, 'fw') || '');
    const firstDay = preferredDay !== -1 ? preferredDay + 1 : !regionOverride && locale.calendar === 'iso8601' ? 1 : $ec535144da9dd70a$var$firstDays[region] || 1;
    return {
        firstDay: firstDay
    };
};

});

parcelRegister("d99bn", function(module, exports) {
$parcel$export(module.exports, "toFormattedParts", () => $3a36f4973ea268a4$export$9b7ca29af37c192);
const $3a36f4973ea268a4$export$9b7ca29af37c192 = (rawParts)=>rawParts.reduce((result, datePart)=>({
            ...result,
            [datePart.type]: datePart.value
        }), {});

});


parcelRegister("j3LDE", function(module, exports) {

var $1XSz3 = parcelRequire("1XSz3");

var $3T67E = parcelRequire("3T67E");
/** `Object#toString` result references. */ var $de0340216d59e237$var$boolTag = '[object Boolean]';
/**
 * Checks if `value` is classified as a boolean primitive or object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a boolean, else `false`.
 * @example
 *
 * _.isBoolean(false);
 * // => true
 *
 * _.isBoolean(null);
 * // => false
 */ function $de0340216d59e237$var$isBoolean(value) {
    return value === true || value === false || $3T67E(value) && $1XSz3(value) == $de0340216d59e237$var$boolTag;
}
module.exports = $de0340216d59e237$var$isBoolean;

});


//# sourceMappingURL=request-create-form.0e06b9e6.js.map
